/* tslint:disable */
/* eslint-disable */
/**
 * SUUS API v0.1
 * This is the API powering SUUS Networks: [Corpshaus 2.0](https://auth.corpshaus2.de),  [Gaudeam](https://auth.gaudeam.de) and [habemus.app](https://auth.habemus.app) The OpenAPI specification can be viewed using   - [Swagger UI](/)   - [ReDoc](/redoc)   - [Stoplight](/stoplight) 
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AbilitiesInner
 */
export interface AbilitiesInner {
    /**
     * 
     * @type {number}
     * @memberof AbilitiesInner
     */
    'id'?: number;
    /**
     * 
     * @type {AbilitiesInnerAbility}
     * @memberof AbilitiesInner
     */
    'ability'?: AbilitiesInnerAbility;
}
/**
 * @type AbilitiesInnerAbility
 * @export
 */
export type AbilitiesInnerAbility = ClientAbility | LevelAbility;

/**
 * 
 * @export
 * @interface AbsorbPersonalRecordRequest
 */
export interface AbsorbPersonalRecordRequest {
    /**
     * 
     * @type {AbsorbPersonalRecordRequestPayload}
     * @memberof AbsorbPersonalRecordRequest
     */
    'payload': AbsorbPersonalRecordRequestPayload;
}
/**
 * 
 * @export
 * @interface AbsorbPersonalRecordRequestPayload
 */
export interface AbsorbPersonalRecordRequestPayload {
    /**
     * 
     * @type {number}
     * @memberof AbsorbPersonalRecordRequestPayload
     */
    'absorbed_id': number;
}
/**
 * 
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * 
     * @type {number}
     * @memberof Address
     */
    'id': number | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'phone_number': string | null;
    /**
     * Country-specific print version of the entire address
     * @type {string}
     * @memberof Address
     */
    'label': string | null;
    /**
     * Country-specific print version of the entire address without the name
     * @type {string}
     * @memberof Address
     */
    'label_without_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'street': string | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'c_o': string | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'postal_code': string | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'region': string | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'country': string | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'fax': string | null;
    /**
     * 
     * @type {number}
     * @memberof Address
     */
    'personal_record_id': number | null;
    /**
     * 
     * @type {number}
     * @memberof Address
     */
    'address_type': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof Address
     */
    'outdated': boolean | null;
    /**
     * 
     * @type {number}
     * @memberof Address
     */
    'longitude': number | null;
    /**
     * 
     * @type {number}
     * @memberof Address
     */
    'latitude': number | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'note': string | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'created_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    'updated_at': string | null;
}
/**
 * Age-based statistics grouped by age ranges
 * @export
 * @interface AgeStats
 */
export interface AgeStats {
    /**
     * Age range statistics where keys are age ranges and values are counts
     * @type {{ [key: string]: number; }}
     * @memberof AgeStats
     */
    'stats': { [key: string]: number; };
    /**
     * Invalid records excluded from statistics
     * @type {Array<AgeStatsInvalidInner>}
     * @memberof AgeStats
     */
    'invalid': Array<AgeStatsInvalidInner>;
}
/**
 * 
 * @export
 * @interface AgeStatsInvalidInner
 */
export interface AgeStatsInvalidInner {
    /**
     * ID of the personal record with invalid data
     * @type {number}
     * @memberof AgeStatsInvalidInner
     */
    'personal_record_id'?: number;
    /**
     * Name of the personal record with invalid data
     * @type {string}
     * @memberof AgeStatsInvalidInner
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const AscDescOrder = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type AscDescOrder = typeof AscDescOrder[keyof typeof AscDescOrder];


/**
 * 
 * @export
 * @enum {string}
 */

export const AttachableType = {
    Event: 'Event',
    Topic: 'Topic',
    Post: 'Post'
} as const;

export type AttachableType = typeof AttachableType[keyof typeof AttachableType];


/**
 * 
 * @export
 * @interface Attachment
 */
export interface Attachment {
    /**
     * 
     * @type {number}
     * @memberof Attachment
     */
    'id': number;
    /**
     * Frontend ID of the attachment.
     * @type {string}
     * @memberof Attachment
     */
    'frontend_id': string | null;
    /**
     * General classification of the file type to decide whether to treat as an file with an image preview.
     * @type {string}
     * @memberof Attachment
     */
    'type': AttachmentTypeEnum;
    /**
     * Name of the file, excluding the file type extension.
     * @type {string}
     * @memberof Attachment
     */
    'name': string;
    /**
     * Horizontal dimension of the original file in pixel.
     * @type {number}
     * @memberof Attachment
     */
    'width': number | null;
    /**
     * Vertical dimension of the original file in pixel.
     * @type {number}
     * @memberof Attachment
     */
    'height': number | null;
    /**
     * File size in Byte
     * @type {number}
     * @memberof Attachment
     */
    'file_size': number | null;
    /**
     * MIME Type of the file. May be null if the type could not be determined or was unknown.
     * @type {string}
     * @memberof Attachment
     */
    'content_type': string | null;
    /**
     * File type extension of the detected mime type.
     * @type {string}
     * @memberof Attachment
     */
    'file_type_extension': string | null;
    /**
     * Counts how often the original file was downloaded.
     * @type {number}
     * @memberof Attachment
     */
    'download_count': number | null;
    /**
     * 
     * @type {string}
     * @memberof Attachment
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof Attachment
     */
    'created_at': string;
    /**
     * 
     * @type {AttachmentLinks}
     * @memberof Attachment
     */
    'links': AttachmentLinks;
}

export const AttachmentTypeEnum = {
    File: 'File',
    Image: 'Image'
} as const;

export type AttachmentTypeEnum = typeof AttachmentTypeEnum[keyof typeof AttachmentTypeEnum];

/**
 * 
 * @export
 * @interface AttachmentLinks
 */
export interface AttachmentLinks {
    /**
     * URL of the 50px x 50px sized image preview, cropped with center in focus if needed.
     * @type {string}
     * @memberof AttachmentLinks
     */
    'icon_url'?: string | null;
    /**
     * URL of the 200px x 200px sized thumbnail, cropped with center in focus if needed.
     * @type {string}
     * @memberof AttachmentLinks
     */
    'thumb_url'?: string | null;
    /**
     * URL of the image preview, resized to 1200px without cropping.
     * @type {string}
     * @memberof AttachmentLinks
     */
    'preview_url'?: string | null;
    /**
     * Contains the URL to view the file if authorized, otherwise null.
     * @type {string}
     * @memberof AttachmentLinks
     */
    'original_url'?: string | null;
    /**
     * Contains the URL to download the original file with the given file name if authorized, otherwise null.
     * @type {string}
     * @memberof AttachmentLinks
     */
    'download_url'?: string | null;
    /**
     * URL to delete this attachment if authorized, otherwise null.
     * @type {string}
     * @memberof AttachmentLinks
     */
    'delete_url'?: string | null;
    /**
     * URL to update this attachment if authorized, otherwise null.
     * @type {string}
     * @memberof AttachmentLinks
     */
    'update_url'?: string | null;
}
/**
 * An attachment to be uploaded. May be a temporary or already persisted file. The API backend takes care of persisting them, when there is time.
 * @export
 * @interface AttachmentUpload
 */
export interface AttachmentUpload {
    /**
     * Display name for the file.
     * @type {string}
     * @memberof AttachmentUpload
     */
    'file_name': string | null;
    /**
     * Key of the uploaded file as returned by AWS, not the full URL.
     * @type {string}
     * @memberof AttachmentUpload
     */
    'stored_file': string;
    /**
     * A unique identifier for the file, assigned by the frontend in order to reference a file even before it is persisted.
     * @type {string}
     * @memberof AttachmentUpload
     */
    'frontend_id': string;
}
/**
 * Error class for API requests that have been rejected due to missing permissions. 
 * @export
 * @interface AuthorizationError
 */
export interface AuthorizationError {
    /**
     * The HTTP 4xx Error Code.
     * @type {number}
     * @memberof AuthorizationError
     */
    'code'?: number;
    /**
     * Short description of the reported error code.
     * @type {string}
     * @memberof AuthorizationError
     */
    'error'?: string;
    /**
     * Specific error message of the error.
     * @type {string}
     * @memberof AuthorizationError
     */
    'message'?: string;
    /**
     * 
     * @type {AuthorizationErrorDetails}
     * @memberof AuthorizationError
     */
    'details'?: AuthorizationErrorDetails;
}
/**
 * 
 * @export
 * @interface AuthorizationErrorDetails
 */
export interface AuthorizationErrorDetails {
    /**
     * Resource class on which the action should be performed.
     * @type {string}
     * @memberof AuthorizationErrorDetails
     */
    'class'?: string;
    /**
     * Policy of the resource that was forbidden.
     * @type {string}
     * @memberof AuthorizationErrorDetails
     */
    'query'?: string;
    /**
     * ID of the resource that was tried to perform an action on.
     * @type {number}
     * @memberof AuthorizationErrorDetails
     */
    'record_id'?: number;
    /**
     * Resource class on which the action should be performed.
     * @type {string}
     * @memberof AuthorizationErrorDetails
     */
    'record_class'?: string;
}
/**
 * 
 * @export
 * @interface AuthorizationErrorResourceClassDetails
 */
export interface AuthorizationErrorResourceClassDetails {
    /**
     * Resource class on which the action should be performed.
     * @type {string}
     * @memberof AuthorizationErrorResourceClassDetails
     */
    'class'?: string;
    /**
     * Policy of the resource that was forbidden.
     * @type {string}
     * @memberof AuthorizationErrorResourceClassDetails
     */
    'query'?: string;
}
/**
 * 
 * @export
 * @interface AuthorizationErrorResourceInstanceDetails
 */
export interface AuthorizationErrorResourceInstanceDetails {
    /**
     * ID of the resource that was tried to perform an action on.
     * @type {number}
     * @memberof AuthorizationErrorResourceInstanceDetails
     */
    'record_id'?: number;
    /**
     * Resource class on which the action should be performed.
     * @type {string}
     * @memberof AuthorizationErrorResourceInstanceDetails
     */
    'record_class'?: string;
    /**
     * Policy of the resource that was forbidden.
     * @type {string}
     * @memberof AuthorizationErrorResourceInstanceDetails
     */
    'query'?: string;
}
/**
 * Error class for API responses that failed due to validation errors of one or many dependant records (HTTP 424). 
 * @export
 * @interface BatchConversionError
 */
export interface BatchConversionError {
    /**
     * HTTP 424 Error Code.
     * @type {number}
     * @memberof BatchConversionError
     */
    'code'?: number;
    /**
     * Short description of the reported error code.
     * @type {string}
     * @memberof BatchConversionError
     */
    'error'?: string;
    /**
     * Localized error message summarizing the overall outcome of the batch operation.
     * @type {string}
     * @memberof BatchConversionError
     */
    'message'?: string;
    /**
     * 
     * @type {Array<BatchConversionErrorDetailsInner>}
     * @memberof BatchConversionError
     */
    'details'?: Array<BatchConversionErrorDetailsInner>;
}
/**
 * 
 * @export
 * @interface BatchConversionErrorDetailsInner
 */
export interface BatchConversionErrorDetailsInner {
    /**
     * The type and ID of the record that failed validation, e.g. PersonalRecord#42
     * @type {string}
     * @memberof BatchConversionErrorDetailsInner
     */
    'attributable'?: string;
    /**
     * The name of the record that failed validation so that the end user can find it.
     * @type {string}
     * @memberof BatchConversionErrorDetailsInner
     */
    'name'?: string;
    /**
     * The value that failed validation.
     * @type {string}
     * @memberof BatchConversionErrorDetailsInner
     */
    'value'?: string;
    /**
     * The error message from the validator.
     * @type {string}
     * @memberof BatchConversionErrorDetailsInner
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface BatchUpdateCustomAttributeValuesRequestInner
 */
export interface BatchUpdateCustomAttributeValuesRequestInner {
    /**
     * 
     * @type {number}
     * @memberof BatchUpdateCustomAttributeValuesRequestInner
     */
    'personal_record_id'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof BatchUpdateCustomAttributeValuesRequestInner
     */
    'club_record_id'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BatchUpdateCustomAttributeValuesRequestInner
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface Client
 */
export interface Client {
    /**
     * 
     * @type {number}
     * @memberof Client
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Client
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Client
     */
    'genitive': string | null;
    /**
     * 
     * @type {string}
     * @memberof Client
     */
    'subdomain': string;
    /**
     * 
     * @type {string}
     * @memberof Client
     */
    'prefix': string;
    /**
     * 
     * @type {string}
     * @memberof Client
     */
    'complete_name': string;
    /**
     * 
     * @type {string}
     * @memberof Client
     */
    'complete_name_with_prefix': string;
    /**
     * 
     * @type {string}
     * @memberof Client
     */
    'shortname': string | null;
    /**
     * 
     * @type {string}
     * @memberof Client
     */
    'client_address_without_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof Client
     */
    'complete_genitive': string | null;
    /**
     * 
     * @type {string}
     * @memberof Client
     */
    'ribbon_css': string;
    /**
     * 
     * @type {string}
     * @memberof Client
     */
    'percussion': string;
    /**
     * 
     * @type {string}
     * @memberof Client
     */
    'url': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof Client
     */
    'colors': Array<string>;
}
/**
 * An individual permission that can be granted to a member via a Group. The group has the ability assigned and all members have this ability while being member of the group. Each Client has a set of ClientAbilities that define the permissions that available for this client. If a permission is not available for a client, it cannot be assigned to any Group of that Client. 
 * @export
 * @enum {string}
 */

export const ClientAbility = {
    AccessGroups: 'ACCESS_GROUPS',
    DomainAdmin: 'DOMAIN_ADMIN',
    ModerateForum: 'MODERATE_FORUM',
    ReadUserProfile: 'READ_USER_PROFILE',
    ModifyAnyProfiles: 'MODIFY_ANY_PROFILES',
    ExportUsers: 'EXPORT_USERS',
    InviteUsers: 'INVITE_USERS',
    ViewGuestRecords: 'VIEW_GUEST_RECORDS',
    AddGuestRecord: 'ADD_GUEST_RECORD',
    ManageGuestRecord: 'MANAGE_GUEST_RECORD',
    ManageOpenEvents: 'MANAGE_OPEN_EVENTS',
    AccessDrive: 'ACCESS_DRIVE',
    ManageDrive: 'MANAGE_DRIVE',
    JoinOtherClients: 'JOIN_OTHER_CLIENTS',
    AccessEvents: 'ACCESS_EVENTS',
    AccessAddressLists: 'ACCESS_ADDRESS_LISTS',
    ManageAddressLists: 'MANAGE_ADDRESS_LISTS',
    SeeInvisibleMembers: 'SEE_INVISIBLE_MEMBERS',
    SendUrgentDigest: 'SEND_URGENT_DIGEST',
    DeleteMembers: 'DELETE_MEMBERS',
    MakeMembersInvisible: 'MAKE_MEMBERS_INVISIBLE'
} as const;

export type ClientAbility = typeof ClientAbility[keyof typeof ClientAbility];


/**
 * Request body to create a new Client.
 * @export
 * @interface ClientCreateRequest
 */
export interface ClientCreateRequest {
    /**
     * Prefix of the Client like \"Corps\".
     * @type {string}
     * @memberof ClientCreateRequest
     */
    'prefix'?: string | null;
    /**
     * Name of the Client without prefix (\'Corps\') or Umbrella additions (\'im KSCV\')
     * @type {string}
     * @memberof ClientCreateRequest
     */
    'name': string;
    /**
     * Any \'subtitle\' of the Client, like \'Traditionsträger der KDStV Testonia zu Musterstadt\'
     * @type {string}
     * @memberof ClientCreateRequest
     */
    'name_addition'?: string | null;
    /**
     * Leave empty to automatically create a subdomain.
     * @type {string}
     * @memberof ClientCreateRequest
     */
    'subdomain'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientCreateRequest
     */
    'genitive'?: string | null;
    /**
     * Shorthand name of the Umbrella to join e.g., CC, CV or KSCV.
     * @type {string}
     * @memberof ClientCreateRequest
     */
    'umbrella_id'?: string | null;
    /**
     * Must be given in the form of percussion top, color 1, ..., color n, percussion bottom as hex or web color.
     * @type {Array<string>}
     * @memberof ClientCreateRequest
     */
    'colors'?: Array<string> | null;
    /**
     * Either a precise date, with omitted day or year only. Can also take the form of a semester. 
     * @type {string}
     * @memberof ClientCreateRequest
     */
    'founded_at'?: string;
    /**
     * If the Client is extinct or merged into another Client.
     * @type {string}
     * @memberof ClientCreateRequest
     */
    'is_extinct'?: string;
    /**
     * Either a precise date, with omitted day or year only. Can also take the form of a semester. 
     * @type {string}
     * @memberof ClientCreateRequest
     */
    'extinct_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientCreateRequest
     */
    'attribute_for_coetanen'?: ClientCreateRequestAttributeForCoetanenEnum;
    /**
     * 
     * @type {string}
     * @memberof ClientCreateRequest
     */
    'c_o'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientCreateRequest
     */
    'street'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientCreateRequest
     */
    'postal_code'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientCreateRequest
     */
    'region'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientCreateRequest
     */
    'phone_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientCreateRequest
     */
    'facebook'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientCreateRequest
     */
    'twitter'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientCreateRequest
     */
    'instagram'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientCreateRequest
     */
    'website'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientCreateRequest
     */
    'fax_number'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientCreateRequest
     */
    'email'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientCreateRequest
     */
    'wahlspruch'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientCreateRequest
     */
    'waffenspruch'?: string | null;
    /**
     * URL of the file that should be linked during member signup as client specific terms and conditions.
     * @type {string}
     * @memberof ClientCreateRequest
     */
    'agb_url'?: string | null;
    /**
     * Replaces the list of ancestors of this client with this list. Linking one-way is sufficient.
     * @type {Array<number>}
     * @memberof ClientCreateRequest
     */
    'ancestor_ids'?: Array<number> | null;
    /**
     * Replaces the list of successors of this client with this list. Linking one-way is sufficient.
     * @type {Array<number>}
     * @memberof ClientCreateRequest
     */
    'successor_ids'?: Array<number> | null;
    /**
     * Replaces the list of levels of this client with this list.
     * @type {Array<number>}
     * @memberof ClientCreateRequest
     */
    'level_ids'?: Array<number> | null;
    /**
     * Replaces the list of available abilities of this client with this list.
     * @type {Array<string>}
     * @memberof ClientCreateRequest
     */
    'available_abilities'?: Array<string> | null;
}

export const ClientCreateRequestAttributeForCoetanenEnum = {
    RenonciertAt: 'renonciert_at',
    RecipiertAt: 'recipiert_at',
    PhilistriertAt: 'philistriert_at'
} as const;

export type ClientCreateRequestAttributeForCoetanenEnum = typeof ClientCreateRequestAttributeForCoetanenEnum[keyof typeof ClientCreateRequestAttributeForCoetanenEnum];

/**
 * 
 * @export
 * @interface ClientDetails
 */
export interface ClientDetails {
    /**
     * 
     * @type {number}
     * @memberof ClientDetails
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ClientDetails
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ClientDetails
     */
    'genitive': string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientDetails
     */
    'subdomain': string;
    /**
     * 
     * @type {string}
     * @memberof ClientDetails
     */
    'prefix': string;
    /**
     * 
     * @type {string}
     * @memberof ClientDetails
     */
    'complete_name': string;
    /**
     * 
     * @type {string}
     * @memberof ClientDetails
     */
    'complete_name_with_prefix': string;
    /**
     * 
     * @type {string}
     * @memberof ClientDetails
     */
    'shortname': string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientDetails
     */
    'client_address_without_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientDetails
     */
    'complete_genitive': string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientDetails
     */
    'ribbon_css': string;
    /**
     * 
     * @type {string}
     * @memberof ClientDetails
     */
    'percussion': string;
    /**
     * 
     * @type {string}
     * @memberof ClientDetails
     */
    'url': string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClientDetails
     */
    'colors': Array<string>;
    /**
     * The abilities that the admins of the client can assign to groups. Also admins of this client cannot have other abilities than in this list.
     * @type {Array<ClientAbility>}
     * @memberof ClientDetails
     */
    'available_abilities'?: Array<ClientAbility>;
    /**
     * The abilities that the admins of the client cannot assign to groups.
     * @type {Array<ClientAbility>}
     * @memberof ClientDetails
     */
    'unavailable_abilities'?: Array<ClientAbility>;
    /**
     * 
     * @type {Array<Client>}
     * @memberof ClientDetails
     */
    'ancestors'?: Array<Client>;
    /**
     * 
     * @type {Array<Client>}
     * @memberof ClientDetails
     */
    'successors'?: Array<Client>;
    /**
     * 
     * @type {Array<Level>}
     * @memberof ClientDetails
     */
    'levels'?: Array<Level>;
}
/**
 * General error class for API responses that failed due to mistakes made at client side, i.e. HTTP 4xx errors. Note that Internal Server Errors (HTTP 5xx) are not reported in a controlled way,  because they are exceptional responses due to bugs in the code or the infrastructre. 
 * @export
 * @interface ClientError
 */
export interface ClientError {
    /**
     * The HTTP 4xx Error Code.
     * @type {number}
     * @memberof ClientError
     */
    'code': number;
    /**
     * Short description of the reported error code.
     * @type {string}
     * @memberof ClientError
     */
    'error': string;
    /**
     * Specific error message of the error.
     * @type {string}
     * @memberof ClientError
     */
    'message': string;
}
/**
 * Health status information for a client
 * @export
 * @interface ClientHealth
 */
export interface ClientHealth {
    /**
     * Whether abilities are healthy
     * @type {boolean}
     * @memberof ClientHealth
     */
    'abilities': boolean;
    /**
     * Detailed ability fraction health checks
     * @type {{ [key: string]: ClientHealthAbilityFractionsValue; }}
     * @memberof ClientHealth
     */
    'ability_fractions': { [key: string]: ClientHealthAbilityFractionsValue; };
    /**
     * Active users health status
     * @type {boolean}
     * @memberof ClientHealth
     */
    'active_users': boolean | null;
    /**
     * Topics health status
     * @type {boolean}
     * @memberof ClientHealth
     */
    'topics': boolean | null;
    /**
     * Events health status
     * @type {boolean}
     * @memberof ClientHealth
     */
    'events': boolean | null;
    /**
     * Drive health status
     * @type {boolean}
     * @memberof ClientHealth
     */
    'drive': boolean | null;
    /**
     * Two week email open rate
     * @type {number}
     * @memberof ClientHealth
     */
    'two_week_open_rate': number | null;
    /**
     * 
     * @type {ClientHealthClientActivity}
     * @memberof ClientHealth
     */
    'client_activity': ClientHealthClientActivity;
    /**
     * 
     * @type {ClientHealthClientActivity}
     * @memberof ClientHealth
     */
    'level_activity': ClientHealthClientActivity;
}
/**
 * 
 * @export
 * @interface ClientHealthAbilityFractionsValue
 */
export interface ClientHealthAbilityFractionsValue {
    /**
     * 
     * @type {number}
     * @memberof ClientHealthAbilityFractionsValue
     */
    'fraction'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof ClientHealthAbilityFractionsValue
     */
    'healthy_range'?: Array<number>;
}
/**
 * 
 * @export
 * @interface ClientHealthClientActivity
 */
export interface ClientHealthClientActivity {
    /**
     * 
     * @type {number}
     * @memberof ClientHealthClientActivity
     */
    'last_month'?: number;
    /**
     * 
     * @type {number}
     * @memberof ClientHealthClientActivity
     */
    'last_three_months'?: number;
    /**
     * 
     * @type {number}
     * @memberof ClientHealthClientActivity
     */
    'since_activation'?: number;
}
/**
 * Statistics about clients and their members
 * @export
 * @interface ClientStats
 */
export interface ClientStats {
    /**
     * Statistics data as key-value pairs where keys are client names and values are counts
     * @type {{ [key: string]: number; }}
     * @memberof ClientStats
     */
    'stats': { [key: string]: number; };
    /**
     * Invalid records excluded from statistics
     * @type {Array<AgeStatsInvalidInner>}
     * @memberof ClientStats
     */
    'invalid': Array<AgeStatsInvalidInner>;
}
/**
 * A ClubRecord assigns a PersonalRecord to a Client, i.e. it represents a current or former membership at a Client. 
 * @export
 * @interface ClubRecord
 */
export interface ClubRecord {
    /**
     * 
     * @type {number}
     * @memberof ClubRecord
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof ClubRecord
     */
    'personal_record_id': number;
    /**
     * 
     * @type {number}
     * @memberof ClubRecord
     */
    'status_id': number;
    /**
     * 
     * @type {number}
     * @memberof ClubRecord
     */
    'client_id': number;
    /**
     * 
     * @type {number}
     * @memberof ClubRecord
     */
    'order': number;
    /**
     * 
     * @type {boolean}
     * @memberof ClubRecord
     */
    'verified': boolean;
    /**
     * 
     * @type {string}
     * @memberof ClubRecord
     */
    'vulgo': string | null;
    /**
     * 
     * @type {string}
     * @memberof ClubRecord
     */
    'chargen': string | null;
    /**
     * 
     * @type {number}
     * @memberof ClubRecord
     */
    'list_number': number | null;
    /**
     * 
     * @type {string}
     * @memberof ClubRecord
     */
    'internal_name_short': string;
    /**
     * 
     * @type {string}
     * @memberof ClubRecord
     */
    'internal_name_long': string;
    /**
     * 
     * @type {string}
     * @memberof ClubRecord
     */
    'umbrella_name_short': string;
    /**
     * 
     * @type {string}
     * @memberof ClubRecord
     */
    'umbrella_name_long': string;
    /**
     * 
     * @type {string}
     * @memberof ClubRecord
     */
    'list_name': string;
    /**
     * 
     * @type {string}
     * @memberof ClubRecord
     */
    'sort_key': string;
    /**
     * 
     * @type {string}
     * @memberof ClubRecord
     */
    'member_note': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ClubRecord
     */
    'is_awarded': boolean;
    /**
     * Either a precise date, with omitted day or year only. Can also take the form of a semester. 
     * @type {string}
     * @memberof ClubRecord
     */
    'awarded_at': string;
    /**
     * Either a precise date, with omitted day or year only. Can also take the form of a semester. 
     * @type {string}
     * @memberof ClubRecord
     */
    'renonciert_at': string;
    /**
     * Either a precise date, with omitted day or year only. Can also take the form of a semester. 
     * @type {string}
     * @memberof ClubRecord
     */
    'recipiert_at': string;
    /**
     * Either a precise date, with omitted day or year only. Can also take the form of a semester. 
     * @type {string}
     * @memberof ClubRecord
     */
    'philistriert_at': string;
    /**
     * Either a precise date, with omitted day or year only. Can also take the form of a semester. 
     * @type {string}
     * @memberof ClubRecord
     */
    'joined_at': string;
    /**
     * 
     * @type {boolean}
     * @memberof ClubRecord
     */
    'resigned': boolean;
    /**
     * Either a precise date, with omitted day or year only. Can also take the form of a semester. 
     * @type {string}
     * @memberof ClubRecord
     */
    'resigned_at': string;
    /**
     * 
     * @type {string}
     * @memberof ClubRecord
     */
    'resigned_reason': string | null;
    /**
     * 
     * @type {UploadedFile}
     * @memberof ClubRecord
     */
    'avatar': UploadedFile;
    /**
     * 
     * @type {boolean}
     * @memberof ClubRecord
     */
    'own_groups_in_forum': boolean;
    /**
     * 
     * @type {string}
     * @memberof ClubRecord
     */
    'note': string | null;
    /**
     * 
     * @type {string}
     * @memberof ClubRecord
     */
    'calendar_token': string;
    /**
     * 
     * @type {string}
     * @memberof ClubRecord
     */
    'token': string;
    /**
     * 
     * @type {number}
     * @memberof ClubRecord
     */
    'summary_freq': number;
    /**
     * 
     * @type {string}
     * @memberof ClubRecord
     */
    'last_summary_sent_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof ClubRecord
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof ClubRecord
     */
    'updated_at': string;
}
/**
 * A comment to a Post or Topic. 
 * @export
 * @interface Comment
 */
export interface Comment {
    /**
     * 
     * @type {number}
     * @memberof Comment
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Comment
     */
    'text': string;
    /**
     * 
     * @type {GroupMember}
     * @memberof Comment
     */
    'creator': GroupMember;
    /**
     * 
     * @type {Reaction}
     * @memberof Comment
     */
    'own_reaction': Reaction | null;
    /**
     * 
     * @type {number}
     * @memberof Comment
     */
    'likes_count': number;
    /**
     * 
     * @type {number}
     * @memberof Comment
     */
    'ideas_count': number;
    /**
     * 
     * @type {number}
     * @memberof Comment
     */
    'cheers_count': number;
    /**
     * 
     * @type {string}
     * @memberof Comment
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof Comment
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof Comment
     */
    'url': string;
    /**
     * 
     * @type {CommentLinks}
     * @memberof Comment
     */
    'links': CommentLinks;
}
/**
 * 
 * @export
 * @interface CommentLinks
 */
export interface CommentLinks {
    /**
     * 
     * @type {string}
     * @memberof CommentLinks
     */
    'update_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CommentLinks
     */
    'delete_url'?: string | null;
    /**
     * 
     * @type {CommentLinksReactions}
     * @memberof CommentLinks
     */
    'reactions'?: CommentLinksReactions;
}
/**
 * 
 * @export
 * @interface CommentLinksReactions
 */
export interface CommentLinksReactions {
    /**
     * 
     * @type {string}
     * @memberof CommentLinksReactions
     */
    'create_url'?: string | null;
}
/**
 * Request body to create a new Comment.
 * @export
 * @interface CommentRequest
 */
export interface CommentRequest {
    /**
     * Text of the comment
     * @type {string}
     * @memberof CommentRequest
     */
    'text': string;
}
/**
 * Create a new Custom Attribute Definition.
 * @export
 * @interface CreateCustomAttributeDefinitionRequest
 */
export interface CreateCustomAttributeDefinitionRequest {
    /**
     * The human readable name of the attribute.
     * @type {string}
     * @memberof CreateCustomAttributeDefinitionRequest
     */
    'name': string;
    /**
     * A description of the Custom Attribute for the user.
     * @type {string}
     * @memberof CreateCustomAttributeDefinitionRequest
     */
    'description'?: string | null;
    /**
     * 
     * @type {CustomAttributeTypeEnum}
     * @memberof CreateCustomAttributeDefinitionRequest
     */
    'attribute_type': CustomAttributeTypeEnum;
    /**
     * Additional settings for certain attribute types:   - For Select: An array of strings representing the possible values. 
     * @type {Array<string>}
     * @memberof CreateCustomAttributeDefinitionRequest
     */
    'config'?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof CreateCustomAttributeDefinitionRequest
     */
    'attributable_type': CreateCustomAttributeDefinitionRequestAttributableTypeEnum;
    /**
     * Set to true to hide the field when viewing the profile if it is empty.
     * @type {boolean}
     * @memberof CreateCustomAttributeDefinitionRequest
     */
    'hide_when_empty'?: boolean;
    /**
     * 
     * @type {CustomAttributeReadAccessEnum}
     * @memberof CreateCustomAttributeDefinitionRequest
     */
    'read_access'?: CustomAttributeReadAccessEnum;
    /**
     * 
     * @type {CustomAttributeWriteAccessEnum}
     * @memberof CreateCustomAttributeDefinitionRequest
     */
    'write_access'?: CustomAttributeWriteAccessEnum;
    /**
     * Index used for ordering relative to sibling CustomAttributeDefintions of this attributable.
     * @type {number}
     * @memberof CreateCustomAttributeDefinitionRequest
     */
    'index'?: number | null;
    /**
     * If true, the attribute will be moved to the front of the list at its attributable.
     * @type {boolean}
     * @memberof CreateCustomAttributeDefinitionRequest
     */
    'send_to_front'?: boolean | null;
    /**
     * If true, the attribute will be moved to the back of the list at its attributable.
     * @type {boolean}
     * @memberof CreateCustomAttributeDefinitionRequest
     */
    'send_to_back'?: boolean | null;
}

export const CreateCustomAttributeDefinitionRequestAttributableTypeEnum = {
    ClubRecord: 'ClubRecord',
    PersonalRecord: 'PersonalRecord'
} as const;

export type CreateCustomAttributeDefinitionRequestAttributableTypeEnum = typeof CreateCustomAttributeDefinitionRequestAttributableTypeEnum[keyof typeof CreateCustomAttributeDefinitionRequestAttributableTypeEnum];

/**
 * 
 * @export
 * @interface CreateUmbrella422Response
 */
export interface CreateUmbrella422Response {
    /**
     * 
     * @type {object}
     * @memberof CreateUmbrella422Response
     */
    'errors'?: object;
}
/**
 * The currently logged in user using its membership of the current client. 
 * @export
 * @interface CurrentMember
 */
export interface CurrentMember {
    /**
     * The ID of the ClubRecord which is the ID of the Member.
     * @type {number}
     * @memberof CurrentMember
     */
    'id': number;
    /**
     * ID of the User which represents the Account used for authentication.
     * @type {number}
     * @memberof CurrentMember
     */
    'user_id': number;
    /**
     * 
     * @type {Client}
     * @memberof CurrentMember
     */
    'client': Client;
    /**
     * 
     * @type {PersonalRecord}
     * @memberof CurrentMember
     */
    'personal_record': PersonalRecord;
    /**
     * 
     * @type {Array<Level>}
     * @memberof CurrentMember
     */
    'levels': Array<Level>;
    /**
     * 
     * @type {Array<ClubRecord>}
     * @memberof CurrentMember
     */
    'club_records': Array<ClubRecord>;
    /**
     * 
     * @type {Array<number>}
     * @memberof CurrentMember
     */
    'group_memberships': Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CurrentMember
     */
    'level_permissions': Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof CurrentMember
     */
    'client_permissions': Array<string> | null;
}
/**
 * Response for batch update of custom attributes
 * @export
 * @interface CustomAttributeBatchUpdateResponse
 */
export interface CustomAttributeBatchUpdateResponse {
    /**
     * Number of records successfully updated
     * @type {number}
     * @memberof CustomAttributeBatchUpdateResponse
     */
    'updated_records_count': number;
    /**
     * Array of any possible errors of items that could not be updated
     * @type {Array<CustomAttributeBatchUpdateResponseRecordsNotUpdatedInner>}
     * @memberof CustomAttributeBatchUpdateResponse
     */
    'records_not_updated': Array<CustomAttributeBatchUpdateResponseRecordsNotUpdatedInner>;
}
/**
 * 
 * @export
 * @interface CustomAttributeBatchUpdateResponseRecordsNotUpdatedInner
 */
export interface CustomAttributeBatchUpdateResponseRecordsNotUpdatedInner {
    /**
     * ID of the record that could not be updated
     * @type {string}
     * @memberof CustomAttributeBatchUpdateResponseRecordsNotUpdatedInner
     */
    'record_id'?: string;
    /**
     * 
     * @type {CustomAttributeBatchUpdateResponseRecordsNotUpdatedInnerError}
     * @memberof CustomAttributeBatchUpdateResponseRecordsNotUpdatedInner
     */
    'error'?: CustomAttributeBatchUpdateResponseRecordsNotUpdatedInnerError;
}
/**
 * 
 * @export
 * @interface CustomAttributeBatchUpdateResponseRecordsNotUpdatedInnerError
 */
export interface CustomAttributeBatchUpdateResponseRecordsNotUpdatedInnerError {
    /**
     * The HTTP 4xx Error Code.
     * @type {number}
     * @memberof CustomAttributeBatchUpdateResponseRecordsNotUpdatedInnerError
     */
    'code': number;
    /**
     * Short description of the reported error code.
     * @type {string}
     * @memberof CustomAttributeBatchUpdateResponseRecordsNotUpdatedInnerError
     */
    'error': string;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof CustomAttributeBatchUpdateResponseRecordsNotUpdatedInnerError
     */
    'message': { [key: string]: Array<string>; };
    /**
     * 
     * @type {{ [key: string]: Array<ValidationErrorDetailsValueInner>; }}
     * @memberof CustomAttributeBatchUpdateResponseRecordsNotUpdatedInnerError
     */
    'details'?: { [key: string]: Array<ValidationErrorDetailsValueInner>; } | null;
}
/**
 * Describes an extension of the native data model for members of that client or level.
 * @export
 * @interface CustomAttributeDefinition
 */
export interface CustomAttributeDefinition {
    /**
     * The internal ID of the attribute definition.
     * @type {number}
     * @memberof CustomAttributeDefinition
     */
    'id': number;
    /**
     * The human readable name of the attribute.
     * @type {string}
     * @memberof CustomAttributeDefinition
     */
    'name': string;
    /**
     * The identifier of this attribute to be used in templates.
     * @type {string}
     * @memberof CustomAttributeDefinition
     */
    'template_name': string;
    /**
     * A description of the Custom Attribute for the user.
     * @type {string}
     * @memberof CustomAttributeDefinition
     */
    'description': string | null;
    /**
     * 
     * @type {CustomAttributeTypeEnum}
     * @memberof CustomAttributeDefinition
     */
    'attribute_type': CustomAttributeTypeEnum;
    /**
     * Additional settings for certain attribute types:   - For Select: An array of strings representing the possible values. 
     * @type {Array<string>}
     * @memberof CustomAttributeDefinition
     */
    'config': Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof CustomAttributeDefinition
     */
    'attributable_type': CustomAttributeDefinitionAttributableTypeEnum;
    /**
     * Set to true to hide the field when viewing the profile if it is empty.
     * @type {boolean}
     * @memberof CustomAttributeDefinition
     */
    'hide_when_empty': boolean;
    /**
     * 
     * @type {CustomAttributeReadAccessEnum}
     * @memberof CustomAttributeDefinition
     */
    'read_access': CustomAttributeReadAccessEnum;
    /**
     * 
     * @type {CustomAttributeWriteAccessEnum}
     * @memberof CustomAttributeDefinition
     */
    'write_access': CustomAttributeWriteAccessEnum;
    /**
     * Leave null if you want to define a level attribute.
     * @type {number}
     * @memberof CustomAttributeDefinition
     */
    'client_id': number | null;
    /**
     * Leave null if you want to define a client attribute.
     * @type {number}
     * @memberof CustomAttributeDefinition
     */
    'level_id': number | null;
    /**
     * Index used for ordering relative to sibling CustomAttributeDefintions of this attributable.
     * @type {number}
     * @memberof CustomAttributeDefinition
     */
    'index': number | null;
    /**
     * If true, then the attribute is locked for further modifications as there is an update running in the background. Requests to update this CustomAttributeDefinition will return a HTTP 423 (Locked) response.
     * @type {boolean}
     * @memberof CustomAttributeDefinition
     */
    'update_in_progress': boolean;
}

export const CustomAttributeDefinitionAttributableTypeEnum = {
    ClubRecord: 'ClubRecord',
    PersonalRecord: 'PersonalRecord'
} as const;

export type CustomAttributeDefinitionAttributableTypeEnum = typeof CustomAttributeDefinitionAttributableTypeEnum[keyof typeof CustomAttributeDefinitionAttributableTypeEnum];

/**
 * The read access level of the attribute. If the attribute is not readable by the user, the attribute is not shown at all. - readable_by_viewers: All users can read the attribute which can view the related record. - readable_by_editors: Only editors of the related record can see this attribute. Note that this is independent from the write access of the attribute itself. - readable_by_managers: Only managers can see the attribute, but not the user himself or other regular users. A manager is a user with ability MANAGE_PROFILES if CustomAttribute is owned by a Client, resp. MODIFY_ANY_PROFILES if owned by a Level. - readable_by_admins: Only admins can see the attribute. An admin is a user with ability DOMAIN_ADMIN if CustomAttribute is owned by a Client, resp. LEVEL_ADMIN if owned by a Level.
 * @export
 * @enum {string}
 */

export const CustomAttributeReadAccessEnum = {
    Admins: 'readable_by_admins',
    Managers: 'readable_by_managers',
    Editors: 'readable_by_editors',
    Viewers: 'readable_by_viewers'
} as const;

export type CustomAttributeReadAccessEnum = typeof CustomAttributeReadAccessEnum[keyof typeof CustomAttributeReadAccessEnum];


/**
 * How the custom attribute shall be displayed and validated.
 * @export
 * @enum {string}
 */

export const CustomAttributeTypeEnum = {
    Boolean: 'Boolean',
    Integer: 'Integer',
    Float: 'Float',
    String: 'String',
    Text: 'Text',
    Date: 'Date',
    Select: 'Select',
    FuzzyDate: 'FuzzyDate'
} as const;

export type CustomAttributeTypeEnum = typeof CustomAttributeTypeEnum[keyof typeof CustomAttributeTypeEnum];


/**
 * The write access level of the attribute. Note that this is independent from the read access of the attribute itself. - writeable_by_editors: Everyone who may update the belonging record can also update the attribute\'s value. - writeable_by_managers: Only managers can update the attribute\'s value, but not the user himself when editing his own profile. A \"manager\" is a user with ability MANAGE_PROFILES if CustomAttribute is owned by a Client, resp. MODIFY_ANY_PROFILES if owned by a Level. - writeable_by_admins: Only admins can update the attribute\'s value. An \"admin\" is a user with ability DOMAIN_ADMIN if CustomAttribute is owned by a Client, resp. LEVEL_ADMIN if owned by a Level.
 * @export
 * @enum {string}
 */

export const CustomAttributeWriteAccessEnum = {
    Admins: 'writeable_by_admins',
    Managers: 'writeable_by_managers',
    Editors: 'writeable_by_editors'
} as const;

export type CustomAttributeWriteAccessEnum = typeof CustomAttributeWriteAccessEnum[keyof typeof CustomAttributeWriteAccessEnum];


/**
 * 
 * @export
 * @interface DetailedEvent
 */
export interface DetailedEvent {
    /**
     * 
     * @type {number}
     * @memberof DetailedEvent
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof DetailedEvent
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof DetailedEvent
     */
    'description': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DetailedEvent
     */
    'all_day': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailedEvent
     */
    'open_ended': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailedEvent
     */
    'start_at': string;
    /**
     * 
     * @type {string}
     * @memberof DetailedEvent
     */
    'start_date': string;
    /**
     * 
     * @type {string}
     * @memberof DetailedEvent
     */
    'start_time': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailedEvent
     */
    'end_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailedEvent
     */
    'end_date': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailedEvent
     */
    'end_time': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailedEvent
     */
    'location': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DetailedEvent
     */
    'online': boolean;
    /**
     * URL for the call, if the event is online. Only shown if permitted to join the event.
     * @type {string}
     * @memberof DetailedEvent
     */
    'custom_call_url': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DetailedEvent
     */
    'is_public': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailedEvent
     */
    'allow_guests': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailedEvent
     */
    'nonmember_access': DetailedEventNonmemberAccessEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof DetailedEvent
     */
    'reminders': Array<DetailedEventRemindersEnum>;
    /**
     * 
     * @type {boolean}
     * @memberof DetailedEvent
     */
    'urgent': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailedEvent
     */
    'mailed_at': string | null;
    /**
     * 
     * @type {Group}
     * @memberof DetailedEvent
     */
    'group': Group;
    /**
     * 
     * @type {number}
     * @memberof DetailedEvent
     */
    'group_id': number;
    /**
     * 
     * @type {number}
     * @memberof DetailedEvent
     */
    'level_id': number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailedEvent
     */
    'client_id': number | null;
    /**
     * Total number of members that have replied to the invitation with \'attend\'
     * @type {number}
     * @memberof DetailedEvent
     */
    'attends_count': number;
    /**
     * Total number of members that have replied to the invitation with \'decline\'
     * @type {number}
     * @memberof DetailedEvent
     */
    'declines_count': number;
    /**
     * Total number of members that have not yet replied to the invitation
     * @type {number}
     * @memberof DetailedEvent
     */
    'pendings_count': number;
    /**
     * Total number of guests that will accompany members having replied to the invitation with \'attend\'
     * @type {number}
     * @memberof DetailedEvent
     */
    'guests_count': number;
    /**
     * Total number of posts of this Event.
     * @type {number}
     * @memberof DetailedEvent
     */
    'posts_count': number;
    /**
     * Total number of highlights of this Event.
     * @type {number}
     * @memberof DetailedEvent
     */
    'highlights_count': number;
    /**
     * 
     * @type {string}
     * @memberof DetailedEvent
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof DetailedEvent
     */
    'updated_at': string;
    /**
     * 
     * @type {DetailedEventFeaturedImage}
     * @memberof DetailedEvent
     */
    'featured_image'?: DetailedEventFeaturedImage | null;
    /**
     * 
     * @type {string}
     * @memberof DetailedEvent
     */
    'contact_type'?: string;
    /**
     * 
     * @type {DetailedEventContact}
     * @memberof DetailedEvent
     */
    'contact'?: DetailedEventContact;
    /**
     * 
     * @type {DetailedEventMailedBy}
     * @memberof DetailedEvent
     */
    'mailed_by'?: DetailedEventMailedBy | null;
    /**
     * 
     * @type {GroupMember}
     * @memberof DetailedEvent
     */
    'creator'?: GroupMember;
    /**
     * 
     * @type {DetailedEventOrganization}
     * @memberof DetailedEvent
     */
    'organization'?: DetailedEventOrganization;
    /**
     * 
     * @type {Array<Attachment>}
     * @memberof DetailedEvent
     */
    'attachments'?: Array<Attachment>;
    /**
     * 
     * @type {Array<DetailedEventContributors>}
     * @memberof DetailedEvent
     */
    'contributors'?: Array<DetailedEventContributors>;
    /**
     * 
     * @type {DetailedEventLinks}
     * @memberof DetailedEvent
     */
    'links'?: DetailedEventLinks;
}

export const DetailedEventNonmemberAccessEnum = {
    Read: 'read',
    Write: 'write',
    Hidden: 'hidden'
} as const;

export type DetailedEventNonmemberAccessEnum = typeof DetailedEventNonmemberAccessEnum[keyof typeof DetailedEventNonmemberAccessEnum];
export const DetailedEventRemindersEnum = {
    EighteenMonths: 'eighteen_months',
    TwelveMonths: 'twelve_months',
    SixMonths: 'six_months',
    ThreeMonths: 'three_months',
    TwoMonths: 'two_months',
    OneMonth: 'one_month',
    TwoWeeks: 'two_weeks',
    OnCreation: 'on_creation'
} as const;

export type DetailedEventRemindersEnum = typeof DetailedEventRemindersEnum[keyof typeof DetailedEventRemindersEnum];

/**
 * 
 * @export
 * @interface DetailedEventContact
 */
export interface DetailedEventContact {
    /**
     * 
     * @type {number}
     * @memberof DetailedEventContact
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof DetailedEventContact
     */
    'user_id'?: number | null;
    /**
     * First name of the person
     * @type {string}
     * @memberof DetailedEventContact
     */
    'first_name': string;
    /**
     * Last name of the person
     * @type {string}
     * @memberof DetailedEventContact
     */
    'last_name': string;
    /**
     * First and last name seperated by a space.
     * @type {string}
     * @memberof DetailedEventContact
     */
    'full_name': string;
    /**
     * Long internal name to be used in the context of the client of the GroupMember. Contains the `internal_name_long` of the `ClubRecord` of the current client. If no ClubRecord of the GroupMember matches the current client, it contains the `internal_name_long` of the `ClubRecord` of the first joined `Client`. 
     * @type {string}
     * @memberof DetailedEventContact
     */
    'internal_name_long': string;
    /**
     * Short internal name to be used in the context of the client of the GroupMember. Contains the `internal_name_short` of the `ClubRecord` of the current client. If no ClubRecord of the  GroupMember matches the current client, it contains the `internal_name_short` of the `ClubRecord` of the first joined `Client`. 
     * @type {string}
     * @memberof DetailedEventContact
     */
    'internal_name_short': string;
    /**
     * Short name of the GroupMember, to be used in context of `Level`s. Contains the `umbrella_name_short` from a ClubRecord that matches the current `Umbrella` the the current client. If none, it is the `umbrella_name_short` of the first joined client. 
     * @type {string}
     * @memberof DetailedEventContact
     */
    'umbrella_name_short': string;
    /**
     * Long name of the GroupMember, to be used in context of `Level`s. Contains the `umbrella_name_long` from a ClubRecord that matches the current `Umbrella` the the current  client. If none, it is the `umbrella_name_long` of the first joined client. 
     * @type {string}
     * @memberof DetailedEventContact
     */
    'umbrella_name_long': string;
    /**
     * A key for lexicographical ordering of GroupMembers. Yields a sorting by first joined client, last name (without nobility particel), first name,  other clients in order by name. 
     * @type {string}
     * @memberof DetailedEventContact
     */
    'global_name_for_sorting': string;
    /**
     * True if the GroupMember has a ClubRecord at the current client
     * @type {boolean}
     * @memberof DetailedEventContact
     */
    'is_member': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailedEventContact
     */
    'alive': boolean;
    /**
     * If true this user is invisible to everyone not allowed to see invisible users. When you see this being truthy, you are apparently permitted.
     * @type {boolean}
     * @memberof DetailedEventContact
     */
    'invisible': boolean;
    /**
     * If false the GroupMember has no verified ClubRecord yet.
     * @type {boolean}
     * @memberof DetailedEventContact
     */
    'verified': boolean;
    /**
     * True if 1) the GroupMember is member of the current client and has resigned at the current client or 2) the GroupMember is from other client(s) and has resigned from all of them.
     * @type {boolean}
     * @memberof DetailedEventContact
     */
    'resigned': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailedEventContact
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof DetailedEventContact
     */
    'avatar_url': string;
    /**
     * 
     * @type {Client}
     * @memberof DetailedEventContact
     */
    'client'?: Client;
    /**
     * 
     * @type {PersonalRecord}
     * @memberof DetailedEventContact
     */
    'personal_record'?: PersonalRecord;
    /**
     * 
     * @type {Array<Client>}
     * @memberof DetailedEventContact
     */
    'clients': Array<Client>;
    /**
     * 
     * @type {Array<ClubRecord>}
     * @memberof DetailedEventContact
     */
    'club_records'?: Array<ClubRecord>;
    /**
     * 
     * @type {Array<Level>}
     * @memberof DetailedEventContact
     */
    'levels'?: Array<Level>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DetailedEventContact
     */
    'level_permissions'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DetailedEventContact
     */
    'client_permissions'?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof DetailedEventContact
     */
    'group_memberships'?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof DetailedEventContact
     */
    'updated_at': string;
    /**
     * 
     * @type {GroupType}
     * @memberof DetailedEventContact
     */
    'type': GroupType;
    /**
     * 
     * @type {string}
     * @memberof DetailedEventContact
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailedEventContact
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailedEventContact
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof DetailedEventContact
     */
    'prefix'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailedEventContact
     */
    'suffix'?: string;
    /**
     * 
     * @type {number}
     * @memberof DetailedEventContact
     */
    'list_order': number;
    /**
     * 
     * @type {number}
     * @memberof DetailedEventContact
     */
    'sort_order': number;
    /**
     * 
     * @type {number}
     * @memberof DetailedEventContact
     */
    'members_count': number;
    /**
     * 
     * @type {boolean}
     * @memberof DetailedEventContact
     */
    'has_forum'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailedEventContact
     */
    'searchable': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailedEventContact
     */
    'closed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailedEventContact
     */
    'exclusive_subgroup': boolean;
    /**
     * 
     * @type {string}
     * @memberof DetailedEventContact
     */
    'more_information': string;
    /**
     * 
     * @type {boolean}
     * @memberof DetailedEventContact
     */
    'has_calendar': boolean;
    /**
     * 
     * @type {Array<AbilitiesInner>}
     * @memberof DetailedEventContact
     */
    'abilities'?: Array<AbilitiesInner>;
    /**
     * 
     * @type {number}
     * @memberof DetailedEventContact
     */
    'client_id'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DetailedEventContact
     */
    'level_id'?: number | null;
    /**
     * 
     * @type {Level}
     * @memberof DetailedEventContact
     */
    'level'?: Level;
    /**
     * 
     * @type {number}
     * @memberof DetailedEventContact
     */
    'voting_group_id'?: number | null;
    /**
     * 
     * @type {Group}
     * @memberof DetailedEventContact
     */
    'voting_group'?: Group;
    /**
     * 
     * @type {number}
     * @memberof DetailedEventContact
     */
    'parent_id'?: number | null;
    /**
     * 
     * @type {Group}
     * @memberof DetailedEventContact
     */
    'parent'?: Group;
    /**
     * 
     * @type {string}
     * @memberof DetailedEventContact
     */
    'path'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailedEventContact
     */
    'join_path'?: string | null;
    /**
     * 
     * @type {GroupLinks}
     * @memberof DetailedEventContact
     */
    'links'?: GroupLinks;
}


/**
 * 
 * @export
 * @interface DetailedEventContributors
 */
export interface DetailedEventContributors {
    /**
     * 
     * @type {number}
     * @memberof DetailedEventContributors
     */
    'highlights_count'?: number;
    /**
     * 
     * @type {GroupMember}
     * @memberof DetailedEventContributors
     */
    'group_member'?: GroupMember;
}
/**
 * 
 * @export
 * @interface DetailedEventFeaturedImage
 */
export interface DetailedEventFeaturedImage {
    /**
     * 
     * @type {number}
     * @memberof DetailedEventFeaturedImage
     */
    'id': number;
    /**
     * General classification of the file type to decide whether to treat as an file with an image preview.
     * @type {string}
     * @memberof DetailedEventFeaturedImage
     */
    'type': DetailedEventFeaturedImageTypeEnum;
    /**
     * Name of the file, excluding the file type extension.
     * @type {string}
     * @memberof DetailedEventFeaturedImage
     */
    'file_name': string;
    /**
     * Horizontal dimension of the original file in pixel.
     * @type {number}
     * @memberof DetailedEventFeaturedImage
     */
    'width'?: number | null;
    /**
     * Vertical dimension of the original file in pixel.
     * @type {number}
     * @memberof DetailedEventFeaturedImage
     */
    'height'?: number | null;
    /**
     * File size in Byte
     * @type {number}
     * @memberof DetailedEventFeaturedImage
     */
    'file_size': number | null;
    /**
     * MIME Type of the file. May be null if the type could not be determined or was unknown.
     * @type {string}
     * @memberof DetailedEventFeaturedImage
     */
    'content_type': string | null;
    /**
     * File type extension of the detected mime type.
     * @type {string}
     * @memberof DetailedEventFeaturedImage
     */
    'file_type_extension': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailedEventFeaturedImage
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof DetailedEventFeaturedImage
     */
    'created_at': string;
    /**
     * 
     * @type {UploadedFileUploadedBy}
     * @memberof DetailedEventFeaturedImage
     */
    'uploaded_by': UploadedFileUploadedBy | null;
    /**
     * 
     * @type {UploadedFileOriginal}
     * @memberof DetailedEventFeaturedImage
     */
    'original'?: UploadedFileOriginal;
    /**
     * 
     * @type {UploadedFileOriginal}
     * @memberof DetailedEventFeaturedImage
     */
    'preview'?: UploadedFileOriginal;
    /**
     * 
     * @type {UploadedFileOriginal}
     * @memberof DetailedEventFeaturedImage
     */
    'thumb'?: UploadedFileOriginal;
    /**
     * 
     * @type {UploadedFileOriginal}
     * @memberof DetailedEventFeaturedImage
     */
    'icon'?: UploadedFileOriginal;
    /**
     * 
     * @type {UploadedFileLinks}
     * @memberof DetailedEventFeaturedImage
     */
    'links'?: UploadedFileLinks;
}

export const DetailedEventFeaturedImageTypeEnum = {
    File: 'File',
    Image: 'Image'
} as const;

export type DetailedEventFeaturedImageTypeEnum = typeof DetailedEventFeaturedImageTypeEnum[keyof typeof DetailedEventFeaturedImageTypeEnum];

/**
 * 
 * @export
 * @interface DetailedEventLinks
 */
export interface DetailedEventLinks {
    /**
     * 
     * @type {string}
     * @memberof DetailedEventLinks
     */
    'self_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailedEventLinks
     */
    'rsvps_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailedEventLinks
     */
    'update_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailedEventLinks
     */
    'delete_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailedEventLinks
     */
    'attend_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailedEventLinks
     */
    'decline_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailedEventLinks
     */
    'publish_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailedEventLinks
     */
    'unpublish_url'?: string | null;
    /**
     * 
     * @type {DetailedEventLinksPosts}
     * @memberof DetailedEventLinks
     */
    'posts'?: DetailedEventLinksPosts | null;
}
/**
 * 
 * @export
 * @interface DetailedEventLinksPosts
 */
export interface DetailedEventLinksPosts {
    /**
     * 
     * @type {string}
     * @memberof DetailedEventLinksPosts
     */
    'create_url'?: string | null;
}
/**
 * 
 * @export
 * @interface DetailedEventMailedBy
 */
export interface DetailedEventMailedBy {
    /**
     * 
     * @type {number}
     * @memberof DetailedEventMailedBy
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof DetailedEventMailedBy
     */
    'user_id'?: number | null;
    /**
     * First name of the person
     * @type {string}
     * @memberof DetailedEventMailedBy
     */
    'first_name': string;
    /**
     * Last name of the person
     * @type {string}
     * @memberof DetailedEventMailedBy
     */
    'last_name': string;
    /**
     * First and last name seperated by a space.
     * @type {string}
     * @memberof DetailedEventMailedBy
     */
    'full_name': string;
    /**
     * Long internal name to be used in the context of the client of the GroupMember. Contains the `internal_name_long` of the `ClubRecord` of the current client. If no ClubRecord of the GroupMember matches the current client, it contains the `internal_name_long` of the `ClubRecord` of the first joined `Client`. 
     * @type {string}
     * @memberof DetailedEventMailedBy
     */
    'internal_name_long': string;
    /**
     * Short internal name to be used in the context of the client of the GroupMember. Contains the `internal_name_short` of the `ClubRecord` of the current client. If no ClubRecord of the  GroupMember matches the current client, it contains the `internal_name_short` of the `ClubRecord` of the first joined `Client`. 
     * @type {string}
     * @memberof DetailedEventMailedBy
     */
    'internal_name_short': string;
    /**
     * Short name of the GroupMember, to be used in context of `Level`s. Contains the `umbrella_name_short` from a ClubRecord that matches the current `Umbrella` the the current client. If none, it is the `umbrella_name_short` of the first joined client. 
     * @type {string}
     * @memberof DetailedEventMailedBy
     */
    'umbrella_name_short': string;
    /**
     * Long name of the GroupMember, to be used in context of `Level`s. Contains the `umbrella_name_long` from a ClubRecord that matches the current `Umbrella` the the current  client. If none, it is the `umbrella_name_long` of the first joined client. 
     * @type {string}
     * @memberof DetailedEventMailedBy
     */
    'umbrella_name_long': string;
    /**
     * A key for lexicographical ordering of GroupMembers. Yields a sorting by first joined client, last name (without nobility particel), first name,  other clients in order by name. 
     * @type {string}
     * @memberof DetailedEventMailedBy
     */
    'global_name_for_sorting': string;
    /**
     * True if the GroupMember has a ClubRecord at the current client
     * @type {boolean}
     * @memberof DetailedEventMailedBy
     */
    'is_member': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DetailedEventMailedBy
     */
    'alive': boolean;
    /**
     * If true this user is invisible to everyone not allowed to see invisible users. When you see this being truthy, you are apparently permitted.
     * @type {boolean}
     * @memberof DetailedEventMailedBy
     */
    'invisible': boolean;
    /**
     * If false the GroupMember has no verified ClubRecord yet.
     * @type {boolean}
     * @memberof DetailedEventMailedBy
     */
    'verified': boolean;
    /**
     * True if 1) the GroupMember is member of the current client and has resigned at the current client or 2) the GroupMember is from other client(s) and has resigned from all of them.
     * @type {boolean}
     * @memberof DetailedEventMailedBy
     */
    'resigned': boolean;
    /**
     * Link to the profile page of the person. Null if viewing the profile is not allowed to the current user.
     * @type {string}
     * @memberof DetailedEventMailedBy
     */
    'url': string | null;
    /**
     * 
     * @type {string}
     * @memberof DetailedEventMailedBy
     */
    'avatar_url': string;
    /**
     * 
     * @type {Client}
     * @memberof DetailedEventMailedBy
     */
    'client'?: Client;
    /**
     * 
     * @type {PersonalRecord}
     * @memberof DetailedEventMailedBy
     */
    'personal_record'?: PersonalRecord;
    /**
     * 
     * @type {Array<Client>}
     * @memberof DetailedEventMailedBy
     */
    'clients': Array<Client>;
    /**
     * 
     * @type {Array<ClubRecord>}
     * @memberof DetailedEventMailedBy
     */
    'club_records'?: Array<ClubRecord>;
    /**
     * 
     * @type {Array<Level>}
     * @memberof DetailedEventMailedBy
     */
    'levels'?: Array<Level>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DetailedEventMailedBy
     */
    'level_permissions'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DetailedEventMailedBy
     */
    'client_permissions'?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof DetailedEventMailedBy
     */
    'group_memberships'?: Array<number>;
    /**
     * Timestamp of the latest change of any of the dependent records of this view. It is the max updated_at timestamp from any of its ClubRecords, Clients and PersonalRecord.
     * @type {string}
     * @memberof DetailedEventMailedBy
     */
    'updated_at': string;
}
/**
 * 
 * @export
 * @interface DetailedEventOrganization
 */
export interface DetailedEventOrganization {
    /**
     * 
     * @type {number}
     * @memberof DetailedEventOrganization
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof DetailedEventOrganization
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailedEventOrganization
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof DetailedEventOrganization
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface DigestEvent
 */
export interface DigestEvent {
    /**
     * 
     * @type {number}
     * @memberof DigestEvent
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof DigestEvent
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof DigestEvent
     */
    'description': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DigestEvent
     */
    'all_day': boolean;
    /**
     * 
     * @type {string}
     * @memberof DigestEvent
     */
    'start_at': string;
    /**
     * 
     * @type {string}
     * @memberof DigestEvent
     */
    'start_date': string;
    /**
     * 
     * @type {string}
     * @memberof DigestEvent
     */
    'start_time': string | null;
    /**
     * 
     * @type {string}
     * @memberof DigestEvent
     */
    'end_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof DigestEvent
     */
    'end_date': string | null;
    /**
     * 
     * @type {string}
     * @memberof DigestEvent
     */
    'end_time': string | null;
    /**
     * 
     * @type {string}
     * @memberof DigestEvent
     */
    'location': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DigestEvent
     */
    'online': boolean;
    /**
     * 
     * @type {string}
     * @memberof DigestEvent
     */
    'custom_call_url': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof DigestEvent
     */
    'is_public': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DigestEvent
     */
    'allow_guests': boolean;
    /**
     * 
     * @type {string}
     * @memberof DigestEvent
     */
    'nonmember_access': DigestEventNonmemberAccessEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof DigestEvent
     */
    'reminders': Array<DigestEventRemindersEnum>;
    /**
     * 
     * @type {boolean}
     * @memberof DigestEvent
     */
    'urgent': boolean;
    /**
     * 
     * @type {string}
     * @memberof DigestEvent
     */
    'mailed_at': string | null;
    /**
     * 
     * @type {GroupMember}
     * @memberof DigestEvent
     */
    'mailed_by'?: GroupMember | null;
    /**
     * 
     * @type {number}
     * @memberof DigestEvent
     */
    'group_id': number;
    /**
     * 
     * @type {number}
     * @memberof DigestEvent
     */
    'level_id': number | null;
    /**
     * 
     * @type {number}
     * @memberof DigestEvent
     */
    'client_id': number | null;
    /**
     * 
     * @type {number}
     * @memberof DigestEvent
     */
    'attends_count': number;
    /**
     * 
     * @type {number}
     * @memberof DigestEvent
     */
    'declines_count': number;
    /**
     * 
     * @type {number}
     * @memberof DigestEvent
     */
    'posts_count': number;
    /**
     * 
     * @type {string}
     * @memberof DigestEvent
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof DigestEvent
     */
    'updated_at': string;
    /**
     * 
     * @type {DetailedEventOrganization}
     * @memberof DigestEvent
     */
    'organization': DetailedEventOrganization;
    /**
     * 
     * @type {DigestEventLinks}
     * @memberof DigestEvent
     */
    'links'?: DigestEventLinks;
}

export const DigestEventNonmemberAccessEnum = {
    Read: 'read',
    Write: 'write',
    Hidden: 'hidden'
} as const;

export type DigestEventNonmemberAccessEnum = typeof DigestEventNonmemberAccessEnum[keyof typeof DigestEventNonmemberAccessEnum];
export const DigestEventRemindersEnum = {
    EighteenMonths: 'eighteen_months',
    TwelveMonths: 'twelve_months',
    SixMonths: 'six_months',
    ThreeMonths: 'three_months',
    TwoMonths: 'two_months',
    OneMonth: 'one_month',
    TwoWeeks: 'two_weeks',
    OnCreation: 'on_creation'
} as const;

export type DigestEventRemindersEnum = typeof DigestEventRemindersEnum[keyof typeof DigestEventRemindersEnum];

/**
 * 
 * @export
 * @interface DigestEventLinks
 */
export interface DigestEventLinks {
    /**
     * 
     * @type {string}
     * @memberof DigestEventLinks
     */
    'update_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigestEventLinks
     */
    'delete_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigestEventLinks
     */
    'attend_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigestEventLinks
     */
    'decline_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigestEventLinks
     */
    'publish_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DigestEventLinks
     */
    'unpublish_url'?: string | null;
}
/**
 * The degree it was possible to verify usage of a email mailbox.
 * @export
 * @enum {string}
 */

export const EmailStatuses = {
    Bounced: 'bounced',
    AutomaticallyVerified: 'automatically_verified',
    ManuallyVerified: 'manually_verified',
    Deliverable: 'deliverable',
    Unverified: 'unverified'
} as const;

export type EmailStatuses = typeof EmailStatuses[keyof typeof EmailStatuses];


/**
 * 
 * @export
 * @enum {string}
 */

export const Emoji = {
    Like: 'like',
    Idea: 'idea',
    Cheers: 'cheers'
} as const;

export type Emoji = typeof Emoji[keyof typeof Emoji];


/**
 * Only the essential data of an event. See DetailedEvent for a fatter view. 
 * @export
 * @interface Event
 */
export interface Event {
    /**
     * 
     * @type {number}
     * @memberof Event
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'description': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Event
     */
    'all_day': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Event
     */
    'open_ended': boolean;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'start_at': string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'start_date': string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'start_time': string | null;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'end_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'end_date': string | null;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'end_time': string | null;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'location': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Event
     */
    'online': boolean;
    /**
     * URL for the call, if the event is online. Only shown if permitted to join the event.
     * @type {string}
     * @memberof Event
     */
    'custom_call_url': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Event
     */
    'is_public': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Event
     */
    'allow_guests': boolean;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'nonmember_access': EventNonmemberAccessEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof Event
     */
    'reminders': Array<EventRemindersEnum>;
    /**
     * 
     * @type {boolean}
     * @memberof Event
     */
    'urgent': boolean;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'mailed_at': string | null;
    /**
     * 
     * @type {Group}
     * @memberof Event
     */
    'group': Group;
    /**
     * 
     * @type {number}
     * @memberof Event
     */
    'group_id': number;
    /**
     * 
     * @type {number}
     * @memberof Event
     */
    'level_id': number | null;
    /**
     * 
     * @type {number}
     * @memberof Event
     */
    'client_id': number | null;
    /**
     * Total number of members that have replied to the invitation with \'attend\'
     * @type {number}
     * @memberof Event
     */
    'attends_count': number;
    /**
     * Total number of members that have replied to the invitation with \'decline\'
     * @type {number}
     * @memberof Event
     */
    'declines_count': number;
    /**
     * Total number of members that have not yet replied to the invitation
     * @type {number}
     * @memberof Event
     */
    'pendings_count': number;
    /**
     * Total number of guests that will accompany members having replied to the invitation with \'attend\'
     * @type {number}
     * @memberof Event
     */
    'guests_count': number;
    /**
     * Total number of posts of this Event.
     * @type {number}
     * @memberof Event
     */
    'posts_count': number;
    /**
     * Total number of highlights of this Event.
     * @type {number}
     * @memberof Event
     */
    'highlights_count': number;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof Event
     */
    'updated_at': string;
}

export const EventNonmemberAccessEnum = {
    Read: 'read',
    Write: 'write',
    Hidden: 'hidden'
} as const;

export type EventNonmemberAccessEnum = typeof EventNonmemberAccessEnum[keyof typeof EventNonmemberAccessEnum];
export const EventRemindersEnum = {
    EighteenMonths: 'eighteen_months',
    TwelveMonths: 'twelve_months',
    SixMonths: 'six_months',
    ThreeMonths: 'three_months',
    TwoMonths: 'two_months',
    OneMonth: 'one_month',
    TwoWeeks: 'two_weeks',
    OnCreation: 'on_creation'
} as const;

export type EventRemindersEnum = typeof EventRemindersEnum[keyof typeof EventRemindersEnum];

/**
 * Request body to create a new Event.
 * @export
 * @interface EventCreateRequest
 */
export interface EventCreateRequest {
    /**
     * Title of the event
     * @type {string}
     * @memberof EventCreateRequest
     */
    'title': string;
    /**
     * Description of the event
     * @type {string}
     * @memberof EventCreateRequest
     */
    'description'?: string;
    /**
     * Address of the event
     * @type {string}
     * @memberof EventCreateRequest
     */
    'location'?: string;
    /**
     * Begin date.
     * @type {string}
     * @memberof EventCreateRequest
     */
    'start_date': string;
    /**
     * Begin time.
     * @type {string}
     * @memberof EventCreateRequest
     */
    'start_time'?: string;
    /**
     * End date.
     * @type {string}
     * @memberof EventCreateRequest
     */
    'end_date'?: string;
    /**
     * End time.
     * @type {string}
     * @memberof EventCreateRequest
     */
    'end_time'?: string;
    /**
     * Indicates if the event has no start or end times, only dates
     * @type {boolean}
     * @memberof EventCreateRequest
     */
    'all_day': boolean;
    /**
     * Indicates if the event is urgent and should trigger a digest now
     * @type {boolean}
     * @memberof EventCreateRequest
     */
    'urgent'?: boolean;
    /**
     * Indicates if the event should offer a video-chat room.
     * @type {boolean}
     * @memberof EventCreateRequest
     */
    'online'?: boolean;
    /**
     * Enable attendings with guests
     * @type {boolean}
     * @memberof EventCreateRequest
     */
    'allow_guests'?: boolean;
    /**
     * Read/Write rights for non group members, one of `write`, `read`, `hidden`. Defaults to `write`
     * @type {string}
     * @memberof EventCreateRequest
     */
    'nonmember_access'?: string;
    /**
     * Custom Video-Call URL to be used instead of the built in one
     * @type {string}
     * @memberof EventCreateRequest
     */
    'custom_call_url'?: string;
    /**
     * Group where this event belongs to
     * @type {number}
     * @memberof EventCreateRequest
     */
    'group_id': number;
    /**
     * PersonalRecord#id or Group#id of the organizer of this event
     * @type {number}
     * @memberof EventCreateRequest
     */
    'contact_id': number;
    /**
     * GroupMember|Group
     * @type {string}
     * @memberof EventCreateRequest
     */
    'contact_type'?: string;
    /**
     * ID of the UploadedFile that should be shown as photo of the event.
     * @type {number}
     * @memberof EventCreateRequest
     */
    'featured_image_id'?: number;
    /**
     * Users will get reminders in their digest
     * @type {Array<string>}
     * @memberof EventCreateRequest
     */
    'reminders'?: Array<string>;
}
/**
 * A collection of photos uploaded to an Event in a Post
 * @export
 * @interface EventGallery
 */
export interface EventGallery {
    /**
     * ID of the Post
     * @type {number}
     * @memberof EventGallery
     */
    'id': number;
    /**
     * 
     * @type {Event}
     * @memberof EventGallery
     */
    'event': Event;
    /**
     * 
     * @type {GroupMember}
     * @memberof EventGallery
     */
    'creator': GroupMember;
    /**
     * Total number of EventMedia uploaded in this Post.
     * @type {number}
     * @memberof EventGallery
     */
    'event_media_count': number;
    /**
     * 
     * @type {Array<EventMedium>}
     * @memberof EventGallery
     */
    'event_media_preview': Array<EventMedium>;
    /**
     * 
     * @type {string}
     * @memberof EventGallery
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof EventGallery
     */
    'updated_at': string;
    /**
     * 
     * @type {EventGalleryLinks}
     * @memberof EventGallery
     */
    'links': EventGalleryLinks;
}
/**
 * 
 * @export
 * @interface EventGalleryLinks
 */
export interface EventGalleryLinks {
    /**
     * Deep link to open the gallery, if permitted.
     * @type {string}
     * @memberof EventGalleryLinks
     */
    'gallery_url'?: string | null;
    /**
     * Link to the event, if permitted to see.
     * @type {string}
     * @memberof EventGalleryLinks
     */
    'event_url'?: string | null;
}
/**
 * 
 * @export
 * @interface EventMedium
 */
export interface EventMedium {
    /**
     * 
     * @type {number}
     * @memberof EventMedium
     */
    'id': number;
    /**
     * Index used for ordering of highlights.
     * @type {number}
     * @memberof EventMedium
     */
    'index': number;
    /**
     * Optional text to describe or label the picture/video.
     * @type {string}
     * @memberof EventMedium
     */
    'description': string;
    /**
     * 
     * @type {Photo}
     * @memberof EventMedium
     */
    'uploaded_file': Photo;
    /**
     * ID of the Post where this EventMedium was uploaded to.
     * @type {number}
     * @memberof EventMedium
     */
    'post_id': number;
    /**
     * If this EventMedium was marked as a highlight, ID of the Highlight.
     * @type {number}
     * @memberof EventMedium
     */
    'highlight_id': number | null;
    /**
     * 
     * @type {string}
     * @memberof EventMedium
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof EventMedium
     */
    'created_at': string;
    /**
     * 
     * @type {EventMediumLinks}
     * @memberof EventMedium
     */
    'links': EventMediumLinks;
}
/**
 * 
 * @export
 * @interface EventMediumLinks
 */
export interface EventMediumLinks {
    /**
     * URL to delete this event_medium if authorized, otherwise null.
     * @type {string}
     * @memberof EventMediumLinks
     */
    'delete_url'?: string | null;
    /**
     * URL to update this event_medium if authorized, otherwise null.
     * @type {string}
     * @memberof EventMediumLinks
     */
    'update_url'?: string | null;
    /**
     * URL of record marking this EventMedium as highlight, otherwise null.
     * @type {string}
     * @memberof EventMediumLinks
     */
    'highlight_url'?: string | null;
}
/**
 * 
 * @export
 * @interface EventMediumUpdate
 */
export interface EventMediumUpdate {
    /**
     * Optional text to describe or label the picture/video.
     * @type {string}
     * @memberof EventMediumUpdate
     */
    'description'?: string | null;
    /**
     * Download name for the file.
     * @type {string}
     * @memberof EventMediumUpdate
     */
    'file_name'?: string | null;
    /**
     * Index used for ordering relative to sibling EventMedia.
     * @type {number}
     * @memberof EventMediumUpdate
     */
    'index'?: number | null;
    /**
     * If true, the highlight will be moved to the front of the list.
     * @type {boolean}
     * @memberof EventMediumUpdate
     */
    'send_to_front'?: boolean | null;
    /**
     * If true, the highlight will be moved to the back of the list.
     * @type {boolean}
     * @memberof EventMediumUpdate
     */
    'send_to_back'?: boolean | null;
}
/**
 * An video or photo to be uploaded. May be a temporary or already persisted file. The API backend takes care of persisting them, when there is time.
 * @export
 * @interface EventMediumUpload
 */
export interface EventMediumUpload {
    /**
     * Optional text to describe or label the picture/video.
     * @type {string}
     * @memberof EventMediumUpload
     */
    'description'?: string | null;
    /**
     * Display name for the file.
     * @type {string}
     * @memberof EventMediumUpload
     */
    'file_name'?: string;
    /**
     * Key of the uploaded file as returned by AWS, not the full URL.
     * @type {string}
     * @memberof EventMediumUpload
     */
    'stored_file'?: string;
    /**
     * MIME Type of the file. May be null if the type could not be determined or was unknown.
     * @type {string}
     * @memberof EventMediumUpload
     */
    'content_type'?: string;
    /**
     * Horizontal dimension of the original file in pixel.
     * @type {number}
     * @memberof EventMediumUpload
     */
    'width'?: number;
    /**
     * Vertical dimension of the original file in pixel.
     * @type {number}
     * @memberof EventMediumUpload
     */
    'height'?: number;
}
/**
 * Request body to update an existing Event.
 * @export
 * @interface EventUpdateRequest
 */
export interface EventUpdateRequest {
    /**
     * Title of the event
     * @type {string}
     * @memberof EventUpdateRequest
     */
    'title'?: string;
    /**
     * Description of the event
     * @type {string}
     * @memberof EventUpdateRequest
     */
    'description'?: string | null;
    /**
     * Address of the event
     * @type {string}
     * @memberof EventUpdateRequest
     */
    'location'?: string | null;
    /**
     * Begin date.
     * @type {string}
     * @memberof EventUpdateRequest
     */
    'start_date'?: string;
    /**
     * Begin time.
     * @type {string}
     * @memberof EventUpdateRequest
     */
    'start_time'?: string;
    /**
     * End date.
     * @type {string}
     * @memberof EventUpdateRequest
     */
    'end_date'?: string;
    /**
     * End time.
     * @type {string}
     * @memberof EventUpdateRequest
     */
    'end_time'?: string;
    /**
     * Indicates if the event has no start or end times, only dates
     * @type {boolean}
     * @memberof EventUpdateRequest
     */
    'all_day'?: boolean;
    /**
     * Indicates if the event is urgent and should trigger a digest now
     * @type {boolean}
     * @memberof EventUpdateRequest
     */
    'urgent'?: boolean;
    /**
     * Indicates if the event should offer a video-chat room.
     * @type {boolean}
     * @memberof EventUpdateRequest
     */
    'online'?: boolean;
    /**
     * Enable attendings with guests
     * @type {boolean}
     * @memberof EventUpdateRequest
     */
    'allow_guests'?: boolean;
    /**
     * Read/Write rights for non group members, one of `write`, `read`, `hidden`. Defaults to `write`
     * @type {string}
     * @memberof EventUpdateRequest
     */
    'nonmember_access'?: string;
    /**
     * Custom Video-Call URL to be used instead of the built in one
     * @type {string}
     * @memberof EventUpdateRequest
     */
    'custom_call_url'?: string | null;
    /**
     * Group where this event belongs to
     * @type {number}
     * @memberof EventUpdateRequest
     */
    'group_id'?: number;
    /**
     * PersonalRecord#id or Group#id of the organizer of this event
     * @type {number}
     * @memberof EventUpdateRequest
     */
    'contact_id'?: number;
    /**
     * GroupMember|Group
     * @type {string}
     * @memberof EventUpdateRequest
     */
    'contact_type'?: string;
    /**
     * ID of the UploadedFile that should be shown as photo of the event.
     * @type {number}
     * @memberof EventUpdateRequest
     */
    'featured_image_id'?: number | null;
    /**
     * Users will get reminders in their digest
     * @type {Array<string>}
     * @memberof EventUpdateRequest
     */
    'reminders'?: Array<string>;
}
/**
 * POST-Endpoint and signature required to upload a file directly into the temporary S3 bucket. The link is valid for 24 hours and a successful upload will return HTTP 201. The file for the upload may be between 100 Byte and 2GB. For more details see https://docs.aws.amazon.com/sdk-for-ruby/v3/api/Aws/S3/PresignedPost.html. 
 * @export
 * @interface FileUploadUrl
 */
export interface FileUploadUrl {
    /**
     * URL where the file should be POST\'ed to.
     * @type {string}
     * @memberof FileUploadUrl
     */
    'postEndpoint': string;
    /**
     * 
     * @type {FileUploadUrlSignature}
     * @memberof FileUploadUrl
     */
    'signature': FileUploadUrlSignature;
}
/**
 * Signature that needs to be included as header in the upload request.
 * @export
 * @interface FileUploadUrlSignature
 */
export interface FileUploadUrlSignature {
    /**
     * Prefix under which the object will be stored in the S3 bucket.
     * @type {string}
     * @memberof FileUploadUrlSignature
     */
    'key'?: string;
    /**
     * HTTP Code that is returned if the file was successully uploaded.
     * @type {string}
     * @memberof FileUploadUrlSignature
     */
    'success_action_status'?: string;
    /**
     * Access control list of the uploaded object.
     * @type {string}
     * @memberof FileUploadUrlSignature
     */
    'acl'?: string;
    /**
     * 
     * @type {string}
     * @memberof FileUploadUrlSignature
     */
    'policy'?: string;
    /**
     * 
     * @type {string}
     * @memberof FileUploadUrlSignature
     */
    'x-amz-credential'?: string;
    /**
     * 
     * @type {string}
     * @memberof FileUploadUrlSignature
     */
    'x-amz-algorithm'?: string;
    /**
     * 
     * @type {string}
     * @memberof FileUploadUrlSignature
     */
    'x-amz-date'?: string;
    /**
     * 
     * @type {string}
     * @memberof FileUploadUrlSignature
     */
    'x-amz-signature'?: string;
}
/**
 * 
 * @export
 * @interface ForumItem
 */
export interface ForumItem {
    /**
     * 
     * @type {string}
     * @memberof ForumItem
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ForumItem
     */
    'type': ForumItemTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof ForumItem
     */
    'forum_item_id': number;
    /**
     * 
     * @type {string}
     * @memberof ForumItem
     */
    'forum_item_type': ForumItemForumItemTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ForumItem
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ForumItem
     */
    'description': string;
    /**
     * 
     * @type {number}
     * @memberof ForumItem
     */
    'posts_count': number;
    /**
     * 
     * @type {ForumItemDetails}
     * @memberof ForumItem
     */
    'details': ForumItemDetails | null;
    /**
     * 
     * @type {string}
     * @memberof ForumItem
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof ForumItem
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof ForumItem
     */
    'mailed_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof ForumItem
     */
    'nonmember_access': ForumItemNonmemberAccessEnum;
    /**
     * 
     * @type {string}
     * @memberof ForumItem
     */
    'group_name': string;
    /**
     * 
     * @type {number}
     * @memberof ForumItem
     */
    'client_id': number | null;
    /**
     * 
     * @type {number}
     * @memberof ForumItem
     */
    'level_id': number | null;
    /**
     * 
     * @type {string}
     * @memberof ForumItem
     */
    'latest_post_at': string | null;
    /**
     * 
     * @type {string}
     * @memberof ForumItem
     */
    'latest_created_at': string;
    /**
     * 
     * @type {number}
     * @memberof ForumItem
     */
    'reading_time': number;
    /**
     * 
     * @type {GroupMember}
     * @memberof ForumItem
     */
    'creator': GroupMember;
    /**
     * 
     * @type {GroupMember}
     * @memberof ForumItem
     */
    'latest_post_by': GroupMember;
    /**
     * 
     * @type {Group}
     * @memberof ForumItem
     */
    'group': Group;
    /**
     * 
     * @type {string}
     * @memberof ForumItem
     */
    'url': string;
    /**
     * 
     * @type {string}
     * @memberof ForumItem
     */
    'group_url': string;
    /**
     * 
     * @type {Array<Tag>}
     * @memberof ForumItem
     */
    'tags': Array<Tag>;
    /**
     * 
     * @type {boolean}
     * @memberof ForumItem
     */
    'is_member': boolean;
}

export const ForumItemTypeEnum = {
    ForumTopic: 'ForumTopic',
    ForumEvent: 'ForumEvent'
} as const;

export type ForumItemTypeEnum = typeof ForumItemTypeEnum[keyof typeof ForumItemTypeEnum];
export const ForumItemForumItemTypeEnum = {
    Topic: 'Topic',
    Event: 'Event'
} as const;

export type ForumItemForumItemTypeEnum = typeof ForumItemForumItemTypeEnum[keyof typeof ForumItemForumItemTypeEnum];
export const ForumItemNonmemberAccessEnum = {
    Hidden: 'hidden',
    Read: 'read',
    Write: 'write'
} as const;

export type ForumItemNonmemberAccessEnum = typeof ForumItemNonmemberAccessEnum[keyof typeof ForumItemNonmemberAccessEnum];

/**
 * 
 * @export
 * @interface ForumItemDetails
 */
export interface ForumItemDetails {
    /**
     * 
     * @type {number}
     * @memberof ForumItemDetails
     */
    'attends_count'?: number;
    /**
     * 
     * @type {number}
     * @memberof ForumItemDetails
     */
    'guests_count'?: number;
    /**
     * 
     * @type {string}
     * @memberof ForumItemDetails
     */
    'start_at'?: string;
    /**
     * 
     * @type {string}
     * @memberof ForumItemDetails
     */
    'end_at'?: string;
}
/**
 * 
 * @export
 * @interface FuzzySearch200Response
 */
export interface FuzzySearch200Response {
    /**
     * 
     * @type {Array<Member>}
     * @memberof FuzzySearch200Response
     */
    'results'?: Array<Member>;
}
/**
 * 
 * @export
 * @interface GetGroupACL200Response
 */
export interface GetGroupACL200Response {
    /**
     * 
     * @type {Array<GetGroupACL200ResponseResultsInner>}
     * @memberof GetGroupACL200Response
     */
    'results'?: Array<GetGroupACL200ResponseResultsInner>;
}
/**
 * 
 * @export
 * @interface GetGroupACL200ResponseResultsInner
 */
export interface GetGroupACL200ResponseResultsInner {
    /**
     * 
     * @type {number}
     * @memberof GetGroupACL200ResponseResultsInner
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof GetGroupACL200ResponseResultsInner
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof GetGroupACL200ResponseResultsInner
     */
    'client_id'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GetGroupACL200ResponseResultsInner
     */
    'level_id'?: number | null;
}
/**
 * 
 * @export
 * @interface GetGroupMembers200Response
 */
export interface GetGroupMembers200Response {
    /**
     * 
     * @type {number}
     * @memberof GetGroupMembers200Response
     */
    'count'?: number;
    /**
     * 
     * @type {Array<GroupMember>}
     * @memberof GetGroupMembers200Response
     */
    'results'?: Array<GroupMember>;
}
/**
 * 
 * @export
 * @interface GetGroups200Response
 */
export interface GetGroups200Response {
    /**
     * 
     * @type {number}
     * @memberof GetGroups200Response
     */
    'count'?: number;
    /**
     * 
     * @type {Array<Group>}
     * @memberof GetGroups200Response
     */
    'results'?: Array<Group>;
}
/**
 * 
 * @export
 * @interface GetLevelACL200Response
 */
export interface GetLevelACL200Response {
    /**
     * 
     * @type {Array<GetLevelACL200ResponseResultsInner>}
     * @memberof GetLevelACL200Response
     */
    'results'?: Array<GetLevelACL200ResponseResultsInner>;
}
/**
 * 
 * @export
 * @interface GetLevelACL200ResponseResultsInner
 */
export interface GetLevelACL200ResponseResultsInner {
    /**
     * 
     * @type {string}
     * @memberof GetLevelACL200ResponseResultsInner
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof GetLevelACL200ResponseResultsInner
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface GetMemberACL200Response
 */
export interface GetMemberACL200Response {
    /**
     * 
     * @type {Array<GroupMember>}
     * @memberof GetMemberACL200Response
     */
    'results'?: Array<GroupMember>;
}
/**
 * Groups are the basic entity to organize contents on the platform. They are used to assign roles (i.e. Permissions) to their members and to create Topics and Events inside them. Groups are hierarchical organized (have another group as parent) and can have other groups as member. Groups can exists either on a Client xor on a Level.  FIXME: This schema is not complete or 100% accurate yet! 
 * @export
 * @interface Group
 */
export interface Group {
    /**
     * 
     * @type {number}
     * @memberof Group
     */
    'id': number;
    /**
     * 
     * @type {GroupType}
     * @memberof Group
     */
    'type': GroupType;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'prefix'?: string;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'suffix'?: string;
    /**
     * 
     * @type {number}
     * @memberof Group
     */
    'list_order': number;
    /**
     * 
     * @type {number}
     * @memberof Group
     */
    'sort_order': number;
    /**
     * 
     * @type {number}
     * @memberof Group
     */
    'members_count': number;
    /**
     * 
     * @type {boolean}
     * @memberof Group
     */
    'has_forum'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Group
     */
    'searchable': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Group
     */
    'closed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Group
     */
    'exclusive_subgroup': boolean;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'more_information': string;
    /**
     * 
     * @type {boolean}
     * @memberof Group
     */
    'has_calendar': boolean;
    /**
     * 
     * @type {Array<AbilitiesInner>}
     * @memberof Group
     */
    'abilities'?: Array<AbilitiesInner>;
    /**
     * 
     * @type {number}
     * @memberof Group
     */
    'client_id'?: number | null;
    /**
     * 
     * @type {Client}
     * @memberof Group
     */
    'client'?: Client;
    /**
     * 
     * @type {number}
     * @memberof Group
     */
    'level_id'?: number | null;
    /**
     * 
     * @type {Level}
     * @memberof Group
     */
    'level'?: Level;
    /**
     * 
     * @type {number}
     * @memberof Group
     */
    'voting_group_id'?: number | null;
    /**
     * 
     * @type {Group}
     * @memberof Group
     */
    'voting_group'?: Group;
    /**
     * 
     * @type {number}
     * @memberof Group
     */
    'parent_id'?: number | null;
    /**
     * 
     * @type {Group}
     * @memberof Group
     */
    'parent'?: Group;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'path'?: string;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'url'?: string;
    /**
     * 
     * @type {string}
     * @memberof Group
     */
    'join_path'?: string | null;
    /**
     * 
     * @type {GroupLinks}
     * @memberof Group
     */
    'links'?: GroupLinks;
}


/**
 * 
 * @export
 * @interface GroupLinks
 */
export interface GroupLinks {
    /**
     * 
     * @type {string}
     * @memberof GroupLinks
     */
    'create_topic_url'?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupLinks
     */
    'create_event_url'?: string;
}
/**
 * The view model of a Person. Carries all information to display a member in the given context of a Client or Level.  Attributes `name` is not included in the model, because it\'s usage is discouraged. Same for `link`, which is a duplicate of `url` but absent if unpermitted to view the profile. 
 * @export
 * @interface GroupMember
 */
export interface GroupMember {
    /**
     * 
     * @type {number}
     * @memberof GroupMember
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof GroupMember
     */
    'user_id'?: number | null;
    /**
     * First name of the person
     * @type {string}
     * @memberof GroupMember
     */
    'first_name': string;
    /**
     * Last name of the person
     * @type {string}
     * @memberof GroupMember
     */
    'last_name': string;
    /**
     * First and last name seperated by a space.
     * @type {string}
     * @memberof GroupMember
     */
    'full_name': string;
    /**
     * Long internal name to be used in the context of the client of the GroupMember. Contains the `internal_name_long` of the `ClubRecord` of the current client. If no ClubRecord of the GroupMember matches the current client, it contains the `internal_name_long` of the `ClubRecord` of the first joined `Client`. 
     * @type {string}
     * @memberof GroupMember
     */
    'internal_name_long': string;
    /**
     * Short internal name to be used in the context of the client of the GroupMember. Contains the `internal_name_short` of the `ClubRecord` of the current client. If no ClubRecord of the  GroupMember matches the current client, it contains the `internal_name_short` of the `ClubRecord` of the first joined `Client`. 
     * @type {string}
     * @memberof GroupMember
     */
    'internal_name_short': string;
    /**
     * Short name of the GroupMember, to be used in context of `Level`s. Contains the `umbrella_name_short` from a ClubRecord that matches the current `Umbrella` the the current client. If none, it is the `umbrella_name_short` of the first joined client. 
     * @type {string}
     * @memberof GroupMember
     */
    'umbrella_name_short': string;
    /**
     * Long name of the GroupMember, to be used in context of `Level`s. Contains the `umbrella_name_long` from a ClubRecord that matches the current `Umbrella` the the current  client. If none, it is the `umbrella_name_long` of the first joined client. 
     * @type {string}
     * @memberof GroupMember
     */
    'umbrella_name_long': string;
    /**
     * A key for lexicographical ordering of GroupMembers. Yields a sorting by first joined client, last name (without nobility particel), first name,  other clients in order by name. 
     * @type {string}
     * @memberof GroupMember
     */
    'global_name_for_sorting': string;
    /**
     * True if the GroupMember has a ClubRecord at the current client
     * @type {boolean}
     * @memberof GroupMember
     */
    'is_member': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GroupMember
     */
    'alive': boolean;
    /**
     * If true this user is invisible to everyone not allowed to see invisible users. When you see this being truthy, you are apparently permitted.
     * @type {boolean}
     * @memberof GroupMember
     */
    'invisible': boolean;
    /**
     * If false the GroupMember has no verified ClubRecord yet.
     * @type {boolean}
     * @memberof GroupMember
     */
    'verified': boolean;
    /**
     * True if 1) the GroupMember is member of the current client and has resigned at the current client or 2) the GroupMember is from other client(s) and has resigned from all of them.
     * @type {boolean}
     * @memberof GroupMember
     */
    'resigned': boolean;
    /**
     * Link to the profile page of the person. Null if viewing the profile is not allowed to the current user.
     * @type {string}
     * @memberof GroupMember
     */
    'url': string | null;
    /**
     * 
     * @type {string}
     * @memberof GroupMember
     */
    'avatar_url': string;
    /**
     * 
     * @type {Client}
     * @memberof GroupMember
     */
    'client'?: Client;
    /**
     * 
     * @type {PersonalRecord}
     * @memberof GroupMember
     */
    'personal_record'?: PersonalRecord;
    /**
     * 
     * @type {Array<Client>}
     * @memberof GroupMember
     */
    'clients': Array<Client>;
    /**
     * 
     * @type {Array<ClubRecord>}
     * @memberof GroupMember
     */
    'club_records'?: Array<ClubRecord>;
    /**
     * 
     * @type {Array<Level>}
     * @memberof GroupMember
     */
    'levels'?: Array<Level>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GroupMember
     */
    'level_permissions'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GroupMember
     */
    'client_permissions'?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof GroupMember
     */
    'group_memberships'?: Array<number>;
    /**
     * Timestamp of the latest change of any of the dependent records of this view. It is the max updated_at timestamp from any of its ClubRecords, Clients and PersonalRecord.
     * @type {string}
     * @memberof GroupMember
     */
    'updated_at': string;
}
/**
 * There are different sub-types of Groups: - DynamicGroup: Cannot have any permissions, but joining is directly possible. - StaticGroup: Can have permissions assigned, but joining requires confirmation by members of the Control Group. - StatusGroup: Sub-Type of a StaticGroup, joining one StatusGroup causes leaving the old StatusGroup. - OneManGroup: To represent chairman and special roles. - PrivateGroup: Hidden from the others, only members can see it. 
 * @export
 * @enum {string}
 */

export const GroupType = {
    Group: 'Group',
    StaticGroup: 'StaticGroup',
    DynamicGroup: 'DynamicGroup',
    VirtualGroup: 'VirtualGroup',
    OneManGroup: 'OneManGroup',
    BaseGroup: 'BaseGroup',
    PrivateGroup: 'PrivateGroup'
} as const;

export type GroupType = typeof GroupType[keyof typeof GroupType];


/**
 * 
 * @export
 * @interface Highlight
 */
export interface Highlight {
    /**
     * 
     * @type {number}
     * @memberof Highlight
     */
    'id': number;
    /**
     * Index used for ordering of highlights.
     * @type {number}
     * @memberof Highlight
     */
    'index': number;
    /**
     * 
     * @type {EventMedium}
     * @memberof Highlight
     */
    'event_medium': EventMedium;
    /**
     * 
     * @type {string}
     * @memberof Highlight
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof Highlight
     */
    'created_at': string;
    /**
     * 
     * @type {HighlightLinks}
     * @memberof Highlight
     */
    'links': HighlightLinks;
}
/**
 * Request to create a new highlight. If no index is given, the highlight will be added to the end of the list.
 * @export
 * @interface HighlightCreateRequest
 */
export interface HighlightCreateRequest {
    /**
     * ID of the EventMedium to be added to the highlights.
     * @type {number}
     * @memberof HighlightCreateRequest
     */
    'event_medium_id': number;
    /**
     * Index used for ordering relative to sibling highlights.
     * @type {number}
     * @memberof HighlightCreateRequest
     */
    'index'?: number | null;
    /**
     * If true, the highlight will be moved to the front of the list.
     * @type {boolean}
     * @memberof HighlightCreateRequest
     */
    'send_to_front'?: boolean | null;
    /**
     * If true, the highlight will be moved to the back of the list.
     * @type {boolean}
     * @memberof HighlightCreateRequest
     */
    'send_to_back'?: boolean | null;
}
/**
 * 
 * @export
 * @interface HighlightLinks
 */
export interface HighlightLinks {
    /**
     * URL of the EventMedium of a Post where this highlight was shared.
     * @type {string}
     * @memberof HighlightLinks
     */
    'event_medium_url'?: string;
    /**
     * URL to remove this EventMedium from the Event highlights if authorized, otherwise null.
     * @type {string}
     * @memberof HighlightLinks
     */
    'delete_url'?: string | null;
    /**
     * Update this highlight, i.e. how this EventMedium is displayed under event highlights if authorized, otherwise null.
     * @type {string}
     * @memberof HighlightLinks
     */
    'update_url'?: string | null;
}
/**
 * 
 * @export
 * @interface HighlightUpdateRequest
 */
export interface HighlightUpdateRequest {
    /**
     * Index used for ordering relative to sibling highlights.
     * @type {number}
     * @memberof HighlightUpdateRequest
     */
    'index'?: number;
    /**
     * If true, the highlight will be moved to the front of the list.
     * @type {boolean}
     * @memberof HighlightUpdateRequest
     */
    'send_to_front'?: boolean | null;
    /**
     * If true, the highlight will be moved to the back of the list.
     * @type {boolean}
     * @memberof HighlightUpdateRequest
     */
    'send_to_back'?: boolean | null;
}
/**
 * 
 * @export
 * @interface ImportValidationResponse
 */
export interface ImportValidationResponse {
    /**
     * Whether the import data is valid.
     * @type {boolean}
     * @memberof ImportValidationResponse
     */
    'valid': boolean;
    /**
     * Number of errors found in the import data.
     * @type {number}
     * @memberof ImportValidationResponse
     */
    'error_count': number;
    /**
     * Total number of records in the import data.
     * @type {number}
     * @memberof ImportValidationResponse
     */
    'total_records': number;
    /**
     * Number of alive and not resigned (at the importing client) members in the import data.
     * @type {number}
     * @memberof ImportValidationResponse
     */
    'current_members': number | null;
    /**
     * 
     * @type {ImportValidationResponseExtraAttributes}
     * @memberof ImportValidationResponse
     */
    'extra_attributes': ImportValidationResponseExtraAttributes;
    /**
     * Mapping of names of clients found in import data (keys on the left) and their matches (value, right side).
     * @type {{ [key: string]: string; }}
     * @memberof ImportValidationResponse
     */
    'client_mapping': { [key: string]: string; };
    /**
     * 
     * @type {Array<ImportValidationResponseErrorsInner>}
     * @memberof ImportValidationResponse
     */
    'errors': Array<ImportValidationResponseErrorsInner>;
}
/**
 * 
 * @export
 * @interface ImportValidationResponseErrorsInner
 */
export interface ImportValidationResponseErrorsInner {
    /**
     * 
     * @type {number}
     * @memberof ImportValidationResponseErrorsInner
     */
    'line'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof ImportValidationResponseErrorsInner
     */
    'errors'?: Array<string>;
}
/**
 * 
 * @export
 * @interface ImportValidationResponseExtraAttributes
 */
export interface ImportValidationResponseExtraAttributes {
    /**
     * Number of custom attribute definitions on PersonalRecord
     * @type {number}
     * @memberof ImportValidationResponseExtraAttributes
     */
    'personal_record'?: number;
    /**
     * Number of custom attribute definitions on ClubRecord
     * @type {number}
     * @memberof ImportValidationResponseExtraAttributes
     */
    'club_record'?: number;
}
/**
 * An inode is an entity in a file system, i.e. a folder or a file stored in the Drive.
 * @export
 * @interface Inode
 */
export interface Inode {
    /**
     * 
     * @type {number}
     * @memberof Inode
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Inode
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof Inode
     */
    'name': string | null;
    /**
     * 
     * @type {number}
     * @memberof Inode
     */
    'parent_id': number | null;
    /**
     * Either a precise date, with omitted day or year only. Can also take the form of a semester. 
     * @type {string}
     * @memberof Inode
     */
    'physically_created_at': string;
    /**
     * 
     * @type {number}
     * @memberof Inode
     */
    'owner_id': number | null;
    /**
     * 
     * @type {string}
     * @memberof Inode
     */
    'owner_type': InodeOwnerTypeEnum | null;
    /**
     * 
     * @type {number}
     * @memberof Inode
     */
    'client_id': number | null;
    /**
     * 
     * @type {string}
     * @memberof Inode
     */
    'content_type': string | null;
    /**
     * 
     * @type {number}
     * @memberof Inode
     */
    'file_size': number | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof Inode
     */
    'dimensions': Array<number> | null;
    /**
     * 
     * @type {string}
     * @memberof Inode
     */
    'stored_file': string | null;
    /**
     * 
     * @type {string}
     * @memberof Inode
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof Inode
     */
    'created_at': string;
    /**
     * 
     * @type {number}
     * @memberof Inode
     */
    'views': number;
    /**
     * 
     * @type {number}
     * @memberof Inode
     */
    'likes_count': number;
    /**
     * Number of direct children
     * @type {number}
     * @memberof Inode
     */
    'children_count': number | null;
    /**
     * 
     * @type {GroupMember}
     * @memberof Inode
     */
    'uploaded_by': GroupMember;
    /**
     * 
     * @type {number}
     * @memberof Inode
     */
    'download_count': number;
    /**
     * 
     * @type {number}
     * @memberof Inode
     */
    'restrict_to_id': number | null;
    /**
     * 
     * @type {number}
     * @memberof Inode
     */
    'shared_level_id': number | null;
    /**
     * 
     * @type {string}
     * @memberof Inode
     */
    'description': string | null;
    /**
     * Order of the Inode at root level
     * @type {number}
     * @memberof Inode
     */
    'order': number | null;
    /**
     * Ordering of the inodes in this folders
     * @type {Array<InodeOrder>}
     * @memberof Inode
     */
    'ordering': Array<InodeOrder> | null;
    /**
     * 
     * @type {Inode}
     * @memberof Inode
     */
    'parent'?: Inode;
    /**
     * 
     * @type {InodeCategory}
     * @memberof Inode
     */
    'category'?: InodeCategory | null;
    /**
     * 
     * @type {string}
     * @memberof Inode
     */
    'signing_url'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Inode
     */
    'is_pinned': boolean | null;
    /**
     * 
     * @type {string}
     * @memberof Inode
     */
    'pin_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Inode
     */
    'update_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Inode
     */
    'destroy_url'?: string | null;
    /**
     * 
     * @type {Array<InodePathInner>}
     * @memberof Inode
     */
    'path'?: Array<InodePathInner> | null;
    /**
     * 
     * @type {number}
     * @memberof Inode
     */
    'level_id': number | null;
    /**
     * 
     * @type {Level}
     * @memberof Inode
     */
    'level'?: Level;
    /**
     * 
     * @type {InodeOwner}
     * @memberof Inode
     */
    'owner'?: InodeOwner;
    /**
     * 
     * @type {Group}
     * @memberof Inode
     */
    'restrict_to'?: Group;
    /**
     * 
     * @type {boolean}
     * @memberof Inode
     */
    'series'?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof Inode
     */
    'is_gallery'?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof Inode
     */
    'inodes_count'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Inode
     */
    'upload_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Inode
     */
    'download_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Inode
     */
    'backup_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Inode
     */
    'create_subfolder_url'?: string | null;
}

export const InodeOwnerTypeEnum = {
    Group: 'Group',
    GroupMember: 'GroupMember'
} as const;

export type InodeOwnerTypeEnum = typeof InodeOwnerTypeEnum[keyof typeof InodeOwnerTypeEnum];

/**
 * 
 * @export
 * @interface InodeCategory
 */
export interface InodeCategory {
    /**
     * 
     * @type {number}
     * @memberof InodeCategory
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof InodeCategory
     */
    'name'?: string;
}
/**
 * The order of the inodes in a folder. Possible values are: - `<name` for sorting by name ascending - `>name` for sorting by name descending - `<created_at` for sorting by creation date ascending - `>created_at` for sorting by creation date descending - `<physically_created_at` for sorting by physical creation date ascending - `>physically_created_at` for sorting by physical creation date descending       
 * @export
 * @enum {string}
 */

export const InodeOrder = {
    Name: '<name',
    Name2: '>name',
    CreatedAt: '<created_at',
    CreatedAt2: '>created_at',
    PhysicallyCreatedAt: '<physically_created_at',
    PhysicallyCreatedAt2: '>physically_created_at'
} as const;

export type InodeOrder = typeof InodeOrder[keyof typeof InodeOrder];


/**
 * 
 * @export
 * @interface InodeOwner
 */
export interface InodeOwner {
    /**
     * 
     * @type {number}
     * @memberof InodeOwner
     */
    'id': number;
    /**
     * 
     * @type {GroupType}
     * @memberof InodeOwner
     */
    'type': GroupType;
    /**
     * 
     * @type {string}
     * @memberof InodeOwner
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof InodeOwner
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof InodeOwner
     */
    'created_at': string;
    /**
     * Timestamp of the latest change of any of the dependent records of this view. It is the max updated_at timestamp from any of its ClubRecords, Clients and PersonalRecord.
     * @type {string}
     * @memberof InodeOwner
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof InodeOwner
     */
    'prefix'?: string;
    /**
     * 
     * @type {string}
     * @memberof InodeOwner
     */
    'suffix'?: string;
    /**
     * 
     * @type {number}
     * @memberof InodeOwner
     */
    'list_order': number;
    /**
     * 
     * @type {number}
     * @memberof InodeOwner
     */
    'sort_order': number;
    /**
     * 
     * @type {number}
     * @memberof InodeOwner
     */
    'members_count': number;
    /**
     * 
     * @type {boolean}
     * @memberof InodeOwner
     */
    'has_forum'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InodeOwner
     */
    'searchable': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InodeOwner
     */
    'closed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InodeOwner
     */
    'exclusive_subgroup': boolean;
    /**
     * 
     * @type {string}
     * @memberof InodeOwner
     */
    'more_information': string;
    /**
     * 
     * @type {boolean}
     * @memberof InodeOwner
     */
    'has_calendar': boolean;
    /**
     * 
     * @type {Array<AbilitiesInner>}
     * @memberof InodeOwner
     */
    'abilities'?: Array<AbilitiesInner>;
    /**
     * 
     * @type {number}
     * @memberof InodeOwner
     */
    'client_id'?: number | null;
    /**
     * 
     * @type {Client}
     * @memberof InodeOwner
     */
    'client'?: Client;
    /**
     * 
     * @type {number}
     * @memberof InodeOwner
     */
    'level_id'?: number | null;
    /**
     * 
     * @type {Level}
     * @memberof InodeOwner
     */
    'level'?: Level;
    /**
     * 
     * @type {number}
     * @memberof InodeOwner
     */
    'voting_group_id'?: number | null;
    /**
     * 
     * @type {Group}
     * @memberof InodeOwner
     */
    'voting_group'?: Group;
    /**
     * 
     * @type {number}
     * @memberof InodeOwner
     */
    'parent_id'?: number | null;
    /**
     * 
     * @type {Group}
     * @memberof InodeOwner
     */
    'parent'?: Group;
    /**
     * 
     * @type {string}
     * @memberof InodeOwner
     */
    'path'?: string;
    /**
     * Link to the profile page of the person. Null if viewing the profile is not allowed to the current user.
     * @type {string}
     * @memberof InodeOwner
     */
    'url': string | null;
    /**
     * 
     * @type {string}
     * @memberof InodeOwner
     */
    'join_path'?: string | null;
    /**
     * 
     * @type {GroupLinks}
     * @memberof InodeOwner
     */
    'links'?: GroupLinks;
    /**
     * 
     * @type {number}
     * @memberof InodeOwner
     */
    'user_id'?: number | null;
    /**
     * First name of the person
     * @type {string}
     * @memberof InodeOwner
     */
    'first_name': string;
    /**
     * Last name of the person
     * @type {string}
     * @memberof InodeOwner
     */
    'last_name': string;
    /**
     * First and last name seperated by a space.
     * @type {string}
     * @memberof InodeOwner
     */
    'full_name': string;
    /**
     * Long internal name to be used in the context of the client of the GroupMember. Contains the `internal_name_long` of the `ClubRecord` of the current client. If no ClubRecord of the GroupMember matches the current client, it contains the `internal_name_long` of the `ClubRecord` of the first joined `Client`. 
     * @type {string}
     * @memberof InodeOwner
     */
    'internal_name_long': string;
    /**
     * Short internal name to be used in the context of the client of the GroupMember. Contains the `internal_name_short` of the `ClubRecord` of the current client. If no ClubRecord of the  GroupMember matches the current client, it contains the `internal_name_short` of the `ClubRecord` of the first joined `Client`. 
     * @type {string}
     * @memberof InodeOwner
     */
    'internal_name_short': string;
    /**
     * Short name of the GroupMember, to be used in context of `Level`s. Contains the `umbrella_name_short` from a ClubRecord that matches the current `Umbrella` the the current client. If none, it is the `umbrella_name_short` of the first joined client. 
     * @type {string}
     * @memberof InodeOwner
     */
    'umbrella_name_short': string;
    /**
     * Long name of the GroupMember, to be used in context of `Level`s. Contains the `umbrella_name_long` from a ClubRecord that matches the current `Umbrella` the the current  client. If none, it is the `umbrella_name_long` of the first joined client. 
     * @type {string}
     * @memberof InodeOwner
     */
    'umbrella_name_long': string;
    /**
     * A key for lexicographical ordering of GroupMembers. Yields a sorting by first joined client, last name (without nobility particel), first name,  other clients in order by name. 
     * @type {string}
     * @memberof InodeOwner
     */
    'global_name_for_sorting': string;
    /**
     * True if the GroupMember has a ClubRecord at the current client
     * @type {boolean}
     * @memberof InodeOwner
     */
    'is_member': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof InodeOwner
     */
    'alive': boolean;
    /**
     * If true this user is invisible to everyone not allowed to see invisible users. When you see this being truthy, you are apparently permitted.
     * @type {boolean}
     * @memberof InodeOwner
     */
    'invisible': boolean;
    /**
     * If false the GroupMember has no verified ClubRecord yet.
     * @type {boolean}
     * @memberof InodeOwner
     */
    'verified': boolean;
    /**
     * True if 1) the GroupMember is member of the current client and has resigned at the current client or 2) the GroupMember is from other client(s) and has resigned from all of them.
     * @type {boolean}
     * @memberof InodeOwner
     */
    'resigned': boolean;
    /**
     * 
     * @type {string}
     * @memberof InodeOwner
     */
    'avatar_url': string;
    /**
     * 
     * @type {PersonalRecord}
     * @memberof InodeOwner
     */
    'personal_record'?: PersonalRecord;
    /**
     * 
     * @type {Array<Client>}
     * @memberof InodeOwner
     */
    'clients': Array<Client>;
    /**
     * 
     * @type {Array<ClubRecord>}
     * @memberof InodeOwner
     */
    'club_records'?: Array<ClubRecord>;
    /**
     * 
     * @type {Array<Level>}
     * @memberof InodeOwner
     */
    'levels'?: Array<Level>;
    /**
     * 
     * @type {Array<string>}
     * @memberof InodeOwner
     */
    'level_permissions'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof InodeOwner
     */
    'client_permissions'?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof InodeOwner
     */
    'group_memberships'?: Array<number>;
}


/**
 * 
 * @export
 * @interface InodePathInner
 */
export interface InodePathInner {
    /**
     * 
     * @type {number}
     * @memberof InodePathInner
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof InodePathInner
     */
    'name'?: string;
}
/**
 * Folders without parents are considered \"categories\". 
 * @export
 * @interface InodeResults
 */
export interface InodeResults {
    /**
     * 
     * @type {string}
     * @memberof InodeResults
     */
    'create_category_url'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof InodeResults
     * @deprecated
     */
    'count': number;
    /**
     * 
     * @type {Array<Inode>}
     * @memberof InodeResults
     */
    'results': Array<Inode>;
}
/**
 * A Level creates an interface between multiple Clients, allowing to have common Groups, Topics, Events and even shared member lists. Levels have their own set of LevelAbilities. 
 * @export
 * @interface Level
 */
export interface Level {
    /**
     * 
     * @type {number}
     * @memberof Level
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Level
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Level
     */
    'description': string;
    /**
     * 
     * @type {boolean}
     * @memberof Level
     */
    'has_drive': boolean;
    /**
     * The abilities that the admins of the level can assign to groups. Also admins of this level cannot have other abilities than in this list.
     * @type {Array<LevelAbility>}
     * @memberof Level
     */
    'available_abilities': Array<LevelAbility>;
    /**
     * The abilities that the admins of the level cannot assign to groups.
     * @type {Array<LevelAbility>}
     * @memberof Level
     */
    'unavailable_abilities': Array<LevelAbility>;
    /**
     * 
     * @type {string}
     * @memberof Level
     */
    'url': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const LevelAbility = {
    LevelAdmin: 'LEVEL_ADMIN',
    PartialLevelExport: 'PARTIAL_LEVEL_EXPORT',
    FullLevelExport: 'FULL_LEVEL_EXPORT',
    EditLevelMembers: 'EDIT_LEVEL_MEMBERS',
    ManageLevelDrive: 'MANAGE_LEVEL_DRIVE',
    SendUrgentLevelDigest: 'SEND_URGENT_LEVEL_DIGEST',
    SeeInvisibleLevelMembers: 'SEE_INVISIBLE_LEVEL_MEMBERS',
    DeleteLevelMembers: 'DELETE_LEVEL_MEMBERS',
    MakeLevelMembersInvisible: 'MAKE_LEVEL_MEMBERS_INVISIBLE'
} as const;

export type LevelAbility = typeof LevelAbility[keyof typeof LevelAbility];


/**
 * Request body to create a new Level.
 * @export
 * @interface LevelCreateRequest
 */
export interface LevelCreateRequest {
    /**
     * Name of the level
     * @type {string}
     * @memberof LevelCreateRequest
     */
    'name': string;
    /**
     * Description of the level
     * @type {string}
     * @memberof LevelCreateRequest
     */
    'description'?: string;
    /**
     * Whether the level has a drive
     * @type {boolean}
     * @memberof LevelCreateRequest
     */
    'has_drive'?: boolean;
    /**
     * List of abilities available for the level.
     * @type {Array<LevelAbility>}
     * @memberof LevelCreateRequest
     */
    'available_abilities'?: Array<LevelAbility> | null;
    /**
     * List of client IDs associated with the level.
     * @type {Array<number>}
     * @memberof LevelCreateRequest
     */
    'client_ids'?: Array<number> | null;
}
/**
 * 
 * @export
 * @interface LevelUpdateRequest
 */
export interface LevelUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof LevelUpdateRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof LevelUpdateRequest
     */
    'description': string;
    /**
     * 
     * @type {boolean}
     * @memberof LevelUpdateRequest
     */
    'has_drive': boolean;
    /**
     * Replaces the list of clients of this level with this list, use with care.
     * @type {Array<number>}
     * @memberof LevelUpdateRequest
     */
    'client_ids': Array<number> | null;
    /**
     * Replaces the list of available abilities of this level with this list.
     * @type {Array<string>}
     * @memberof LevelUpdateRequest
     */
    'available_abilities': Array<string> | null;
}
/**
 * Login statistics grouped by age ranges
 * @export
 * @interface LoginByAgeStats
 */
export interface LoginByAgeStats {
    /**
     * Array of age group login statistics
     * @type {Array<LoginByAgeStatsStatsInner>}
     * @memberof LoginByAgeStats
     */
    'stats': Array<LoginByAgeStatsStatsInner>;
    /**
     * Invalid records excluded from statistics
     * @type {Array<AgeStatsInvalidInner>}
     * @memberof LoginByAgeStats
     */
    'invalid': Array<AgeStatsInvalidInner>;
}
/**
 * 
 * @export
 * @interface LoginByAgeStatsStatsInner
 */
export interface LoginByAgeStatsStatsInner {
    /**
     * Age group name
     * @type {string}
     * @memberof LoginByAgeStatsStatsInner
     */
    'name'?: string;
    /**
     * Login frequency data for this age group
     * @type {Array<Array<LoginByAgeStatsStatsInnerDataInnerInner>>}
     * @memberof LoginByAgeStatsStatsInner
     */
    'data'?: Array<Array<LoginByAgeStatsStatsInnerDataInnerInner>>;
}
/**
 * 
 * @export
 * @interface LoginByAgeStatsStatsInnerDataInnerInner
 */
export interface LoginByAgeStatsStatsInnerDataInnerInner {
}
/**
 * Login statistics based on time between logins
 * @export
 * @interface LoginMeantimeStats
 */
export interface LoginMeantimeStats {
    /**
     * 
     * @type {LoginMeantimeStatsStats}
     * @memberof LoginMeantimeStats
     */
    'stats': LoginMeantimeStatsStats;
    /**
     * Invalid records excluded from statistics
     * @type {Array<AgeStatsInvalidInner>}
     * @memberof LoginMeantimeStats
     */
    'invalid': Array<AgeStatsInvalidInner>;
}
/**
 * Login frequency statistics
 * @export
 * @interface LoginMeantimeStatsStats
 */
export interface LoginMeantimeStatsStats {
    /**
     * Users who log in within 1 week
     * @type {number}
     * @memberof LoginMeantimeStatsStats
     */
    '1w'?: number;
    /**
     * Users who log in within 1 month
     * @type {number}
     * @memberof LoginMeantimeStatsStats
     */
    '1m'?: number;
    /**
     * Users who log in within 1 year
     * @type {number}
     * @memberof LoginMeantimeStatsStats
     */
    '1y'?: number;
    /**
     * Users who have only logged in once
     * @type {number}
     * @memberof LoginMeantimeStatsStats
     */
    'once'?: number;
}
/**
 * Login statistics based on weeks since last login
 * @export
 * @interface LoginWeeksStats
 */
export interface LoginWeeksStats {
    /**
     * Weekly login statistics where keys are week numbers and values are user counts
     * @type {{ [key: string]: number; }}
     * @memberof LoginWeeksStats
     */
    'stats': { [key: string]: number; };
    /**
     * Invalid records excluded from statistics
     * @type {Array<AgeStatsInvalidInner>}
     * @memberof LoginWeeksStats
     */
    'invalid': Array<AgeStatsInvalidInner>;
}
/**
 * 
 * @export
 * @interface Member
 */
export interface Member {
    /**
     * 
     * @type {number}
     * @memberof Member
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof Member
     */
    'club_record_id': number;
    /**
     * 
     * @type {number}
     * @memberof Member
     */
    'client_id': number;
    /**
     * 
     * @type {number}
     * @memberof Member
     */
    'user_id': number;
    /**
     * 
     * @type {number}
     * @memberof Member
     */
    'personal_record_id': number;
    /**
     * 
     * @type {Array<AbilitiesInner>}
     * @memberof Member
     */
    'abilities': Array<AbilitiesInner>;
    /**
     * 
     * @type {Array<number>}
     * @memberof Member
     */
    'group_ids_array': Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof Member
     */
    'clients': Array<number>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Member
     */
    'chairs': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Member
     */
    'client_name': string;
    /**
     * 
     * @type {string}
     * @memberof Member
     */
    'client_subdomain': string;
    /**
     * 
     * @type {boolean}
     * @memberof Member
     */
    'active': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Member
     */
    'show_wizard': boolean;
    /**
     * 
     * @type {string}
     * @memberof Member
     */
    'title': string | null;
    /**
     * 
     * @type {string}
     * @memberof Member
     */
    'first_name': string | null;
    /**
     * Nobility particle of the last name
     * @type {string}
     * @memberof Member
     */
    'particle': string | null;
    /**
     * 
     * @type {string}
     * @memberof Member
     */
    'last_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof Member
     */
    'full_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof Member
     */
    'email': string | null;
    /**
     * 
     * @type {string}
     * @memberof Member
     */
    'unconfirmed_email': string | null;
    /**
     * Either a precise date, with omitted day or year only. Can also take the form of a semester. 
     * @type {string}
     * @memberof Member
     */
    'birthdate': string;
    /**
     * 
     * @type {string}
     * @memberof Member
     */
    'birthplace': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof Member
     */
    'alive': boolean;
    /**
     * 
     * @type {number}
     * @memberof Member
     */
    'age': number | null;
    /**
     * Either a precise date, with omitted day or year only. Can also take the form of a semester. 
     * @type {string}
     * @memberof Member
     */
    'date_of_death': string;
    /**
     * 
     * @type {string}
     * @memberof Member
     */
    'place_of_death': string | null;
    /**
     * 
     * @type {string}
     * @memberof Member
     */
    'phone_number': string | null;
    /**
     * 
     * @type {string}
     * @memberof Member
     */
    'company': string | null;
    /**
     * 
     * @type {string}
     * @memberof Member
     */
    'position': string | null;
    /**
     * 
     * @type {string}
     * @memberof Member
     */
    'studies': string | null;
    /**
     * 
     * @type {string}
     * @memberof Member
     */
    'academic_title': string | null;
    /**
     * 
     * @type {string}
     * @memberof Member
     */
    'job': string | null;
    /**
     * 
     * @type {string}
     * @memberof Member
     */
    'website': string | null;
    /**
     * 
     * @type {string}
     * @memberof Member
     */
    'facebook': string | null;
    /**
     * 
     * @type {string}
     * @memberof Member
     */
    'instagram': string | null;
    /**
     * 
     * @type {string}
     * @memberof Member
     */
    'twitter': string | null;
    /**
     * Avatar from the PersonalRecord
     * @type {string}
     * @memberof Member
     */
    'avatar': string;
    /**
     * Avatar URL from the PersonalRecord
     * @type {string}
     * @memberof Member
     */
    'avatar_url': string;
    /**
     * 
     * @type {EmailStatuses}
     * @memberof Member
     */
    'email_status': EmailStatuses;
    /**
     * 
     * @type {boolean}
     * @memberof Member
     */
    'verified': boolean;
    /**
     * 
     * @type {string}
     * @memberof Member
     */
    'vulgo': string | null;
    /**
     * 
     * @type {string}
     * @memberof Member
     */
    'vulgo_without_particle': string | null;
    /**
     * Prefix of the Status
     * @type {string}
     * @memberof Member
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof Member
     */
    'chargen': string | null;
    /**
     * 
     * @type {string}
     * @memberof Member
     */
    'internal_name_short': string;
    /**
     * 
     * @type {string}
     * @memberof Member
     */
    'internal_name_long': string;
    /**
     * 
     * @type {string}
     * @memberof Member
     */
    'umbrella_name_short': string;
    /**
     * 
     * @type {string}
     * @memberof Member
     */
    'umbrella_name_long': string;
    /**
     * 
     * @type {string}
     * @memberof Member
     */
    'list_name': string;
    /**
     * 
     * @type {string}
     * @memberof Member
     */
    'sort_key': string;
    /**
     * Either a precise date, with omitted day or year only. Can also take the form of a semester. 
     * @type {string}
     * @memberof Member
     */
    'renonciert_at': string;
    /**
     * Either a precise date, with omitted day or year only. Can also take the form of a semester. 
     * @type {string}
     * @memberof Member
     */
    'recipiert_at': string;
    /**
     * Either a precise date, with omitted day or year only. Can also take the form of a semester. 
     * @type {string}
     * @memberof Member
     */
    'philistriert_at': string;
    /**
     * 
     * @type {boolean}
     * @memberof Member
     */
    'is_awarded': boolean;
    /**
     * Either a precise date, with omitted day or year only. Can also take the form of a semester. 
     * @type {string}
     * @memberof Member
     */
    'awarded_at': string;
    /**
     * 
     * @type {boolean}
     * @memberof Member
     */
    'resigned': boolean;
    /**
     * Either a precise date, with omitted day or year only. Can also take the form of a semester. 
     * @type {string}
     * @memberof Member
     */
    'joined_at': string;
    /**
     * 
     * @type {string}
     * @memberof Member
     */
    'region': string | null;
    /**
     * 
     * @type {string}
     * @memberof Member
     */
    'postal_code': string | null;
    /**
     * 
     * @type {string}
     * @memberof Member
     */
    'user_updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof Member
     */
    'personal_record_updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof Member
     */
    'club_record_updated_at': string;
    /**
     * Localized timestamp of last update
     * @type {string}
     * @memberof Member
     */
    'updated_at': string | null;
}


/**
 * 
 * @export
 * @interface MoveMembersRequest
 */
export interface MoveMembersRequest {
    /**
     * 
     * @type {MoveMembersRequestPayload}
     * @memberof MoveMembersRequest
     */
    'payload': MoveMembersRequestPayload;
}
/**
 * 
 * @export
 * @interface MoveMembersRequestPayload
 */
export interface MoveMembersRequestPayload {
    /**
     * 
     * @type {number}
     * @memberof MoveMembersRequestPayload
     */
    'from_id': number;
    /**
     * 
     * @type {number}
     * @memberof MoveMembersRequestPayload
     */
    'to_id': number;
}
/**
 * A natural person. Each PersonalRecord can have multiple ClubRecords, if he/she is member in a Client. 
 * @export
 * @interface PersonalRecord
 */
export interface PersonalRecord {
    /**
     * 
     * @type {number}
     * @memberof PersonalRecord
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof PersonalRecord
     */
    'sex': PersonalRecordSexEnum;
    /**
     * 
     * @type {boolean}
     * @memberof PersonalRecord
     */
    'is_relative': boolean;
    /**
     * 
     * @type {string}
     * @memberof PersonalRecord
     */
    'particle': string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalRecord
     */
    'name_without_particle': string;
    /**
     * 
     * @type {string}
     * @memberof PersonalRecord
     */
    'first_name': string | null;
    /**
     * 
     * @type {string}
     * @memberof PersonalRecord
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof PersonalRecord
     */
    'email': string | null;
    /**
     * Either a precise date, with omitted day or year only. Can also take the form of a semester. 
     * @type {string}
     * @memberof PersonalRecord
     */
    'birthdate': string;
    /**
     * 
     * @type {number}
     * @memberof PersonalRecord
     */
    'age': number | null;
    /**
     * 
     * @type {boolean}
     * @memberof PersonalRecord
     */
    'alive': boolean;
    /**
     * 
     * @type {string}
     * @memberof PersonalRecord
     */
    'date_of_death': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PersonalRecord
     * @deprecated
     */
    'edit': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PersonalRecord
     */
    'is_spef': boolean | null;
    /**
     * 
     * @type {EmailStatuses}
     * @memberof PersonalRecord
     */
    'email_status': EmailStatuses;
    /**
     * 
     * @type {Array<PersonalRecordColorsInner>}
     * @memberof PersonalRecord
     */
    'colors': Array<PersonalRecordColorsInner>;
    /**
     * 
     * @type {Array<InodePathInner>}
     * @memberof PersonalRecord
     */
    'address_lists': Array<InodePathInner>;
    /**
     * 
     * @type {Array<PersonalRecordAbosInner>}
     * @memberof PersonalRecord
     */
    'abos': Array<PersonalRecordAbosInner>;
}

export const PersonalRecordSexEnum = {
    Male: 'male',
    Female: 'female',
    Family: 'family',
    Company: 'company'
} as const;

export type PersonalRecordSexEnum = typeof PersonalRecordSexEnum[keyof typeof PersonalRecordSexEnum];

/**
 * 
 * @export
 * @interface PersonalRecordAbosInner
 */
export interface PersonalRecordAbosInner {
    /**
     * 
     * @type {number}
     * @memberof PersonalRecordAbosInner
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof PersonalRecordAbosInner
     */
    'magazine'?: string;
    /**
     * 
     * @type {number}
     * @memberof PersonalRecordAbosInner
     */
    'copies'?: number;
}
/**
 * 
 * @export
 * @interface PersonalRecordColorsInner
 */
export interface PersonalRecordColorsInner {
    /**
     * 
     * @type {string}
     * @memberof PersonalRecordColorsInner
     */
    'colors_css'?: string;
    /**
     * 
     * @type {string}
     * @memberof PersonalRecordColorsInner
     */
    'colors_title'?: string;
}
/**
 * 
 * @export
 * @interface Photo
 */
export interface Photo {
    /**
     * 
     * @type {number}
     * @memberof Photo
     */
    'id': number;
    /**
     * General classification of the file type to decide whether to treat as an file with an image preview.
     * @type {string}
     * @memberof Photo
     */
    'type': PhotoTypeEnum;
    /**
     * Name of the file, excluding the file type extension.
     * @type {string}
     * @memberof Photo
     */
    'file_name': string;
    /**
     * Horizontal dimension of the original file in pixel.
     * @type {number}
     * @memberof Photo
     */
    'width': number | null;
    /**
     * Vertical dimension of the original file in pixel.
     * @type {number}
     * @memberof Photo
     */
    'height': number | null;
    /**
     * File size in Byte
     * @type {number}
     * @memberof Photo
     */
    'file_size': number | null;
    /**
     * MIME Type of the file. May be null if the type could not be determined or was unknown.
     * @type {string}
     * @memberof Photo
     */
    'content_type': string | null;
    /**
     * File type extension of the detected mime type.
     * @type {string}
     * @memberof Photo
     */
    'file_type_extension': string | null;
    /**
     * 
     * @type {string}
     * @memberof Photo
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof Photo
     */
    'created_at': string;
    /**
     * 
     * @type {UploadedFileUploadedBy}
     * @memberof Photo
     */
    'uploaded_by': UploadedFileUploadedBy | null;
    /**
     * 
     * @type {PhotoAllOfOriginal}
     * @memberof Photo
     */
    'original': PhotoAllOfOriginal;
    /**
     * 
     * @type {PhotoAllOfPreview}
     * @memberof Photo
     */
    'preview': PhotoAllOfPreview;
    /**
     * 
     * @type {PhotoAllOfThumb}
     * @memberof Photo
     */
    'thumb': PhotoAllOfThumb;
    /**
     * 
     * @type {PhotoAllOfIcon}
     * @memberof Photo
     */
    'icon': PhotoAllOfIcon;
    /**
     * 
     * @type {PhotoAllOfLinks}
     * @memberof Photo
     */
    'links': PhotoAllOfLinks;
}

export const PhotoTypeEnum = {
    File: 'File',
    Image: 'Image'
} as const;

export type PhotoTypeEnum = typeof PhotoTypeEnum[keyof typeof PhotoTypeEnum];

/**
 * URL of the 50px x 50px sized image preview, cropped with center in focus if needed.
 * @export
 * @interface PhotoAllOfIcon
 */
export interface PhotoAllOfIcon {
    /**
     * 
     * @type {string}
     * @memberof PhotoAllOfIcon
     */
    'url'?: string;
    /**
     * 
     * @type {number}
     * @memberof PhotoAllOfIcon
     */
    'width'?: number;
    /**
     * 
     * @type {number}
     * @memberof PhotoAllOfIcon
     */
    'height'?: number;
}
/**
 * 
 * @export
 * @interface PhotoAllOfLinks
 */
export interface PhotoAllOfLinks {
    /**
     * URL of the 50px x 50px sized image preview, cropped with center in focus if needed.
     * @type {string}
     * @memberof PhotoAllOfLinks
     */
    'icon_url'?: string | null;
    /**
     * URL of the 200px x 200px sized thumbnail, cropped with center in focus if needed.
     * @type {string}
     * @memberof PhotoAllOfLinks
     */
    'thumb_url'?: string | null;
    /**
     * URL of the image preview, resized to 1200px without cropping.
     * @type {string}
     * @memberof PhotoAllOfLinks
     */
    'preview_url'?: string | null;
}
/**
 * The original file. Note that this might be huge, so use only for download or zoom-in features.
 * @export
 * @interface PhotoAllOfOriginal
 */
export interface PhotoAllOfOriginal {
    /**
     * 
     * @type {string}
     * @memberof PhotoAllOfOriginal
     */
    'url'?: string;
    /**
     * 
     * @type {number}
     * @memberof PhotoAllOfOriginal
     */
    'width'?: number;
    /**
     * 
     * @type {number}
     * @memberof PhotoAllOfOriginal
     */
    'height'?: number;
}
/**
 * URL of the image preview, resized to 1200px without cropping.
 * @export
 * @interface PhotoAllOfPreview
 */
export interface PhotoAllOfPreview {
    /**
     * 
     * @type {string}
     * @memberof PhotoAllOfPreview
     */
    'url'?: string;
    /**
     * 
     * @type {number}
     * @memberof PhotoAllOfPreview
     */
    'width'?: number;
    /**
     * 
     * @type {number}
     * @memberof PhotoAllOfPreview
     */
    'height'?: number;
}
/**
 * URL of the 200px x 200px sized thumbnail, cropped with center in focus if needed.
 * @export
 * @interface PhotoAllOfThumb
 */
export interface PhotoAllOfThumb {
    /**
     * 
     * @type {string}
     * @memberof PhotoAllOfThumb
     */
    'url'?: string;
    /**
     * 
     * @type {number}
     * @memberof PhotoAllOfThumb
     */
    'width'?: number;
    /**
     * 
     * @type {number}
     * @memberof PhotoAllOfThumb
     */
    'height'?: number;
}
/**
 * User signup pickup statistics over time
 * @export
 * @interface PickupStats
 */
export interface PickupStats {
    /**
     * Array of date-count pairs showing cumulative user signups
     * @type {Array<Array<PickupStatsStatsInnerInner>>}
     * @memberof PickupStats
     */
    'stats': Array<Array<PickupStatsStatsInnerInner>>;
    /**
     * Invalid records excluded from statistics
     * @type {Array<AgeStatsInvalidInner>}
     * @memberof PickupStats
     */
    'invalid': Array<AgeStatsInvalidInner>;
}
/**
 * 
 * @export
 * @interface PickupStatsStatsInnerInner
 */
export interface PickupStatsStatsInnerInner {
}
/**
 * 
 * @export
 * @interface Post
 */
export interface Post {
    /**
     * 
     * @type {number}
     * @memberof Post
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Post
     */
    'text': string;
    /**
     * 
     * @type {number}
     * @memberof Post
     */
    'comments_count': number;
    /**
     * 
     * @type {number}
     * @memberof Post
     */
    'likes_count': number;
    /**
     * 
     * @type {number}
     * @memberof Post
     */
    'ideas_count': number;
    /**
     * 
     * @type {number}
     * @memberof Post
     */
    'cheers_count': number;
    /**
     * Total number of EventMedia uploaded in this Post.
     * @type {number}
     * @memberof Post
     */
    'event_media_count': number;
    /**
     * Total number of EventMedia uploaded in this Post that are highlights.
     * @type {number}
     * @memberof Post
     */
    'highlights_count': number;
    /**
     * 
     * @type {GroupMember}
     * @memberof Post
     */
    'creator': GroupMember;
    /**
     * 
     * @type {Reaction}
     * @memberof Post
     */
    'own_reaction': Reaction | null;
    /**
     * 
     * @type {Array<Comment>}
     * @memberof Post
     */
    'comments': Array<Comment>;
    /**
     * 
     * @type {Array<Attachment>}
     * @memberof Post
     */
    'attachments': Array<Attachment>;
    /**
     * A preview of max. 8 EventMedia eagerly loaded to show in the preview of the Post.
     * @type {Array<EventMedium>}
     * @memberof Post
     */
    'event_media_preview': Array<EventMedium>;
    /**
     * 
     * @type {string}
     * @memberof Post
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof Post
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof Post
     */
    'url': string;
    /**
     * 
     * @type {PostLinks}
     * @memberof Post
     */
    'links': PostLinks;
}
/**
 * 
 * @export
 * @interface PostLinks
 */
export interface PostLinks {
    /**
     * 
     * @type {string}
     * @memberof PostLinks
     */
    'update_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PostLinks
     */
    'delete_url'?: string | null;
    /**
     * 
     * @type {CommentLinksReactions}
     * @memberof PostLinks
     */
    'reactions'?: CommentLinksReactions;
    /**
     * 
     * @type {CommentLinksReactions}
     * @memberof PostLinks
     */
    'comments'?: CommentLinksReactions;
}
/**
 * Request body to create a new Post.
 * @export
 * @interface PostRequest
 */
export interface PostRequest {
    /**
     * Text of the post
     * @type {string}
     * @memberof PostRequest
     */
    'text': string;
}
/**
 * A registration of a device for WebPush. Note that there may be multiple registrations for a single user.
 * @export
 * @interface PushRegistration
 */
export interface PushRegistration {
    /**
     * Unique Identifier of this PushRegistration.
     * @type {number}
     * @memberof PushRegistration
     */
    'id': number;
    /**
     * Registration ID of the push device
     * @type {string}
     * @memberof PushRegistration
     */
    'registration_id': string;
    /**
     * ID of the ClubRecord of this PushRegistration.
     * @type {number}
     * @memberof PushRegistration
     */
    'club_record_id': number;
    /**
     * Timestamp when the user clicked last on a notification that was delivered to this device
     * @type {string}
     * @memberof PushRegistration
     */
    'last_notification_clicked_at': string | null;
    /**
     * Date when the PushRegistration was created
     * @type {string}
     * @memberof PushRegistration
     */
    'created_at': string;
    /**
     * Date when the PushRegistration was last updated, e.g. when received a ping that the device was used.
     * @type {string}
     * @memberof PushRegistration
     */
    'updated_at': string;
}
/**
 * Request body to create a new PushRegistration.
 * @export
 * @interface PushRegistrationRequest
 */
export interface PushRegistrationRequest {
    /**
     * Registration ID of the push device
     * @type {string}
     * @memberof PushRegistrationRequest
     */
    'registration_id': string;
}
/**
 * 
 * @export
 * @interface Reaction
 */
export interface Reaction {
    /**
     * 
     * @type {number}
     * @memberof Reaction
     */
    'id': number;
    /**
     * 
     * @type {Emoji}
     * @memberof Reaction
     */
    'emoji': Emoji;
    /**
     * 
     * @type {GroupMember}
     * @memberof Reaction
     */
    'creator': GroupMember;
    /**
     * 
     * @type {string}
     * @memberof Reaction
     */
    'created_at': string;
}


/**
 * A RSVP (fr.: répondez s\'il vous plaît) is a entity for tracking status of people that may join an event.
 * @export
 * @interface Rsvp
 */
export interface Rsvp {
    /**
     * Event ID where this RSVP is about.
     * @type {number}
     * @memberof Rsvp
     */
    'event_id': number;
    /**
     * PersonalRecord of the person that may or may not join this event.
     * @type {number}
     * @memberof Rsvp
     */
    'personal_record_id': number;
    /**
     * Context-Name of the member w.r.t. the Client/Level where the group of this event is created in.
     * @type {string}
     * @memberof Rsvp
     */
    'name': string | null;
    /**
     * Number of guests that this person brings additional to his/her own attendance.
     * @type {number}
     * @memberof Rsvp
     */
    'guests_count': number | null;
    /**
     * URL of the Profile Page of this PersonalRecord. Empty if the current use ris not permitted to see the profile URL.
     * @type {string}
     * @memberof Rsvp
     */
    'url': string | null;
    /**
     * Email of the PersonalRecord of this RSVP.
     * @type {string}
     * @memberof Rsvp
     */
    'email': string | null;
    /**
     * URL of the avatar of the PersonalRecord (scaled down to Photo.PREVIEW_SIZE)
     * @type {string}
     * @memberof Rsvp
     */
    'avatar_url': string;
    /**
     * The RSVP of this person is of special interest for the current user.
     * @type {boolean}
     * @memberof Rsvp
     */
    'is_coetan': boolean;
    /**
     * 
     * @type {RsvpReply}
     * @memberof Rsvp
     */
    'reply': RsvpReply;
    /**
     * 
     * @type {RsvpReply}
     * @memberof Rsvp
     */
    'type': RsvpReply;
    /**
     * Indicates if the registration was completed or e.g. guests are not yet added or explicitly skipped.
     * @type {boolean}
     * @memberof Rsvp
     */
    'finished_registration': boolean;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const RsvpReply = {
    Pending: 'pending',
    Decline: 'decline',
    Attend: 'attend'
} as const;

export type RsvpReply = typeof RsvpReply[keyof typeof RsvpReply];


/**
 * Request to create a new RSVP.
 * @export
 * @interface RsvpRequest
 */
export interface RsvpRequest {
    /**
     * 
     * @type {RsvpReply}
     * @memberof RsvpRequest
     */
    'reply': RsvpReply;
    /**
     * Number of guests additional to the person itself.
     * @type {number}
     * @memberof RsvpRequest
     */
    'guests_count'?: number;
}


/**
 * 
 * @export
 * @interface SendTestNotification200Response
 */
export interface SendTestNotification200Response {
    /**
     * 
     * @type {string}
     * @memberof SendTestNotification200Response
     */
    'message_id'?: string;
}
/**
 * 
 * @export
 * @interface SetChangelogViewedNow200Response
 */
export interface SetChangelogViewedNow200Response {
    /**
     * 
     * @type {string}
     * @memberof SetChangelogViewedNow200Response
     */
    'changelog_last_viewed_at'?: string;
}
/**
 * 
 * @export
 * @interface SimulateLiquidTemplate200Response
 */
export interface SimulateLiquidTemplate200Response {
    /**
     * 
     * @type {string}
     * @memberof SimulateLiquidTemplate200Response
     */
    'value'?: string;
    /**
     * 
     * @type {string}
     * @memberof SimulateLiquidTemplate200Response
     */
    'template'?: string;
}
/**
 * 
 * @export
 * @interface Tag
 */
export interface Tag {
    /**
     * 
     * @type {number}
     * @memberof Tag
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Tag
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof Tag
     */
    'taggings_count': number;
    /**
     * 
     * @type {number}
     * @memberof Tag
     */
    'client_id': number;
    /**
     * 
     * @type {string}
     * @memberof Tag
     */
    'url': string | null;
}
/**
 * 
 * @export
 * @interface Topic
 */
export interface Topic {
    /**
     * 
     * @type {number}
     * @memberof Topic
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Topic
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof Topic
     */
    'text': string;
    /**
     * 
     * @type {string}
     * @memberof Topic
     */
    'nonmember_access': TopicNonmemberAccessEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof Topic
     */
    'topic_tag_list': Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof Topic
     */
    'urgent': boolean;
    /**
     * 
     * @type {string}
     * @memberof Topic
     */
    'mailed_at': string | null;
    /**
     * 
     * @type {GroupMember}
     * @memberof Topic
     */
    'mailed_by': GroupMember | null;
    /**
     * 
     * @type {GroupMember}
     * @memberof Topic
     */
    'creator': GroupMember;
    /**
     * 
     * @type {Group}
     * @memberof Topic
     */
    'group': Group;
    /**
     * 
     * @type {Reaction}
     * @memberof Topic
     */
    'own_reaction': Reaction | null;
    /**
     * 
     * @type {Array<Comment>}
     * @memberof Topic
     */
    'comments': Array<Comment>;
    /**
     * 
     * @type {Array<Attachment>}
     * @memberof Topic
     */
    'attachments': Array<Attachment>;
    /**
     * 
     * @type {number}
     * @memberof Topic
     */
    'posts_count': number;
    /**
     * 
     * @type {number}
     * @memberof Topic
     */
    'comments_count': number;
    /**
     * 
     * @type {number}
     * @memberof Topic
     */
    'likes_count': number;
    /**
     * 
     * @type {number}
     * @memberof Topic
     */
    'ideas_count': number;
    /**
     * 
     * @type {number}
     * @memberof Topic
     */
    'cheers_count': number;
    /**
     * 
     * @type {string}
     * @memberof Topic
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof Topic
     */
    'updated_at': string;
    /**
     * 
     * @type {TopicLinks}
     * @memberof Topic
     */
    'links': TopicLinks;
}

export const TopicNonmemberAccessEnum = {
    Read: 'read',
    Write: 'write',
    Hidden: 'hidden'
} as const;

export type TopicNonmemberAccessEnum = typeof TopicNonmemberAccessEnum[keyof typeof TopicNonmemberAccessEnum];

/**
 * Request body to create a new Topic.
 * @export
 * @interface TopicCreateRequest
 */
export interface TopicCreateRequest {
    /**
     * Title of the topic
     * @type {string}
     * @memberof TopicCreateRequest
     */
    'title': string;
    /**
     * Text of the topic
     * @type {string}
     * @memberof TopicCreateRequest
     */
    'text': string;
    /**
     * Id of associated group
     * @type {number}
     * @memberof TopicCreateRequest
     */
    'group_id': number;
    /**
     * Comma separated list of tags
     * @type {string}
     * @memberof TopicCreateRequest
     */
    'topic_tag_list'?: string;
}
/**
 * 
 * @export
 * @interface TopicLinks
 */
export interface TopicLinks {
    /**
     * 
     * @type {string}
     * @memberof TopicLinks
     */
    'update_url'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TopicLinks
     */
    'delete_url'?: string | null;
    /**
     * 
     * @type {CommentLinksReactions}
     * @memberof TopicLinks
     */
    'reactions'?: CommentLinksReactions;
    /**
     * 
     * @type {CommentLinksReactions}
     * @memberof TopicLinks
     */
    'posts'?: CommentLinksReactions;
}
/**
 * Request body to update a new Topic.
 * @export
 * @interface TopicUpdateRequest
 */
export interface TopicUpdateRequest {
    /**
     * Title of the topic
     * @type {string}
     * @memberof TopicUpdateRequest
     */
    'title': string;
    /**
     * Text of the topic
     * @type {string}
     * @memberof TopicUpdateRequest
     */
    'text': string;
    /**
     * Id of associated group
     * @type {number}
     * @memberof TopicUpdateRequest
     */
    'group_id': number;
    /**
     * Comma separated list of tags
     * @type {string}
     * @memberof TopicUpdateRequest
     */
    'topic_tag_list': string;
    /**
     * Indicates if the topic is urgent and should trigger a digest now
     * @type {boolean}
     * @memberof TopicUpdateRequest
     */
    'urgent': boolean;
}
/**
 * 
 * @export
 * @interface Umbrella
 */
export interface Umbrella {
    /**
     * Unique identifier for the umbrella organization
     * @type {number}
     * @memberof Umbrella
     */
    'id': number;
    /**
     * Full name of the umbrella organization
     * @type {string}
     * @memberof Umbrella
     */
    'name': string;
    /**
     * Short identifier or abbreviation for the umbrella
     * @type {string}
     * @memberof Umbrella
     */
    'shorthand': string;
    /**
     * Suffix that is added to the client name of clients from this umbrella
     * @type {string}
     * @memberof Umbrella
     */
    'suffix'?: string;
    /**
     * Liquid template for generating short umbrella names when displaying members to people from other clients
     * @type {string}
     * @memberof Umbrella
     */
    'umbrella_name_short_template': string;
    /**
     * Liquid template for generating long umbrella names when displaying members to people from other clients
     * @type {string}
     * @memberof Umbrella
     */
    'umbrella_name_long_template': string;
    /**
     * Default group structure configuration for new clients under this umbrella
     * @type {Array<object>}
     * @memberof Umbrella
     */
    'default_group_structure'?: Array<object>;
    /**
     * List of clients associated with this umbrella (only present in show action)
     * @type {Array<Client>}
     * @memberof Umbrella
     */
    'clients'?: Array<Client> | null;
    /**
     * Timestamp when the umbrella was created
     * @type {string}
     * @memberof Umbrella
     */
    'created_at'?: string;
    /**
     * Timestamp when the umbrella was last updated
     * @type {string}
     * @memberof Umbrella
     */
    'updated_at'?: string;
}
/**
 * 
 * @export
 * @interface UmbrellaRequest
 */
export interface UmbrellaRequest {
    /**
     * Short identifier or abbreviation for the umbrella
     * @type {string}
     * @memberof UmbrellaRequest
     */
    'shorthand': string;
    /**
     * Full name of the umbrella organization
     * @type {string}
     * @memberof UmbrellaRequest
     */
    'name': string;
    /**
     * Suffix that is added to the client name of clients from this umbrella
     * @type {string}
     * @memberof UmbrellaRequest
     */
    'suffix'?: string;
    /**
     * Liquid template for generating short umbrella names when displaying members to people from other clients
     * @type {string}
     * @memberof UmbrellaRequest
     */
    'umbrella_name_short_template': string;
    /**
     * Liquid template for generating long umbrella names when displaying members to people from other clients
     * @type {string}
     * @memberof UmbrellaRequest
     */
    'umbrella_name_long_template': string;
}
/**
 * Update an existing Custom Attribute Definition. The update can take up to a few minutes to complete. Expect the request to take up to a minute and afterwards certain background jobs will be scheduled potentially  e.g. to update the values of the Custom Attributes. While the update is in progress, the Custom Attribute Definition is locked for further modifications. Requests to update this Custom Attribute Definition will return a HTTP 423 (Locked) response. 
 * @export
 * @interface UpdateCustomAttributeDefinitionRequest
 */
export interface UpdateCustomAttributeDefinitionRequest {
    /**
     * The human readable name of the attribute.
     * @type {string}
     * @memberof UpdateCustomAttributeDefinitionRequest
     */
    'name': string;
    /**
     * A description of the Custom Attribute for the user.
     * @type {string}
     * @memberof UpdateCustomAttributeDefinitionRequest
     */
    'description': string | null;
    /**
     * WARNING: If you change the type from ClubRecord to PersonalRecord only the values from the ClubRecord of the    owner (Client or Client being member at this Level) of the CustomAttributeDefinition will be kept. Values from other ClubRecords wil be deleted!    Memberships at ancestor clients are considered after \"native\" memberships.    For Level-Attributes where multiple ClubRecords are in a Client that is member of this Level, it is undefined which of the candidate values is chosen, so change with care!  Type of the entity this attribute should be attached to. If ClubRecord, that each ClubRecord of the Member will receive this attribute, so multiple values (one per ClubRecord) are possible. If you choose PersonalRecord the attribute is associated to the person itself so there is only one value per person. 
     * @type {string}
     * @memberof UpdateCustomAttributeDefinitionRequest
     */
    'attributable_type': UpdateCustomAttributeDefinitionRequestAttributableTypeEnum;
    /**
     * 
     * @type {CustomAttributeTypeEnum}
     * @memberof UpdateCustomAttributeDefinitionRequest
     */
    'attribute_type': CustomAttributeTypeEnum;
    /**
     * Additional settings for certain attribute types:   - For Select: An array of strings representing the possible values. 
     * @type {Array<string>}
     * @memberof UpdateCustomAttributeDefinitionRequest
     */
    'config': Array<string> | null;
    /**
     * Set to true to hide the field when viewing the profile if it is empty.
     * @type {boolean}
     * @memberof UpdateCustomAttributeDefinitionRequest
     */
    'hide_when_empty': boolean;
    /**
     * 
     * @type {CustomAttributeReadAccessEnum}
     * @memberof UpdateCustomAttributeDefinitionRequest
     */
    'read_access': CustomAttributeReadAccessEnum;
    /**
     * 
     * @type {CustomAttributeWriteAccessEnum}
     * @memberof UpdateCustomAttributeDefinitionRequest
     */
    'write_access': CustomAttributeWriteAccessEnum;
    /**
     * Leave null if you want to define a level attribute.
     * @type {number}
     * @memberof UpdateCustomAttributeDefinitionRequest
     */
    'client_id': number | null;
    /**
     * Leave null if you want to define a client attribute.
     * @type {number}
     * @memberof UpdateCustomAttributeDefinitionRequest
     */
    'level_id': number | null;
    /**
     * Index used for ordering relative to sibling CustomAttributeDefintions of this attributable.
     * @type {number}
     * @memberof UpdateCustomAttributeDefinitionRequest
     */
    'index': number | null;
    /**
     * If true, the attribute will be moved to the front of the list at its attributable.
     * @type {boolean}
     * @memberof UpdateCustomAttributeDefinitionRequest
     */
    'send_to_front': boolean | null;
    /**
     * If true, the attribute will be moved to the back of the list at its attributable.
     * @type {boolean}
     * @memberof UpdateCustomAttributeDefinitionRequest
     */
    'send_to_back': boolean | null;
}

export const UpdateCustomAttributeDefinitionRequestAttributableTypeEnum = {
    PersonalRecord: 'PersonalRecord',
    ClubRecord: 'ClubRecord'
} as const;

export type UpdateCustomAttributeDefinitionRequestAttributableTypeEnum = typeof UpdateCustomAttributeDefinitionRequestAttributableTypeEnum[keyof typeof UpdateCustomAttributeDefinitionRequestAttributableTypeEnum];

/**
 * 
 * @export
 * @interface UpdateEventAttachmentRequest
 */
export interface UpdateEventAttachmentRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateEventAttachmentRequest
     */
    'name'?: string;
}
/**
 * Update a folder.
 * @export
 * @interface UpdateFolderRequest
 */
export interface UpdateFolderRequest {
    /**
     * 
     * @type {UpdateFolderRequestInode}
     * @memberof UpdateFolderRequest
     */
    'inode': UpdateFolderRequestInode;
}
/**
 * 
 * @export
 * @interface UpdateFolderRequestInode
 */
export interface UpdateFolderRequestInode {
    /**
     * 
     * @type {string}
     * @memberof UpdateFolderRequestInode
     */
    'type': UpdateFolderRequestInodeTypeEnum;
    /**
     * The name of the file or folder.
     * @type {string}
     * @memberof UpdateFolderRequestInode
     */
    'name': string;
    /**
     * Some optional descriptional text of the file or folder.
     * @type {string}
     * @memberof UpdateFolderRequestInode
     */
    'description': string | null;
    /**
     * ID of the parent folder, if any. If empty the folder is considered a category.
     * @type {number}
     * @memberof UpdateFolderRequestInode
     */
    'parent_id': number | null;
    /**
     * Limits the access to the folder and its (transitive) contents to a Group.
     * @type {number}
     * @memberof UpdateFolderRequestInode
     */
    'restrict_to_id': number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateFolderRequestInode
     */
    'owner_id': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateFolderRequestInode
     */
    'owner_type': UpdateFolderRequestInodeOwnerTypeEnum;
    /**
     * Shares the folder and its contents with a Level.
     * @type {number}
     * @memberof UpdateFolderRequestInode
     */
    'shared_level_id'?: number | null;
    /**
     * Index used for ordering relative to sibling folders.
     * @type {number}
     * @memberof UpdateFolderRequestInode
     */
    'order'?: number;
    /**
     * Ordering of the direct contents of this folder.
     * @type {Array<string>}
     * @memberof UpdateFolderRequestInode
     */
    'ordering'?: Array<UpdateFolderRequestInodeOrderingEnum> | null;
}

export const UpdateFolderRequestInodeTypeEnum = {
    Folder: 'Folder',
    Container: 'Container',
    Gallery: 'Gallery',
    UploadedFile: 'UploadedFile',
    Photo: 'Photo',
    ContainerFile: 'ContainerFile'
} as const;

export type UpdateFolderRequestInodeTypeEnum = typeof UpdateFolderRequestInodeTypeEnum[keyof typeof UpdateFolderRequestInodeTypeEnum];
export const UpdateFolderRequestInodeOwnerTypeEnum = {
    GroupMember: 'GroupMember',
    Group: 'Group'
} as const;

export type UpdateFolderRequestInodeOwnerTypeEnum = typeof UpdateFolderRequestInodeOwnerTypeEnum[keyof typeof UpdateFolderRequestInodeOwnerTypeEnum];
export const UpdateFolderRequestInodeOrderingEnum = {
    Name: '<name',
    Name2: '>name',
    PhysicallyCreatedAt: '<physically_created_at',
    PhysicallyCreatedAt2: '>physically_created_at',
    CreatedAt: '<created_at',
    CreatedAt2: '>created_at'
} as const;

export type UpdateFolderRequestInodeOrderingEnum = typeof UpdateFolderRequestInodeOrderingEnum[keyof typeof UpdateFolderRequestInodeOrderingEnum];

/**
 * Update a file or a folder.
 * @export
 * @interface UpdateInodeRequest
 */
export interface UpdateInodeRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateInodeRequest
     */
    'type': UpdateInodeRequestTypeEnum;
    /**
     * The name of the file or folder.
     * @type {string}
     * @memberof UpdateInodeRequest
     */
    'name': string;
    /**
     * Some optional descriptional text of the file or folder.
     * @type {string}
     * @memberof UpdateInodeRequest
     */
    'description': string | null;
    /**
     * ID of the parent folder, if any. If empty the folder is considered a category.
     * @type {number}
     * @memberof UpdateInodeRequest
     */
    'parent_id': number | null;
    /**
     * Limits the access to the folder and its (transitive) contents to a Group.
     * @type {number}
     * @memberof UpdateInodeRequest
     */
    'restrict_to_id': number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateInodeRequest
     */
    'owner_id': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateInodeRequest
     */
    'owner_type': UpdateInodeRequestOwnerTypeEnum;
}

export const UpdateInodeRequestTypeEnum = {
    Folder: 'Folder',
    Container: 'Container',
    Gallery: 'Gallery',
    UploadedFile: 'UploadedFile',
    Photo: 'Photo',
    ContainerFile: 'ContainerFile'
} as const;

export type UpdateInodeRequestTypeEnum = typeof UpdateInodeRequestTypeEnum[keyof typeof UpdateInodeRequestTypeEnum];
export const UpdateInodeRequestOwnerTypeEnum = {
    GroupMember: 'GroupMember',
    Group: 'Group'
} as const;

export type UpdateInodeRequestOwnerTypeEnum = typeof UpdateInodeRequestOwnerTypeEnum[keyof typeof UpdateInodeRequestOwnerTypeEnum];

/**
 * Update a uploaded file.
 * @export
 * @interface UpdateUploadedFileRequest
 */
export interface UpdateUploadedFileRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateUploadedFileRequest
     */
    'type': UpdateUploadedFileRequestTypeEnum;
    /**
     * The name of the file or folder.
     * @type {string}
     * @memberof UpdateUploadedFileRequest
     */
    'name': string;
    /**
     * Some optional descriptional text of the file or folder.
     * @type {string}
     * @memberof UpdateUploadedFileRequest
     */
    'description': string | null;
    /**
     * ID of the parent folder, if any. If empty the folder is considered a category.
     * @type {number}
     * @memberof UpdateUploadedFileRequest
     */
    'parent_id': number | null;
    /**
     * Limits the access to the folder and its (transitive) contents to a Group.
     * @type {number}
     * @memberof UpdateUploadedFileRequest
     */
    'restrict_to_id': number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateUploadedFileRequest
     */
    'owner_id': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateUploadedFileRequest
     */
    'owner_type': UpdateUploadedFileRequestOwnerTypeEnum;
    /**
     * Shares the folder and its contents with a Level.
     * @type {number}
     * @memberof UpdateUploadedFileRequest
     */
    'shared_level_id'?: number | null;
    /**
     * Size of the file in bytes.
     * @type {number}
     * @memberof UpdateUploadedFileRequest
     */
    'file_size'?: number;
    /**
     * Width of a pictural file, if applicable.
     * @type {number}
     * @memberof UpdateUploadedFileRequest
     */
    'width'?: number | null;
    /**
     * Height of a pictural file, if applicable.
     * @type {number}
     * @memberof UpdateUploadedFileRequest
     */
    'height'?: number | null;
    /**
     * Index used for ordering relative to sibling folders.
     * @type {number}
     * @memberof UpdateUploadedFileRequest
     */
    'order'?: number;
    /**
     * Physical URL to the file uploaded to the temporary S3 bucket that should be persisted.
     * @type {string}
     * @memberof UpdateUploadedFileRequest
     */
    'stored_file': string;
    /**
     * MIME content type of the file
     * @type {string}
     * @memberof UpdateUploadedFileRequest
     */
    'content_type'?: string;
    /**
     * Either a precise date, with omitted day or year only. Can also take the form of a semester. 
     * @type {string}
     * @memberof UpdateUploadedFileRequest
     */
    'physically_created_at'?: string;
}

export const UpdateUploadedFileRequestTypeEnum = {
    Folder: 'Folder',
    Container: 'Container',
    Gallery: 'Gallery',
    UploadedFile: 'UploadedFile',
    Photo: 'Photo',
    ContainerFile: 'ContainerFile'
} as const;

export type UpdateUploadedFileRequestTypeEnum = typeof UpdateUploadedFileRequestTypeEnum[keyof typeof UpdateUploadedFileRequestTypeEnum];
export const UpdateUploadedFileRequestOwnerTypeEnum = {
    GroupMember: 'GroupMember',
    Group: 'Group'
} as const;

export type UpdateUploadedFileRequestOwnerTypeEnum = typeof UpdateUploadedFileRequestOwnerTypeEnum[keyof typeof UpdateUploadedFileRequestOwnerTypeEnum];

/**
 * An UploadedFile is the context independent entity of a file that is stored by SUUS. It is a dumb data object that is referenced by context classes like Attachment or DriveFile.
 * @export
 * @interface UploadedFile
 */
export interface UploadedFile {
    /**
     * 
     * @type {number}
     * @memberof UploadedFile
     */
    'id': number;
    /**
     * General classification of the file type to decide whether to treat as an file with an image preview.
     * @type {string}
     * @memberof UploadedFile
     */
    'type': UploadedFileTypeEnum;
    /**
     * Name of the file, excluding the file type extension.
     * @type {string}
     * @memberof UploadedFile
     */
    'file_name': string;
    /**
     * Horizontal dimension of the original file in pixel.
     * @type {number}
     * @memberof UploadedFile
     */
    'width'?: number | null;
    /**
     * Vertical dimension of the original file in pixel.
     * @type {number}
     * @memberof UploadedFile
     */
    'height'?: number | null;
    /**
     * File size in Byte
     * @type {number}
     * @memberof UploadedFile
     */
    'file_size': number | null;
    /**
     * MIME Type of the file. May be null if the type could not be determined or was unknown.
     * @type {string}
     * @memberof UploadedFile
     */
    'content_type': string | null;
    /**
     * File type extension of the detected mime type.
     * @type {string}
     * @memberof UploadedFile
     */
    'file_type_extension': string | null;
    /**
     * 
     * @type {string}
     * @memberof UploadedFile
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof UploadedFile
     */
    'created_at': string;
    /**
     * 
     * @type {UploadedFileUploadedBy}
     * @memberof UploadedFile
     */
    'uploaded_by': UploadedFileUploadedBy | null;
    /**
     * 
     * @type {UploadedFileOriginal}
     * @memberof UploadedFile
     */
    'original'?: UploadedFileOriginal;
    /**
     * 
     * @type {UploadedFileOriginal}
     * @memberof UploadedFile
     */
    'preview'?: UploadedFileOriginal;
    /**
     * 
     * @type {UploadedFileOriginal}
     * @memberof UploadedFile
     */
    'thumb'?: UploadedFileOriginal;
    /**
     * 
     * @type {UploadedFileOriginal}
     * @memberof UploadedFile
     */
    'icon'?: UploadedFileOriginal;
    /**
     * 
     * @type {UploadedFileLinks}
     * @memberof UploadedFile
     */
    'links'?: UploadedFileLinks;
}

export const UploadedFileTypeEnum = {
    File: 'File',
    Image: 'Image'
} as const;

export type UploadedFileTypeEnum = typeof UploadedFileTypeEnum[keyof typeof UploadedFileTypeEnum];

/**
 * 
 * @export
 * @interface UploadedFileLinks
 */
export interface UploadedFileLinks {
    /**
     * URL of the 50px x 50px sized image preview, cropped with center in focus if needed.
     * @type {string}
     * @memberof UploadedFileLinks
     */
    'icon_url'?: string | null;
    /**
     * URL of the 200px x 200px sized thumbnail, cropped with center in focus if needed.
     * @type {string}
     * @memberof UploadedFileLinks
     */
    'thumb_url'?: string | null;
    /**
     * URL of the image preview, resized to 1200px without cropping.
     * @type {string}
     * @memberof UploadedFileLinks
     */
    'preview_url'?: string | null;
    /**
     * Contains the URL to download the original file if authorized, otherwise null.
     * @type {string}
     * @memberof UploadedFileLinks
     */
    'download_url'?: string | null;
}
/**
 * 
 * @export
 * @interface UploadedFileOriginal
 */
export interface UploadedFileOriginal {
    /**
     * 
     * @type {string}
     * @memberof UploadedFileOriginal
     */
    'url'?: string;
    /**
     * 
     * @type {number}
     * @memberof UploadedFileOriginal
     */
    'width'?: number;
    /**
     * 
     * @type {number}
     * @memberof UploadedFileOriginal
     */
    'height'?: number;
}
/**
 * The GroupMember who uploaded the file. Null if the image is an avatar to avoid circular references.
 * @export
 * @interface UploadedFileUploadedBy
 */
export interface UploadedFileUploadedBy {
    /**
     * 
     * @type {number}
     * @memberof UploadedFileUploadedBy
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof UploadedFileUploadedBy
     */
    'user_id'?: number | null;
    /**
     * First name of the person
     * @type {string}
     * @memberof UploadedFileUploadedBy
     */
    'first_name': string;
    /**
     * Last name of the person
     * @type {string}
     * @memberof UploadedFileUploadedBy
     */
    'last_name': string;
    /**
     * First and last name seperated by a space.
     * @type {string}
     * @memberof UploadedFileUploadedBy
     */
    'full_name': string;
    /**
     * Long internal name to be used in the context of the client of the GroupMember. Contains the `internal_name_long` of the `ClubRecord` of the current client. If no ClubRecord of the GroupMember matches the current client, it contains the `internal_name_long` of the `ClubRecord` of the first joined `Client`. 
     * @type {string}
     * @memberof UploadedFileUploadedBy
     */
    'internal_name_long': string;
    /**
     * Short internal name to be used in the context of the client of the GroupMember. Contains the `internal_name_short` of the `ClubRecord` of the current client. If no ClubRecord of the  GroupMember matches the current client, it contains the `internal_name_short` of the `ClubRecord` of the first joined `Client`. 
     * @type {string}
     * @memberof UploadedFileUploadedBy
     */
    'internal_name_short': string;
    /**
     * Short name of the GroupMember, to be used in context of `Level`s. Contains the `umbrella_name_short` from a ClubRecord that matches the current `Umbrella` the the current client. If none, it is the `umbrella_name_short` of the first joined client. 
     * @type {string}
     * @memberof UploadedFileUploadedBy
     */
    'umbrella_name_short': string;
    /**
     * Long name of the GroupMember, to be used in context of `Level`s. Contains the `umbrella_name_long` from a ClubRecord that matches the current `Umbrella` the the current  client. If none, it is the `umbrella_name_long` of the first joined client. 
     * @type {string}
     * @memberof UploadedFileUploadedBy
     */
    'umbrella_name_long': string;
    /**
     * A key for lexicographical ordering of GroupMembers. Yields a sorting by first joined client, last name (without nobility particel), first name,  other clients in order by name. 
     * @type {string}
     * @memberof UploadedFileUploadedBy
     */
    'global_name_for_sorting': string;
    /**
     * True if the GroupMember has a ClubRecord at the current client
     * @type {boolean}
     * @memberof UploadedFileUploadedBy
     */
    'is_member': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UploadedFileUploadedBy
     */
    'alive': boolean;
    /**
     * If true this user is invisible to everyone not allowed to see invisible users. When you see this being truthy, you are apparently permitted.
     * @type {boolean}
     * @memberof UploadedFileUploadedBy
     */
    'invisible': boolean;
    /**
     * If false the GroupMember has no verified ClubRecord yet.
     * @type {boolean}
     * @memberof UploadedFileUploadedBy
     */
    'verified': boolean;
    /**
     * True if 1) the GroupMember is member of the current client and has resigned at the current client or 2) the GroupMember is from other client(s) and has resigned from all of them.
     * @type {boolean}
     * @memberof UploadedFileUploadedBy
     */
    'resigned': boolean;
    /**
     * Link to the profile page of the person. Null if viewing the profile is not allowed to the current user.
     * @type {string}
     * @memberof UploadedFileUploadedBy
     */
    'url': string | null;
    /**
     * 
     * @type {string}
     * @memberof UploadedFileUploadedBy
     */
    'avatar_url': string;
    /**
     * 
     * @type {Client}
     * @memberof UploadedFileUploadedBy
     */
    'client'?: Client;
    /**
     * 
     * @type {PersonalRecord}
     * @memberof UploadedFileUploadedBy
     */
    'personal_record'?: PersonalRecord;
    /**
     * 
     * @type {Array<Client>}
     * @memberof UploadedFileUploadedBy
     */
    'clients': Array<Client>;
    /**
     * 
     * @type {Array<ClubRecord>}
     * @memberof UploadedFileUploadedBy
     */
    'club_records'?: Array<ClubRecord>;
    /**
     * 
     * @type {Array<Level>}
     * @memberof UploadedFileUploadedBy
     */
    'levels'?: Array<Level>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UploadedFileUploadedBy
     */
    'level_permissions'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UploadedFileUploadedBy
     */
    'client_permissions'?: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof UploadedFileUploadedBy
     */
    'group_memberships'?: Array<number>;
    /**
     * Timestamp of the latest change of any of the dependent records of this view. It is the max updated_at timestamp from any of its ClubRecords, Clients and PersonalRecord.
     * @type {string}
     * @memberof UploadedFileUploadedBy
     */
    'updated_at': string;
}
/**
 * User registration and activity statistics
 * @export
 * @interface UsageStats
 */
export interface UsageStats {
    /**
     * 
     * @type {UsageStatsStats}
     * @memberof UsageStats
     */
    'stats': UsageStatsStats;
    /**
     * Invalid records excluded from statistics
     * @type {Array<AgeStatsInvalidInner>}
     * @memberof UsageStats
     */
    'invalid': Array<AgeStatsInvalidInner>;
}
/**
 * Usage statistics with specific metrics
 * @export
 * @interface UsageStatsStats
 */
export interface UsageStatsStats {
    /**
     * Number of users who have accepted invitations
     * @type {number}
     * @memberof UsageStatsStats
     */
    'active_users'?: number;
    /**
     * Number of users who haven\'t registered yet
     * @type {number}
     * @memberof UsageStatsStats
     */
    'not_registered'?: number;
    /**
     * Number of records without email addresses
     * @type {number}
     * @memberof UsageStatsStats
     */
    'without_email'?: number;
    /**
     * Number of users with bounced email addresses
     * @type {number}
     * @memberof UsageStatsStats
     */
    'bounced_emails'?: number;
}
/**
 * Error class for API responses that failed due to validation errors (HTTP 422). 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * The HTTP 4xx Error Code.
     * @type {number}
     * @memberof ValidationError
     */
    'code'?: number;
    /**
     * Short description of the reported error code.
     * @type {string}
     * @memberof ValidationError
     */
    'error'?: string;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ValidationError
     */
    'message'?: { [key: string]: Array<string>; };
    /**
     * 
     * @type {{ [key: string]: Array<ValidationErrorDetailsValueInner>; }}
     * @memberof ValidationError
     */
    'details'?: { [key: string]: Array<ValidationErrorDetailsValueInner>; } | null;
}
/**
 * 
 * @export
 * @interface ValidationErrorDetailsValueInner
 */
export interface ValidationErrorDetailsValueInner {
    /**
     * Technical key of the failed validation on this object type.
     * @type {string}
     * @memberof ValidationErrorDetailsValueInner
     */
    'error'?: string;
}

/**
 * AddressesApi - axios parameter creator
 * @export
 */
export const AddressesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Auto suggest addresses for query
         * @param {string} query 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressSuggestions: async (query: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'query' is not null or undefined
            assertParamExists('addressSuggestions', 'query', query)
            const localVarPath = `/api/v1/addresses/suggestions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AddressesApi - functional programming interface
 * @export
 */
export const AddressesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AddressesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Auto suggest addresses for query
         * @param {string} query 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addressSuggestions(query: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Address>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addressSuggestions(query, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['AddressesApi.addressSuggestions']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * AddressesApi - factory interface
 * @export
 */
export const AddressesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AddressesApiFp(configuration)
    return {
        /**
         * 
         * @summary Auto suggest addresses for query
         * @param {string} query 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressSuggestions(query: string, options?: any): AxiosPromise<Array<Address>> {
            return localVarFp.addressSuggestions(query, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AddressesApi - interface
 * @export
 * @interface AddressesApi
 */
export interface AddressesApiInterface {
    /**
     * 
     * @summary Auto suggest addresses for query
     * @param {string} query 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApiInterface
     */
    addressSuggestions(query: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Address>>;

}

/**
 * AddressesApi - object-oriented interface
 * @export
 * @class AddressesApi
 * @extends {BaseAPI}
 */
export class AddressesApi extends BaseAPI implements AddressesApiInterface {
    /**
     * 
     * @summary Auto suggest addresses for query
     * @param {string} query 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AddressesApi
     */
    public addressSuggestions(query: string, options?: RawAxiosRequestConfig) {
        return AddressesApiFp(this.configuration).addressSuggestions(query, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ClientApi - axios parameter creator
 * @export
 */
export const ClientApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a Client
         * @param {ClientCreateRequest} [clientCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClient: async (clientCreateRequest?: ClientCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/clients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a Client
         * @param {string} id ID of the Client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClient: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteClient', 'id', id)
            const localVarPath = `/api/v1/clients/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Retrieve details of a client
         * @param {string} id ID of the Client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClient: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getClient', 'id', id)
            const localVarPath = `/api/v1/clients/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get locales for current client.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocales: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/locales.json`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all Clients
         * @param {number} [offset] Index of the first requested item, starting at 0.
         * @param {number} [limit] Maximum number of items to be returned.
         * @param {AscDescOrder} [order] Direction of the ordering by creation date (created_at).
         * @param {number} [levelId] Filter by level ID - only return clients that are member of the given level
         * @param {number} [umbrellaId] Filter by umbrella ID
         * @param {ListClientsStatusEnum} [status] Filter by status
         * @param {string} [name] Filter by name using Client.smart_find method
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listClients: async (offset?: number, limit?: number, order?: AscDescOrder, levelId?: number, umbrellaId?: number, status?: ListClientsStatusEnum, name?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/clients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (levelId !== undefined) {
                localVarQueryParameter['level_id'] = levelId;
            }

            if (umbrellaId !== undefined) {
                localVarQueryParameter['umbrella_id'] = umbrellaId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a Client
         * @param {string} id ID of the Client
         * @param {ClientCreateRequest} [clientCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClient: async (id: string, clientCreateRequest?: ClientCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateClient', 'id', id)
            const localVarPath = `/api/v1/clients/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientApi - functional programming interface
 * @export
 */
export const ClientApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a Client
         * @param {ClientCreateRequest} [clientCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createClient(clientCreateRequest?: ClientCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createClient(clientCreateRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ClientApi.createClient']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a Client
         * @param {string} id ID of the Client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteClient(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteClient(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ClientApi.deleteClient']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Retrieve details of a client
         * @param {string} id ID of the Client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClient(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClient(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ClientApi.getClient']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get locales for current client.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLocales(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLocales(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ClientApi.getLocales']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary List all Clients
         * @param {number} [offset] Index of the first requested item, starting at 0.
         * @param {number} [limit] Maximum number of items to be returned.
         * @param {AscDescOrder} [order] Direction of the ordering by creation date (created_at).
         * @param {number} [levelId] Filter by level ID - only return clients that are member of the given level
         * @param {number} [umbrellaId] Filter by umbrella ID
         * @param {ListClientsStatusEnum} [status] Filter by status
         * @param {string} [name] Filter by name using Client.smart_find method
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listClients(offset?: number, limit?: number, order?: AscDescOrder, levelId?: number, umbrellaId?: number, status?: ListClientsStatusEnum, name?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Client>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listClients(offset, limit, order, levelId, umbrellaId, status, name, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ClientApi.listClients']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Update a Client
         * @param {string} id ID of the Client
         * @param {ClientCreateRequest} [clientCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateClient(id: string, clientCreateRequest?: ClientCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientDetails>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateClient(id, clientCreateRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ClientApi.updateClient']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * ClientApi - factory interface
 * @export
 */
export const ClientApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a Client
         * @param {ClientCreateRequest} [clientCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createClient(clientCreateRequest?: ClientCreateRequest, options?: any): AxiosPromise<ClientDetails> {
            return localVarFp.createClient(clientCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a Client
         * @param {string} id ID of the Client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteClient(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteClient(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Retrieve details of a client
         * @param {string} id ID of the Client
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClient(id: string, options?: any): AxiosPromise<ClientDetails> {
            return localVarFp.getClient(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get locales for current client.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLocales(options?: any): AxiosPromise<object> {
            return localVarFp.getLocales(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all Clients
         * @param {number} [offset] Index of the first requested item, starting at 0.
         * @param {number} [limit] Maximum number of items to be returned.
         * @param {AscDescOrder} [order] Direction of the ordering by creation date (created_at).
         * @param {number} [levelId] Filter by level ID - only return clients that are member of the given level
         * @param {number} [umbrellaId] Filter by umbrella ID
         * @param {ListClientsStatusEnum} [status] Filter by status
         * @param {string} [name] Filter by name using Client.smart_find method
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listClients(offset?: number, limit?: number, order?: AscDescOrder, levelId?: number, umbrellaId?: number, status?: ListClientsStatusEnum, name?: string, options?: any): AxiosPromise<Array<Client>> {
            return localVarFp.listClients(offset, limit, order, levelId, umbrellaId, status, name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a Client
         * @param {string} id ID of the Client
         * @param {ClientCreateRequest} [clientCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClient(id: string, clientCreateRequest?: ClientCreateRequest, options?: any): AxiosPromise<ClientDetails> {
            return localVarFp.updateClient(id, clientCreateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientApi - interface
 * @export
 * @interface ClientApi
 */
export interface ClientApiInterface {
    /**
     * 
     * @summary Create a Client
     * @param {ClientCreateRequest} [clientCreateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApiInterface
     */
    createClient(clientCreateRequest?: ClientCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientDetails>;

    /**
     * 
     * @summary Delete a Client
     * @param {string} id ID of the Client
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApiInterface
     */
    deleteClient(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Retrieve details of a client
     * @param {string} id ID of the Client
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApiInterface
     */
    getClient(id: string, options?: RawAxiosRequestConfig): AxiosPromise<ClientDetails>;

    /**
     * 
     * @summary Get locales for current client.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApiInterface
     */
    getLocales(options?: RawAxiosRequestConfig): AxiosPromise<object>;

    /**
     * 
     * @summary List all Clients
     * @param {number} [offset] Index of the first requested item, starting at 0.
     * @param {number} [limit] Maximum number of items to be returned.
     * @param {AscDescOrder} [order] Direction of the ordering by creation date (created_at).
     * @param {number} [levelId] Filter by level ID - only return clients that are member of the given level
     * @param {number} [umbrellaId] Filter by umbrella ID
     * @param {ListClientsStatusEnum} [status] Filter by status
     * @param {string} [name] Filter by name using Client.smart_find method
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApiInterface
     */
    listClients(offset?: number, limit?: number, order?: AscDescOrder, levelId?: number, umbrellaId?: number, status?: ListClientsStatusEnum, name?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Client>>;

    /**
     * 
     * @summary Update a Client
     * @param {string} id ID of the Client
     * @param {ClientCreateRequest} [clientCreateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApiInterface
     */
    updateClient(id: string, clientCreateRequest?: ClientCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientDetails>;

}

/**
 * ClientApi - object-oriented interface
 * @export
 * @class ClientApi
 * @extends {BaseAPI}
 */
export class ClientApi extends BaseAPI implements ClientApiInterface {
    /**
     * 
     * @summary Create a Client
     * @param {ClientCreateRequest} [clientCreateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public createClient(clientCreateRequest?: ClientCreateRequest, options?: RawAxiosRequestConfig) {
        return ClientApiFp(this.configuration).createClient(clientCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a Client
     * @param {string} id ID of the Client
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public deleteClient(id: string, options?: RawAxiosRequestConfig) {
        return ClientApiFp(this.configuration).deleteClient(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Retrieve details of a client
     * @param {string} id ID of the Client
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public getClient(id: string, options?: RawAxiosRequestConfig) {
        return ClientApiFp(this.configuration).getClient(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get locales for current client.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public getLocales(options?: RawAxiosRequestConfig) {
        return ClientApiFp(this.configuration).getLocales(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all Clients
     * @param {number} [offset] Index of the first requested item, starting at 0.
     * @param {number} [limit] Maximum number of items to be returned.
     * @param {AscDescOrder} [order] Direction of the ordering by creation date (created_at).
     * @param {number} [levelId] Filter by level ID - only return clients that are member of the given level
     * @param {number} [umbrellaId] Filter by umbrella ID
     * @param {ListClientsStatusEnum} [status] Filter by status
     * @param {string} [name] Filter by name using Client.smart_find method
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public listClients(offset?: number, limit?: number, order?: AscDescOrder, levelId?: number, umbrellaId?: number, status?: ListClientsStatusEnum, name?: string, options?: RawAxiosRequestConfig) {
        return ClientApiFp(this.configuration).listClients(offset, limit, order, levelId, umbrellaId, status, name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a Client
     * @param {string} id ID of the Client
     * @param {ClientCreateRequest} [clientCreateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientApi
     */
    public updateClient(id: string, clientCreateRequest?: ClientCreateRequest, options?: RawAxiosRequestConfig) {
        return ClientApiFp(this.configuration).updateClient(id, clientCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ListClientsStatusEnum = {
    Offline: 'offline',
    Activated: 'activated',
    Released: 'released'
} as const;
export type ListClientsStatusEnum = typeof ListClientsStatusEnum[keyof typeof ListClientsStatusEnum];


/**
 * ClientStatisticsApi - axios parameter creator
 * @export
 */
export const ClientStatisticsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get statistics about age distribution in 5-year age groups
         * @summary Get age distribution statistics
         * @param {number} [clientId] ID of the client to get statistics for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgeStats: async (clientId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/stats/age`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required

            if (clientId !== undefined) {
                localVarQueryParameter['client_id'] = clientId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get health status information for a specific client
         * @summary Get client health status
         * @param {number} clientId ID of the client to get health status for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientHealth: async (clientId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getClientHealth', 'clientId', clientId)
            const localVarPath = `/api/v1/stats/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required

            if (clientId !== undefined) {
                localVarQueryParameter['client_id'] = clientId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get statistics about clubs where current members also have memberships
         * @summary Get clubs of members statistics
         * @param {number} clientId ID of the client to get statistics for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClubsOfMembersStats: async (clientId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getClubsOfMembersStats', 'clientId', clientId)
            const localVarPath = `/api/v1/stats/clubs_of_members`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required

            if (clientId !== undefined) {
                localVarQueryParameter['client_id'] = clientId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get login frequency statistics grouped by age ranges
         * @summary Get login statistics by age groups
         * @param {number} [clientId] ID of the client to get statistics for, only support may omit the parameter to get overall stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoginByAgeStats: async (clientId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/stats/logins/by_age`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required

            if (clientId !== undefined) {
                localVarQueryParameter['client_id'] = clientId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get login frequency statistics based on time between logins
         * @summary Get login statistics by mean time between logins
         * @param {number} [clientId] ID of the client to get statistics for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoginByMeantimeStats: async (clientId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/stats/logins/by_meantime`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required

            if (clientId !== undefined) {
                localVarQueryParameter['client_id'] = clientId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get login frequency statistics based on weeks since last login
         * @summary Get login statistics by weeks since last login
         * @param {number} [clientId] ID of the client to get statistics for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoginByWeeksStats: async (clientId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/stats/logins/by_weeks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required

            if (clientId !== undefined) {
                localVarQueryParameter['client_id'] = clientId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get statistics about member statuses
         * @summary Get member status statistics
         * @param {number} [clientId] ID of the client to get statistics for, only support may omit the parameter to get overall stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberStatusStats: async (clientId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/stats/status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required

            if (clientId !== undefined) {
                localVarQueryParameter['client_id'] = clientId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get statistics about origin clients of current members
         * @summary Get origin client statistics
         * @param {number} clientId ID of the client to get statistics for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOriginClientsStats: async (clientId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getOriginClientsStats', 'clientId', clientId)
            const localVarPath = `/api/v1/stats/origin_clients`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required

            if (clientId !== undefined) {
                localVarQueryParameter['client_id'] = clientId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get cumulative user signup statistics over time
         * @summary Get signup pickup statistics
         * @param {number} [clientId] ID of the client to get statistics for, only support may omit the parameter to get overall stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPickupStats: async (clientId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/stats/pickup`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required

            if (clientId !== undefined) {
                localVarQueryParameter['client_id'] = clientId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get statistics about recipiert dates by year
         * @summary Get recipiert statistics
         * @param {number} clientId ID of the client to get statistics for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecipiertStats: async (clientId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('getRecipiertStats', 'clientId', clientId)
            const localVarPath = `/api/v1/stats/recipiert`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required

            if (clientId !== undefined) {
                localVarQueryParameter['client_id'] = clientId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get statistics about summary email frequency preferences
         * @summary Get summary frequency statistics
         * @param {number} [clientId] ID of the client to get statistics for, only support may omit the parameter to get overall stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummaryFreqStats: async (clientId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/stats/summary/freq`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required

            if (clientId !== undefined) {
                localVarQueryParameter['client_id'] = clientId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get statistics about user registration and activity
         * @summary Get user usage statistics
         * @param {number} [clientId] ID of the client to get statistics for, only support may omit the parameter to get overall stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsageStats: async (clientId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/stats/usage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required

            if (clientId !== undefined) {
                localVarQueryParameter['client_id'] = clientId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Release a client (admin only operation)
         * @summary Release a client
         * @param {number} clientId ID of the client to release
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releaseClient: async (clientId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('releaseClient', 'clientId', clientId)
            const localVarPath = `/api/v1/stats/release`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required

            if (clientId !== undefined) {
                localVarQueryParameter['client_id'] = clientId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientStatisticsApi - functional programming interface
 * @export
 */
export const ClientStatisticsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientStatisticsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get statistics about age distribution in 5-year age groups
         * @summary Get age distribution statistics
         * @param {number} [clientId] ID of the client to get statistics for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAgeStats(clientId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AgeStats>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAgeStats(clientId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ClientStatisticsApi.getAgeStats']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get health status information for a specific client
         * @summary Get client health status
         * @param {number} clientId ID of the client to get health status for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientHealth(clientId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientHealth>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientHealth(clientId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ClientStatisticsApi.getClientHealth']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get statistics about clubs where current members also have memberships
         * @summary Get clubs of members statistics
         * @param {number} clientId ID of the client to get statistics for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClubsOfMembersStats(clientId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientStats>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClubsOfMembersStats(clientId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ClientStatisticsApi.getClubsOfMembersStats']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get login frequency statistics grouped by age ranges
         * @summary Get login statistics by age groups
         * @param {number} [clientId] ID of the client to get statistics for, only support may omit the parameter to get overall stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLoginByAgeStats(clientId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginByAgeStats>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLoginByAgeStats(clientId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ClientStatisticsApi.getLoginByAgeStats']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get login frequency statistics based on time between logins
         * @summary Get login statistics by mean time between logins
         * @param {number} [clientId] ID of the client to get statistics for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLoginByMeantimeStats(clientId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginMeantimeStats>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLoginByMeantimeStats(clientId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ClientStatisticsApi.getLoginByMeantimeStats']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get login frequency statistics based on weeks since last login
         * @summary Get login statistics by weeks since last login
         * @param {number} [clientId] ID of the client to get statistics for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLoginByWeeksStats(clientId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LoginWeeksStats>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLoginByWeeksStats(clientId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ClientStatisticsApi.getLoginByWeeksStats']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get statistics about member statuses
         * @summary Get member status statistics
         * @param {number} [clientId] ID of the client to get statistics for, only support may omit the parameter to get overall stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMemberStatusStats(clientId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientStats>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMemberStatusStats(clientId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ClientStatisticsApi.getMemberStatusStats']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get statistics about origin clients of current members
         * @summary Get origin client statistics
         * @param {number} clientId ID of the client to get statistics for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOriginClientsStats(clientId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientStats>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOriginClientsStats(clientId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ClientStatisticsApi.getOriginClientsStats']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get cumulative user signup statistics over time
         * @summary Get signup pickup statistics
         * @param {number} [clientId] ID of the client to get statistics for, only support may omit the parameter to get overall stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPickupStats(clientId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PickupStats>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPickupStats(clientId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ClientStatisticsApi.getPickupStats']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get statistics about recipiert dates by year
         * @summary Get recipiert statistics
         * @param {number} clientId ID of the client to get statistics for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecipiertStats(clientId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientStats>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecipiertStats(clientId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ClientStatisticsApi.getRecipiertStats']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get statistics about summary email frequency preferences
         * @summary Get summary frequency statistics
         * @param {number} [clientId] ID of the client to get statistics for, only support may omit the parameter to get overall stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSummaryFreqStats(clientId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientStats>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSummaryFreqStats(clientId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ClientStatisticsApi.getSummaryFreqStats']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Get statistics about user registration and activity
         * @summary Get user usage statistics
         * @param {number} [clientId] ID of the client to get statistics for, only support may omit the parameter to get overall stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsageStats(clientId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsageStats>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsageStats(clientId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ClientStatisticsApi.getUsageStats']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Release a client (admin only operation)
         * @summary Release a client
         * @param {number} clientId ID of the client to release
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async releaseClient(clientId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Client>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.releaseClient(clientId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ClientStatisticsApi.releaseClient']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * ClientStatisticsApi - factory interface
 * @export
 */
export const ClientStatisticsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientStatisticsApiFp(configuration)
    return {
        /**
         * Get statistics about age distribution in 5-year age groups
         * @summary Get age distribution statistics
         * @param {number} [clientId] ID of the client to get statistics for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAgeStats(clientId?: number, options?: any): AxiosPromise<AgeStats> {
            return localVarFp.getAgeStats(clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get health status information for a specific client
         * @summary Get client health status
         * @param {number} clientId ID of the client to get health status for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientHealth(clientId: number, options?: any): AxiosPromise<ClientHealth> {
            return localVarFp.getClientHealth(clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get statistics about clubs where current members also have memberships
         * @summary Get clubs of members statistics
         * @param {number} clientId ID of the client to get statistics for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClubsOfMembersStats(clientId: number, options?: any): AxiosPromise<ClientStats> {
            return localVarFp.getClubsOfMembersStats(clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get login frequency statistics grouped by age ranges
         * @summary Get login statistics by age groups
         * @param {number} [clientId] ID of the client to get statistics for, only support may omit the parameter to get overall stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoginByAgeStats(clientId?: number, options?: any): AxiosPromise<LoginByAgeStats> {
            return localVarFp.getLoginByAgeStats(clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get login frequency statistics based on time between logins
         * @summary Get login statistics by mean time between logins
         * @param {number} [clientId] ID of the client to get statistics for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoginByMeantimeStats(clientId?: number, options?: any): AxiosPromise<LoginMeantimeStats> {
            return localVarFp.getLoginByMeantimeStats(clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get login frequency statistics based on weeks since last login
         * @summary Get login statistics by weeks since last login
         * @param {number} [clientId] ID of the client to get statistics for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoginByWeeksStats(clientId?: number, options?: any): AxiosPromise<LoginWeeksStats> {
            return localVarFp.getLoginByWeeksStats(clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get statistics about member statuses
         * @summary Get member status statistics
         * @param {number} [clientId] ID of the client to get statistics for, only support may omit the parameter to get overall stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberStatusStats(clientId?: number, options?: any): AxiosPromise<ClientStats> {
            return localVarFp.getMemberStatusStats(clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get statistics about origin clients of current members
         * @summary Get origin client statistics
         * @param {number} clientId ID of the client to get statistics for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOriginClientsStats(clientId: number, options?: any): AxiosPromise<ClientStats> {
            return localVarFp.getOriginClientsStats(clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get cumulative user signup statistics over time
         * @summary Get signup pickup statistics
         * @param {number} [clientId] ID of the client to get statistics for, only support may omit the parameter to get overall stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPickupStats(clientId?: number, options?: any): AxiosPromise<PickupStats> {
            return localVarFp.getPickupStats(clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get statistics about recipiert dates by year
         * @summary Get recipiert statistics
         * @param {number} clientId ID of the client to get statistics for
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecipiertStats(clientId: number, options?: any): AxiosPromise<ClientStats> {
            return localVarFp.getRecipiertStats(clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get statistics about summary email frequency preferences
         * @summary Get summary frequency statistics
         * @param {number} [clientId] ID of the client to get statistics for, only support may omit the parameter to get overall stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSummaryFreqStats(clientId?: number, options?: any): AxiosPromise<ClientStats> {
            return localVarFp.getSummaryFreqStats(clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get statistics about user registration and activity
         * @summary Get user usage statistics
         * @param {number} [clientId] ID of the client to get statistics for, only support may omit the parameter to get overall stats
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsageStats(clientId?: number, options?: any): AxiosPromise<UsageStats> {
            return localVarFp.getUsageStats(clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * Release a client (admin only operation)
         * @summary Release a client
         * @param {number} clientId ID of the client to release
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releaseClient(clientId: number, options?: any): AxiosPromise<Client> {
            return localVarFp.releaseClient(clientId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientStatisticsApi - interface
 * @export
 * @interface ClientStatisticsApi
 */
export interface ClientStatisticsApiInterface {
    /**
     * Get statistics about age distribution in 5-year age groups
     * @summary Get age distribution statistics
     * @param {number} [clientId] ID of the client to get statistics for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientStatisticsApiInterface
     */
    getAgeStats(clientId?: number, options?: RawAxiosRequestConfig): AxiosPromise<AgeStats>;

    /**
     * Get health status information for a specific client
     * @summary Get client health status
     * @param {number} clientId ID of the client to get health status for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientStatisticsApiInterface
     */
    getClientHealth(clientId: number, options?: RawAxiosRequestConfig): AxiosPromise<ClientHealth>;

    /**
     * Get statistics about clubs where current members also have memberships
     * @summary Get clubs of members statistics
     * @param {number} clientId ID of the client to get statistics for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientStatisticsApiInterface
     */
    getClubsOfMembersStats(clientId: number, options?: RawAxiosRequestConfig): AxiosPromise<ClientStats>;

    /**
     * Get login frequency statistics grouped by age ranges
     * @summary Get login statistics by age groups
     * @param {number} [clientId] ID of the client to get statistics for, only support may omit the parameter to get overall stats
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientStatisticsApiInterface
     */
    getLoginByAgeStats(clientId?: number, options?: RawAxiosRequestConfig): AxiosPromise<LoginByAgeStats>;

    /**
     * Get login frequency statistics based on time between logins
     * @summary Get login statistics by mean time between logins
     * @param {number} [clientId] ID of the client to get statistics for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientStatisticsApiInterface
     */
    getLoginByMeantimeStats(clientId?: number, options?: RawAxiosRequestConfig): AxiosPromise<LoginMeantimeStats>;

    /**
     * Get login frequency statistics based on weeks since last login
     * @summary Get login statistics by weeks since last login
     * @param {number} [clientId] ID of the client to get statistics for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientStatisticsApiInterface
     */
    getLoginByWeeksStats(clientId?: number, options?: RawAxiosRequestConfig): AxiosPromise<LoginWeeksStats>;

    /**
     * Get statistics about member statuses
     * @summary Get member status statistics
     * @param {number} [clientId] ID of the client to get statistics for, only support may omit the parameter to get overall stats
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientStatisticsApiInterface
     */
    getMemberStatusStats(clientId?: number, options?: RawAxiosRequestConfig): AxiosPromise<ClientStats>;

    /**
     * Get statistics about origin clients of current members
     * @summary Get origin client statistics
     * @param {number} clientId ID of the client to get statistics for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientStatisticsApiInterface
     */
    getOriginClientsStats(clientId: number, options?: RawAxiosRequestConfig): AxiosPromise<ClientStats>;

    /**
     * Get cumulative user signup statistics over time
     * @summary Get signup pickup statistics
     * @param {number} [clientId] ID of the client to get statistics for, only support may omit the parameter to get overall stats
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientStatisticsApiInterface
     */
    getPickupStats(clientId?: number, options?: RawAxiosRequestConfig): AxiosPromise<PickupStats>;

    /**
     * Get statistics about recipiert dates by year
     * @summary Get recipiert statistics
     * @param {number} clientId ID of the client to get statistics for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientStatisticsApiInterface
     */
    getRecipiertStats(clientId: number, options?: RawAxiosRequestConfig): AxiosPromise<ClientStats>;

    /**
     * Get statistics about summary email frequency preferences
     * @summary Get summary frequency statistics
     * @param {number} [clientId] ID of the client to get statistics for, only support may omit the parameter to get overall stats
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientStatisticsApiInterface
     */
    getSummaryFreqStats(clientId?: number, options?: RawAxiosRequestConfig): AxiosPromise<ClientStats>;

    /**
     * Get statistics about user registration and activity
     * @summary Get user usage statistics
     * @param {number} [clientId] ID of the client to get statistics for, only support may omit the parameter to get overall stats
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientStatisticsApiInterface
     */
    getUsageStats(clientId?: number, options?: RawAxiosRequestConfig): AxiosPromise<UsageStats>;

    /**
     * Release a client (admin only operation)
     * @summary Release a client
     * @param {number} clientId ID of the client to release
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientStatisticsApiInterface
     */
    releaseClient(clientId: number, options?: RawAxiosRequestConfig): AxiosPromise<Client>;

}

/**
 * ClientStatisticsApi - object-oriented interface
 * @export
 * @class ClientStatisticsApi
 * @extends {BaseAPI}
 */
export class ClientStatisticsApi extends BaseAPI implements ClientStatisticsApiInterface {
    /**
     * Get statistics about age distribution in 5-year age groups
     * @summary Get age distribution statistics
     * @param {number} [clientId] ID of the client to get statistics for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientStatisticsApi
     */
    public getAgeStats(clientId?: number, options?: RawAxiosRequestConfig) {
        return ClientStatisticsApiFp(this.configuration).getAgeStats(clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get health status information for a specific client
     * @summary Get client health status
     * @param {number} clientId ID of the client to get health status for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientStatisticsApi
     */
    public getClientHealth(clientId: number, options?: RawAxiosRequestConfig) {
        return ClientStatisticsApiFp(this.configuration).getClientHealth(clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get statistics about clubs where current members also have memberships
     * @summary Get clubs of members statistics
     * @param {number} clientId ID of the client to get statistics for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientStatisticsApi
     */
    public getClubsOfMembersStats(clientId: number, options?: RawAxiosRequestConfig) {
        return ClientStatisticsApiFp(this.configuration).getClubsOfMembersStats(clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get login frequency statistics grouped by age ranges
     * @summary Get login statistics by age groups
     * @param {number} [clientId] ID of the client to get statistics for, only support may omit the parameter to get overall stats
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientStatisticsApi
     */
    public getLoginByAgeStats(clientId?: number, options?: RawAxiosRequestConfig) {
        return ClientStatisticsApiFp(this.configuration).getLoginByAgeStats(clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get login frequency statistics based on time between logins
     * @summary Get login statistics by mean time between logins
     * @param {number} [clientId] ID of the client to get statistics for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientStatisticsApi
     */
    public getLoginByMeantimeStats(clientId?: number, options?: RawAxiosRequestConfig) {
        return ClientStatisticsApiFp(this.configuration).getLoginByMeantimeStats(clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get login frequency statistics based on weeks since last login
     * @summary Get login statistics by weeks since last login
     * @param {number} [clientId] ID of the client to get statistics for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientStatisticsApi
     */
    public getLoginByWeeksStats(clientId?: number, options?: RawAxiosRequestConfig) {
        return ClientStatisticsApiFp(this.configuration).getLoginByWeeksStats(clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get statistics about member statuses
     * @summary Get member status statistics
     * @param {number} [clientId] ID of the client to get statistics for, only support may omit the parameter to get overall stats
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientStatisticsApi
     */
    public getMemberStatusStats(clientId?: number, options?: RawAxiosRequestConfig) {
        return ClientStatisticsApiFp(this.configuration).getMemberStatusStats(clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get statistics about origin clients of current members
     * @summary Get origin client statistics
     * @param {number} clientId ID of the client to get statistics for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientStatisticsApi
     */
    public getOriginClientsStats(clientId: number, options?: RawAxiosRequestConfig) {
        return ClientStatisticsApiFp(this.configuration).getOriginClientsStats(clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get cumulative user signup statistics over time
     * @summary Get signup pickup statistics
     * @param {number} [clientId] ID of the client to get statistics for, only support may omit the parameter to get overall stats
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientStatisticsApi
     */
    public getPickupStats(clientId?: number, options?: RawAxiosRequestConfig) {
        return ClientStatisticsApiFp(this.configuration).getPickupStats(clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get statistics about recipiert dates by year
     * @summary Get recipiert statistics
     * @param {number} clientId ID of the client to get statistics for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientStatisticsApi
     */
    public getRecipiertStats(clientId: number, options?: RawAxiosRequestConfig) {
        return ClientStatisticsApiFp(this.configuration).getRecipiertStats(clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get statistics about summary email frequency preferences
     * @summary Get summary frequency statistics
     * @param {number} [clientId] ID of the client to get statistics for, only support may omit the parameter to get overall stats
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientStatisticsApi
     */
    public getSummaryFreqStats(clientId?: number, options?: RawAxiosRequestConfig) {
        return ClientStatisticsApiFp(this.configuration).getSummaryFreqStats(clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get statistics about user registration and activity
     * @summary Get user usage statistics
     * @param {number} [clientId] ID of the client to get statistics for, only support may omit the parameter to get overall stats
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientStatisticsApi
     */
    public getUsageStats(clientId?: number, options?: RawAxiosRequestConfig) {
        return ClientStatisticsApiFp(this.configuration).getUsageStats(clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Release a client (admin only operation)
     * @summary Release a client
     * @param {number} clientId ID of the client to release
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientStatisticsApi
     */
    public releaseClient(clientId: number, options?: RawAxiosRequestConfig) {
        return ClientStatisticsApiFp(this.configuration).releaseClient(clientId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CommentsApi - axios parameter creator
 * @export
 */
export const CommentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete a Comment
         * @param {string} id id of post to post to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteComment: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteComment', 'id', id)
            const localVarPath = `/api/v1/comments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a Comment
         * @param {string} id id of post to post to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComment: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getComment', 'id', id)
            const localVarPath = `/api/v1/comments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a Comment
         * @param {string} id id of post to post to
         * @param {CommentRequest} [commentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateComment: async (id: string, commentRequest?: CommentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateComment', 'id', id)
            const localVarPath = `/api/v1/comments/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommentsApi - functional programming interface
 * @export
 */
export const CommentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CommentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete a Comment
         * @param {string} id id of post to post to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteComment(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteComment(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommentsApi.deleteComment']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get a Comment
         * @param {string} id id of post to post to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getComment(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Comment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getComment(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommentsApi.getComment']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Update a Comment
         * @param {string} id id of post to post to
         * @param {CommentRequest} [commentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateComment(id: string, commentRequest?: CommentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Comment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateComment(id, commentRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CommentsApi.updateComment']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * CommentsApi - factory interface
 * @export
 */
export const CommentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CommentsApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete a Comment
         * @param {string} id id of post to post to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteComment(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteComment(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a Comment
         * @param {string} id id of post to post to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getComment(id: string, options?: any): AxiosPromise<Comment> {
            return localVarFp.getComment(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a Comment
         * @param {string} id id of post to post to
         * @param {CommentRequest} [commentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateComment(id: string, commentRequest?: CommentRequest, options?: any): AxiosPromise<Comment> {
            return localVarFp.updateComment(id, commentRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CommentsApi - interface
 * @export
 * @interface CommentsApi
 */
export interface CommentsApiInterface {
    /**
     * 
     * @summary Delete a Comment
     * @param {string} id id of post to post to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentsApiInterface
     */
    deleteComment(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Get a Comment
     * @param {string} id id of post to post to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentsApiInterface
     */
    getComment(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Comment>;

    /**
     * 
     * @summary Update a Comment
     * @param {string} id id of post to post to
     * @param {CommentRequest} [commentRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentsApiInterface
     */
    updateComment(id: string, commentRequest?: CommentRequest, options?: RawAxiosRequestConfig): AxiosPromise<Comment>;

}

/**
 * CommentsApi - object-oriented interface
 * @export
 * @class CommentsApi
 * @extends {BaseAPI}
 */
export class CommentsApi extends BaseAPI implements CommentsApiInterface {
    /**
     * 
     * @summary Delete a Comment
     * @param {string} id id of post to post to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentsApi
     */
    public deleteComment(id: string, options?: RawAxiosRequestConfig) {
        return CommentsApiFp(this.configuration).deleteComment(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a Comment
     * @param {string} id id of post to post to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentsApi
     */
    public getComment(id: string, options?: RawAxiosRequestConfig) {
        return CommentsApiFp(this.configuration).getComment(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a Comment
     * @param {string} id id of post to post to
     * @param {CommentRequest} [commentRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommentsApi
     */
    public updateComment(id: string, commentRequest?: CommentRequest, options?: RawAxiosRequestConfig) {
        return CommentsApiFp(this.configuration).updateComment(id, commentRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CurrentMemberApi - axios parameter creator
 * @export
 */
export const CurrentMemberApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get CurrentMember
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentMember: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/current_member`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark Changelog as viewed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setChangelogViewedNow: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/member/changelog_viewed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CurrentMemberApi - functional programming interface
 * @export
 */
export const CurrentMemberApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CurrentMemberApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get CurrentMember
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentMember(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CurrentMember>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentMember(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CurrentMemberApi.getCurrentMember']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Mark Changelog as viewed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setChangelogViewedNow(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SetChangelogViewedNow200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setChangelogViewedNow(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CurrentMemberApi.setChangelogViewedNow']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * CurrentMemberApi - factory interface
 * @export
 */
export const CurrentMemberApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CurrentMemberApiFp(configuration)
    return {
        /**
         * 
         * @summary Get CurrentMember
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentMember(options?: any): AxiosPromise<CurrentMember> {
            return localVarFp.getCurrentMember(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mark Changelog as viewed
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setChangelogViewedNow(options?: any): AxiosPromise<SetChangelogViewedNow200Response> {
            return localVarFp.setChangelogViewedNow(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CurrentMemberApi - interface
 * @export
 * @interface CurrentMemberApi
 */
export interface CurrentMemberApiInterface {
    /**
     * 
     * @summary Get CurrentMember
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CurrentMemberApiInterface
     */
    getCurrentMember(options?: RawAxiosRequestConfig): AxiosPromise<CurrentMember>;

    /**
     * 
     * @summary Mark Changelog as viewed
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CurrentMemberApiInterface
     */
    setChangelogViewedNow(options?: RawAxiosRequestConfig): AxiosPromise<SetChangelogViewedNow200Response>;

}

/**
 * CurrentMemberApi - object-oriented interface
 * @export
 * @class CurrentMemberApi
 * @extends {BaseAPI}
 */
export class CurrentMemberApi extends BaseAPI implements CurrentMemberApiInterface {
    /**
     * 
     * @summary Get CurrentMember
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CurrentMemberApi
     */
    public getCurrentMember(options?: RawAxiosRequestConfig) {
        return CurrentMemberApiFp(this.configuration).getCurrentMember(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mark Changelog as viewed
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CurrentMemberApi
     */
    public setChangelogViewedNow(options?: RawAxiosRequestConfig) {
        return CurrentMemberApiFp(this.configuration).setChangelogViewedNow(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CustomAttributeDefinitionsApi - axios parameter creator
 * @export
 */
export const CustomAttributeDefinitionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Batch Update CustomAttributeValues
         * @param {string} id ID of the Custom Attribute Definition
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchUpdateCustomAttributeValues: async (id: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('batchUpdateCustomAttributeValues', 'id', id)
            const localVarPath = `/api/v1/custom_attribute_definitions/{id}/batch_update`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication legacyCookieAuth required


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a Custom Attribute Definition
         * @param {string} [clientId] Client ID of this Custom Attribute Definition. Leave null if you want to define a level attribute.
         * @param {string} [levelId] Level ID of this Custom Attribute Definition. Leave null if you want to define a client attribute.
         * @param {CreateCustomAttributeDefinitionRequest} [createCustomAttributeDefinitionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomAttributeDefinition: async (clientId?: string, levelId?: string, createCustomAttributeDefinitionRequest?: CreateCustomAttributeDefinitionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/custom_attribute_definitions/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required

            if (clientId !== undefined) {
                localVarQueryParameter['client_id'] = clientId;
            }

            if (levelId !== undefined) {
                localVarQueryParameter['level_id'] = levelId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCustomAttributeDefinitionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a CustomAttributeDefinition
         * @param {string} id ID of the Custom Attribute Definition
         * @param {boolean} [force] Force delete the Custom Attribute Definition, even though there are Custom Attribute Values associated with it.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomAttributeDefinition: async (id: string, force?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteCustomAttributeDefinition', 'id', id)
            const localVarPath = `/api/v1/custom_attribute_definitions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required

            if (force !== undefined) {
                localVarQueryParameter['force'] = force;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a CustomAttributeDefinition
         * @param {string} id ID of the Custom Attribute Definition
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomAttributeDefinition: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCustomAttributeDefinition', 'id', id)
            const localVarPath = `/api/v1/custom_attribute_definitions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Custom Attribute Definitions
         * @param {string} [clientId] Client ID of this Custom Attribute Definition. Leave null if you want to define a level attribute.
         * @param {string} [levelId] Level ID of this Custom Attribute Definition. Leave null if you want to define a client attribute.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomAttributeDefinitions: async (clientId?: string, levelId?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/custom_attribute_definitions/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required

            if (clientId !== undefined) {
                localVarQueryParameter['client_id'] = clientId;
            }

            if (levelId !== undefined) {
                localVarQueryParameter['level_id'] = levelId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a CustomAttributeDefinition
         * @param {string} id ID of the Custom Attribute Definition
         * @param {UpdateCustomAttributeDefinitionRequest} [updateCustomAttributeDefinitionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomAttributeDefinition: async (id: string, updateCustomAttributeDefinitionRequest?: UpdateCustomAttributeDefinitionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCustomAttributeDefinition', 'id', id)
            const localVarPath = `/api/v1/custom_attribute_definitions/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCustomAttributeDefinitionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CustomAttributeDefinitionsApi - functional programming interface
 * @export
 */
export const CustomAttributeDefinitionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CustomAttributeDefinitionsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Batch Update CustomAttributeValues
         * @param {string} id ID of the Custom Attribute Definition
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async batchUpdateCustomAttributeValues(id: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomAttributeBatchUpdateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.batchUpdateCustomAttributeValues(id, file, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CustomAttributeDefinitionsApi.batchUpdateCustomAttributeValues']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Create a Custom Attribute Definition
         * @param {string} [clientId] Client ID of this Custom Attribute Definition. Leave null if you want to define a level attribute.
         * @param {string} [levelId] Level ID of this Custom Attribute Definition. Leave null if you want to define a client attribute.
         * @param {CreateCustomAttributeDefinitionRequest} [createCustomAttributeDefinitionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCustomAttributeDefinition(clientId?: string, levelId?: string, createCustomAttributeDefinitionRequest?: CreateCustomAttributeDefinitionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomAttributeDefinition>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCustomAttributeDefinition(clientId, levelId, createCustomAttributeDefinitionRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CustomAttributeDefinitionsApi.createCustomAttributeDefinition']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a CustomAttributeDefinition
         * @param {string} id ID of the Custom Attribute Definition
         * @param {boolean} [force] Force delete the Custom Attribute Definition, even though there are Custom Attribute Values associated with it.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCustomAttributeDefinition(id: string, force?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCustomAttributeDefinition(id, force, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CustomAttributeDefinitionsApi.deleteCustomAttributeDefinition']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get a CustomAttributeDefinition
         * @param {string} id ID of the Custom Attribute Definition
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomAttributeDefinition(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomAttributeDefinition>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomAttributeDefinition(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CustomAttributeDefinitionsApi.getCustomAttributeDefinition']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary List Custom Attribute Definitions
         * @param {string} [clientId] Client ID of this Custom Attribute Definition. Leave null if you want to define a level attribute.
         * @param {string} [levelId] Level ID of this Custom Attribute Definition. Leave null if you want to define a client attribute.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCustomAttributeDefinitions(clientId?: string, levelId?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CustomAttributeDefinition>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCustomAttributeDefinitions(clientId, levelId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CustomAttributeDefinitionsApi.getCustomAttributeDefinitions']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Update a CustomAttributeDefinition
         * @param {string} id ID of the Custom Attribute Definition
         * @param {UpdateCustomAttributeDefinitionRequest} [updateCustomAttributeDefinitionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCustomAttributeDefinition(id: string, updateCustomAttributeDefinitionRequest?: UpdateCustomAttributeDefinitionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CustomAttributeDefinition>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCustomAttributeDefinition(id, updateCustomAttributeDefinitionRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CustomAttributeDefinitionsApi.updateCustomAttributeDefinition']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * CustomAttributeDefinitionsApi - factory interface
 * @export
 */
export const CustomAttributeDefinitionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CustomAttributeDefinitionsApiFp(configuration)
    return {
        /**
         * 
         * @summary Batch Update CustomAttributeValues
         * @param {string} id ID of the Custom Attribute Definition
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        batchUpdateCustomAttributeValues(id: string, file?: File, options?: any): AxiosPromise<CustomAttributeBatchUpdateResponse> {
            return localVarFp.batchUpdateCustomAttributeValues(id, file, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a Custom Attribute Definition
         * @param {string} [clientId] Client ID of this Custom Attribute Definition. Leave null if you want to define a level attribute.
         * @param {string} [levelId] Level ID of this Custom Attribute Definition. Leave null if you want to define a client attribute.
         * @param {CreateCustomAttributeDefinitionRequest} [createCustomAttributeDefinitionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCustomAttributeDefinition(clientId?: string, levelId?: string, createCustomAttributeDefinitionRequest?: CreateCustomAttributeDefinitionRequest, options?: any): AxiosPromise<CustomAttributeDefinition> {
            return localVarFp.createCustomAttributeDefinition(clientId, levelId, createCustomAttributeDefinitionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a CustomAttributeDefinition
         * @param {string} id ID of the Custom Attribute Definition
         * @param {boolean} [force] Force delete the Custom Attribute Definition, even though there are Custom Attribute Values associated with it.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCustomAttributeDefinition(id: string, force?: boolean, options?: any): AxiosPromise<void> {
            return localVarFp.deleteCustomAttributeDefinition(id, force, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a CustomAttributeDefinition
         * @param {string} id ID of the Custom Attribute Definition
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomAttributeDefinition(id: string, options?: any): AxiosPromise<CustomAttributeDefinition> {
            return localVarFp.getCustomAttributeDefinition(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Custom Attribute Definitions
         * @param {string} [clientId] Client ID of this Custom Attribute Definition. Leave null if you want to define a level attribute.
         * @param {string} [levelId] Level ID of this Custom Attribute Definition. Leave null if you want to define a client attribute.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomAttributeDefinitions(clientId?: string, levelId?: string, options?: any): AxiosPromise<Array<CustomAttributeDefinition>> {
            return localVarFp.getCustomAttributeDefinitions(clientId, levelId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a CustomAttributeDefinition
         * @param {string} id ID of the Custom Attribute Definition
         * @param {UpdateCustomAttributeDefinitionRequest} [updateCustomAttributeDefinitionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCustomAttributeDefinition(id: string, updateCustomAttributeDefinitionRequest?: UpdateCustomAttributeDefinitionRequest, options?: any): AxiosPromise<CustomAttributeDefinition> {
            return localVarFp.updateCustomAttributeDefinition(id, updateCustomAttributeDefinitionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CustomAttributeDefinitionsApi - interface
 * @export
 * @interface CustomAttributeDefinitionsApi
 */
export interface CustomAttributeDefinitionsApiInterface {
    /**
     * 
     * @summary Batch Update CustomAttributeValues
     * @param {string} id ID of the Custom Attribute Definition
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomAttributeDefinitionsApiInterface
     */
    batchUpdateCustomAttributeValues(id: string, file?: File, options?: RawAxiosRequestConfig): AxiosPromise<CustomAttributeBatchUpdateResponse>;

    /**
     * 
     * @summary Create a Custom Attribute Definition
     * @param {string} [clientId] Client ID of this Custom Attribute Definition. Leave null if you want to define a level attribute.
     * @param {string} [levelId] Level ID of this Custom Attribute Definition. Leave null if you want to define a client attribute.
     * @param {CreateCustomAttributeDefinitionRequest} [createCustomAttributeDefinitionRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomAttributeDefinitionsApiInterface
     */
    createCustomAttributeDefinition(clientId?: string, levelId?: string, createCustomAttributeDefinitionRequest?: CreateCustomAttributeDefinitionRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomAttributeDefinition>;

    /**
     * 
     * @summary Delete a CustomAttributeDefinition
     * @param {string} id ID of the Custom Attribute Definition
     * @param {boolean} [force] Force delete the Custom Attribute Definition, even though there are Custom Attribute Values associated with it.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomAttributeDefinitionsApiInterface
     */
    deleteCustomAttributeDefinition(id: string, force?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Get a CustomAttributeDefinition
     * @param {string} id ID of the Custom Attribute Definition
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomAttributeDefinitionsApiInterface
     */
    getCustomAttributeDefinition(id: string, options?: RawAxiosRequestConfig): AxiosPromise<CustomAttributeDefinition>;

    /**
     * 
     * @summary List Custom Attribute Definitions
     * @param {string} [clientId] Client ID of this Custom Attribute Definition. Leave null if you want to define a level attribute.
     * @param {string} [levelId] Level ID of this Custom Attribute Definition. Leave null if you want to define a client attribute.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomAttributeDefinitionsApiInterface
     */
    getCustomAttributeDefinitions(clientId?: string, levelId?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<CustomAttributeDefinition>>;

    /**
     * 
     * @summary Update a CustomAttributeDefinition
     * @param {string} id ID of the Custom Attribute Definition
     * @param {UpdateCustomAttributeDefinitionRequest} [updateCustomAttributeDefinitionRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomAttributeDefinitionsApiInterface
     */
    updateCustomAttributeDefinition(id: string, updateCustomAttributeDefinitionRequest?: UpdateCustomAttributeDefinitionRequest, options?: RawAxiosRequestConfig): AxiosPromise<CustomAttributeDefinition>;

}

/**
 * CustomAttributeDefinitionsApi - object-oriented interface
 * @export
 * @class CustomAttributeDefinitionsApi
 * @extends {BaseAPI}
 */
export class CustomAttributeDefinitionsApi extends BaseAPI implements CustomAttributeDefinitionsApiInterface {
    /**
     * 
     * @summary Batch Update CustomAttributeValues
     * @param {string} id ID of the Custom Attribute Definition
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomAttributeDefinitionsApi
     */
    public batchUpdateCustomAttributeValues(id: string, file?: File, options?: RawAxiosRequestConfig) {
        return CustomAttributeDefinitionsApiFp(this.configuration).batchUpdateCustomAttributeValues(id, file, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a Custom Attribute Definition
     * @param {string} [clientId] Client ID of this Custom Attribute Definition. Leave null if you want to define a level attribute.
     * @param {string} [levelId] Level ID of this Custom Attribute Definition. Leave null if you want to define a client attribute.
     * @param {CreateCustomAttributeDefinitionRequest} [createCustomAttributeDefinitionRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomAttributeDefinitionsApi
     */
    public createCustomAttributeDefinition(clientId?: string, levelId?: string, createCustomAttributeDefinitionRequest?: CreateCustomAttributeDefinitionRequest, options?: RawAxiosRequestConfig) {
        return CustomAttributeDefinitionsApiFp(this.configuration).createCustomAttributeDefinition(clientId, levelId, createCustomAttributeDefinitionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a CustomAttributeDefinition
     * @param {string} id ID of the Custom Attribute Definition
     * @param {boolean} [force] Force delete the Custom Attribute Definition, even though there are Custom Attribute Values associated with it.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomAttributeDefinitionsApi
     */
    public deleteCustomAttributeDefinition(id: string, force?: boolean, options?: RawAxiosRequestConfig) {
        return CustomAttributeDefinitionsApiFp(this.configuration).deleteCustomAttributeDefinition(id, force, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a CustomAttributeDefinition
     * @param {string} id ID of the Custom Attribute Definition
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomAttributeDefinitionsApi
     */
    public getCustomAttributeDefinition(id: string, options?: RawAxiosRequestConfig) {
        return CustomAttributeDefinitionsApiFp(this.configuration).getCustomAttributeDefinition(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Custom Attribute Definitions
     * @param {string} [clientId] Client ID of this Custom Attribute Definition. Leave null if you want to define a level attribute.
     * @param {string} [levelId] Level ID of this Custom Attribute Definition. Leave null if you want to define a client attribute.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomAttributeDefinitionsApi
     */
    public getCustomAttributeDefinitions(clientId?: string, levelId?: string, options?: RawAxiosRequestConfig) {
        return CustomAttributeDefinitionsApiFp(this.configuration).getCustomAttributeDefinitions(clientId, levelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a CustomAttributeDefinition
     * @param {string} id ID of the Custom Attribute Definition
     * @param {UpdateCustomAttributeDefinitionRequest} [updateCustomAttributeDefinitionRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CustomAttributeDefinitionsApi
     */
    public updateCustomAttributeDefinition(id: string, updateCustomAttributeDefinitionRequest?: UpdateCustomAttributeDefinitionRequest, options?: RawAxiosRequestConfig) {
        return CustomAttributeDefinitionsApiFp(this.configuration).updateCustomAttributeDefinition(id, updateCustomAttributeDefinitionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DigestApi - axios parameter creator
 * @export
 */
export const DigestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * The response is the same like the normal Event, but has no creator, contact, contact_type and group.
         * @summary show event
         * @param {string} id id of corresponding event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDigestEvent: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDigestEvent', 'id', id)
            const localVarPath = `/api/v1/digest/events/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary own status for event
         * @param {string} id id of corresponding event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDigestOwnRsvp: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDigestOwnRsvp', 'id', id)
            const localVarPath = `/api/v1/digest/events/{id}/rsvp`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set RSVP
         * @param {string} id id of corresponding event
         * @param {RsvpRequest} [rsvpRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertDigestOwnRsvp: async (id: string, rsvpRequest?: RsvpRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('upsertDigestOwnRsvp', 'id', id)
            const localVarPath = `/api/v1/digest/events/{id}/rsvp`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rsvpRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DigestApi - functional programming interface
 * @export
 */
export const DigestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DigestApiAxiosParamCreator(configuration)
    return {
        /**
         * The response is the same like the normal Event, but has no creator, contact, contact_type and group.
         * @summary show event
         * @param {string} id id of corresponding event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDigestEvent(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DigestEvent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDigestEvent(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DigestApi.getDigestEvent']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary own status for event
         * @param {string} id id of corresponding event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDigestOwnRsvp(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Rsvp>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDigestOwnRsvp(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DigestApi.getDigestOwnRsvp']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Set RSVP
         * @param {string} id id of corresponding event
         * @param {RsvpRequest} [rsvpRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async upsertDigestOwnRsvp(id: string, rsvpRequest?: RsvpRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Rsvp>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.upsertDigestOwnRsvp(id, rsvpRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DigestApi.upsertDigestOwnRsvp']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * DigestApi - factory interface
 * @export
 */
export const DigestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DigestApiFp(configuration)
    return {
        /**
         * The response is the same like the normal Event, but has no creator, contact, contact_type and group.
         * @summary show event
         * @param {string} id id of corresponding event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDigestEvent(id: string, options?: any): AxiosPromise<DigestEvent> {
            return localVarFp.getDigestEvent(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary own status for event
         * @param {string} id id of corresponding event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDigestOwnRsvp(id: string, options?: any): AxiosPromise<Rsvp> {
            return localVarFp.getDigestOwnRsvp(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set RSVP
         * @param {string} id id of corresponding event
         * @param {RsvpRequest} [rsvpRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upsertDigestOwnRsvp(id: string, rsvpRequest?: RsvpRequest, options?: any): AxiosPromise<Rsvp> {
            return localVarFp.upsertDigestOwnRsvp(id, rsvpRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DigestApi - interface
 * @export
 * @interface DigestApi
 */
export interface DigestApiInterface {
    /**
     * The response is the same like the normal Event, but has no creator, contact, contact_type and group.
     * @summary show event
     * @param {string} id id of corresponding event
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DigestApiInterface
     */
    getDigestEvent(id: string, options?: RawAxiosRequestConfig): AxiosPromise<DigestEvent>;

    /**
     * 
     * @summary own status for event
     * @param {string} id id of corresponding event
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DigestApiInterface
     */
    getDigestOwnRsvp(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Rsvp>;

    /**
     * 
     * @summary Set RSVP
     * @param {string} id id of corresponding event
     * @param {RsvpRequest} [rsvpRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DigestApiInterface
     */
    upsertDigestOwnRsvp(id: string, rsvpRequest?: RsvpRequest, options?: RawAxiosRequestConfig): AxiosPromise<Rsvp>;

}

/**
 * DigestApi - object-oriented interface
 * @export
 * @class DigestApi
 * @extends {BaseAPI}
 */
export class DigestApi extends BaseAPI implements DigestApiInterface {
    /**
     * The response is the same like the normal Event, but has no creator, contact, contact_type and group.
     * @summary show event
     * @param {string} id id of corresponding event
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DigestApi
     */
    public getDigestEvent(id: string, options?: RawAxiosRequestConfig) {
        return DigestApiFp(this.configuration).getDigestEvent(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary own status for event
     * @param {string} id id of corresponding event
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DigestApi
     */
    public getDigestOwnRsvp(id: string, options?: RawAxiosRequestConfig) {
        return DigestApiFp(this.configuration).getDigestOwnRsvp(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set RSVP
     * @param {string} id id of corresponding event
     * @param {RsvpRequest} [rsvpRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DigestApi
     */
    public upsertDigestOwnRsvp(id: string, rsvpRequest?: RsvpRequest, options?: RawAxiosRequestConfig) {
        return DigestApiFp(this.configuration).upsertDigestOwnRsvp(id, rsvpRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * DriveApi - axios parameter creator
 * @export
 */
export const DriveApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List all root level folder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategories: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/drive/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns an overview of which groups could possibly access this file given the provided settings
         * @param {number} [inodeId] Inode to take as basis for considerations
         * @param {GetGroupACLModeEnum} [mode] For reading or writing
         * @param {number} [parentId] Parent Override
         * @param {number} [levelId] Level-Override
         * @param {number} [restrictToId] Restrict_to-Override, must be stricter than parents restrict_to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupACL: async (inodeId?: number, mode?: GetGroupACLModeEnum, parentId?: number, levelId?: number, restrictToId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/drive/group_acl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required

            if (inodeId !== undefined) {
                localVarQueryParameter['inode_id'] = inodeId;
            }

            if (mode !== undefined) {
                localVarQueryParameter['mode'] = mode;
            }

            if (parentId !== undefined) {
                localVarQueryParameter['parent_id'] = parentId;
            }

            if (levelId !== undefined) {
                localVarQueryParameter['level_id'] = levelId;
            }

            if (restrictToId !== undefined) {
                localVarQueryParameter['restrict_to_id'] = restrictToId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns an overview of what levels could possibly access this file given the provided settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLevelACL: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/drive/level_acl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns an overview of who could possibly access this file given the provided settings
         * @param {number} [inodeId] Inode to take as basis for considerations
         * @param {string} [filter] Search query for first and last name
         * @param {number} [parentId] Parent Override
         * @param {number} [levelId] Level-Override
         * @param {number} [restrictToId] Restrict_to-Override, must be stricter than parents restrict_to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberACL: async (inodeId?: number, filter?: string, parentId?: number, levelId?: number, restrictToId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/drive/member_acl`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required

            if (inodeId !== undefined) {
                localVarQueryParameter['inode_id'] = inodeId;
            }

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (parentId !== undefined) {
                localVarQueryParameter['parent_id'] = parentId;
            }

            if (levelId !== undefined) {
                localVarQueryParameter['level_id'] = levelId;
            }

            if (restrictToId !== undefined) {
                localVarQueryParameter['restrict_to_id'] = restrictToId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get most recent added files and folders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNews: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/drive/news`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all parents of an Inode up to the root.
         * @param {number} inodeId ID of the folder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPath: async (inodeId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inodeId' is not null or undefined
            assertParamExists('getPath', 'inodeId', inodeId)
            const localVarPath = `/api/v1/drive/parents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required

            if (inodeId !== undefined) {
                localVarQueryParameter['inode_id'] = inodeId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all pinned files and folder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPinnedInodes: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/drive/pinned`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate a signed upload URL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUploadURL: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/drive/sign`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DriveApi - functional programming interface
 * @export
 */
export const DriveApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DriveApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List all root level folder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCategories(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InodeResults>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCategories(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DriveApi.getCategories']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns an overview of which groups could possibly access this file given the provided settings
         * @param {number} [inodeId] Inode to take as basis for considerations
         * @param {GetGroupACLModeEnum} [mode] For reading or writing
         * @param {number} [parentId] Parent Override
         * @param {number} [levelId] Level-Override
         * @param {number} [restrictToId] Restrict_to-Override, must be stricter than parents restrict_to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGroupACL(inodeId?: number, mode?: GetGroupACLModeEnum, parentId?: number, levelId?: number, restrictToId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetGroupACL200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGroupACL(inodeId, mode, parentId, levelId, restrictToId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DriveApi.getGroupACL']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns an overview of what levels could possibly access this file given the provided settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLevelACL(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLevelACL200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLevelACL(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DriveApi.getLevelACL']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Returns an overview of who could possibly access this file given the provided settings
         * @param {number} [inodeId] Inode to take as basis for considerations
         * @param {string} [filter] Search query for first and last name
         * @param {number} [parentId] Parent Override
         * @param {number} [levelId] Level-Override
         * @param {number} [restrictToId] Restrict_to-Override, must be stricter than parents restrict_to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMemberACL(inodeId?: number, filter?: string, parentId?: number, levelId?: number, restrictToId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetMemberACL200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMemberACL(inodeId, filter, parentId, levelId, restrictToId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DriveApi.getMemberACL']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get most recent added files and folders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNews(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InodeResults>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNews(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DriveApi.getNews']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get all parents of an Inode up to the root.
         * @param {number} inodeId ID of the folder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPath(inodeId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetLevelACL200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPath(inodeId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DriveApi.getPath']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary List all pinned files and folder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPinnedInodes(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InodeResults>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPinnedInodes(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DriveApi.getPinnedInodes']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Generate a signed upload URL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUploadURL(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUploadUrl>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUploadURL(options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DriveApi.getUploadURL']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * DriveApi - factory interface
 * @export
 */
export const DriveApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DriveApiFp(configuration)
    return {
        /**
         * 
         * @summary List all root level folder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCategories(options?: any): AxiosPromise<InodeResults> {
            return localVarFp.getCategories(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns an overview of which groups could possibly access this file given the provided settings
         * @param {number} [inodeId] Inode to take as basis for considerations
         * @param {GetGroupACLModeEnum} [mode] For reading or writing
         * @param {number} [parentId] Parent Override
         * @param {number} [levelId] Level-Override
         * @param {number} [restrictToId] Restrict_to-Override, must be stricter than parents restrict_to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupACL(inodeId?: number, mode?: GetGroupACLModeEnum, parentId?: number, levelId?: number, restrictToId?: number, options?: any): AxiosPromise<GetGroupACL200Response> {
            return localVarFp.getGroupACL(inodeId, mode, parentId, levelId, restrictToId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns an overview of what levels could possibly access this file given the provided settings
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLevelACL(options?: any): AxiosPromise<GetLevelACL200Response> {
            return localVarFp.getLevelACL(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns an overview of who could possibly access this file given the provided settings
         * @param {number} [inodeId] Inode to take as basis for considerations
         * @param {string} [filter] Search query for first and last name
         * @param {number} [parentId] Parent Override
         * @param {number} [levelId] Level-Override
         * @param {number} [restrictToId] Restrict_to-Override, must be stricter than parents restrict_to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMemberACL(inodeId?: number, filter?: string, parentId?: number, levelId?: number, restrictToId?: number, options?: any): AxiosPromise<GetMemberACL200Response> {
            return localVarFp.getMemberACL(inodeId, filter, parentId, levelId, restrictToId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get most recent added files and folders
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNews(options?: any): AxiosPromise<InodeResults> {
            return localVarFp.getNews(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all parents of an Inode up to the root.
         * @param {number} inodeId ID of the folder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPath(inodeId: number, options?: any): AxiosPromise<GetLevelACL200Response> {
            return localVarFp.getPath(inodeId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all pinned files and folder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPinnedInodes(options?: any): AxiosPromise<InodeResults> {
            return localVarFp.getPinnedInodes(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate a signed upload URL
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUploadURL(options?: any): AxiosPromise<FileUploadUrl> {
            return localVarFp.getUploadURL(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DriveApi - interface
 * @export
 * @interface DriveApi
 */
export interface DriveApiInterface {
    /**
     * 
     * @summary List all root level folder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriveApiInterface
     */
    getCategories(options?: RawAxiosRequestConfig): AxiosPromise<InodeResults>;

    /**
     * 
     * @summary Returns an overview of which groups could possibly access this file given the provided settings
     * @param {number} [inodeId] Inode to take as basis for considerations
     * @param {GetGroupACLModeEnum} [mode] For reading or writing
     * @param {number} [parentId] Parent Override
     * @param {number} [levelId] Level-Override
     * @param {number} [restrictToId] Restrict_to-Override, must be stricter than parents restrict_to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriveApiInterface
     */
    getGroupACL(inodeId?: number, mode?: GetGroupACLModeEnum, parentId?: number, levelId?: number, restrictToId?: number, options?: RawAxiosRequestConfig): AxiosPromise<GetGroupACL200Response>;

    /**
     * 
     * @summary Returns an overview of what levels could possibly access this file given the provided settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriveApiInterface
     */
    getLevelACL(options?: RawAxiosRequestConfig): AxiosPromise<GetLevelACL200Response>;

    /**
     * 
     * @summary Returns an overview of who could possibly access this file given the provided settings
     * @param {number} [inodeId] Inode to take as basis for considerations
     * @param {string} [filter] Search query for first and last name
     * @param {number} [parentId] Parent Override
     * @param {number} [levelId] Level-Override
     * @param {number} [restrictToId] Restrict_to-Override, must be stricter than parents restrict_to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriveApiInterface
     */
    getMemberACL(inodeId?: number, filter?: string, parentId?: number, levelId?: number, restrictToId?: number, options?: RawAxiosRequestConfig): AxiosPromise<GetMemberACL200Response>;

    /**
     * 
     * @summary Get most recent added files and folders
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriveApiInterface
     */
    getNews(options?: RawAxiosRequestConfig): AxiosPromise<InodeResults>;

    /**
     * 
     * @summary Get all parents of an Inode up to the root.
     * @param {number} inodeId ID of the folder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriveApiInterface
     */
    getPath(inodeId: number, options?: RawAxiosRequestConfig): AxiosPromise<GetLevelACL200Response>;

    /**
     * 
     * @summary List all pinned files and folder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriveApiInterface
     */
    getPinnedInodes(options?: RawAxiosRequestConfig): AxiosPromise<InodeResults>;

    /**
     * 
     * @summary Generate a signed upload URL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriveApiInterface
     */
    getUploadURL(options?: RawAxiosRequestConfig): AxiosPromise<FileUploadUrl>;

}

/**
 * DriveApi - object-oriented interface
 * @export
 * @class DriveApi
 * @extends {BaseAPI}
 */
export class DriveApi extends BaseAPI implements DriveApiInterface {
    /**
     * 
     * @summary List all root level folder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriveApi
     */
    public getCategories(options?: RawAxiosRequestConfig) {
        return DriveApiFp(this.configuration).getCategories(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns an overview of which groups could possibly access this file given the provided settings
     * @param {number} [inodeId] Inode to take as basis for considerations
     * @param {GetGroupACLModeEnum} [mode] For reading or writing
     * @param {number} [parentId] Parent Override
     * @param {number} [levelId] Level-Override
     * @param {number} [restrictToId] Restrict_to-Override, must be stricter than parents restrict_to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriveApi
     */
    public getGroupACL(inodeId?: number, mode?: GetGroupACLModeEnum, parentId?: number, levelId?: number, restrictToId?: number, options?: RawAxiosRequestConfig) {
        return DriveApiFp(this.configuration).getGroupACL(inodeId, mode, parentId, levelId, restrictToId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns an overview of what levels could possibly access this file given the provided settings
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriveApi
     */
    public getLevelACL(options?: RawAxiosRequestConfig) {
        return DriveApiFp(this.configuration).getLevelACL(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns an overview of who could possibly access this file given the provided settings
     * @param {number} [inodeId] Inode to take as basis for considerations
     * @param {string} [filter] Search query for first and last name
     * @param {number} [parentId] Parent Override
     * @param {number} [levelId] Level-Override
     * @param {number} [restrictToId] Restrict_to-Override, must be stricter than parents restrict_to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriveApi
     */
    public getMemberACL(inodeId?: number, filter?: string, parentId?: number, levelId?: number, restrictToId?: number, options?: RawAxiosRequestConfig) {
        return DriveApiFp(this.configuration).getMemberACL(inodeId, filter, parentId, levelId, restrictToId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get most recent added files and folders
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriveApi
     */
    public getNews(options?: RawAxiosRequestConfig) {
        return DriveApiFp(this.configuration).getNews(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all parents of an Inode up to the root.
     * @param {number} inodeId ID of the folder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriveApi
     */
    public getPath(inodeId: number, options?: RawAxiosRequestConfig) {
        return DriveApiFp(this.configuration).getPath(inodeId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all pinned files and folder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriveApi
     */
    public getPinnedInodes(options?: RawAxiosRequestConfig) {
        return DriveApiFp(this.configuration).getPinnedInodes(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate a signed upload URL
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriveApi
     */
    public getUploadURL(options?: RawAxiosRequestConfig) {
        return DriveApiFp(this.configuration).getUploadURL(options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetGroupACLModeEnum = {
    R: 'r',
    W: 'w'
} as const;
export type GetGroupACLModeEnum = typeof GetGroupACLModeEnum[keyof typeof GetGroupACLModeEnum];


/**
 * DriveFilesApi - axios parameter creator
 * @export
 */
export const DriveFilesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Saves an file that was previously uploaded to a temporary S3 bucket in the database and moves the temp-file to a permanent storage afterwards.
         * @summary Create a DriveFile
         * @param {UpdateUploadedFileRequest} [updateUploadedFileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDriveFile: async (updateUploadedFileRequest?: UpdateUploadedFileRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/drive/uploaded_files`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUploadedFileRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a DriveFile
         * @param {number} id ID of the DriveFile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDriveFile: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteDriveFile', 'id', id)
            const localVarPath = `/api/v1/drive/uploaded_files/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download the stored file
         * @param {number} id ID of the DriveFile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDriveFile: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('downloadDriveFile', 'id', id)
            const localVarPath = `/api/v1/drive/uploaded_files/{id}/download`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all details of a DriveFile
         * @param {number} id ID of the DriveFile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDriveFile: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getDriveFile', 'id', id)
            const localVarPath = `/api/v1/drive/uploaded_files/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Pins an DriveFile
         * @param {number} id ID of the DriveFile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pinDriveFile: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('pinDriveFile', 'id', id)
            const localVarPath = `/api/v1/drive/inodes/{id}/flag/pin`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unpins an DriveFile
         * @param {number} id ID of the DriveFile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unpinDriveFile: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('unpinDriveFile', 'id', id)
            const localVarPath = `/api/v1/drive/inodes/{id}/flag/pin`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a DriveFile
         * @param {number} id ID of the DriveFile
         * @param {UpdateUploadedFileRequest} [updateUploadedFileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDriveFile: async (id: number, updateUploadedFileRequest?: UpdateUploadedFileRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateDriveFile', 'id', id)
            const localVarPath = `/api/v1/drive/uploaded_files/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUploadedFileRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DriveFilesApi - functional programming interface
 * @export
 */
export const DriveFilesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DriveFilesApiAxiosParamCreator(configuration)
    return {
        /**
         * Saves an file that was previously uploaded to a temporary S3 bucket in the database and moves the temp-file to a permanent storage afterwards.
         * @summary Create a DriveFile
         * @param {UpdateUploadedFileRequest} [updateUploadedFileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createDriveFile(updateUploadedFileRequest?: UpdateUploadedFileRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Inode>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createDriveFile(updateUploadedFileRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DriveFilesApi.createDriveFile']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a DriveFile
         * @param {number} id ID of the DriveFile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDriveFile(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDriveFile(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DriveFilesApi.deleteDriveFile']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Download the stored file
         * @param {number} id ID of the DriveFile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadDriveFile(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadDriveFile(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DriveFilesApi.downloadDriveFile']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get all details of a DriveFile
         * @param {number} id ID of the DriveFile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDriveFile(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Inode>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDriveFile(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DriveFilesApi.getDriveFile']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Pins an DriveFile
         * @param {number} id ID of the DriveFile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pinDriveFile(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Inode>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pinDriveFile(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DriveFilesApi.pinDriveFile']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Unpins an DriveFile
         * @param {number} id ID of the DriveFile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unpinDriveFile(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unpinDriveFile(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DriveFilesApi.unpinDriveFile']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Update a DriveFile
         * @param {number} id ID of the DriveFile
         * @param {UpdateUploadedFileRequest} [updateUploadedFileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDriveFile(id: number, updateUploadedFileRequest?: UpdateUploadedFileRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Inode>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDriveFile(id, updateUploadedFileRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['DriveFilesApi.updateDriveFile']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * DriveFilesApi - factory interface
 * @export
 */
export const DriveFilesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DriveFilesApiFp(configuration)
    return {
        /**
         * Saves an file that was previously uploaded to a temporary S3 bucket in the database and moves the temp-file to a permanent storage afterwards.
         * @summary Create a DriveFile
         * @param {UpdateUploadedFileRequest} [updateUploadedFileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createDriveFile(updateUploadedFileRequest?: UpdateUploadedFileRequest, options?: any): AxiosPromise<Inode> {
            return localVarFp.createDriveFile(updateUploadedFileRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a DriveFile
         * @param {number} id ID of the DriveFile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDriveFile(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteDriveFile(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download the stored file
         * @param {number} id ID of the DriveFile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadDriveFile(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.downloadDriveFile(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all details of a DriveFile
         * @param {number} id ID of the DriveFile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDriveFile(id: number, options?: any): AxiosPromise<Inode> {
            return localVarFp.getDriveFile(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Pins an DriveFile
         * @param {number} id ID of the DriveFile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pinDriveFile(id: number, options?: any): AxiosPromise<Inode> {
            return localVarFp.pinDriveFile(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unpins an DriveFile
         * @param {number} id ID of the DriveFile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unpinDriveFile(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.unpinDriveFile(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a DriveFile
         * @param {number} id ID of the DriveFile
         * @param {UpdateUploadedFileRequest} [updateUploadedFileRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDriveFile(id: number, updateUploadedFileRequest?: UpdateUploadedFileRequest, options?: any): AxiosPromise<Inode> {
            return localVarFp.updateDriveFile(id, updateUploadedFileRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DriveFilesApi - interface
 * @export
 * @interface DriveFilesApi
 */
export interface DriveFilesApiInterface {
    /**
     * Saves an file that was previously uploaded to a temporary S3 bucket in the database and moves the temp-file to a permanent storage afterwards.
     * @summary Create a DriveFile
     * @param {UpdateUploadedFileRequest} [updateUploadedFileRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriveFilesApiInterface
     */
    createDriveFile(updateUploadedFileRequest?: UpdateUploadedFileRequest, options?: RawAxiosRequestConfig): AxiosPromise<Inode>;

    /**
     * 
     * @summary Delete a DriveFile
     * @param {number} id ID of the DriveFile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriveFilesApiInterface
     */
    deleteDriveFile(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Download the stored file
     * @param {number} id ID of the DriveFile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriveFilesApiInterface
     */
    downloadDriveFile(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Get all details of a DriveFile
     * @param {number} id ID of the DriveFile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriveFilesApiInterface
     */
    getDriveFile(id: number, options?: RawAxiosRequestConfig): AxiosPromise<Inode>;

    /**
     * 
     * @summary Pins an DriveFile
     * @param {number} id ID of the DriveFile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriveFilesApiInterface
     */
    pinDriveFile(id: number, options?: RawAxiosRequestConfig): AxiosPromise<Inode>;

    /**
     * 
     * @summary Unpins an DriveFile
     * @param {number} id ID of the DriveFile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriveFilesApiInterface
     */
    unpinDriveFile(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Update a DriveFile
     * @param {number} id ID of the DriveFile
     * @param {UpdateUploadedFileRequest} [updateUploadedFileRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriveFilesApiInterface
     */
    updateDriveFile(id: number, updateUploadedFileRequest?: UpdateUploadedFileRequest, options?: RawAxiosRequestConfig): AxiosPromise<Inode>;

}

/**
 * DriveFilesApi - object-oriented interface
 * @export
 * @class DriveFilesApi
 * @extends {BaseAPI}
 */
export class DriveFilesApi extends BaseAPI implements DriveFilesApiInterface {
    /**
     * Saves an file that was previously uploaded to a temporary S3 bucket in the database and moves the temp-file to a permanent storage afterwards.
     * @summary Create a DriveFile
     * @param {UpdateUploadedFileRequest} [updateUploadedFileRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriveFilesApi
     */
    public createDriveFile(updateUploadedFileRequest?: UpdateUploadedFileRequest, options?: RawAxiosRequestConfig) {
        return DriveFilesApiFp(this.configuration).createDriveFile(updateUploadedFileRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a DriveFile
     * @param {number} id ID of the DriveFile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriveFilesApi
     */
    public deleteDriveFile(id: number, options?: RawAxiosRequestConfig) {
        return DriveFilesApiFp(this.configuration).deleteDriveFile(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download the stored file
     * @param {number} id ID of the DriveFile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriveFilesApi
     */
    public downloadDriveFile(id: number, options?: RawAxiosRequestConfig) {
        return DriveFilesApiFp(this.configuration).downloadDriveFile(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all details of a DriveFile
     * @param {number} id ID of the DriveFile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriveFilesApi
     */
    public getDriveFile(id: number, options?: RawAxiosRequestConfig) {
        return DriveFilesApiFp(this.configuration).getDriveFile(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Pins an DriveFile
     * @param {number} id ID of the DriveFile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriveFilesApi
     */
    public pinDriveFile(id: number, options?: RawAxiosRequestConfig) {
        return DriveFilesApiFp(this.configuration).pinDriveFile(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unpins an DriveFile
     * @param {number} id ID of the DriveFile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriveFilesApi
     */
    public unpinDriveFile(id: number, options?: RawAxiosRequestConfig) {
        return DriveFilesApiFp(this.configuration).unpinDriveFile(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a DriveFile
     * @param {number} id ID of the DriveFile
     * @param {UpdateUploadedFileRequest} [updateUploadedFileRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DriveFilesApi
     */
    public updateDriveFile(id: number, updateUploadedFileRequest?: UpdateUploadedFileRequest, options?: RawAxiosRequestConfig) {
        return DriveFilesApiFp(this.configuration).updateDriveFile(id, updateUploadedFileRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EventMediaApi - axios parameter creator
 * @export
 */
export const EventMediaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Adds a batch of EventMedium to a Post.
         * @summary Add EventMedia for a Post
         * @param {string} id ID of the Post
         * @param {Array<EventMediumUpload>} [eventMediumUpload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEventMedia: async (id: string, eventMediumUpload?: Array<EventMediumUpload>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addEventMedia', 'id', id)
            const localVarPath = `/api/v1/posts/{id}/event_media`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eventMediumUpload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Deletes a EventMedium of a Post.
         * @summary Delete a EventMedium of a Post
         * @param {string} id ID of the EventMedium
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEventMedium: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteEventMedium', 'id', id)
            const localVarPath = `/api/v1/event_media/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Downloads EventMedia of a Post.
         * @summary Download EventMedia of a Post
         * @param {string} id ID of the Post
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadEventMedia: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('downloadEventMedia', 'id', id)
            const localVarPath = `/api/v1/posts/{id}/event_media.zip`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns EventMedia of a Post.
         * @summary Get EventMedia of a Post
         * @param {string} id ID of the Post
         * @param {number} [offset] Index of the first requested EventMedium, starting at 0.
         * @param {number} [limit] Maximum number of EventMedia to be returned.
         * @param {AscDescOrder} [order] Direction of the ordering by creation date (created_at).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventMedia: async (id: string, offset?: number, limit?: number, order?: AscDescOrder, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEventMedia', 'id', id)
            const localVarPath = `/api/v1/posts/{id}/event_media`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all Event Galleries (i.e. Posts with EventMedia).
         * @summary Get EventMedia of a Post
         * @param {number} [offset] Index of the first requested item, starting at 0.
         * @param {number} [limit] Maximum number of items to be returned.
         * @param {AscDescOrder} [order] Direction of the ordering by creation date (created_at).
         * @param {number} [preload] How many images should be eagerly loaded per gallery.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGalleries: async (offset?: number, limit?: number, order?: AscDescOrder, preload?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/event_galleries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (preload !== undefined) {
                localVarQueryParameter['preload'] = preload;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates a EventMedium of a Post.
         * @summary Update a EventMedium of a Post
         * @param {string} id ID of the EventMedium
         * @param {EventMediumUpdate} [eventMediumUpdate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEventMedium: async (id: string, eventMediumUpdate?: EventMediumUpdate, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateEventMedium', 'id', id)
            const localVarPath = `/api/v1/event_media/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eventMediumUpdate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EventMediaApi - functional programming interface
 * @export
 */
export const EventMediaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EventMediaApiAxiosParamCreator(configuration)
    return {
        /**
         * Adds a batch of EventMedium to a Post.
         * @summary Add EventMedia for a Post
         * @param {string} id ID of the Post
         * @param {Array<EventMediumUpload>} [eventMediumUpload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addEventMedia(id: string, eventMediumUpload?: Array<EventMediumUpload>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventMedium>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addEventMedia(id, eventMediumUpload, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EventMediaApi.addEventMedia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Deletes a EventMedium of a Post.
         * @summary Delete a EventMedium of a Post
         * @param {string} id ID of the EventMedium
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEventMedium(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEventMedium(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EventMediaApi.deleteEventMedium']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Downloads EventMedia of a Post.
         * @summary Download EventMedia of a Post
         * @param {string} id ID of the Post
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadEventMedia(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadEventMedia(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EventMediaApi.downloadEventMedia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Returns EventMedia of a Post.
         * @summary Get EventMedia of a Post
         * @param {string} id ID of the Post
         * @param {number} [offset] Index of the first requested EventMedium, starting at 0.
         * @param {number} [limit] Maximum number of EventMedia to be returned.
         * @param {AscDescOrder} [order] Direction of the ordering by creation date (created_at).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventMedia(id: string, offset?: number, limit?: number, order?: AscDescOrder, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventMedium>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventMedia(id, offset, limit, order, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EventMediaApi.getEventMedia']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Returns all Event Galleries (i.e. Posts with EventMedia).
         * @summary Get EventMedia of a Post
         * @param {number} [offset] Index of the first requested item, starting at 0.
         * @param {number} [limit] Maximum number of items to be returned.
         * @param {AscDescOrder} [order] Direction of the ordering by creation date (created_at).
         * @param {number} [preload] How many images should be eagerly loaded per gallery.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGalleries(offset?: number, limit?: number, order?: AscDescOrder, preload?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventGallery>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGalleries(offset, limit, order, preload, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EventMediaApi.getGalleries']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Updates a EventMedium of a Post.
         * @summary Update a EventMedium of a Post
         * @param {string} id ID of the EventMedium
         * @param {EventMediumUpdate} [eventMediumUpdate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEventMedium(id: string, eventMediumUpdate?: EventMediumUpdate, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<EventMedium>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEventMedium(id, eventMediumUpdate, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EventMediaApi.updateEventMedium']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * EventMediaApi - factory interface
 * @export
 */
export const EventMediaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EventMediaApiFp(configuration)
    return {
        /**
         * Adds a batch of EventMedium to a Post.
         * @summary Add EventMedia for a Post
         * @param {string} id ID of the Post
         * @param {Array<EventMediumUpload>} [eventMediumUpload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEventMedia(id: string, eventMediumUpload?: Array<EventMediumUpload>, options?: any): AxiosPromise<Array<EventMedium>> {
            return localVarFp.addEventMedia(id, eventMediumUpload, options).then((request) => request(axios, basePath));
        },
        /**
         * Deletes a EventMedium of a Post.
         * @summary Delete a EventMedium of a Post
         * @param {string} id ID of the EventMedium
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEventMedium(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteEventMedium(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Downloads EventMedia of a Post.
         * @summary Download EventMedia of a Post
         * @param {string} id ID of the Post
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadEventMedia(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.downloadEventMedia(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns EventMedia of a Post.
         * @summary Get EventMedia of a Post
         * @param {string} id ID of the Post
         * @param {number} [offset] Index of the first requested EventMedium, starting at 0.
         * @param {number} [limit] Maximum number of EventMedia to be returned.
         * @param {AscDescOrder} [order] Direction of the ordering by creation date (created_at).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventMedia(id: string, offset?: number, limit?: number, order?: AscDescOrder, options?: any): AxiosPromise<Array<EventMedium>> {
            return localVarFp.getEventMedia(id, offset, limit, order, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all Event Galleries (i.e. Posts with EventMedia).
         * @summary Get EventMedia of a Post
         * @param {number} [offset] Index of the first requested item, starting at 0.
         * @param {number} [limit] Maximum number of items to be returned.
         * @param {AscDescOrder} [order] Direction of the ordering by creation date (created_at).
         * @param {number} [preload] How many images should be eagerly loaded per gallery.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGalleries(offset?: number, limit?: number, order?: AscDescOrder, preload?: number, options?: any): AxiosPromise<Array<EventGallery>> {
            return localVarFp.getGalleries(offset, limit, order, preload, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates a EventMedium of a Post.
         * @summary Update a EventMedium of a Post
         * @param {string} id ID of the EventMedium
         * @param {EventMediumUpdate} [eventMediumUpdate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEventMedium(id: string, eventMediumUpdate?: EventMediumUpdate, options?: any): AxiosPromise<EventMedium> {
            return localVarFp.updateEventMedium(id, eventMediumUpdate, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EventMediaApi - interface
 * @export
 * @interface EventMediaApi
 */
export interface EventMediaApiInterface {
    /**
     * Adds a batch of EventMedium to a Post.
     * @summary Add EventMedia for a Post
     * @param {string} id ID of the Post
     * @param {Array<EventMediumUpload>} [eventMediumUpload] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventMediaApiInterface
     */
    addEventMedia(id: string, eventMediumUpload?: Array<EventMediumUpload>, options?: RawAxiosRequestConfig): AxiosPromise<Array<EventMedium>>;

    /**
     * Deletes a EventMedium of a Post.
     * @summary Delete a EventMedium of a Post
     * @param {string} id ID of the EventMedium
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventMediaApiInterface
     */
    deleteEventMedium(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Downloads EventMedia of a Post.
     * @summary Download EventMedia of a Post
     * @param {string} id ID of the Post
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventMediaApiInterface
     */
    downloadEventMedia(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Returns EventMedia of a Post.
     * @summary Get EventMedia of a Post
     * @param {string} id ID of the Post
     * @param {number} [offset] Index of the first requested EventMedium, starting at 0.
     * @param {number} [limit] Maximum number of EventMedia to be returned.
     * @param {AscDescOrder} [order] Direction of the ordering by creation date (created_at).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventMediaApiInterface
     */
    getEventMedia(id: string, offset?: number, limit?: number, order?: AscDescOrder, options?: RawAxiosRequestConfig): AxiosPromise<Array<EventMedium>>;

    /**
     * Returns all Event Galleries (i.e. Posts with EventMedia).
     * @summary Get EventMedia of a Post
     * @param {number} [offset] Index of the first requested item, starting at 0.
     * @param {number} [limit] Maximum number of items to be returned.
     * @param {AscDescOrder} [order] Direction of the ordering by creation date (created_at).
     * @param {number} [preload] How many images should be eagerly loaded per gallery.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventMediaApiInterface
     */
    getGalleries(offset?: number, limit?: number, order?: AscDescOrder, preload?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<EventGallery>>;

    /**
     * Updates a EventMedium of a Post.
     * @summary Update a EventMedium of a Post
     * @param {string} id ID of the EventMedium
     * @param {EventMediumUpdate} [eventMediumUpdate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventMediaApiInterface
     */
    updateEventMedium(id: string, eventMediumUpdate?: EventMediumUpdate, options?: RawAxiosRequestConfig): AxiosPromise<EventMedium>;

}

/**
 * EventMediaApi - object-oriented interface
 * @export
 * @class EventMediaApi
 * @extends {BaseAPI}
 */
export class EventMediaApi extends BaseAPI implements EventMediaApiInterface {
    /**
     * Adds a batch of EventMedium to a Post.
     * @summary Add EventMedia for a Post
     * @param {string} id ID of the Post
     * @param {Array<EventMediumUpload>} [eventMediumUpload] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventMediaApi
     */
    public addEventMedia(id: string, eventMediumUpload?: Array<EventMediumUpload>, options?: RawAxiosRequestConfig) {
        return EventMediaApiFp(this.configuration).addEventMedia(id, eventMediumUpload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Deletes a EventMedium of a Post.
     * @summary Delete a EventMedium of a Post
     * @param {string} id ID of the EventMedium
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventMediaApi
     */
    public deleteEventMedium(id: string, options?: RawAxiosRequestConfig) {
        return EventMediaApiFp(this.configuration).deleteEventMedium(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Downloads EventMedia of a Post.
     * @summary Download EventMedia of a Post
     * @param {string} id ID of the Post
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventMediaApi
     */
    public downloadEventMedia(id: string, options?: RawAxiosRequestConfig) {
        return EventMediaApiFp(this.configuration).downloadEventMedia(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns EventMedia of a Post.
     * @summary Get EventMedia of a Post
     * @param {string} id ID of the Post
     * @param {number} [offset] Index of the first requested EventMedium, starting at 0.
     * @param {number} [limit] Maximum number of EventMedia to be returned.
     * @param {AscDescOrder} [order] Direction of the ordering by creation date (created_at).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventMediaApi
     */
    public getEventMedia(id: string, offset?: number, limit?: number, order?: AscDescOrder, options?: RawAxiosRequestConfig) {
        return EventMediaApiFp(this.configuration).getEventMedia(id, offset, limit, order, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all Event Galleries (i.e. Posts with EventMedia).
     * @summary Get EventMedia of a Post
     * @param {number} [offset] Index of the first requested item, starting at 0.
     * @param {number} [limit] Maximum number of items to be returned.
     * @param {AscDescOrder} [order] Direction of the ordering by creation date (created_at).
     * @param {number} [preload] How many images should be eagerly loaded per gallery.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventMediaApi
     */
    public getGalleries(offset?: number, limit?: number, order?: AscDescOrder, preload?: number, options?: RawAxiosRequestConfig) {
        return EventMediaApiFp(this.configuration).getGalleries(offset, limit, order, preload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates a EventMedium of a Post.
     * @summary Update a EventMedium of a Post
     * @param {string} id ID of the EventMedium
     * @param {EventMediumUpdate} [eventMediumUpdate] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventMediaApi
     */
    public updateEventMedium(id: string, eventMediumUpdate?: EventMediumUpdate, options?: RawAxiosRequestConfig) {
        return EventMediaApiFp(this.configuration).updateEventMedium(id, eventMediumUpdate, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * EventsApi - axios parameter creator
 * @export
 */
export const EventsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add attachments to this event
         * @param {string} id id of corresponding attachable (e.g. Topic)
         * @param {Array<AttachmentUpload>} [attachmentUpload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEventAttachments: async (id: string, attachmentUpload?: Array<AttachmentUpload>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addEventAttachments', 'id', id)
            const localVarPath = `/api/v1/events/{id}/attachments`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(attachmentUpload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new event
         * @param {EventCreateRequest} [eventCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEvent: async (eventCreateRequest?: EventCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eventCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new post for an event
         * @param {string} id id of event to post to
         * @param {PostRequest} [postRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEventPost: async (id: string, postRequest?: PostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createEventPost', 'id', id)
            const localVarPath = `/api/v1/events/{id}/posts`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an Event
         * @param {string} id id of corresponding event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEvent: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteEvent', 'id', id)
            const localVarPath = `/api/v1/events/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an Attachment
         * @param {string} id ID of the attachable, e.g. Topic.
         * @param {string} attachmentId ID of the attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEventAttachment: async (id: string, attachmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteEventAttachment', 'id', id)
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('deleteEventAttachment', 'attachmentId', attachmentId)
            const localVarPath = `/api/v1/events/{id}/attachments/{attachment_id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"attachment_id"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete attachments
         * @param {string} id id of corresponding attachable (e.g. Topic)
         * @param {Array<string>} [requestBody] IDs of the attachments to be deleted.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEventAttachments: async (id: string, requestBody?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteEventAttachments', 'id', id)
            const localVarPath = `/api/v1/events/{id}/attachments`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a post of an event
         * @param {string} id id of event to post to
         * @param {string} postId id of post
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEventPost: async (id: string, postId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteEventPost', 'id', id)
            // verify required parameter 'postId' is not null or undefined
            assertParamExists('deleteEventPost', 'postId', postId)
            const localVarPath = `/api/v1/events/{id}/posts/{post_id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"post_id"}}`, encodeURIComponent(String(postId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get an Event
         * @param {string} id id of corresponding event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvent: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEvent', 'id', id)
            const localVarPath = `/api/v1/events/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get details of an Attachment
         * @param {string} id ID of the attachable, e.g. Topic.
         * @param {string} attachmentId ID of the attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventAttachment: async (id: string, attachmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEventAttachment', 'id', id)
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('getEventAttachment', 'attachmentId', attachmentId)
            const localVarPath = `/api/v1/events/{id}/attachments/{attachment_id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"attachment_id"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all Attachments of this event
         * @param {string} id id of corresponding attachable (e.g. Topic)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventAttachments: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEventAttachments', 'id', id)
            const localVarPath = `/api/v1/events/{id}/attachments`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a post of an event
         * @param {string} id id of event to post to
         * @param {string} postId id of post
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventPost: async (id: string, postId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEventPost', 'id', id)
            // verify required parameter 'postId' is not null or undefined
            assertParamExists('getEventPost', 'postId', postId)
            const localVarPath = `/api/v1/events/{id}/posts/{post_id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"post_id"}}`, encodeURIComponent(String(postId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Posts are returned in a paginated way, so you specify how many Posts should be on a page and where your page should begin.
         * @summary Get a list of Posts of an Event
         * @param {string} id id of event to post to
         * @param {number} [offset] Index of the first requested Post, starting at 0.
         * @param {number} [limit] Maximum number of Posts to be returned.
         * @param {AscDescOrder} [order] RSVPs of Coetanen are always shown first. Direction of the ordering by creation date (created_at).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventPosts: async (id: string, offset?: number, limit?: number, order?: AscDescOrder, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getEventPosts', 'id', id)
            const localVarPath = `/api/v1/events/{id}/posts`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List events
         * @param {number} [attendBy] Only show events attended by this PersonalRecord ID
         * @param {number} [declineBy] Only show events declined by this PersonalRecord ID
         * @param {number} [noRsvpBy] Only show events with pending replies by this PersonalRecord ID
         * @param {number} [groupId] Only show events in this group
         * @param {number} [clientId] Only show events in this client
         * @param {number} [levelId] Only show events in this level
         * @param {string} [startAfter] Only show events at or after this date
         * @param {string} [startBefore] Only show events starting before this date
         * @param {number} [offset] Index of the first requested item, starting at 0.
         * @param {number} [limit] Maximum number of items to be returned.
         * @param {AscDescOrder} [order] Direction of the ordering by creation date (created_at).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvents: async (attendBy?: number, declineBy?: number, noRsvpBy?: number, groupId?: number, clientId?: number, levelId?: number, startAfter?: string, startBefore?: string, offset?: number, limit?: number, order?: AscDescOrder, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required

            if (attendBy !== undefined) {
                localVarQueryParameter['attend_by'] = attendBy;
            }

            if (declineBy !== undefined) {
                localVarQueryParameter['decline_by'] = declineBy;
            }

            if (noRsvpBy !== undefined) {
                localVarQueryParameter['no_rsvp_by'] = noRsvpBy;
            }

            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }

            if (clientId !== undefined) {
                localVarQueryParameter['client_id'] = clientId;
            }

            if (levelId !== undefined) {
                localVarQueryParameter['level_id'] = levelId;
            }

            if (startAfter !== undefined) {
                localVarQueryParameter['start_after'] = startAfter;
            }

            if (startBefore !== undefined) {
                localVarQueryParameter['start_before'] = startBefore;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * API to list all open events of the current semester, for integration in the customer web pages.
         * @summary List all open events
         * @param {number} [limit] Limit the number of events to return. Without a limit all events of the current semester are returned. If all these are past, the next semester is also included unless there is explicitly a semester specified.
         * @param {number} [year] Year (YYYY) of the semester to show events for. Needs to be provided in conjunction with semester.
         * @param {ListOpenEventsSemesterEnum} [semester] Semester to show events for. Either \&quot;ss\&quot; or \&quot;ws\&quot;. Needs to be provided in conjunction with year.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOpenEvents: async (limit?: number, year?: number, semester?: ListOpenEventsSemesterEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/open_events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }

            if (semester !== undefined) {
                localVarQueryParameter['semester'] = semester;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update details of an Event
         * @param {string} id id of corresponding event
         * @param {EventUpdateRequest} [eventUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEvent: async (id: string, eventUpdateRequest?: EventUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateEvent', 'id', id)
            const localVarPath = `/api/v1/events/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(eventUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the name of an Attachment
         * @param {string} id ID of the attachable, e.g. Topic.
         * @param {string} attachmentId ID of the attachment
         * @param {UpdateEventAttachmentRequest} [updateEventAttachmentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEventAttachment: async (id: string, attachmentId: string, updateEventAttachmentRequest?: UpdateEventAttachmentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateEventAttachment', 'id', id)
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('updateEventAttachment', 'attachmentId', attachmentId)
            const localVarPath = `/api/v1/events/{id}/attachments/{attachment_id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"attachment_id"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEventAttachmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a post of an event
         * @param {string} id id of event to post to
         * @param {string} postId id of post
         * @param {PostRequest} [postRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEventPost: async (id: string, postId: string, postRequest?: PostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateEventPost', 'id', id)
            // verify required parameter 'postId' is not null or undefined
            assertParamExists('updateEventPost', 'postId', postId)
            const localVarPath = `/api/v1/events/{id}/posts/{post_id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"post_id"}}`, encodeURIComponent(String(postId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EventsApi - functional programming interface
 * @export
 */
export const EventsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EventsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add attachments to this event
         * @param {string} id id of corresponding attachable (e.g. Topic)
         * @param {Array<AttachmentUpload>} [attachmentUpload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addEventAttachments(id: string, attachmentUpload?: Array<AttachmentUpload>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Attachment>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addEventAttachments(id, attachmentUpload, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EventsApi.addEventAttachments']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new event
         * @param {EventCreateRequest} [eventCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEvent(eventCreateRequest?: EventCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailedEvent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEvent(eventCreateRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EventsApi.createEvent']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new post for an event
         * @param {string} id id of event to post to
         * @param {PostRequest} [postRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createEventPost(id: string, postRequest?: PostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Post>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createEventPost(id, postRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EventsApi.createEventPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Delete an Event
         * @param {string} id id of corresponding event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEvent(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEvent(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EventsApi.deleteEvent']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Delete an Attachment
         * @param {string} id ID of the attachable, e.g. Topic.
         * @param {string} attachmentId ID of the attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEventAttachment(id: string, attachmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEventAttachment(id, attachmentId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EventsApi.deleteEventAttachment']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Delete attachments
         * @param {string} id id of corresponding attachable (e.g. Topic)
         * @param {Array<string>} [requestBody] IDs of the attachments to be deleted.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEventAttachments(id: string, requestBody?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEventAttachments(id, requestBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EventsApi.deleteEventAttachments']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a post of an event
         * @param {string} id id of event to post to
         * @param {string} postId id of post
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEventPost(id: string, postId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEventPost(id, postId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EventsApi.deleteEventPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get an Event
         * @param {string} id id of corresponding event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEvent(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailedEvent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEvent(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EventsApi.getEvent']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get details of an Attachment
         * @param {string} id ID of the attachable, e.g. Topic.
         * @param {string} attachmentId ID of the attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventAttachment(id: string, attachmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Attachment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventAttachment(id, attachmentId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EventsApi.getEventAttachment']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary List all Attachments of this event
         * @param {string} id id of corresponding attachable (e.g. Topic)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventAttachments(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Attachment>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventAttachments(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EventsApi.getEventAttachments']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get a post of an event
         * @param {string} id id of event to post to
         * @param {string} postId id of post
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventPost(id: string, postId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Post>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventPost(id, postId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EventsApi.getEventPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Posts are returned in a paginated way, so you specify how many Posts should be on a page and where your page should begin.
         * @summary Get a list of Posts of an Event
         * @param {string} id id of event to post to
         * @param {number} [offset] Index of the first requested Post, starting at 0.
         * @param {number} [limit] Maximum number of Posts to be returned.
         * @param {AscDescOrder} [order] RSVPs of Coetanen are always shown first. Direction of the ordering by creation date (created_at).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEventPosts(id: string, offset?: number, limit?: number, order?: AscDescOrder, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Post>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEventPosts(id, offset, limit, order, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EventsApi.getEventPosts']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary List events
         * @param {number} [attendBy] Only show events attended by this PersonalRecord ID
         * @param {number} [declineBy] Only show events declined by this PersonalRecord ID
         * @param {number} [noRsvpBy] Only show events with pending replies by this PersonalRecord ID
         * @param {number} [groupId] Only show events in this group
         * @param {number} [clientId] Only show events in this client
         * @param {number} [levelId] Only show events in this level
         * @param {string} [startAfter] Only show events at or after this date
         * @param {string} [startBefore] Only show events starting before this date
         * @param {number} [offset] Index of the first requested item, starting at 0.
         * @param {number} [limit] Maximum number of items to be returned.
         * @param {AscDescOrder} [order] Direction of the ordering by creation date (created_at).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEvents(attendBy?: number, declineBy?: number, noRsvpBy?: number, groupId?: number, clientId?: number, levelId?: number, startAfter?: string, startBefore?: string, offset?: number, limit?: number, order?: AscDescOrder, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Event>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEvents(attendBy, declineBy, noRsvpBy, groupId, clientId, levelId, startAfter, startBefore, offset, limit, order, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EventsApi.getEvents']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * API to list all open events of the current semester, for integration in the customer web pages.
         * @summary List all open events
         * @param {number} [limit] Limit the number of events to return. Without a limit all events of the current semester are returned. If all these are past, the next semester is also included unless there is explicitly a semester specified.
         * @param {number} [year] Year (YYYY) of the semester to show events for. Needs to be provided in conjunction with semester.
         * @param {ListOpenEventsSemesterEnum} [semester] Semester to show events for. Either \&quot;ss\&quot; or \&quot;ws\&quot;. Needs to be provided in conjunction with year.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOpenEvents(limit?: number, year?: number, semester?: ListOpenEventsSemesterEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOpenEvents(limit, year, semester, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EventsApi.listOpenEvents']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Update details of an Event
         * @param {string} id id of corresponding event
         * @param {EventUpdateRequest} [eventUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEvent(id: string, eventUpdateRequest?: EventUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DetailedEvent>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEvent(id, eventUpdateRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EventsApi.updateEvent']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Update the name of an Attachment
         * @param {string} id ID of the attachable, e.g. Topic.
         * @param {string} attachmentId ID of the attachment
         * @param {UpdateEventAttachmentRequest} [updateEventAttachmentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEventAttachment(id: string, attachmentId: string, updateEventAttachmentRequest?: UpdateEventAttachmentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Attachment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEventAttachment(id, attachmentId, updateEventAttachmentRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EventsApi.updateEventAttachment']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Update a post of an event
         * @param {string} id id of event to post to
         * @param {string} postId id of post
         * @param {PostRequest} [postRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateEventPost(id: string, postId: string, postRequest?: PostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Post>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateEventPost(id, postId, postRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['EventsApi.updateEventPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * EventsApi - factory interface
 * @export
 */
export const EventsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EventsApiFp(configuration)
    return {
        /**
         * 
         * @summary Add attachments to this event
         * @param {string} id id of corresponding attachable (e.g. Topic)
         * @param {Array<AttachmentUpload>} [attachmentUpload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addEventAttachments(id: string, attachmentUpload?: Array<AttachmentUpload>, options?: any): AxiosPromise<Array<Attachment>> {
            return localVarFp.addEventAttachments(id, attachmentUpload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new event
         * @param {EventCreateRequest} [eventCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEvent(eventCreateRequest?: EventCreateRequest, options?: any): AxiosPromise<DetailedEvent> {
            return localVarFp.createEvent(eventCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new post for an event
         * @param {string} id id of event to post to
         * @param {PostRequest} [postRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createEventPost(id: string, postRequest?: PostRequest, options?: any): AxiosPromise<Post> {
            return localVarFp.createEventPost(id, postRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an Event
         * @param {string} id id of corresponding event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEvent(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteEvent(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an Attachment
         * @param {string} id ID of the attachable, e.g. Topic.
         * @param {string} attachmentId ID of the attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEventAttachment(id: string, attachmentId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteEventAttachment(id, attachmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete attachments
         * @param {string} id id of corresponding attachable (e.g. Topic)
         * @param {Array<string>} [requestBody] IDs of the attachments to be deleted.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEventAttachments(id: string, requestBody?: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.deleteEventAttachments(id, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a post of an event
         * @param {string} id id of event to post to
         * @param {string} postId id of post
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEventPost(id: string, postId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteEventPost(id, postId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get an Event
         * @param {string} id id of corresponding event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvent(id: string, options?: any): AxiosPromise<DetailedEvent> {
            return localVarFp.getEvent(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get details of an Attachment
         * @param {string} id ID of the attachable, e.g. Topic.
         * @param {string} attachmentId ID of the attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventAttachment(id: string, attachmentId: string, options?: any): AxiosPromise<Attachment> {
            return localVarFp.getEventAttachment(id, attachmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all Attachments of this event
         * @param {string} id id of corresponding attachable (e.g. Topic)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventAttachments(id: string, options?: any): AxiosPromise<Array<Attachment>> {
            return localVarFp.getEventAttachments(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a post of an event
         * @param {string} id id of event to post to
         * @param {string} postId id of post
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventPost(id: string, postId: string, options?: any): AxiosPromise<Post> {
            return localVarFp.getEventPost(id, postId, options).then((request) => request(axios, basePath));
        },
        /**
         * Posts are returned in a paginated way, so you specify how many Posts should be on a page and where your page should begin.
         * @summary Get a list of Posts of an Event
         * @param {string} id id of event to post to
         * @param {number} [offset] Index of the first requested Post, starting at 0.
         * @param {number} [limit] Maximum number of Posts to be returned.
         * @param {AscDescOrder} [order] RSVPs of Coetanen are always shown first. Direction of the ordering by creation date (created_at).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEventPosts(id: string, offset?: number, limit?: number, order?: AscDescOrder, options?: any): AxiosPromise<Array<Post>> {
            return localVarFp.getEventPosts(id, offset, limit, order, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List events
         * @param {number} [attendBy] Only show events attended by this PersonalRecord ID
         * @param {number} [declineBy] Only show events declined by this PersonalRecord ID
         * @param {number} [noRsvpBy] Only show events with pending replies by this PersonalRecord ID
         * @param {number} [groupId] Only show events in this group
         * @param {number} [clientId] Only show events in this client
         * @param {number} [levelId] Only show events in this level
         * @param {string} [startAfter] Only show events at or after this date
         * @param {string} [startBefore] Only show events starting before this date
         * @param {number} [offset] Index of the first requested item, starting at 0.
         * @param {number} [limit] Maximum number of items to be returned.
         * @param {AscDescOrder} [order] Direction of the ordering by creation date (created_at).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvents(attendBy?: number, declineBy?: number, noRsvpBy?: number, groupId?: number, clientId?: number, levelId?: number, startAfter?: string, startBefore?: string, offset?: number, limit?: number, order?: AscDescOrder, options?: any): AxiosPromise<Array<Event>> {
            return localVarFp.getEvents(attendBy, declineBy, noRsvpBy, groupId, clientId, levelId, startAfter, startBefore, offset, limit, order, options).then((request) => request(axios, basePath));
        },
        /**
         * API to list all open events of the current semester, for integration in the customer web pages.
         * @summary List all open events
         * @param {number} [limit] Limit the number of events to return. Without a limit all events of the current semester are returned. If all these are past, the next semester is also included unless there is explicitly a semester specified.
         * @param {number} [year] Year (YYYY) of the semester to show events for. Needs to be provided in conjunction with semester.
         * @param {ListOpenEventsSemesterEnum} [semester] Semester to show events for. Either \&quot;ss\&quot; or \&quot;ws\&quot;. Needs to be provided in conjunction with year.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOpenEvents(limit?: number, year?: number, semester?: ListOpenEventsSemesterEnum, options?: any): AxiosPromise<void> {
            return localVarFp.listOpenEvents(limit, year, semester, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update details of an Event
         * @param {string} id id of corresponding event
         * @param {EventUpdateRequest} [eventUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEvent(id: string, eventUpdateRequest?: EventUpdateRequest, options?: any): AxiosPromise<DetailedEvent> {
            return localVarFp.updateEvent(id, eventUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update the name of an Attachment
         * @param {string} id ID of the attachable, e.g. Topic.
         * @param {string} attachmentId ID of the attachment
         * @param {UpdateEventAttachmentRequest} [updateEventAttachmentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEventAttachment(id: string, attachmentId: string, updateEventAttachmentRequest?: UpdateEventAttachmentRequest, options?: any): AxiosPromise<Attachment> {
            return localVarFp.updateEventAttachment(id, attachmentId, updateEventAttachmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a post of an event
         * @param {string} id id of event to post to
         * @param {string} postId id of post
         * @param {PostRequest} [postRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateEventPost(id: string, postId: string, postRequest?: PostRequest, options?: any): AxiosPromise<Post> {
            return localVarFp.updateEventPost(id, postId, postRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EventsApi - interface
 * @export
 * @interface EventsApi
 */
export interface EventsApiInterface {
    /**
     * 
     * @summary Add attachments to this event
     * @param {string} id id of corresponding attachable (e.g. Topic)
     * @param {Array<AttachmentUpload>} [attachmentUpload] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApiInterface
     */
    addEventAttachments(id: string, attachmentUpload?: Array<AttachmentUpload>, options?: RawAxiosRequestConfig): AxiosPromise<Array<Attachment>>;

    /**
     * 
     * @summary Create a new event
     * @param {EventCreateRequest} [eventCreateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApiInterface
     */
    createEvent(eventCreateRequest?: EventCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<DetailedEvent>;

    /**
     * 
     * @summary Create a new post for an event
     * @param {string} id id of event to post to
     * @param {PostRequest} [postRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApiInterface
     */
    createEventPost(id: string, postRequest?: PostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Post>;

    /**
     * 
     * @summary Delete an Event
     * @param {string} id id of corresponding event
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApiInterface
     */
    deleteEvent(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Delete an Attachment
     * @param {string} id ID of the attachable, e.g. Topic.
     * @param {string} attachmentId ID of the attachment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApiInterface
     */
    deleteEventAttachment(id: string, attachmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Delete attachments
     * @param {string} id id of corresponding attachable (e.g. Topic)
     * @param {Array<string>} [requestBody] IDs of the attachments to be deleted.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApiInterface
     */
    deleteEventAttachments(id: string, requestBody?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Delete a post of an event
     * @param {string} id id of event to post to
     * @param {string} postId id of post
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApiInterface
     */
    deleteEventPost(id: string, postId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Get an Event
     * @param {string} id id of corresponding event
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApiInterface
     */
    getEvent(id: string, options?: RawAxiosRequestConfig): AxiosPromise<DetailedEvent>;

    /**
     * 
     * @summary Get details of an Attachment
     * @param {string} id ID of the attachable, e.g. Topic.
     * @param {string} attachmentId ID of the attachment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApiInterface
     */
    getEventAttachment(id: string, attachmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<Attachment>;

    /**
     * 
     * @summary List all Attachments of this event
     * @param {string} id id of corresponding attachable (e.g. Topic)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApiInterface
     */
    getEventAttachments(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Attachment>>;

    /**
     * 
     * @summary Get a post of an event
     * @param {string} id id of event to post to
     * @param {string} postId id of post
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApiInterface
     */
    getEventPost(id: string, postId: string, options?: RawAxiosRequestConfig): AxiosPromise<Post>;

    /**
     * Posts are returned in a paginated way, so you specify how many Posts should be on a page and where your page should begin.
     * @summary Get a list of Posts of an Event
     * @param {string} id id of event to post to
     * @param {number} [offset] Index of the first requested Post, starting at 0.
     * @param {number} [limit] Maximum number of Posts to be returned.
     * @param {AscDescOrder} [order] RSVPs of Coetanen are always shown first. Direction of the ordering by creation date (created_at).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApiInterface
     */
    getEventPosts(id: string, offset?: number, limit?: number, order?: AscDescOrder, options?: RawAxiosRequestConfig): AxiosPromise<Array<Post>>;

    /**
     * 
     * @summary List events
     * @param {number} [attendBy] Only show events attended by this PersonalRecord ID
     * @param {number} [declineBy] Only show events declined by this PersonalRecord ID
     * @param {number} [noRsvpBy] Only show events with pending replies by this PersonalRecord ID
     * @param {number} [groupId] Only show events in this group
     * @param {number} [clientId] Only show events in this client
     * @param {number} [levelId] Only show events in this level
     * @param {string} [startAfter] Only show events at or after this date
     * @param {string} [startBefore] Only show events starting before this date
     * @param {number} [offset] Index of the first requested item, starting at 0.
     * @param {number} [limit] Maximum number of items to be returned.
     * @param {AscDescOrder} [order] Direction of the ordering by creation date (created_at).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApiInterface
     */
    getEvents(attendBy?: number, declineBy?: number, noRsvpBy?: number, groupId?: number, clientId?: number, levelId?: number, startAfter?: string, startBefore?: string, offset?: number, limit?: number, order?: AscDescOrder, options?: RawAxiosRequestConfig): AxiosPromise<Array<Event>>;

    /**
     * API to list all open events of the current semester, for integration in the customer web pages.
     * @summary List all open events
     * @param {number} [limit] Limit the number of events to return. Without a limit all events of the current semester are returned. If all these are past, the next semester is also included unless there is explicitly a semester specified.
     * @param {number} [year] Year (YYYY) of the semester to show events for. Needs to be provided in conjunction with semester.
     * @param {ListOpenEventsSemesterEnum} [semester] Semester to show events for. Either \&quot;ss\&quot; or \&quot;ws\&quot;. Needs to be provided in conjunction with year.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApiInterface
     */
    listOpenEvents(limit?: number, year?: number, semester?: ListOpenEventsSemesterEnum, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Update details of an Event
     * @param {string} id id of corresponding event
     * @param {EventUpdateRequest} [eventUpdateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApiInterface
     */
    updateEvent(id: string, eventUpdateRequest?: EventUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<DetailedEvent>;

    /**
     * 
     * @summary Update the name of an Attachment
     * @param {string} id ID of the attachable, e.g. Topic.
     * @param {string} attachmentId ID of the attachment
     * @param {UpdateEventAttachmentRequest} [updateEventAttachmentRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApiInterface
     */
    updateEventAttachment(id: string, attachmentId: string, updateEventAttachmentRequest?: UpdateEventAttachmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<Attachment>;

    /**
     * 
     * @summary Update a post of an event
     * @param {string} id id of event to post to
     * @param {string} postId id of post
     * @param {PostRequest} [postRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApiInterface
     */
    updateEventPost(id: string, postId: string, postRequest?: PostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Post>;

}

/**
 * EventsApi - object-oriented interface
 * @export
 * @class EventsApi
 * @extends {BaseAPI}
 */
export class EventsApi extends BaseAPI implements EventsApiInterface {
    /**
     * 
     * @summary Add attachments to this event
     * @param {string} id id of corresponding attachable (e.g. Topic)
     * @param {Array<AttachmentUpload>} [attachmentUpload] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public addEventAttachments(id: string, attachmentUpload?: Array<AttachmentUpload>, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).addEventAttachments(id, attachmentUpload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new event
     * @param {EventCreateRequest} [eventCreateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public createEvent(eventCreateRequest?: EventCreateRequest, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).createEvent(eventCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new post for an event
     * @param {string} id id of event to post to
     * @param {PostRequest} [postRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public createEventPost(id: string, postRequest?: PostRequest, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).createEventPost(id, postRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an Event
     * @param {string} id id of corresponding event
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public deleteEvent(id: string, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).deleteEvent(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an Attachment
     * @param {string} id ID of the attachable, e.g. Topic.
     * @param {string} attachmentId ID of the attachment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public deleteEventAttachment(id: string, attachmentId: string, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).deleteEventAttachment(id, attachmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete attachments
     * @param {string} id id of corresponding attachable (e.g. Topic)
     * @param {Array<string>} [requestBody] IDs of the attachments to be deleted.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public deleteEventAttachments(id: string, requestBody?: Array<string>, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).deleteEventAttachments(id, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a post of an event
     * @param {string} id id of event to post to
     * @param {string} postId id of post
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public deleteEventPost(id: string, postId: string, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).deleteEventPost(id, postId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get an Event
     * @param {string} id id of corresponding event
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getEvent(id: string, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).getEvent(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get details of an Attachment
     * @param {string} id ID of the attachable, e.g. Topic.
     * @param {string} attachmentId ID of the attachment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getEventAttachment(id: string, attachmentId: string, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).getEventAttachment(id, attachmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all Attachments of this event
     * @param {string} id id of corresponding attachable (e.g. Topic)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getEventAttachments(id: string, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).getEventAttachments(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a post of an event
     * @param {string} id id of event to post to
     * @param {string} postId id of post
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getEventPost(id: string, postId: string, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).getEventPost(id, postId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Posts are returned in a paginated way, so you specify how many Posts should be on a page and where your page should begin.
     * @summary Get a list of Posts of an Event
     * @param {string} id id of event to post to
     * @param {number} [offset] Index of the first requested Post, starting at 0.
     * @param {number} [limit] Maximum number of Posts to be returned.
     * @param {AscDescOrder} [order] RSVPs of Coetanen are always shown first. Direction of the ordering by creation date (created_at).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getEventPosts(id: string, offset?: number, limit?: number, order?: AscDescOrder, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).getEventPosts(id, offset, limit, order, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List events
     * @param {number} [attendBy] Only show events attended by this PersonalRecord ID
     * @param {number} [declineBy] Only show events declined by this PersonalRecord ID
     * @param {number} [noRsvpBy] Only show events with pending replies by this PersonalRecord ID
     * @param {number} [groupId] Only show events in this group
     * @param {number} [clientId] Only show events in this client
     * @param {number} [levelId] Only show events in this level
     * @param {string} [startAfter] Only show events at or after this date
     * @param {string} [startBefore] Only show events starting before this date
     * @param {number} [offset] Index of the first requested item, starting at 0.
     * @param {number} [limit] Maximum number of items to be returned.
     * @param {AscDescOrder} [order] Direction of the ordering by creation date (created_at).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public getEvents(attendBy?: number, declineBy?: number, noRsvpBy?: number, groupId?: number, clientId?: number, levelId?: number, startAfter?: string, startBefore?: string, offset?: number, limit?: number, order?: AscDescOrder, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).getEvents(attendBy, declineBy, noRsvpBy, groupId, clientId, levelId, startAfter, startBefore, offset, limit, order, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * API to list all open events of the current semester, for integration in the customer web pages.
     * @summary List all open events
     * @param {number} [limit] Limit the number of events to return. Without a limit all events of the current semester are returned. If all these are past, the next semester is also included unless there is explicitly a semester specified.
     * @param {number} [year] Year (YYYY) of the semester to show events for. Needs to be provided in conjunction with semester.
     * @param {ListOpenEventsSemesterEnum} [semester] Semester to show events for. Either \&quot;ss\&quot; or \&quot;ws\&quot;. Needs to be provided in conjunction with year.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public listOpenEvents(limit?: number, year?: number, semester?: ListOpenEventsSemesterEnum, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).listOpenEvents(limit, year, semester, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update details of an Event
     * @param {string} id id of corresponding event
     * @param {EventUpdateRequest} [eventUpdateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public updateEvent(id: string, eventUpdateRequest?: EventUpdateRequest, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).updateEvent(id, eventUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update the name of an Attachment
     * @param {string} id ID of the attachable, e.g. Topic.
     * @param {string} attachmentId ID of the attachment
     * @param {UpdateEventAttachmentRequest} [updateEventAttachmentRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public updateEventAttachment(id: string, attachmentId: string, updateEventAttachmentRequest?: UpdateEventAttachmentRequest, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).updateEventAttachment(id, attachmentId, updateEventAttachmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a post of an event
     * @param {string} id id of event to post to
     * @param {string} postId id of post
     * @param {PostRequest} [postRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EventsApi
     */
    public updateEventPost(id: string, postId: string, postRequest?: PostRequest, options?: RawAxiosRequestConfig) {
        return EventsApiFp(this.configuration).updateEventPost(id, postId, postRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ListOpenEventsSemesterEnum = {
    Ws: 'ws',
    Ss: 'ss'
} as const;
export type ListOpenEventsSemesterEnum = typeof ListOpenEventsSemesterEnum[keyof typeof ListOpenEventsSemesterEnum];


/**
 * FoldersApi - axios parameter creator
 * @export
 */
export const FoldersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a Folder
         * @param {UpdateFolderRequest} [updateFolderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFolder: async (updateFolderRequest?: UpdateFolderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/drive/folders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFolderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a Folder
         * @param {number} id ID of the folder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFolder: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteFolder', 'id', id)
            const localVarPath = `/api/v1/drive/folders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all details of a folder
         * @param {number} id ID of the folder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFolder: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getFolder', 'id', id)
            const localVarPath = `/api/v1/drive/folders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Folder Contents
         * @param {number} parentId ID of the parent folder which contents we want to retrieve.
         * @param {number} limit Limit the number of results
         * @param {number} [offset] Offset the results
         * @param {string} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFolderContents: async (parentId: number, limit: number, offset?: number, order?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'parentId' is not null or undefined
            assertParamExists('getFolderContents', 'parentId', parentId)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('getFolderContents', 'limit', limit)
            const localVarPath = `/api/v1/drive/folders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required

            if (parentId !== undefined) {
                localVarQueryParameter['parent_id'] = parentId;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a Folder
         * @param {number} id ID of the folder
         * @param {UpdateFolderRequest} [updateFolderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFolder: async (id: number, updateFolderRequest?: UpdateFolderRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateFolder', 'id', id)
            const localVarPath = `/api/v1/drive/folders/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFolderRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FoldersApi - functional programming interface
 * @export
 */
export const FoldersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FoldersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a Folder
         * @param {UpdateFolderRequest} [updateFolderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFolder(updateFolderRequest?: UpdateFolderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Inode>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFolder(updateFolderRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FoldersApi.createFolder']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a Folder
         * @param {number} id ID of the folder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFolder(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFolder(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FoldersApi.deleteFolder']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get all details of a folder
         * @param {number} id ID of the folder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFolder(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Inode>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFolder(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FoldersApi.getFolder']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Folder Contents
         * @param {number} parentId ID of the parent folder which contents we want to retrieve.
         * @param {number} limit Limit the number of results
         * @param {number} [offset] Offset the results
         * @param {string} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFolderContents(parentId: number, limit: number, offset?: number, order?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<InodeResults>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFolderContents(parentId, limit, offset, order, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FoldersApi.getFolderContents']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Update a Folder
         * @param {number} id ID of the folder
         * @param {UpdateFolderRequest} [updateFolderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFolder(id: number, updateFolderRequest?: UpdateFolderRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Inode>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFolder(id, updateFolderRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['FoldersApi.updateFolder']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * FoldersApi - factory interface
 * @export
 */
export const FoldersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FoldersApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a Folder
         * @param {UpdateFolderRequest} [updateFolderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFolder(updateFolderRequest?: UpdateFolderRequest, options?: any): AxiosPromise<Inode> {
            return localVarFp.createFolder(updateFolderRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a Folder
         * @param {number} id ID of the folder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFolder(id: number, options?: any): AxiosPromise<void> {
            return localVarFp.deleteFolder(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all details of a folder
         * @param {number} id ID of the folder
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFolder(id: number, options?: any): AxiosPromise<Inode> {
            return localVarFp.getFolder(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Folder Contents
         * @param {number} parentId ID of the parent folder which contents we want to retrieve.
         * @param {number} limit Limit the number of results
         * @param {number} [offset] Offset the results
         * @param {string} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFolderContents(parentId: number, limit: number, offset?: number, order?: string, options?: any): AxiosPromise<InodeResults> {
            return localVarFp.getFolderContents(parentId, limit, offset, order, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a Folder
         * @param {number} id ID of the folder
         * @param {UpdateFolderRequest} [updateFolderRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFolder(id: number, updateFolderRequest?: UpdateFolderRequest, options?: any): AxiosPromise<Inode> {
            return localVarFp.updateFolder(id, updateFolderRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FoldersApi - interface
 * @export
 * @interface FoldersApi
 */
export interface FoldersApiInterface {
    /**
     * 
     * @summary Create a Folder
     * @param {UpdateFolderRequest} [updateFolderRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FoldersApiInterface
     */
    createFolder(updateFolderRequest?: UpdateFolderRequest, options?: RawAxiosRequestConfig): AxiosPromise<Inode>;

    /**
     * 
     * @summary Delete a Folder
     * @param {number} id ID of the folder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FoldersApiInterface
     */
    deleteFolder(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Get all details of a folder
     * @param {number} id ID of the folder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FoldersApiInterface
     */
    getFolder(id: number, options?: RawAxiosRequestConfig): AxiosPromise<Inode>;

    /**
     * 
     * @summary Get Folder Contents
     * @param {number} parentId ID of the parent folder which contents we want to retrieve.
     * @param {number} limit Limit the number of results
     * @param {number} [offset] Offset the results
     * @param {string} [order] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FoldersApiInterface
     */
    getFolderContents(parentId: number, limit: number, offset?: number, order?: string, options?: RawAxiosRequestConfig): AxiosPromise<InodeResults>;

    /**
     * 
     * @summary Update a Folder
     * @param {number} id ID of the folder
     * @param {UpdateFolderRequest} [updateFolderRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FoldersApiInterface
     */
    updateFolder(id: number, updateFolderRequest?: UpdateFolderRequest, options?: RawAxiosRequestConfig): AxiosPromise<Inode>;

}

/**
 * FoldersApi - object-oriented interface
 * @export
 * @class FoldersApi
 * @extends {BaseAPI}
 */
export class FoldersApi extends BaseAPI implements FoldersApiInterface {
    /**
     * 
     * @summary Create a Folder
     * @param {UpdateFolderRequest} [updateFolderRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FoldersApi
     */
    public createFolder(updateFolderRequest?: UpdateFolderRequest, options?: RawAxiosRequestConfig) {
        return FoldersApiFp(this.configuration).createFolder(updateFolderRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a Folder
     * @param {number} id ID of the folder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FoldersApi
     */
    public deleteFolder(id: number, options?: RawAxiosRequestConfig) {
        return FoldersApiFp(this.configuration).deleteFolder(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all details of a folder
     * @param {number} id ID of the folder
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FoldersApi
     */
    public getFolder(id: number, options?: RawAxiosRequestConfig) {
        return FoldersApiFp(this.configuration).getFolder(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Folder Contents
     * @param {number} parentId ID of the parent folder which contents we want to retrieve.
     * @param {number} limit Limit the number of results
     * @param {number} [offset] Offset the results
     * @param {string} [order] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FoldersApi
     */
    public getFolderContents(parentId: number, limit: number, offset?: number, order?: string, options?: RawAxiosRequestConfig) {
        return FoldersApiFp(this.configuration).getFolderContents(parentId, limit, offset, order, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a Folder
     * @param {number} id ID of the folder
     * @param {UpdateFolderRequest} [updateFolderRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FoldersApi
     */
    public updateFolder(id: number, updateFolderRequest?: UpdateFolderRequest, options?: RawAxiosRequestConfig) {
        return FoldersApiFp(this.configuration).updateFolder(id, updateFolderRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ForumItemsApi - axios parameter creator
 * @export
 */
export const ForumItemsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get forum items
         * @param {number} [offset] Index of the first requested item, starting at 0.
         * @param {number} [limit] Maximum number of items to be returned.
         * @param {AscDescOrder} [order] Direction of the ordering by creation date (created_at).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForumItems: async (offset?: number, limit?: number, order?: AscDescOrder, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/forum_items`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ForumItemsApi - functional programming interface
 * @export
 */
export const ForumItemsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ForumItemsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get forum items
         * @param {number} [offset] Index of the first requested item, starting at 0.
         * @param {number} [limit] Maximum number of items to be returned.
         * @param {AscDescOrder} [order] Direction of the ordering by creation date (created_at).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getForumItems(offset?: number, limit?: number, order?: AscDescOrder, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ForumItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getForumItems(offset, limit, order, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ForumItemsApi.getForumItems']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * ForumItemsApi - factory interface
 * @export
 */
export const ForumItemsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ForumItemsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get forum items
         * @param {number} [offset] Index of the first requested item, starting at 0.
         * @param {number} [limit] Maximum number of items to be returned.
         * @param {AscDescOrder} [order] Direction of the ordering by creation date (created_at).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForumItems(offset?: number, limit?: number, order?: AscDescOrder, options?: any): AxiosPromise<Array<ForumItem>> {
            return localVarFp.getForumItems(offset, limit, order, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ForumItemsApi - interface
 * @export
 * @interface ForumItemsApi
 */
export interface ForumItemsApiInterface {
    /**
     * 
     * @summary Get forum items
     * @param {number} [offset] Index of the first requested item, starting at 0.
     * @param {number} [limit] Maximum number of items to be returned.
     * @param {AscDescOrder} [order] Direction of the ordering by creation date (created_at).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ForumItemsApiInterface
     */
    getForumItems(offset?: number, limit?: number, order?: AscDescOrder, options?: RawAxiosRequestConfig): AxiosPromise<Array<ForumItem>>;

}

/**
 * ForumItemsApi - object-oriented interface
 * @export
 * @class ForumItemsApi
 * @extends {BaseAPI}
 */
export class ForumItemsApi extends BaseAPI implements ForumItemsApiInterface {
    /**
     * 
     * @summary Get forum items
     * @param {number} [offset] Index of the first requested item, starting at 0.
     * @param {number} [limit] Maximum number of items to be returned.
     * @param {AscDescOrder} [order] Direction of the ordering by creation date (created_at).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ForumItemsApi
     */
    public getForumItems(offset?: number, limit?: number, order?: AscDescOrder, options?: RawAxiosRequestConfig) {
        return ForumItemsApiFp(this.configuration).getForumItems(offset, limit, order, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GroupApi - axios parameter creator
 * @export
 */
export const GroupApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get a Group by ID
         * @param {string} id id of corresponding group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroup: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getGroup', 'id', id)
            const localVarPath = `/api/v1/groups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search for Groups
         * @param {string} [name] Search by name
         * @param {number} [levelId] Comma seperated list of Integers. Consider only groups from the given levels.
         * @param {number} [clientId] Comma seperated list of Integers. Consider only groups from the given clients.
         * @param {number} [ofMember] When present, only groups of this member are returned.
         * @param {number} [accessibleToPersonalRecordId] When present, only groups are returned that are not hidden or closed or that the PersonalRecord is a member of.
         * @param {string} [excludeTreeId] Exclude members from this subtrees.
         * @param {number} [rootId] Comma seperated list of Integers. Limit results to members of this subtree.
         * @param {boolean} [tree] When present, not a flat list but a forest is returned.
         * @param {boolean} [calendar] When true, groups without calendar are omitted.
         * @param {boolean} [forum] When true, groups without forum are omitted.
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroups: async (name?: string, levelId?: number, clientId?: number, ofMember?: number, accessibleToPersonalRecordId?: number, excludeTreeId?: string, rootId?: number, tree?: boolean, calendar?: boolean, forum?: boolean, offset?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/groups/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (levelId !== undefined) {
                localVarQueryParameter['level_id'] = levelId;
            }

            if (clientId !== undefined) {
                localVarQueryParameter['client_id'] = clientId;
            }

            if (ofMember !== undefined) {
                localVarQueryParameter['of_member'] = ofMember;
            }

            if (accessibleToPersonalRecordId !== undefined) {
                localVarQueryParameter['accessible_to_personal_record_id'] = accessibleToPersonalRecordId;
            }

            if (excludeTreeId !== undefined) {
                localVarQueryParameter['exclude_tree_id'] = excludeTreeId;
            }

            if (rootId !== undefined) {
                localVarQueryParameter['root_id'] = rootId;
            }

            if (tree !== undefined) {
                localVarQueryParameter['tree'] = tree;
            }

            if (calendar !== undefined) {
                localVarQueryParameter['calendar'] = calendar;
            }

            if (forum !== undefined) {
                localVarQueryParameter['forum'] = forum;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GroupApi - functional programming interface
 * @export
 */
export const GroupApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GroupApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get a Group by ID
         * @param {string} id id of corresponding group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGroup(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Group>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGroup(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GroupApi.getGroup']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Search for Groups
         * @param {string} [name] Search by name
         * @param {number} [levelId] Comma seperated list of Integers. Consider only groups from the given levels.
         * @param {number} [clientId] Comma seperated list of Integers. Consider only groups from the given clients.
         * @param {number} [ofMember] When present, only groups of this member are returned.
         * @param {number} [accessibleToPersonalRecordId] When present, only groups are returned that are not hidden or closed or that the PersonalRecord is a member of.
         * @param {string} [excludeTreeId] Exclude members from this subtrees.
         * @param {number} [rootId] Comma seperated list of Integers. Limit results to members of this subtree.
         * @param {boolean} [tree] When present, not a flat list but a forest is returned.
         * @param {boolean} [calendar] When true, groups without calendar are omitted.
         * @param {boolean} [forum] When true, groups without forum are omitted.
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGroups(name?: string, levelId?: number, clientId?: number, ofMember?: number, accessibleToPersonalRecordId?: number, excludeTreeId?: string, rootId?: number, tree?: boolean, calendar?: boolean, forum?: boolean, offset?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetGroups200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGroups(name, levelId, clientId, ofMember, accessibleToPersonalRecordId, excludeTreeId, rootId, tree, calendar, forum, offset, limit, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GroupApi.getGroups']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * GroupApi - factory interface
 * @export
 */
export const GroupApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GroupApiFp(configuration)
    return {
        /**
         * 
         * @summary Get a Group by ID
         * @param {string} id id of corresponding group
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroup(id: string, options?: any): AxiosPromise<Group> {
            return localVarFp.getGroup(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search for Groups
         * @param {string} [name] Search by name
         * @param {number} [levelId] Comma seperated list of Integers. Consider only groups from the given levels.
         * @param {number} [clientId] Comma seperated list of Integers. Consider only groups from the given clients.
         * @param {number} [ofMember] When present, only groups of this member are returned.
         * @param {number} [accessibleToPersonalRecordId] When present, only groups are returned that are not hidden or closed or that the PersonalRecord is a member of.
         * @param {string} [excludeTreeId] Exclude members from this subtrees.
         * @param {number} [rootId] Comma seperated list of Integers. Limit results to members of this subtree.
         * @param {boolean} [tree] When present, not a flat list but a forest is returned.
         * @param {boolean} [calendar] When true, groups without calendar are omitted.
         * @param {boolean} [forum] When true, groups without forum are omitted.
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroups(name?: string, levelId?: number, clientId?: number, ofMember?: number, accessibleToPersonalRecordId?: number, excludeTreeId?: string, rootId?: number, tree?: boolean, calendar?: boolean, forum?: boolean, offset?: number, limit?: number, options?: any): AxiosPromise<GetGroups200Response> {
            return localVarFp.getGroups(name, levelId, clientId, ofMember, accessibleToPersonalRecordId, excludeTreeId, rootId, tree, calendar, forum, offset, limit, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GroupApi - interface
 * @export
 * @interface GroupApi
 */
export interface GroupApiInterface {
    /**
     * 
     * @summary Get a Group by ID
     * @param {string} id id of corresponding group
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApiInterface
     */
    getGroup(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Group>;

    /**
     * 
     * @summary Search for Groups
     * @param {string} [name] Search by name
     * @param {number} [levelId] Comma seperated list of Integers. Consider only groups from the given levels.
     * @param {number} [clientId] Comma seperated list of Integers. Consider only groups from the given clients.
     * @param {number} [ofMember] When present, only groups of this member are returned.
     * @param {number} [accessibleToPersonalRecordId] When present, only groups are returned that are not hidden or closed or that the PersonalRecord is a member of.
     * @param {string} [excludeTreeId] Exclude members from this subtrees.
     * @param {number} [rootId] Comma seperated list of Integers. Limit results to members of this subtree.
     * @param {boolean} [tree] When present, not a flat list but a forest is returned.
     * @param {boolean} [calendar] When true, groups without calendar are omitted.
     * @param {boolean} [forum] When true, groups without forum are omitted.
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApiInterface
     */
    getGroups(name?: string, levelId?: number, clientId?: number, ofMember?: number, accessibleToPersonalRecordId?: number, excludeTreeId?: string, rootId?: number, tree?: boolean, calendar?: boolean, forum?: boolean, offset?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<GetGroups200Response>;

}

/**
 * GroupApi - object-oriented interface
 * @export
 * @class GroupApi
 * @extends {BaseAPI}
 */
export class GroupApi extends BaseAPI implements GroupApiInterface {
    /**
     * 
     * @summary Get a Group by ID
     * @param {string} id id of corresponding group
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    public getGroup(id: string, options?: RawAxiosRequestConfig) {
        return GroupApiFp(this.configuration).getGroup(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search for Groups
     * @param {string} [name] Search by name
     * @param {number} [levelId] Comma seperated list of Integers. Consider only groups from the given levels.
     * @param {number} [clientId] Comma seperated list of Integers. Consider only groups from the given clients.
     * @param {number} [ofMember] When present, only groups of this member are returned.
     * @param {number} [accessibleToPersonalRecordId] When present, only groups are returned that are not hidden or closed or that the PersonalRecord is a member of.
     * @param {string} [excludeTreeId] Exclude members from this subtrees.
     * @param {number} [rootId] Comma seperated list of Integers. Limit results to members of this subtree.
     * @param {boolean} [tree] When present, not a flat list but a forest is returned.
     * @param {boolean} [calendar] When true, groups without calendar are omitted.
     * @param {boolean} [forum] When true, groups without forum are omitted.
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApi
     */
    public getGroups(name?: string, levelId?: number, clientId?: number, ofMember?: number, accessibleToPersonalRecordId?: number, excludeTreeId?: string, rootId?: number, tree?: boolean, calendar?: boolean, forum?: boolean, offset?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return GroupApiFp(this.configuration).getGroups(name, levelId, clientId, ofMember, accessibleToPersonalRecordId, excludeTreeId, rootId, tree, calendar, forum, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * GroupMemberApi - axios parameter creator
 * @export
 */
export const GroupMemberApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get a GroupMember by ID
         * @param {string} id id of corresponding group_member
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupMember: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getGroupMember', 'id', id)
            const localVarPath = `/api/v1/group_members/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Search for GroupMembers
         * @param {string} [q] Search by query for occurences in full_name and internal_name_long
         * @param {number} [levelId] If provided, GroupMembers from this Level are returned instead from the current client
         * @param {number} [groupId] Comma seperated list of Integers. Returns only members of this groups.
         * @param {number} [excludeGroupId] Comma seperated list of Integers. Exclude members from this groups.
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {boolean} [current] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupMembers: async (q?: string, levelId?: number, groupId?: number, excludeGroupId?: number, offset?: number, limit?: number, current?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/group_members/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required

            if (q !== undefined) {
                localVarQueryParameter['q'] = q;
            }

            if (levelId !== undefined) {
                localVarQueryParameter['level_id'] = levelId;
            }

            if (groupId !== undefined) {
                localVarQueryParameter['group_id'] = groupId;
            }

            if (excludeGroupId !== undefined) {
                localVarQueryParameter['exclude_group_id'] = excludeGroupId;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (current !== undefined) {
                localVarQueryParameter['current'] = current;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GroupMemberApi - functional programming interface
 * @export
 */
export const GroupMemberApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = GroupMemberApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get a GroupMember by ID
         * @param {string} id id of corresponding group_member
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGroupMember(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GroupMember>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGroupMember(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GroupMemberApi.getGroupMember']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Search for GroupMembers
         * @param {string} [q] Search by query for occurences in full_name and internal_name_long
         * @param {number} [levelId] If provided, GroupMembers from this Level are returned instead from the current client
         * @param {number} [groupId] Comma seperated list of Integers. Returns only members of this groups.
         * @param {number} [excludeGroupId] Comma seperated list of Integers. Exclude members from this groups.
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {boolean} [current] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGroupMembers(q?: string, levelId?: number, groupId?: number, excludeGroupId?: number, offset?: number, limit?: number, current?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetGroupMembers200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGroupMembers(q, levelId, groupId, excludeGroupId, offset, limit, current, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['GroupMemberApi.getGroupMembers']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * GroupMemberApi - factory interface
 * @export
 */
export const GroupMemberApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = GroupMemberApiFp(configuration)
    return {
        /**
         * 
         * @summary Get a GroupMember by ID
         * @param {string} id id of corresponding group_member
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupMember(id: string, options?: any): AxiosPromise<GroupMember> {
            return localVarFp.getGroupMember(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Search for GroupMembers
         * @param {string} [q] Search by query for occurences in full_name and internal_name_long
         * @param {number} [levelId] If provided, GroupMembers from this Level are returned instead from the current client
         * @param {number} [groupId] Comma seperated list of Integers. Returns only members of this groups.
         * @param {number} [excludeGroupId] Comma seperated list of Integers. Exclude members from this groups.
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {boolean} [current] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGroupMembers(q?: string, levelId?: number, groupId?: number, excludeGroupId?: number, offset?: number, limit?: number, current?: boolean, options?: any): AxiosPromise<GetGroupMembers200Response> {
            return localVarFp.getGroupMembers(q, levelId, groupId, excludeGroupId, offset, limit, current, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * GroupMemberApi - interface
 * @export
 * @interface GroupMemberApi
 */
export interface GroupMemberApiInterface {
    /**
     * 
     * @summary Get a GroupMember by ID
     * @param {string} id id of corresponding group_member
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupMemberApiInterface
     */
    getGroupMember(id: string, options?: RawAxiosRequestConfig): AxiosPromise<GroupMember>;

    /**
     * 
     * @summary Search for GroupMembers
     * @param {string} [q] Search by query for occurences in full_name and internal_name_long
     * @param {number} [levelId] If provided, GroupMembers from this Level are returned instead from the current client
     * @param {number} [groupId] Comma seperated list of Integers. Returns only members of this groups.
     * @param {number} [excludeGroupId] Comma seperated list of Integers. Exclude members from this groups.
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {boolean} [current] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupMemberApiInterface
     */
    getGroupMembers(q?: string, levelId?: number, groupId?: number, excludeGroupId?: number, offset?: number, limit?: number, current?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<GetGroupMembers200Response>;

}

/**
 * GroupMemberApi - object-oriented interface
 * @export
 * @class GroupMemberApi
 * @extends {BaseAPI}
 */
export class GroupMemberApi extends BaseAPI implements GroupMemberApiInterface {
    /**
     * 
     * @summary Get a GroupMember by ID
     * @param {string} id id of corresponding group_member
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupMemberApi
     */
    public getGroupMember(id: string, options?: RawAxiosRequestConfig) {
        return GroupMemberApiFp(this.configuration).getGroupMember(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Search for GroupMembers
     * @param {string} [q] Search by query for occurences in full_name and internal_name_long
     * @param {number} [levelId] If provided, GroupMembers from this Level are returned instead from the current client
     * @param {number} [groupId] Comma seperated list of Integers. Returns only members of this groups.
     * @param {number} [excludeGroupId] Comma seperated list of Integers. Exclude members from this groups.
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {boolean} [current] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupMemberApi
     */
    public getGroupMembers(q?: string, levelId?: number, groupId?: number, excludeGroupId?: number, offset?: number, limit?: number, current?: boolean, options?: RawAxiosRequestConfig) {
        return GroupMemberApiFp(this.configuration).getGroupMembers(q, levelId, groupId, excludeGroupId, offset, limit, current, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * HighlightsApi - axios parameter creator
 * @export
 */
export const HighlightsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add a highlight
         * @param {string} id id of corresponding event
         * @param {HighlightCreateRequest} [highlightCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addHighlight: async (id: string, highlightCreateRequest?: HighlightCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addHighlight', 'id', id)
            const localVarPath = `/api/v1/events/{id}/highlights`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(highlightCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Download highlights
         * @param {string} id id of corresponding event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadHighlights: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('downloadHighlights', 'id', id)
            const localVarPath = `/api/v1/events/{id}/highlights.zip`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a highlight
         * @param {string} id ID of the Highlight
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHighlight: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getHighlight', 'id', id)
            const localVarPath = `/api/v1/highlights/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all Highlights as galleries.
         * @summary Get all Highlights across Events and Groups
         * @param {number} [offset] Index of the first requested item, starting at 0.
         * @param {number} [limit] Maximum number of items to be returned.
         * @param {AscDescOrder} [order] Direction of the ordering by creation date (created_at).
         * @param {number} [preload] How many images should be eagerly loaded per gallery.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHighlightGalleries: async (offset?: number, limit?: number, order?: AscDescOrder, preload?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/highlights`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (preload !== undefined) {
                localVarQueryParameter['preload'] = preload;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the highlights
         * @param {string} id id of corresponding event
         * @param {number} [offset] Index of the first requested highlight, starting at 0.
         * @param {number} [limit] Maximum number of highlights to be returned.
         * @param {AscDescOrder} [order] Elements are always ordered by their order attribute. Direction of ordering.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHighlights: async (id: string, offset?: number, limit?: number, order?: AscDescOrder, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getHighlights', 'id', id)
            const localVarPath = `/api/v1/events/{id}/highlights`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove a highlight
         * @param {string} id ID of the Highlight
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFromHighlights: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('removeFromHighlights', 'id', id)
            const localVarPath = `/api/v1/highlights/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a highlight
         * @param {string} id ID of the Highlight
         * @param {HighlightUpdateRequest} [highlightUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHighlight: async (id: string, highlightUpdateRequest?: HighlightUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateHighlight', 'id', id)
            const localVarPath = `/api/v1/highlights/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(highlightUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HighlightsApi - functional programming interface
 * @export
 */
export const HighlightsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HighlightsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add a highlight
         * @param {string} id id of corresponding event
         * @param {HighlightCreateRequest} [highlightCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addHighlight(id: string, highlightCreateRequest?: HighlightCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Highlight>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addHighlight(id, highlightCreateRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['HighlightsApi.addHighlight']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Download highlights
         * @param {string} id id of corresponding event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadHighlights(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadHighlights(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['HighlightsApi.downloadHighlights']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get a highlight
         * @param {string} id ID of the Highlight
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHighlight(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Highlight>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHighlight(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['HighlightsApi.getHighlight']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Returns all Highlights as galleries.
         * @summary Get all Highlights across Events and Groups
         * @param {number} [offset] Index of the first requested item, starting at 0.
         * @param {number} [limit] Maximum number of items to be returned.
         * @param {AscDescOrder} [order] Direction of the ordering by creation date (created_at).
         * @param {number} [preload] How many images should be eagerly loaded per gallery.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHighlightGalleries(offset?: number, limit?: number, order?: AscDescOrder, preload?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EventGallery>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHighlightGalleries(offset, limit, order, preload, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['HighlightsApi.getHighlightGalleries']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get the highlights
         * @param {string} id id of corresponding event
         * @param {number} [offset] Index of the first requested highlight, starting at 0.
         * @param {number} [limit] Maximum number of highlights to be returned.
         * @param {AscDescOrder} [order] Elements are always ordered by their order attribute. Direction of ordering.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHighlights(id: string, offset?: number, limit?: number, order?: AscDescOrder, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Highlight>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHighlights(id, offset, limit, order, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['HighlightsApi.getHighlights']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Remove a highlight
         * @param {string} id ID of the Highlight
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeFromHighlights(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeFromHighlights(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['HighlightsApi.removeFromHighlights']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Update a highlight
         * @param {string} id ID of the Highlight
         * @param {HighlightUpdateRequest} [highlightUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateHighlight(id: string, highlightUpdateRequest?: HighlightUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Highlight>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateHighlight(id, highlightUpdateRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['HighlightsApi.updateHighlight']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * HighlightsApi - factory interface
 * @export
 */
export const HighlightsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HighlightsApiFp(configuration)
    return {
        /**
         * 
         * @summary Add a highlight
         * @param {string} id id of corresponding event
         * @param {HighlightCreateRequest} [highlightCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addHighlight(id: string, highlightCreateRequest?: HighlightCreateRequest, options?: any): AxiosPromise<Highlight> {
            return localVarFp.addHighlight(id, highlightCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Download highlights
         * @param {string} id id of corresponding event
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadHighlights(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.downloadHighlights(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a highlight
         * @param {string} id ID of the Highlight
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHighlight(id: string, options?: any): AxiosPromise<Highlight> {
            return localVarFp.getHighlight(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all Highlights as galleries.
         * @summary Get all Highlights across Events and Groups
         * @param {number} [offset] Index of the first requested item, starting at 0.
         * @param {number} [limit] Maximum number of items to be returned.
         * @param {AscDescOrder} [order] Direction of the ordering by creation date (created_at).
         * @param {number} [preload] How many images should be eagerly loaded per gallery.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHighlightGalleries(offset?: number, limit?: number, order?: AscDescOrder, preload?: number, options?: any): AxiosPromise<Array<EventGallery>> {
            return localVarFp.getHighlightGalleries(offset, limit, order, preload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the highlights
         * @param {string} id id of corresponding event
         * @param {number} [offset] Index of the first requested highlight, starting at 0.
         * @param {number} [limit] Maximum number of highlights to be returned.
         * @param {AscDescOrder} [order] Elements are always ordered by their order attribute. Direction of ordering.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHighlights(id: string, offset?: number, limit?: number, order?: AscDescOrder, options?: any): AxiosPromise<Array<Highlight>> {
            return localVarFp.getHighlights(id, offset, limit, order, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove a highlight
         * @param {string} id ID of the Highlight
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeFromHighlights(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.removeFromHighlights(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a highlight
         * @param {string} id ID of the Highlight
         * @param {HighlightUpdateRequest} [highlightUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHighlight(id: string, highlightUpdateRequest?: HighlightUpdateRequest, options?: any): AxiosPromise<Highlight> {
            return localVarFp.updateHighlight(id, highlightUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HighlightsApi - interface
 * @export
 * @interface HighlightsApi
 */
export interface HighlightsApiInterface {
    /**
     * 
     * @summary Add a highlight
     * @param {string} id id of corresponding event
     * @param {HighlightCreateRequest} [highlightCreateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HighlightsApiInterface
     */
    addHighlight(id: string, highlightCreateRequest?: HighlightCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Highlight>;

    /**
     * 
     * @summary Download highlights
     * @param {string} id id of corresponding event
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HighlightsApiInterface
     */
    downloadHighlights(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Get a highlight
     * @param {string} id ID of the Highlight
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HighlightsApiInterface
     */
    getHighlight(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Highlight>;

    /**
     * Returns all Highlights as galleries.
     * @summary Get all Highlights across Events and Groups
     * @param {number} [offset] Index of the first requested item, starting at 0.
     * @param {number} [limit] Maximum number of items to be returned.
     * @param {AscDescOrder} [order] Direction of the ordering by creation date (created_at).
     * @param {number} [preload] How many images should be eagerly loaded per gallery.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HighlightsApiInterface
     */
    getHighlightGalleries(offset?: number, limit?: number, order?: AscDescOrder, preload?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<EventGallery>>;

    /**
     * 
     * @summary Get the highlights
     * @param {string} id id of corresponding event
     * @param {number} [offset] Index of the first requested highlight, starting at 0.
     * @param {number} [limit] Maximum number of highlights to be returned.
     * @param {AscDescOrder} [order] Elements are always ordered by their order attribute. Direction of ordering.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HighlightsApiInterface
     */
    getHighlights(id: string, offset?: number, limit?: number, order?: AscDescOrder, options?: RawAxiosRequestConfig): AxiosPromise<Array<Highlight>>;

    /**
     * 
     * @summary Remove a highlight
     * @param {string} id ID of the Highlight
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HighlightsApiInterface
     */
    removeFromHighlights(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Update a highlight
     * @param {string} id ID of the Highlight
     * @param {HighlightUpdateRequest} [highlightUpdateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HighlightsApiInterface
     */
    updateHighlight(id: string, highlightUpdateRequest?: HighlightUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Highlight>;

}

/**
 * HighlightsApi - object-oriented interface
 * @export
 * @class HighlightsApi
 * @extends {BaseAPI}
 */
export class HighlightsApi extends BaseAPI implements HighlightsApiInterface {
    /**
     * 
     * @summary Add a highlight
     * @param {string} id id of corresponding event
     * @param {HighlightCreateRequest} [highlightCreateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HighlightsApi
     */
    public addHighlight(id: string, highlightCreateRequest?: HighlightCreateRequest, options?: RawAxiosRequestConfig) {
        return HighlightsApiFp(this.configuration).addHighlight(id, highlightCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Download highlights
     * @param {string} id id of corresponding event
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HighlightsApi
     */
    public downloadHighlights(id: string, options?: RawAxiosRequestConfig) {
        return HighlightsApiFp(this.configuration).downloadHighlights(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a highlight
     * @param {string} id ID of the Highlight
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HighlightsApi
     */
    public getHighlight(id: string, options?: RawAxiosRequestConfig) {
        return HighlightsApiFp(this.configuration).getHighlight(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all Highlights as galleries.
     * @summary Get all Highlights across Events and Groups
     * @param {number} [offset] Index of the first requested item, starting at 0.
     * @param {number} [limit] Maximum number of items to be returned.
     * @param {AscDescOrder} [order] Direction of the ordering by creation date (created_at).
     * @param {number} [preload] How many images should be eagerly loaded per gallery.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HighlightsApi
     */
    public getHighlightGalleries(offset?: number, limit?: number, order?: AscDescOrder, preload?: number, options?: RawAxiosRequestConfig) {
        return HighlightsApiFp(this.configuration).getHighlightGalleries(offset, limit, order, preload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the highlights
     * @param {string} id id of corresponding event
     * @param {number} [offset] Index of the first requested highlight, starting at 0.
     * @param {number} [limit] Maximum number of highlights to be returned.
     * @param {AscDescOrder} [order] Elements are always ordered by their order attribute. Direction of ordering.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HighlightsApi
     */
    public getHighlights(id: string, offset?: number, limit?: number, order?: AscDescOrder, options?: RawAxiosRequestConfig) {
        return HighlightsApiFp(this.configuration).getHighlights(id, offset, limit, order, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove a highlight
     * @param {string} id ID of the Highlight
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HighlightsApi
     */
    public removeFromHighlights(id: string, options?: RawAxiosRequestConfig) {
        return HighlightsApiFp(this.configuration).removeFromHighlights(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a highlight
     * @param {string} id ID of the Highlight
     * @param {HighlightUpdateRequest} [highlightUpdateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HighlightsApi
     */
    public updateHighlight(id: string, highlightUpdateRequest?: HighlightUpdateRequest, options?: RawAxiosRequestConfig) {
        return HighlightsApiFp(this.configuration).updateHighlight(id, highlightUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ImporterApi - axios parameter creator
 * @export
 */
export const ImporterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * **Erlaubte Felder:**  - Personen ID - Unsichtbar - Titel für Anrede - Vorname - Nachname - Geburtsdatum - Geburtsort - Verstorben - Sterbedatum - Sterbeort - Handynummer - E-Mail - Beruflicher Status - Studium - Beruf - Firma - Position - Akademische Grade - Notiz zur Person - Website - Wikipedia - Vulgo - Status - Mitgliedsnummer - Recipiert - Renonciert - Philistriert - Ehrenhalber verliehen - Datum der Bandverleihung - Geklammerte Chargen - Ausgetreten - Austrittsdatum - Austrittsgrund - Notiz zur Mitgliedschaft - Profilfoto - Receptionsfoto - {i}. Bund - {i}. Bund Vulgo - {i}. Bund Status - {i}. Bund Mitgliedsnummer - {i}. Bund Recipiert - {i}. Bund Renonciert - {i}. Bund Philistriert - {i}. Bund Ehrenhalber verliehen - {i}. Bund Datum der Bandverleihung - {i}. Bund Geklammerte - {i}. Bund Ausgetreten - {i}. Bund Austrittsdatum - {i}. Bund Austrittsgrund - {i}. Bund Receptionsfoto - {i}. Bund Notiz - Straße - c/o - PLZ - Ort - Land - Telefon (Festnetz) - Fax - Notiz zur Adresse - Geschäftlich: Straße - Geschäftlich: c/o - Geschäftlich: PLZ - Geschäftlich: Ort - Geschäftlich: Land - Geschäftlich: Telefon (Festnetz - Geschäftlich: Fax - Geschäftlich: Notiz zur Adresse - LinkedIn - Xing - Facebook - Instagram - Twitter - Stand - Extra (Personendaten): <Name> - Extra (Mitgliedsdaten): <Name> 
         * @summary Validate Import Data
         * @param {string} clientId 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateImport: async (clientId: string, file?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'clientId' is not null or undefined
            assertParamExists('validateImport', 'clientId', clientId)
            const localVarPath = `/api/v1/importer/validate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication legacyCookieAuth required

            if (clientId !== undefined) {
                localVarQueryParameter['client_id'] = clientId;
            }


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ImporterApi - functional programming interface
 * @export
 */
export const ImporterApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ImporterApiAxiosParamCreator(configuration)
    return {
        /**
         * **Erlaubte Felder:**  - Personen ID - Unsichtbar - Titel für Anrede - Vorname - Nachname - Geburtsdatum - Geburtsort - Verstorben - Sterbedatum - Sterbeort - Handynummer - E-Mail - Beruflicher Status - Studium - Beruf - Firma - Position - Akademische Grade - Notiz zur Person - Website - Wikipedia - Vulgo - Status - Mitgliedsnummer - Recipiert - Renonciert - Philistriert - Ehrenhalber verliehen - Datum der Bandverleihung - Geklammerte Chargen - Ausgetreten - Austrittsdatum - Austrittsgrund - Notiz zur Mitgliedschaft - Profilfoto - Receptionsfoto - {i}. Bund - {i}. Bund Vulgo - {i}. Bund Status - {i}. Bund Mitgliedsnummer - {i}. Bund Recipiert - {i}. Bund Renonciert - {i}. Bund Philistriert - {i}. Bund Ehrenhalber verliehen - {i}. Bund Datum der Bandverleihung - {i}. Bund Geklammerte - {i}. Bund Ausgetreten - {i}. Bund Austrittsdatum - {i}. Bund Austrittsgrund - {i}. Bund Receptionsfoto - {i}. Bund Notiz - Straße - c/o - PLZ - Ort - Land - Telefon (Festnetz) - Fax - Notiz zur Adresse - Geschäftlich: Straße - Geschäftlich: c/o - Geschäftlich: PLZ - Geschäftlich: Ort - Geschäftlich: Land - Geschäftlich: Telefon (Festnetz - Geschäftlich: Fax - Geschäftlich: Notiz zur Adresse - LinkedIn - Xing - Facebook - Instagram - Twitter - Stand - Extra (Personendaten): <Name> - Extra (Mitgliedsdaten): <Name> 
         * @summary Validate Import Data
         * @param {string} clientId 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async validateImport(clientId: string, file?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ImportValidationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.validateImport(clientId, file, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ImporterApi.validateImport']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * ImporterApi - factory interface
 * @export
 */
export const ImporterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ImporterApiFp(configuration)
    return {
        /**
         * **Erlaubte Felder:**  - Personen ID - Unsichtbar - Titel für Anrede - Vorname - Nachname - Geburtsdatum - Geburtsort - Verstorben - Sterbedatum - Sterbeort - Handynummer - E-Mail - Beruflicher Status - Studium - Beruf - Firma - Position - Akademische Grade - Notiz zur Person - Website - Wikipedia - Vulgo - Status - Mitgliedsnummer - Recipiert - Renonciert - Philistriert - Ehrenhalber verliehen - Datum der Bandverleihung - Geklammerte Chargen - Ausgetreten - Austrittsdatum - Austrittsgrund - Notiz zur Mitgliedschaft - Profilfoto - Receptionsfoto - {i}. Bund - {i}. Bund Vulgo - {i}. Bund Status - {i}. Bund Mitgliedsnummer - {i}. Bund Recipiert - {i}. Bund Renonciert - {i}. Bund Philistriert - {i}. Bund Ehrenhalber verliehen - {i}. Bund Datum der Bandverleihung - {i}. Bund Geklammerte - {i}. Bund Ausgetreten - {i}. Bund Austrittsdatum - {i}. Bund Austrittsgrund - {i}. Bund Receptionsfoto - {i}. Bund Notiz - Straße - c/o - PLZ - Ort - Land - Telefon (Festnetz) - Fax - Notiz zur Adresse - Geschäftlich: Straße - Geschäftlich: c/o - Geschäftlich: PLZ - Geschäftlich: Ort - Geschäftlich: Land - Geschäftlich: Telefon (Festnetz - Geschäftlich: Fax - Geschäftlich: Notiz zur Adresse - LinkedIn - Xing - Facebook - Instagram - Twitter - Stand - Extra (Personendaten): <Name> - Extra (Mitgliedsdaten): <Name> 
         * @summary Validate Import Data
         * @param {string} clientId 
         * @param {File} [file] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        validateImport(clientId: string, file?: File, options?: any): AxiosPromise<ImportValidationResponse> {
            return localVarFp.validateImport(clientId, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ImporterApi - interface
 * @export
 * @interface ImporterApi
 */
export interface ImporterApiInterface {
    /**
     * **Erlaubte Felder:**  - Personen ID - Unsichtbar - Titel für Anrede - Vorname - Nachname - Geburtsdatum - Geburtsort - Verstorben - Sterbedatum - Sterbeort - Handynummer - E-Mail - Beruflicher Status - Studium - Beruf - Firma - Position - Akademische Grade - Notiz zur Person - Website - Wikipedia - Vulgo - Status - Mitgliedsnummer - Recipiert - Renonciert - Philistriert - Ehrenhalber verliehen - Datum der Bandverleihung - Geklammerte Chargen - Ausgetreten - Austrittsdatum - Austrittsgrund - Notiz zur Mitgliedschaft - Profilfoto - Receptionsfoto - {i}. Bund - {i}. Bund Vulgo - {i}. Bund Status - {i}. Bund Mitgliedsnummer - {i}. Bund Recipiert - {i}. Bund Renonciert - {i}. Bund Philistriert - {i}. Bund Ehrenhalber verliehen - {i}. Bund Datum der Bandverleihung - {i}. Bund Geklammerte - {i}. Bund Ausgetreten - {i}. Bund Austrittsdatum - {i}. Bund Austrittsgrund - {i}. Bund Receptionsfoto - {i}. Bund Notiz - Straße - c/o - PLZ - Ort - Land - Telefon (Festnetz) - Fax - Notiz zur Adresse - Geschäftlich: Straße - Geschäftlich: c/o - Geschäftlich: PLZ - Geschäftlich: Ort - Geschäftlich: Land - Geschäftlich: Telefon (Festnetz - Geschäftlich: Fax - Geschäftlich: Notiz zur Adresse - LinkedIn - Xing - Facebook - Instagram - Twitter - Stand - Extra (Personendaten): <Name> - Extra (Mitgliedsdaten): <Name> 
     * @summary Validate Import Data
     * @param {string} clientId 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImporterApiInterface
     */
    validateImport(clientId: string, file?: File, options?: RawAxiosRequestConfig): AxiosPromise<ImportValidationResponse>;

}

/**
 * ImporterApi - object-oriented interface
 * @export
 * @class ImporterApi
 * @extends {BaseAPI}
 */
export class ImporterApi extends BaseAPI implements ImporterApiInterface {
    /**
     * **Erlaubte Felder:**  - Personen ID - Unsichtbar - Titel für Anrede - Vorname - Nachname - Geburtsdatum - Geburtsort - Verstorben - Sterbedatum - Sterbeort - Handynummer - E-Mail - Beruflicher Status - Studium - Beruf - Firma - Position - Akademische Grade - Notiz zur Person - Website - Wikipedia - Vulgo - Status - Mitgliedsnummer - Recipiert - Renonciert - Philistriert - Ehrenhalber verliehen - Datum der Bandverleihung - Geklammerte Chargen - Ausgetreten - Austrittsdatum - Austrittsgrund - Notiz zur Mitgliedschaft - Profilfoto - Receptionsfoto - {i}. Bund - {i}. Bund Vulgo - {i}. Bund Status - {i}. Bund Mitgliedsnummer - {i}. Bund Recipiert - {i}. Bund Renonciert - {i}. Bund Philistriert - {i}. Bund Ehrenhalber verliehen - {i}. Bund Datum der Bandverleihung - {i}. Bund Geklammerte - {i}. Bund Ausgetreten - {i}. Bund Austrittsdatum - {i}. Bund Austrittsgrund - {i}. Bund Receptionsfoto - {i}. Bund Notiz - Straße - c/o - PLZ - Ort - Land - Telefon (Festnetz) - Fax - Notiz zur Adresse - Geschäftlich: Straße - Geschäftlich: c/o - Geschäftlich: PLZ - Geschäftlich: Ort - Geschäftlich: Land - Geschäftlich: Telefon (Festnetz - Geschäftlich: Fax - Geschäftlich: Notiz zur Adresse - LinkedIn - Xing - Facebook - Instagram - Twitter - Stand - Extra (Personendaten): <Name> - Extra (Mitgliedsdaten): <Name> 
     * @summary Validate Import Data
     * @param {string} clientId 
     * @param {File} [file] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ImporterApi
     */
    public validateImport(clientId: string, file?: File, options?: RawAxiosRequestConfig) {
        return ImporterApiFp(this.configuration).validateImport(clientId, file, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * LevelApi - axios parameter creator
 * @export
 */
export const LevelApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Level
         * @param {LevelCreateRequest} [levelCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLevel: async (levelCreateRequest?: LevelCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/levels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(levelCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Level
         * @param {string} id ID of the Level
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLevel: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteLevel', 'id', id)
            const localVarPath = `/api/v1/levels/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Show Level
         * @param {string} id ID of the Level
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLevel: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getLevel', 'id', id)
            const localVarPath = `/api/v1/levels/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Levels
         * @param {number} [offset] Index of the first requested item, starting at 0.
         * @param {number} [limit] Maximum number of items to be returned.
         * @param {AscDescOrder} [order] Direction of the ordering by creation date (created_at).
         * @param {number} [clientId] Show only levels of the given client.
         * @param {boolean} [hasDrive] Show only levels with or without a drive.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLevels: async (offset?: number, limit?: number, order?: AscDescOrder, clientId?: number, hasDrive?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/levels`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (clientId !== undefined) {
                localVarQueryParameter['client_id'] = clientId;
            }

            if (hasDrive !== undefined) {
                localVarQueryParameter['has_drive'] = hasDrive;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Level
         * @param {string} id ID of the Level
         * @param {LevelUpdateRequest} [levelUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLevel: async (id: string, levelUpdateRequest?: LevelUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateLevel', 'id', id)
            const localVarPath = `/api/v1/levels/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(levelUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LevelApi - functional programming interface
 * @export
 */
export const LevelApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LevelApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Level
         * @param {LevelCreateRequest} [levelCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createLevel(levelCreateRequest?: LevelCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Level>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createLevel(levelCreateRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LevelApi.createLevel']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Level
         * @param {string} id ID of the Level
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteLevel(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteLevel(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LevelApi.deleteLevel']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Show Level
         * @param {string} id ID of the Level
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLevel(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Level>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLevel(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LevelApi.getLevel']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary List Levels
         * @param {number} [offset] Index of the first requested item, starting at 0.
         * @param {number} [limit] Maximum number of items to be returned.
         * @param {AscDescOrder} [order] Direction of the ordering by creation date (created_at).
         * @param {number} [clientId] Show only levels of the given client.
         * @param {boolean} [hasDrive] Show only levels with or without a drive.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLevels(offset?: number, limit?: number, order?: AscDescOrder, clientId?: number, hasDrive?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Level>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLevels(offset, limit, order, clientId, hasDrive, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LevelApi.getLevels']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Update Level
         * @param {string} id ID of the Level
         * @param {LevelUpdateRequest} [levelUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateLevel(id: string, levelUpdateRequest?: LevelUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Level>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateLevel(id, levelUpdateRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['LevelApi.updateLevel']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * LevelApi - factory interface
 * @export
 */
export const LevelApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LevelApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Level
         * @param {LevelCreateRequest} [levelCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createLevel(levelCreateRequest?: LevelCreateRequest, options?: any): AxiosPromise<Level> {
            return localVarFp.createLevel(levelCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Level
         * @param {string} id ID of the Level
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteLevel(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteLevel(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Show Level
         * @param {string} id ID of the Level
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLevel(id: string, options?: any): AxiosPromise<Level> {
            return localVarFp.getLevel(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Levels
         * @param {number} [offset] Index of the first requested item, starting at 0.
         * @param {number} [limit] Maximum number of items to be returned.
         * @param {AscDescOrder} [order] Direction of the ordering by creation date (created_at).
         * @param {number} [clientId] Show only levels of the given client.
         * @param {boolean} [hasDrive] Show only levels with or without a drive.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLevels(offset?: number, limit?: number, order?: AscDescOrder, clientId?: number, hasDrive?: boolean, options?: any): AxiosPromise<Array<Level>> {
            return localVarFp.getLevels(offset, limit, order, clientId, hasDrive, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Level
         * @param {string} id ID of the Level
         * @param {LevelUpdateRequest} [levelUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLevel(id: string, levelUpdateRequest?: LevelUpdateRequest, options?: any): AxiosPromise<Level> {
            return localVarFp.updateLevel(id, levelUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LevelApi - interface
 * @export
 * @interface LevelApi
 */
export interface LevelApiInterface {
    /**
     * 
     * @summary Create Level
     * @param {LevelCreateRequest} [levelCreateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LevelApiInterface
     */
    createLevel(levelCreateRequest?: LevelCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Level>;

    /**
     * 
     * @summary Delete Level
     * @param {string} id ID of the Level
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LevelApiInterface
     */
    deleteLevel(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Show Level
     * @param {string} id ID of the Level
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LevelApiInterface
     */
    getLevel(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Level>;

    /**
     * 
     * @summary List Levels
     * @param {number} [offset] Index of the first requested item, starting at 0.
     * @param {number} [limit] Maximum number of items to be returned.
     * @param {AscDescOrder} [order] Direction of the ordering by creation date (created_at).
     * @param {number} [clientId] Show only levels of the given client.
     * @param {boolean} [hasDrive] Show only levels with or without a drive.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LevelApiInterface
     */
    getLevels(offset?: number, limit?: number, order?: AscDescOrder, clientId?: number, hasDrive?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<Level>>;

    /**
     * 
     * @summary Update Level
     * @param {string} id ID of the Level
     * @param {LevelUpdateRequest} [levelUpdateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LevelApiInterface
     */
    updateLevel(id: string, levelUpdateRequest?: LevelUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Level>;

}

/**
 * LevelApi - object-oriented interface
 * @export
 * @class LevelApi
 * @extends {BaseAPI}
 */
export class LevelApi extends BaseAPI implements LevelApiInterface {
    /**
     * 
     * @summary Create Level
     * @param {LevelCreateRequest} [levelCreateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LevelApi
     */
    public createLevel(levelCreateRequest?: LevelCreateRequest, options?: RawAxiosRequestConfig) {
        return LevelApiFp(this.configuration).createLevel(levelCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Level
     * @param {string} id ID of the Level
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LevelApi
     */
    public deleteLevel(id: string, options?: RawAxiosRequestConfig) {
        return LevelApiFp(this.configuration).deleteLevel(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Show Level
     * @param {string} id ID of the Level
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LevelApi
     */
    public getLevel(id: string, options?: RawAxiosRequestConfig) {
        return LevelApiFp(this.configuration).getLevel(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Levels
     * @param {number} [offset] Index of the first requested item, starting at 0.
     * @param {number} [limit] Maximum number of items to be returned.
     * @param {AscDescOrder} [order] Direction of the ordering by creation date (created_at).
     * @param {number} [clientId] Show only levels of the given client.
     * @param {boolean} [hasDrive] Show only levels with or without a drive.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LevelApi
     */
    public getLevels(offset?: number, limit?: number, order?: AscDescOrder, clientId?: number, hasDrive?: boolean, options?: RawAxiosRequestConfig) {
        return LevelApiFp(this.configuration).getLevels(offset, limit, order, clientId, hasDrive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Level
     * @param {string} id ID of the Level
     * @param {LevelUpdateRequest} [levelUpdateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LevelApi
     */
    public updateLevel(id: string, levelUpdateRequest?: LevelUpdateRequest, options?: RawAxiosRequestConfig) {
        return LevelApiFp(this.configuration).updateLevel(id, levelUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * MembersApi - axios parameter creator
 * @export
 */
export const MembersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get a list of members you can filter using elastic search
         * @param {string} [name] Search for the given name in all template fields for names
         * @param {string} [levelId] Only show members that are member of the given Level
         * @param {Array<number>} [clientIds] Only show members with a membership of any of the given Clients.
         * @param {Array<number>} [groupIds] Only show members that are member in any of the given Groups.
         * @param {boolean} [currentOnly] Limit the search to only current members, excluding former and dead members.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fuzzySearch: async (name?: string, levelId?: string, clientIds?: Array<number>, groupIds?: Array<number>, currentOnly?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/members/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (levelId !== undefined) {
                localVarQueryParameter['level_id'] = levelId;
            }

            if (clientIds) {
                localVarQueryParameter['client_ids[]'] = clientIds;
            }

            if (groupIds) {
                localVarQueryParameter['group_ids[]'] = groupIds;
            }

            if (currentOnly !== undefined) {
                localVarQueryParameter['current_only'] = currentOnly;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * In each templateable field you have the following variables: - The current person itself: `person` - The current member (basically the ClubRecord of the current client): `membership` - All memberships of the current client: `memberships`  You can also chain attribute access e.g. `membership.club.umbrella.name`.  The following is the full list of available attributes for each object type:  **Membership**  - membership.id:  - membership.order:  - membership.is_awarded - membership.awarded_at - membership.renonciert_at - membership.recipiert_at - membership.philistriert_at - membership.chargen - membership.awarded_at_unfuzzy - membership.renonciert_at_unfuzzy - membership.recipiert_at_unfuzzy - membership.philistriert_at_unfuzzy - membership.vulgo - membership.verified - membership.last_summary_sent_at - membership.summary_freq - membership.resigned - membership.resigned_at - membership.resigned_reason - membership.list_number - membership.note - membership.family_number_arabic - membership.family_number_roman - membership.vulgo_without_familiy_number - membership.couleur - membership.extra_attributes.THE_ATTRIBUTE_NAME - membership.club => Client - membership.status => Status - membership.group_memberships => GroupMembership  **Person**  - person.id - person.title - person.last_name - person.birthdate - person.first_name - person.phone_number - person.company - person.position - person.studies - person.academic_title - person.job - person.website - person.alive - person.date_of_death - person.sex - person.facebook - person.instagram - person.twitter - person.job_status - person.email - person.place_of_death - person.birthplace - person.note - person.linkedin - person.xing - person.first_bounce_at - person.bounce_at - person.bounce_code - person.wiki - person.avatar - person.no_contact - person.contact_confirmed_at - person.last_email_opened_at - person.last_name_without_particle - person.particle - person.extra_attributes.THE_ATTRIBUTE_NAME  **Club**  - club.id - club.name - club.complete_name - club.shorthand - club.genitive - club.umbrella => Umbrella  **Status** - status.id - status.name - status.prefix  **Umbrella**  - umbrella.id - umbrella.shorthand - umbrella.name - umbrella.suffix  **Extra-Attributes**  - Can be accessed from a person or membership directly using the name (converted to snake case) of the attribute, e.g. `person.extra_attributes.anzahl_partien`  
         * @summary Simulate liquid template
         * @param {string} id Personal Record Id of a Member that you may view.
         * @param {SimulateLiquidTemplateAttributeEnum} attribute 
         * @param {string} template 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        simulateLiquidTemplate: async (id: string, attribute: SimulateLiquidTemplateAttributeEnum, template: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('simulateLiquidTemplate', 'id', id)
            // verify required parameter 'attribute' is not null or undefined
            assertParamExists('simulateLiquidTemplate', 'attribute', attribute)
            // verify required parameter 'template' is not null or undefined
            assertParamExists('simulateLiquidTemplate', 'template', template)
            const localVarPath = `/api/v1/members/{id}/render_template`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required

            if (attribute !== undefined) {
                localVarQueryParameter['attribute'] = attribute;
            }

            if (template !== undefined) {
                localVarQueryParameter['template'] = template;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send the 3 Onboarding-Emails for the given user to the email of current member.
         * @summary Test Onboarding Emails
         * @param {string} id Personal Record Id of a Member that you may view and in who\&#39;s client you are an admin.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testOnboardingEmail: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('testOnboardingEmail', 'id', id)
            const localVarPath = `/api/v1/members/{id}/trigger_onboarding_email`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send the Promo-Email for the given user to the email of current member.
         * @summary Test Promo Email
         * @param {string} id Personal Record Id of a Member that you may view and in who\&#39;s client you are an admin.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testPromoEmail: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('testPromoEmail', 'id', id)
            const localVarPath = `/api/v1/members/{id}/trigger_promo_email`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MembersApi - functional programming interface
 * @export
 */
export const MembersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MembersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get a list of members you can filter using elastic search
         * @param {string} [name] Search for the given name in all template fields for names
         * @param {string} [levelId] Only show members that are member of the given Level
         * @param {Array<number>} [clientIds] Only show members with a membership of any of the given Clients.
         * @param {Array<number>} [groupIds] Only show members that are member in any of the given Groups.
         * @param {boolean} [currentOnly] Limit the search to only current members, excluding former and dead members.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fuzzySearch(name?: string, levelId?: string, clientIds?: Array<number>, groupIds?: Array<number>, currentOnly?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FuzzySearch200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fuzzySearch(name, levelId, clientIds, groupIds, currentOnly, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MembersApi.fuzzySearch']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * In each templateable field you have the following variables: - The current person itself: `person` - The current member (basically the ClubRecord of the current client): `membership` - All memberships of the current client: `memberships`  You can also chain attribute access e.g. `membership.club.umbrella.name`.  The following is the full list of available attributes for each object type:  **Membership**  - membership.id:  - membership.order:  - membership.is_awarded - membership.awarded_at - membership.renonciert_at - membership.recipiert_at - membership.philistriert_at - membership.chargen - membership.awarded_at_unfuzzy - membership.renonciert_at_unfuzzy - membership.recipiert_at_unfuzzy - membership.philistriert_at_unfuzzy - membership.vulgo - membership.verified - membership.last_summary_sent_at - membership.summary_freq - membership.resigned - membership.resigned_at - membership.resigned_reason - membership.list_number - membership.note - membership.family_number_arabic - membership.family_number_roman - membership.vulgo_without_familiy_number - membership.couleur - membership.extra_attributes.THE_ATTRIBUTE_NAME - membership.club => Client - membership.status => Status - membership.group_memberships => GroupMembership  **Person**  - person.id - person.title - person.last_name - person.birthdate - person.first_name - person.phone_number - person.company - person.position - person.studies - person.academic_title - person.job - person.website - person.alive - person.date_of_death - person.sex - person.facebook - person.instagram - person.twitter - person.job_status - person.email - person.place_of_death - person.birthplace - person.note - person.linkedin - person.xing - person.first_bounce_at - person.bounce_at - person.bounce_code - person.wiki - person.avatar - person.no_contact - person.contact_confirmed_at - person.last_email_opened_at - person.last_name_without_particle - person.particle - person.extra_attributes.THE_ATTRIBUTE_NAME  **Club**  - club.id - club.name - club.complete_name - club.shorthand - club.genitive - club.umbrella => Umbrella  **Status** - status.id - status.name - status.prefix  **Umbrella**  - umbrella.id - umbrella.shorthand - umbrella.name - umbrella.suffix  **Extra-Attributes**  - Can be accessed from a person or membership directly using the name (converted to snake case) of the attribute, e.g. `person.extra_attributes.anzahl_partien`  
         * @summary Simulate liquid template
         * @param {string} id Personal Record Id of a Member that you may view.
         * @param {SimulateLiquidTemplateAttributeEnum} attribute 
         * @param {string} template 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async simulateLiquidTemplate(id: string, attribute: SimulateLiquidTemplateAttributeEnum, template: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SimulateLiquidTemplate200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.simulateLiquidTemplate(id, attribute, template, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MembersApi.simulateLiquidTemplate']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Send the 3 Onboarding-Emails for the given user to the email of current member.
         * @summary Test Onboarding Emails
         * @param {string} id Personal Record Id of a Member that you may view and in who\&#39;s client you are an admin.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testOnboardingEmail(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testOnboardingEmail(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MembersApi.testOnboardingEmail']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Send the Promo-Email for the given user to the email of current member.
         * @summary Test Promo Email
         * @param {string} id Personal Record Id of a Member that you may view and in who\&#39;s client you are an admin.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async testPromoEmail(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.testPromoEmail(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['MembersApi.testPromoEmail']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * MembersApi - factory interface
 * @export
 */
export const MembersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MembersApiFp(configuration)
    return {
        /**
         * 
         * @summary Get a list of members you can filter using elastic search
         * @param {string} [name] Search for the given name in all template fields for names
         * @param {string} [levelId] Only show members that are member of the given Level
         * @param {Array<number>} [clientIds] Only show members with a membership of any of the given Clients.
         * @param {Array<number>} [groupIds] Only show members that are member in any of the given Groups.
         * @param {boolean} [currentOnly] Limit the search to only current members, excluding former and dead members.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fuzzySearch(name?: string, levelId?: string, clientIds?: Array<number>, groupIds?: Array<number>, currentOnly?: boolean, options?: any): AxiosPromise<FuzzySearch200Response> {
            return localVarFp.fuzzySearch(name, levelId, clientIds, groupIds, currentOnly, options).then((request) => request(axios, basePath));
        },
        /**
         * In each templateable field you have the following variables: - The current person itself: `person` - The current member (basically the ClubRecord of the current client): `membership` - All memberships of the current client: `memberships`  You can also chain attribute access e.g. `membership.club.umbrella.name`.  The following is the full list of available attributes for each object type:  **Membership**  - membership.id:  - membership.order:  - membership.is_awarded - membership.awarded_at - membership.renonciert_at - membership.recipiert_at - membership.philistriert_at - membership.chargen - membership.awarded_at_unfuzzy - membership.renonciert_at_unfuzzy - membership.recipiert_at_unfuzzy - membership.philistriert_at_unfuzzy - membership.vulgo - membership.verified - membership.last_summary_sent_at - membership.summary_freq - membership.resigned - membership.resigned_at - membership.resigned_reason - membership.list_number - membership.note - membership.family_number_arabic - membership.family_number_roman - membership.vulgo_without_familiy_number - membership.couleur - membership.extra_attributes.THE_ATTRIBUTE_NAME - membership.club => Client - membership.status => Status - membership.group_memberships => GroupMembership  **Person**  - person.id - person.title - person.last_name - person.birthdate - person.first_name - person.phone_number - person.company - person.position - person.studies - person.academic_title - person.job - person.website - person.alive - person.date_of_death - person.sex - person.facebook - person.instagram - person.twitter - person.job_status - person.email - person.place_of_death - person.birthplace - person.note - person.linkedin - person.xing - person.first_bounce_at - person.bounce_at - person.bounce_code - person.wiki - person.avatar - person.no_contact - person.contact_confirmed_at - person.last_email_opened_at - person.last_name_without_particle - person.particle - person.extra_attributes.THE_ATTRIBUTE_NAME  **Club**  - club.id - club.name - club.complete_name - club.shorthand - club.genitive - club.umbrella => Umbrella  **Status** - status.id - status.name - status.prefix  **Umbrella**  - umbrella.id - umbrella.shorthand - umbrella.name - umbrella.suffix  **Extra-Attributes**  - Can be accessed from a person or membership directly using the name (converted to snake case) of the attribute, e.g. `person.extra_attributes.anzahl_partien`  
         * @summary Simulate liquid template
         * @param {string} id Personal Record Id of a Member that you may view.
         * @param {SimulateLiquidTemplateAttributeEnum} attribute 
         * @param {string} template 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        simulateLiquidTemplate(id: string, attribute: SimulateLiquidTemplateAttributeEnum, template: string, options?: any): AxiosPromise<SimulateLiquidTemplate200Response> {
            return localVarFp.simulateLiquidTemplate(id, attribute, template, options).then((request) => request(axios, basePath));
        },
        /**
         * Send the 3 Onboarding-Emails for the given user to the email of current member.
         * @summary Test Onboarding Emails
         * @param {string} id Personal Record Id of a Member that you may view and in who\&#39;s client you are an admin.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testOnboardingEmail(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.testOnboardingEmail(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Send the Promo-Email for the given user to the email of current member.
         * @summary Test Promo Email
         * @param {string} id Personal Record Id of a Member that you may view and in who\&#39;s client you are an admin.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        testPromoEmail(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.testPromoEmail(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MembersApi - interface
 * @export
 * @interface MembersApi
 */
export interface MembersApiInterface {
    /**
     * 
     * @summary Get a list of members you can filter using elastic search
     * @param {string} [name] Search for the given name in all template fields for names
     * @param {string} [levelId] Only show members that are member of the given Level
     * @param {Array<number>} [clientIds] Only show members with a membership of any of the given Clients.
     * @param {Array<number>} [groupIds] Only show members that are member in any of the given Groups.
     * @param {boolean} [currentOnly] Limit the search to only current members, excluding former and dead members.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembersApiInterface
     */
    fuzzySearch(name?: string, levelId?: string, clientIds?: Array<number>, groupIds?: Array<number>, currentOnly?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<FuzzySearch200Response>;

    /**
     * In each templateable field you have the following variables: - The current person itself: `person` - The current member (basically the ClubRecord of the current client): `membership` - All memberships of the current client: `memberships`  You can also chain attribute access e.g. `membership.club.umbrella.name`.  The following is the full list of available attributes for each object type:  **Membership**  - membership.id:  - membership.order:  - membership.is_awarded - membership.awarded_at - membership.renonciert_at - membership.recipiert_at - membership.philistriert_at - membership.chargen - membership.awarded_at_unfuzzy - membership.renonciert_at_unfuzzy - membership.recipiert_at_unfuzzy - membership.philistriert_at_unfuzzy - membership.vulgo - membership.verified - membership.last_summary_sent_at - membership.summary_freq - membership.resigned - membership.resigned_at - membership.resigned_reason - membership.list_number - membership.note - membership.family_number_arabic - membership.family_number_roman - membership.vulgo_without_familiy_number - membership.couleur - membership.extra_attributes.THE_ATTRIBUTE_NAME - membership.club => Client - membership.status => Status - membership.group_memberships => GroupMembership  **Person**  - person.id - person.title - person.last_name - person.birthdate - person.first_name - person.phone_number - person.company - person.position - person.studies - person.academic_title - person.job - person.website - person.alive - person.date_of_death - person.sex - person.facebook - person.instagram - person.twitter - person.job_status - person.email - person.place_of_death - person.birthplace - person.note - person.linkedin - person.xing - person.first_bounce_at - person.bounce_at - person.bounce_code - person.wiki - person.avatar - person.no_contact - person.contact_confirmed_at - person.last_email_opened_at - person.last_name_without_particle - person.particle - person.extra_attributes.THE_ATTRIBUTE_NAME  **Club**  - club.id - club.name - club.complete_name - club.shorthand - club.genitive - club.umbrella => Umbrella  **Status** - status.id - status.name - status.prefix  **Umbrella**  - umbrella.id - umbrella.shorthand - umbrella.name - umbrella.suffix  **Extra-Attributes**  - Can be accessed from a person or membership directly using the name (converted to snake case) of the attribute, e.g. `person.extra_attributes.anzahl_partien`  
     * @summary Simulate liquid template
     * @param {string} id Personal Record Id of a Member that you may view.
     * @param {SimulateLiquidTemplateAttributeEnum} attribute 
     * @param {string} template 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembersApiInterface
     */
    simulateLiquidTemplate(id: string, attribute: SimulateLiquidTemplateAttributeEnum, template: string, options?: RawAxiosRequestConfig): AxiosPromise<SimulateLiquidTemplate200Response>;

    /**
     * Send the 3 Onboarding-Emails for the given user to the email of current member.
     * @summary Test Onboarding Emails
     * @param {string} id Personal Record Id of a Member that you may view and in who\&#39;s client you are an admin.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembersApiInterface
     */
    testOnboardingEmail(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Send the Promo-Email for the given user to the email of current member.
     * @summary Test Promo Email
     * @param {string} id Personal Record Id of a Member that you may view and in who\&#39;s client you are an admin.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembersApiInterface
     */
    testPromoEmail(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * MembersApi - object-oriented interface
 * @export
 * @class MembersApi
 * @extends {BaseAPI}
 */
export class MembersApi extends BaseAPI implements MembersApiInterface {
    /**
     * 
     * @summary Get a list of members you can filter using elastic search
     * @param {string} [name] Search for the given name in all template fields for names
     * @param {string} [levelId] Only show members that are member of the given Level
     * @param {Array<number>} [clientIds] Only show members with a membership of any of the given Clients.
     * @param {Array<number>} [groupIds] Only show members that are member in any of the given Groups.
     * @param {boolean} [currentOnly] Limit the search to only current members, excluding former and dead members.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembersApi
     */
    public fuzzySearch(name?: string, levelId?: string, clientIds?: Array<number>, groupIds?: Array<number>, currentOnly?: boolean, options?: RawAxiosRequestConfig) {
        return MembersApiFp(this.configuration).fuzzySearch(name, levelId, clientIds, groupIds, currentOnly, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * In each templateable field you have the following variables: - The current person itself: `person` - The current member (basically the ClubRecord of the current client): `membership` - All memberships of the current client: `memberships`  You can also chain attribute access e.g. `membership.club.umbrella.name`.  The following is the full list of available attributes for each object type:  **Membership**  - membership.id:  - membership.order:  - membership.is_awarded - membership.awarded_at - membership.renonciert_at - membership.recipiert_at - membership.philistriert_at - membership.chargen - membership.awarded_at_unfuzzy - membership.renonciert_at_unfuzzy - membership.recipiert_at_unfuzzy - membership.philistriert_at_unfuzzy - membership.vulgo - membership.verified - membership.last_summary_sent_at - membership.summary_freq - membership.resigned - membership.resigned_at - membership.resigned_reason - membership.list_number - membership.note - membership.family_number_arabic - membership.family_number_roman - membership.vulgo_without_familiy_number - membership.couleur - membership.extra_attributes.THE_ATTRIBUTE_NAME - membership.club => Client - membership.status => Status - membership.group_memberships => GroupMembership  **Person**  - person.id - person.title - person.last_name - person.birthdate - person.first_name - person.phone_number - person.company - person.position - person.studies - person.academic_title - person.job - person.website - person.alive - person.date_of_death - person.sex - person.facebook - person.instagram - person.twitter - person.job_status - person.email - person.place_of_death - person.birthplace - person.note - person.linkedin - person.xing - person.first_bounce_at - person.bounce_at - person.bounce_code - person.wiki - person.avatar - person.no_contact - person.contact_confirmed_at - person.last_email_opened_at - person.last_name_without_particle - person.particle - person.extra_attributes.THE_ATTRIBUTE_NAME  **Club**  - club.id - club.name - club.complete_name - club.shorthand - club.genitive - club.umbrella => Umbrella  **Status** - status.id - status.name - status.prefix  **Umbrella**  - umbrella.id - umbrella.shorthand - umbrella.name - umbrella.suffix  **Extra-Attributes**  - Can be accessed from a person or membership directly using the name (converted to snake case) of the attribute, e.g. `person.extra_attributes.anzahl_partien`  
     * @summary Simulate liquid template
     * @param {string} id Personal Record Id of a Member that you may view.
     * @param {SimulateLiquidTemplateAttributeEnum} attribute 
     * @param {string} template 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembersApi
     */
    public simulateLiquidTemplate(id: string, attribute: SimulateLiquidTemplateAttributeEnum, template: string, options?: RawAxiosRequestConfig) {
        return MembersApiFp(this.configuration).simulateLiquidTemplate(id, attribute, template, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send the 3 Onboarding-Emails for the given user to the email of current member.
     * @summary Test Onboarding Emails
     * @param {string} id Personal Record Id of a Member that you may view and in who\&#39;s client you are an admin.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembersApi
     */
    public testOnboardingEmail(id: string, options?: RawAxiosRequestConfig) {
        return MembersApiFp(this.configuration).testOnboardingEmail(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send the Promo-Email for the given user to the email of current member.
     * @summary Test Promo Email
     * @param {string} id Personal Record Id of a Member that you may view and in who\&#39;s client you are an admin.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MembersApi
     */
    public testPromoEmail(id: string, options?: RawAxiosRequestConfig) {
        return MembersApiFp(this.configuration).testPromoEmail(id, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const SimulateLiquidTemplateAttributeEnum = {
    ListName: 'list_name',
    SortKey: 'sort_key',
    InternalNameShort: 'internal_name_short',
    InternalNameLong: 'internal_name_long',
    UmbrellaNameShort: 'umbrella_name_short',
    UmbrellaNameLong: 'umbrella_name_long'
} as const;
export type SimulateLiquidTemplateAttributeEnum = typeof SimulateLiquidTemplateAttributeEnum[keyof typeof SimulateLiquidTemplateAttributeEnum];


/**
 * PersonalRecordsApi - axios parameter creator
 * @export
 */
export const PersonalRecordsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Absorb a PersonalRecord into another one
         * @param {string} id ID of the PersonalRecord that absorbs the duplicate
         * @param {AbsorbPersonalRecordRequest} [absorbPersonalRecordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        absorbPersonalRecord: async (id: string, absorbPersonalRecordRequest?: AbsorbPersonalRecordRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('absorbPersonalRecord', 'id', id)
            const localVarPath = `/api/v1/personal_records/{id}/absorb`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(absorbPersonalRecordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PersonalRecordsApi - functional programming interface
 * @export
 */
export const PersonalRecordsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PersonalRecordsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Absorb a PersonalRecord into another one
         * @param {string} id ID of the PersonalRecord that absorbs the duplicate
         * @param {AbsorbPersonalRecordRequest} [absorbPersonalRecordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async absorbPersonalRecord(id: string, absorbPersonalRecordRequest?: AbsorbPersonalRecordRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PersonalRecord>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.absorbPersonalRecord(id, absorbPersonalRecordRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PersonalRecordsApi.absorbPersonalRecord']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * PersonalRecordsApi - factory interface
 * @export
 */
export const PersonalRecordsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PersonalRecordsApiFp(configuration)
    return {
        /**
         * 
         * @summary Absorb a PersonalRecord into another one
         * @param {string} id ID of the PersonalRecord that absorbs the duplicate
         * @param {AbsorbPersonalRecordRequest} [absorbPersonalRecordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        absorbPersonalRecord(id: string, absorbPersonalRecordRequest?: AbsorbPersonalRecordRequest, options?: any): AxiosPromise<PersonalRecord> {
            return localVarFp.absorbPersonalRecord(id, absorbPersonalRecordRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PersonalRecordsApi - interface
 * @export
 * @interface PersonalRecordsApi
 */
export interface PersonalRecordsApiInterface {
    /**
     * 
     * @summary Absorb a PersonalRecord into another one
     * @param {string} id ID of the PersonalRecord that absorbs the duplicate
     * @param {AbsorbPersonalRecordRequest} [absorbPersonalRecordRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalRecordsApiInterface
     */
    absorbPersonalRecord(id: string, absorbPersonalRecordRequest?: AbsorbPersonalRecordRequest, options?: RawAxiosRequestConfig): AxiosPromise<PersonalRecord>;

}

/**
 * PersonalRecordsApi - object-oriented interface
 * @export
 * @class PersonalRecordsApi
 * @extends {BaseAPI}
 */
export class PersonalRecordsApi extends BaseAPI implements PersonalRecordsApiInterface {
    /**
     * 
     * @summary Absorb a PersonalRecord into another one
     * @param {string} id ID of the PersonalRecord that absorbs the duplicate
     * @param {AbsorbPersonalRecordRequest} [absorbPersonalRecordRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PersonalRecordsApi
     */
    public absorbPersonalRecord(id: string, absorbPersonalRecordRequest?: AbsorbPersonalRecordRequest, options?: RawAxiosRequestConfig) {
        return PersonalRecordsApiFp(this.configuration).absorbPersonalRecord(id, absorbPersonalRecordRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PostsApi - axios parameter creator
 * @export
 */
export const PostsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add attachments to this post
         * @param {string} id id of corresponding attachable (e.g. Topic)
         * @param {Array<AttachmentUpload>} [attachmentUpload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPostAttachments: async (id: string, attachmentUpload?: Array<AttachmentUpload>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addPostAttachments', 'id', id)
            const localVarPath = `/api/v1/posts/{id}/attachments`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(attachmentUpload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a Comment
         * @param {string} id id of post to react to
         * @param {CommentRequest} [commentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPostComment: async (id: string, commentRequest?: CommentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createPostComment', 'id', id)
            const localVarPath = `/api/v1/posts/{id}/comments`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a Reaction to a Post
         * @param {string} postId id of post to react to
         * @param {Emoji} emoji 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPostReaction: async (postId: string, emoji: Emoji, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postId' is not null or undefined
            assertParamExists('createPostReaction', 'postId', postId)
            // verify required parameter 'emoji' is not null or undefined
            assertParamExists('createPostReaction', 'emoji', emoji)
            const localVarPath = `/api/v1/posts/{post_id}/reactions`
                .replace(`{${"post_id"}}`, encodeURIComponent(String(postId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required

            if (emoji !== undefined) {
                localVarQueryParameter['emoji'] = emoji;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an Attachment
         * @param {string} id ID of the attachable, e.g. Topic.
         * @param {string} attachmentId ID of the attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePostAttachment: async (id: string, attachmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePostAttachment', 'id', id)
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('deletePostAttachment', 'attachmentId', attachmentId)
            const localVarPath = `/api/v1/posts/{id}/attachments/{attachment_id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"attachment_id"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete attachments
         * @param {string} id id of corresponding attachable (e.g. Topic)
         * @param {Array<string>} [requestBody] IDs of the attachments to be deleted.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePostAttachments: async (id: string, requestBody?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deletePostAttachments', 'id', id)
            const localVarPath = `/api/v1/posts/{id}/attachments`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a Reaction to a Post
         * @param {string} postId id of post to react to
         * @param {Emoji} emoji 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePostReaction: async (postId: string, emoji: Emoji, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postId' is not null or undefined
            assertParamExists('deletePostReaction', 'postId', postId)
            // verify required parameter 'emoji' is not null or undefined
            assertParamExists('deletePostReaction', 'emoji', emoji)
            const localVarPath = `/api/v1/posts/{post_id}/reactions`
                .replace(`{${"post_id"}}`, encodeURIComponent(String(postId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required

            if (emoji !== undefined) {
                localVarQueryParameter['emoji'] = emoji;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a Post
         * @param {string} id id of topic to post to
         * @param {string} postId id of post
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTopicPost: async (id: string, postId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteTopicPost', 'id', id)
            // verify required parameter 'postId' is not null or undefined
            assertParamExists('deleteTopicPost', 'postId', postId)
            const localVarPath = `/api/v1/topics/{id}/posts/{post_id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"post_id"}}`, encodeURIComponent(String(postId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get details of an Attachment
         * @param {string} id ID of the attachable, e.g. Topic.
         * @param {string} attachmentId ID of the attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPostAttachment: async (id: string, attachmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPostAttachment', 'id', id)
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('getPostAttachment', 'attachmentId', attachmentId)
            const localVarPath = `/api/v1/posts/{id}/attachments/{attachment_id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"attachment_id"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all Attachments of this post
         * @param {string} id id of corresponding attachable (e.g. Topic)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPostAttachments: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPostAttachments', 'id', id)
            const localVarPath = `/api/v1/posts/{id}/attachments`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all Comments of a Post
         * @param {string} id id of post to react to
         * @param {number} [offset] Index of the first requested item, starting at 0.
         * @param {number} [limit] Maximum number of items to be returned.
         * @param {AscDescOrder} [order] Direction of the ordering by creation date.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPostComments: async (id: string, offset?: number, limit?: number, order?: AscDescOrder, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getPostComments', 'id', id)
            const localVarPath = `/api/v1/posts/{id}/comments`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all Reactions of a Post
         * @param {string} postId id of post to react to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPostReactions: async (postId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'postId' is not null or undefined
            assertParamExists('getPostReactions', 'postId', postId)
            const localVarPath = `/api/v1/posts/{post_id}/reactions`
                .replace(`{${"post_id"}}`, encodeURIComponent(String(postId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a Post
         * @param {string} id id of topic to post to
         * @param {string} postId id of post
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopicPost: async (id: string, postId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTopicPost', 'id', id)
            // verify required parameter 'postId' is not null or undefined
            assertParamExists('getTopicPost', 'postId', postId)
            const localVarPath = `/api/v1/topics/{id}/posts/{post_id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"post_id"}}`, encodeURIComponent(String(postId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the name of an Attachment
         * @param {string} id ID of the attachable, e.g. Topic.
         * @param {string} attachmentId ID of the attachment
         * @param {UpdateEventAttachmentRequest} [updateEventAttachmentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePostAttachment: async (id: string, attachmentId: string, updateEventAttachmentRequest?: UpdateEventAttachmentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updatePostAttachment', 'id', id)
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('updatePostAttachment', 'attachmentId', attachmentId)
            const localVarPath = `/api/v1/posts/{id}/attachments/{attachment_id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"attachment_id"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEventAttachmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a Post
         * @param {string} id id of topic to post to
         * @param {string} postId id of post
         * @param {PostRequest} [postRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTopicPost: async (id: string, postId: string, postRequest?: PostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTopicPost', 'id', id)
            // verify required parameter 'postId' is not null or undefined
            assertParamExists('updateTopicPost', 'postId', postId)
            const localVarPath = `/api/v1/topics/{id}/posts/{post_id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"post_id"}}`, encodeURIComponent(String(postId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PostsApi - functional programming interface
 * @export
 */
export const PostsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PostsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add attachments to this post
         * @param {string} id id of corresponding attachable (e.g. Topic)
         * @param {Array<AttachmentUpload>} [attachmentUpload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addPostAttachments(id: string, attachmentUpload?: Array<AttachmentUpload>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Attachment>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addPostAttachments(id, attachmentUpload, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PostsApi.addPostAttachments']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Create a Comment
         * @param {string} id id of post to react to
         * @param {CommentRequest} [commentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPostComment(id: string, commentRequest?: CommentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Comment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPostComment(id, commentRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PostsApi.createPostComment']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Create a Reaction to a Post
         * @param {string} postId id of post to react to
         * @param {Emoji} emoji 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPostReaction(postId: string, emoji: Emoji, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Reaction>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPostReaction(postId, emoji, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PostsApi.createPostReaction']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Delete an Attachment
         * @param {string} id ID of the attachable, e.g. Topic.
         * @param {string} attachmentId ID of the attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePostAttachment(id: string, attachmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePostAttachment(id, attachmentId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PostsApi.deletePostAttachment']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Delete attachments
         * @param {string} id id of corresponding attachable (e.g. Topic)
         * @param {Array<string>} [requestBody] IDs of the attachments to be deleted.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePostAttachments(id: string, requestBody?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePostAttachments(id, requestBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PostsApi.deletePostAttachments']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a Reaction to a Post
         * @param {string} postId id of post to react to
         * @param {Emoji} emoji 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePostReaction(postId: string, emoji: Emoji, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePostReaction(postId, emoji, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PostsApi.deletePostReaction']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a Post
         * @param {string} id id of topic to post to
         * @param {string} postId id of post
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTopicPost(id: string, postId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTopicPost(id, postId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PostsApi.deleteTopicPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get details of an Attachment
         * @param {string} id ID of the attachable, e.g. Topic.
         * @param {string} attachmentId ID of the attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPostAttachment(id: string, attachmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Attachment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPostAttachment(id, attachmentId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PostsApi.getPostAttachment']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary List all Attachments of this post
         * @param {string} id id of corresponding attachable (e.g. Topic)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPostAttachments(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Attachment>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPostAttachments(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PostsApi.getPostAttachments']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get all Comments of a Post
         * @param {string} id id of post to react to
         * @param {number} [offset] Index of the first requested item, starting at 0.
         * @param {number} [limit] Maximum number of items to be returned.
         * @param {AscDescOrder} [order] Direction of the ordering by creation date.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPostComments(id: string, offset?: number, limit?: number, order?: AscDescOrder, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Comment>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPostComments(id, offset, limit, order, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PostsApi.getPostComments']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get all Reactions of a Post
         * @param {string} postId id of post to react to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPostReactions(postId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Reaction>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPostReactions(postId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PostsApi.getPostReactions']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get a Post
         * @param {string} id id of topic to post to
         * @param {string} postId id of post
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTopicPost(id: string, postId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Post>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTopicPost(id, postId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PostsApi.getTopicPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Update the name of an Attachment
         * @param {string} id ID of the attachable, e.g. Topic.
         * @param {string} attachmentId ID of the attachment
         * @param {UpdateEventAttachmentRequest} [updateEventAttachmentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePostAttachment(id: string, attachmentId: string, updateEventAttachmentRequest?: UpdateEventAttachmentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Attachment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePostAttachment(id, attachmentId, updateEventAttachmentRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PostsApi.updatePostAttachment']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Update a Post
         * @param {string} id id of topic to post to
         * @param {string} postId id of post
         * @param {PostRequest} [postRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTopicPost(id: string, postId: string, postRequest?: PostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Post>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTopicPost(id, postId, postRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PostsApi.updateTopicPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * PostsApi - factory interface
 * @export
 */
export const PostsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PostsApiFp(configuration)
    return {
        /**
         * 
         * @summary Add attachments to this post
         * @param {string} id id of corresponding attachable (e.g. Topic)
         * @param {Array<AttachmentUpload>} [attachmentUpload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addPostAttachments(id: string, attachmentUpload?: Array<AttachmentUpload>, options?: any): AxiosPromise<Array<Attachment>> {
            return localVarFp.addPostAttachments(id, attachmentUpload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a Comment
         * @param {string} id id of post to react to
         * @param {CommentRequest} [commentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPostComment(id: string, commentRequest?: CommentRequest, options?: any): AxiosPromise<Comment> {
            return localVarFp.createPostComment(id, commentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a Reaction to a Post
         * @param {string} postId id of post to react to
         * @param {Emoji} emoji 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPostReaction(postId: string, emoji: Emoji, options?: any): AxiosPromise<Reaction> {
            return localVarFp.createPostReaction(postId, emoji, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an Attachment
         * @param {string} id ID of the attachable, e.g. Topic.
         * @param {string} attachmentId ID of the attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePostAttachment(id: string, attachmentId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePostAttachment(id, attachmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete attachments
         * @param {string} id id of corresponding attachable (e.g. Topic)
         * @param {Array<string>} [requestBody] IDs of the attachments to be deleted.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePostAttachments(id: string, requestBody?: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.deletePostAttachments(id, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a Reaction to a Post
         * @param {string} postId id of post to react to
         * @param {Emoji} emoji 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePostReaction(postId: string, emoji: Emoji, options?: any): AxiosPromise<void> {
            return localVarFp.deletePostReaction(postId, emoji, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a Post
         * @param {string} id id of topic to post to
         * @param {string} postId id of post
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTopicPost(id: string, postId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteTopicPost(id, postId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get details of an Attachment
         * @param {string} id ID of the attachable, e.g. Topic.
         * @param {string} attachmentId ID of the attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPostAttachment(id: string, attachmentId: string, options?: any): AxiosPromise<Attachment> {
            return localVarFp.getPostAttachment(id, attachmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all Attachments of this post
         * @param {string} id id of corresponding attachable (e.g. Topic)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPostAttachments(id: string, options?: any): AxiosPromise<Array<Attachment>> {
            return localVarFp.getPostAttachments(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all Comments of a Post
         * @param {string} id id of post to react to
         * @param {number} [offset] Index of the first requested item, starting at 0.
         * @param {number} [limit] Maximum number of items to be returned.
         * @param {AscDescOrder} [order] Direction of the ordering by creation date.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPostComments(id: string, offset?: number, limit?: number, order?: AscDescOrder, options?: any): AxiosPromise<Array<Comment>> {
            return localVarFp.getPostComments(id, offset, limit, order, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all Reactions of a Post
         * @param {string} postId id of post to react to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPostReactions(postId: string, options?: any): AxiosPromise<Array<Reaction>> {
            return localVarFp.getPostReactions(postId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a Post
         * @param {string} id id of topic to post to
         * @param {string} postId id of post
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopicPost(id: string, postId: string, options?: any): AxiosPromise<Post> {
            return localVarFp.getTopicPost(id, postId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update the name of an Attachment
         * @param {string} id ID of the attachable, e.g. Topic.
         * @param {string} attachmentId ID of the attachment
         * @param {UpdateEventAttachmentRequest} [updateEventAttachmentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePostAttachment(id: string, attachmentId: string, updateEventAttachmentRequest?: UpdateEventAttachmentRequest, options?: any): AxiosPromise<Attachment> {
            return localVarFp.updatePostAttachment(id, attachmentId, updateEventAttachmentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a Post
         * @param {string} id id of topic to post to
         * @param {string} postId id of post
         * @param {PostRequest} [postRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTopicPost(id: string, postId: string, postRequest?: PostRequest, options?: any): AxiosPromise<Post> {
            return localVarFp.updateTopicPost(id, postId, postRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PostsApi - interface
 * @export
 * @interface PostsApi
 */
export interface PostsApiInterface {
    /**
     * 
     * @summary Add attachments to this post
     * @param {string} id id of corresponding attachable (e.g. Topic)
     * @param {Array<AttachmentUpload>} [attachmentUpload] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostsApiInterface
     */
    addPostAttachments(id: string, attachmentUpload?: Array<AttachmentUpload>, options?: RawAxiosRequestConfig): AxiosPromise<Array<Attachment>>;

    /**
     * 
     * @summary Create a Comment
     * @param {string} id id of post to react to
     * @param {CommentRequest} [commentRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostsApiInterface
     */
    createPostComment(id: string, commentRequest?: CommentRequest, options?: RawAxiosRequestConfig): AxiosPromise<Comment>;

    /**
     * 
     * @summary Create a Reaction to a Post
     * @param {string} postId id of post to react to
     * @param {Emoji} emoji 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostsApiInterface
     */
    createPostReaction(postId: string, emoji: Emoji, options?: RawAxiosRequestConfig): AxiosPromise<Reaction>;

    /**
     * 
     * @summary Delete an Attachment
     * @param {string} id ID of the attachable, e.g. Topic.
     * @param {string} attachmentId ID of the attachment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostsApiInterface
     */
    deletePostAttachment(id: string, attachmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Delete attachments
     * @param {string} id id of corresponding attachable (e.g. Topic)
     * @param {Array<string>} [requestBody] IDs of the attachments to be deleted.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostsApiInterface
     */
    deletePostAttachments(id: string, requestBody?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Delete a Reaction to a Post
     * @param {string} postId id of post to react to
     * @param {Emoji} emoji 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostsApiInterface
     */
    deletePostReaction(postId: string, emoji: Emoji, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Delete a Post
     * @param {string} id id of topic to post to
     * @param {string} postId id of post
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostsApiInterface
     */
    deleteTopicPost(id: string, postId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Get details of an Attachment
     * @param {string} id ID of the attachable, e.g. Topic.
     * @param {string} attachmentId ID of the attachment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostsApiInterface
     */
    getPostAttachment(id: string, attachmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<Attachment>;

    /**
     * 
     * @summary List all Attachments of this post
     * @param {string} id id of corresponding attachable (e.g. Topic)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostsApiInterface
     */
    getPostAttachments(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Attachment>>;

    /**
     * 
     * @summary Get all Comments of a Post
     * @param {string} id id of post to react to
     * @param {number} [offset] Index of the first requested item, starting at 0.
     * @param {number} [limit] Maximum number of items to be returned.
     * @param {AscDescOrder} [order] Direction of the ordering by creation date.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostsApiInterface
     */
    getPostComments(id: string, offset?: number, limit?: number, order?: AscDescOrder, options?: RawAxiosRequestConfig): AxiosPromise<Array<Comment>>;

    /**
     * 
     * @summary Get all Reactions of a Post
     * @param {string} postId id of post to react to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostsApiInterface
     */
    getPostReactions(postId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Reaction>>;

    /**
     * 
     * @summary Get a Post
     * @param {string} id id of topic to post to
     * @param {string} postId id of post
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostsApiInterface
     */
    getTopicPost(id: string, postId: string, options?: RawAxiosRequestConfig): AxiosPromise<Post>;

    /**
     * 
     * @summary Update the name of an Attachment
     * @param {string} id ID of the attachable, e.g. Topic.
     * @param {string} attachmentId ID of the attachment
     * @param {UpdateEventAttachmentRequest} [updateEventAttachmentRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostsApiInterface
     */
    updatePostAttachment(id: string, attachmentId: string, updateEventAttachmentRequest?: UpdateEventAttachmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<Attachment>;

    /**
     * 
     * @summary Update a Post
     * @param {string} id id of topic to post to
     * @param {string} postId id of post
     * @param {PostRequest} [postRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostsApiInterface
     */
    updateTopicPost(id: string, postId: string, postRequest?: PostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Post>;

}

/**
 * PostsApi - object-oriented interface
 * @export
 * @class PostsApi
 * @extends {BaseAPI}
 */
export class PostsApi extends BaseAPI implements PostsApiInterface {
    /**
     * 
     * @summary Add attachments to this post
     * @param {string} id id of corresponding attachable (e.g. Topic)
     * @param {Array<AttachmentUpload>} [attachmentUpload] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostsApi
     */
    public addPostAttachments(id: string, attachmentUpload?: Array<AttachmentUpload>, options?: RawAxiosRequestConfig) {
        return PostsApiFp(this.configuration).addPostAttachments(id, attachmentUpload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a Comment
     * @param {string} id id of post to react to
     * @param {CommentRequest} [commentRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostsApi
     */
    public createPostComment(id: string, commentRequest?: CommentRequest, options?: RawAxiosRequestConfig) {
        return PostsApiFp(this.configuration).createPostComment(id, commentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a Reaction to a Post
     * @param {string} postId id of post to react to
     * @param {Emoji} emoji 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostsApi
     */
    public createPostReaction(postId: string, emoji: Emoji, options?: RawAxiosRequestConfig) {
        return PostsApiFp(this.configuration).createPostReaction(postId, emoji, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an Attachment
     * @param {string} id ID of the attachable, e.g. Topic.
     * @param {string} attachmentId ID of the attachment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostsApi
     */
    public deletePostAttachment(id: string, attachmentId: string, options?: RawAxiosRequestConfig) {
        return PostsApiFp(this.configuration).deletePostAttachment(id, attachmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete attachments
     * @param {string} id id of corresponding attachable (e.g. Topic)
     * @param {Array<string>} [requestBody] IDs of the attachments to be deleted.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostsApi
     */
    public deletePostAttachments(id: string, requestBody?: Array<string>, options?: RawAxiosRequestConfig) {
        return PostsApiFp(this.configuration).deletePostAttachments(id, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a Reaction to a Post
     * @param {string} postId id of post to react to
     * @param {Emoji} emoji 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostsApi
     */
    public deletePostReaction(postId: string, emoji: Emoji, options?: RawAxiosRequestConfig) {
        return PostsApiFp(this.configuration).deletePostReaction(postId, emoji, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a Post
     * @param {string} id id of topic to post to
     * @param {string} postId id of post
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostsApi
     */
    public deleteTopicPost(id: string, postId: string, options?: RawAxiosRequestConfig) {
        return PostsApiFp(this.configuration).deleteTopicPost(id, postId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get details of an Attachment
     * @param {string} id ID of the attachable, e.g. Topic.
     * @param {string} attachmentId ID of the attachment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostsApi
     */
    public getPostAttachment(id: string, attachmentId: string, options?: RawAxiosRequestConfig) {
        return PostsApiFp(this.configuration).getPostAttachment(id, attachmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all Attachments of this post
     * @param {string} id id of corresponding attachable (e.g. Topic)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostsApi
     */
    public getPostAttachments(id: string, options?: RawAxiosRequestConfig) {
        return PostsApiFp(this.configuration).getPostAttachments(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all Comments of a Post
     * @param {string} id id of post to react to
     * @param {number} [offset] Index of the first requested item, starting at 0.
     * @param {number} [limit] Maximum number of items to be returned.
     * @param {AscDescOrder} [order] Direction of the ordering by creation date.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostsApi
     */
    public getPostComments(id: string, offset?: number, limit?: number, order?: AscDescOrder, options?: RawAxiosRequestConfig) {
        return PostsApiFp(this.configuration).getPostComments(id, offset, limit, order, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all Reactions of a Post
     * @param {string} postId id of post to react to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostsApi
     */
    public getPostReactions(postId: string, options?: RawAxiosRequestConfig) {
        return PostsApiFp(this.configuration).getPostReactions(postId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a Post
     * @param {string} id id of topic to post to
     * @param {string} postId id of post
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostsApi
     */
    public getTopicPost(id: string, postId: string, options?: RawAxiosRequestConfig) {
        return PostsApiFp(this.configuration).getTopicPost(id, postId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update the name of an Attachment
     * @param {string} id ID of the attachable, e.g. Topic.
     * @param {string} attachmentId ID of the attachment
     * @param {UpdateEventAttachmentRequest} [updateEventAttachmentRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostsApi
     */
    public updatePostAttachment(id: string, attachmentId: string, updateEventAttachmentRequest?: UpdateEventAttachmentRequest, options?: RawAxiosRequestConfig) {
        return PostsApiFp(this.configuration).updatePostAttachment(id, attachmentId, updateEventAttachmentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a Post
     * @param {string} id id of topic to post to
     * @param {string} postId id of post
     * @param {PostRequest} [postRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PostsApi
     */
    public updateTopicPost(id: string, postId: string, postRequest?: PostRequest, options?: RawAxiosRequestConfig) {
        return PostsApiFp(this.configuration).updateTopicPost(id, postId, postRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PushDeviceApi - axios parameter creator
 * @export
 */
export const PushDeviceApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a Push Device Registration
         * @param {PushRegistrationRequest} pushRegistrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPushRegistration: async (pushRegistrationRequest: PushRegistrationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pushRegistrationRequest' is not null or undefined
            assertParamExists('createPushRegistration', 'pushRegistrationRequest', pushRegistrationRequest)
            const localVarPath = `/api/v1/push_device`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pushRegistrationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete the Push Registration
         * @param {string} pushRegistrationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePushRegistration: async (pushRegistrationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pushRegistrationId' is not null or undefined
            assertParamExists('deletePushRegistration', 'pushRegistrationId', pushRegistrationId)
            const localVarPath = `/api/v1/push_device/{push_registration_id}`
                .replace(`{${"push_registration_id"}}`, encodeURIComponent(String(pushRegistrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send a test notification to this device
         * @param {string} pushRegistrationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTestNotification: async (pushRegistrationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pushRegistrationId' is not null or undefined
            assertParamExists('sendTestNotification', 'pushRegistrationId', pushRegistrationId)
            const localVarPath = `/api/v1/push_device/{push_registration_id}`
                .replace(`{${"push_registration_id"}}`, encodeURIComponent(String(pushRegistrationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a Push Device Registration
         * @param {PushRegistrationRequest} pushRegistrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePushRegistration: async (pushRegistrationRequest: PushRegistrationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'pushRegistrationRequest' is not null or undefined
            assertParamExists('updatePushRegistration', 'pushRegistrationRequest', pushRegistrationRequest)
            const localVarPath = `/api/v1/push_device`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(pushRegistrationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PushDeviceApi - functional programming interface
 * @export
 */
export const PushDeviceApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PushDeviceApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a Push Device Registration
         * @param {PushRegistrationRequest} pushRegistrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createPushRegistration(pushRegistrationRequest: PushRegistrationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PushRegistration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createPushRegistration(pushRegistrationRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PushDeviceApi.createPushRegistration']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Delete the Push Registration
         * @param {string} pushRegistrationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePushRegistration(pushRegistrationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePushRegistration(pushRegistrationId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PushDeviceApi.deletePushRegistration']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Send a test notification to this device
         * @param {string} pushRegistrationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendTestNotification(pushRegistrationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendTestNotification200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendTestNotification(pushRegistrationId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PushDeviceApi.sendTestNotification']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Update a Push Device Registration
         * @param {PushRegistrationRequest} pushRegistrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updatePushRegistration(pushRegistrationRequest: PushRegistrationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PushRegistration>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updatePushRegistration(pushRegistrationRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['PushDeviceApi.updatePushRegistration']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * PushDeviceApi - factory interface
 * @export
 */
export const PushDeviceApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PushDeviceApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a Push Device Registration
         * @param {PushRegistrationRequest} pushRegistrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createPushRegistration(pushRegistrationRequest: PushRegistrationRequest, options?: any): AxiosPromise<PushRegistration> {
            return localVarFp.createPushRegistration(pushRegistrationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete the Push Registration
         * @param {string} pushRegistrationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePushRegistration(pushRegistrationId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePushRegistration(pushRegistrationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send a test notification to this device
         * @param {string} pushRegistrationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendTestNotification(pushRegistrationId: string, options?: any): AxiosPromise<SendTestNotification200Response> {
            return localVarFp.sendTestNotification(pushRegistrationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a Push Device Registration
         * @param {PushRegistrationRequest} pushRegistrationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updatePushRegistration(pushRegistrationRequest: PushRegistrationRequest, options?: any): AxiosPromise<PushRegistration> {
            return localVarFp.updatePushRegistration(pushRegistrationRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PushDeviceApi - interface
 * @export
 * @interface PushDeviceApi
 */
export interface PushDeviceApiInterface {
    /**
     * 
     * @summary Create a Push Device Registration
     * @param {PushRegistrationRequest} pushRegistrationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PushDeviceApiInterface
     */
    createPushRegistration(pushRegistrationRequest: PushRegistrationRequest, options?: RawAxiosRequestConfig): AxiosPromise<PushRegistration>;

    /**
     * 
     * @summary Delete the Push Registration
     * @param {string} pushRegistrationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PushDeviceApiInterface
     */
    deletePushRegistration(pushRegistrationId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Send a test notification to this device
     * @param {string} pushRegistrationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PushDeviceApiInterface
     */
    sendTestNotification(pushRegistrationId: string, options?: RawAxiosRequestConfig): AxiosPromise<SendTestNotification200Response>;

    /**
     * 
     * @summary Update a Push Device Registration
     * @param {PushRegistrationRequest} pushRegistrationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PushDeviceApiInterface
     */
    updatePushRegistration(pushRegistrationRequest: PushRegistrationRequest, options?: RawAxiosRequestConfig): AxiosPromise<PushRegistration>;

}

/**
 * PushDeviceApi - object-oriented interface
 * @export
 * @class PushDeviceApi
 * @extends {BaseAPI}
 */
export class PushDeviceApi extends BaseAPI implements PushDeviceApiInterface {
    /**
     * 
     * @summary Create a Push Device Registration
     * @param {PushRegistrationRequest} pushRegistrationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PushDeviceApi
     */
    public createPushRegistration(pushRegistrationRequest: PushRegistrationRequest, options?: RawAxiosRequestConfig) {
        return PushDeviceApiFp(this.configuration).createPushRegistration(pushRegistrationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete the Push Registration
     * @param {string} pushRegistrationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PushDeviceApi
     */
    public deletePushRegistration(pushRegistrationId: string, options?: RawAxiosRequestConfig) {
        return PushDeviceApiFp(this.configuration).deletePushRegistration(pushRegistrationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send a test notification to this device
     * @param {string} pushRegistrationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PushDeviceApi
     */
    public sendTestNotification(pushRegistrationId: string, options?: RawAxiosRequestConfig) {
        return PushDeviceApiFp(this.configuration).sendTestNotification(pushRegistrationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a Push Device Registration
     * @param {PushRegistrationRequest} pushRegistrationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PushDeviceApi
     */
    public updatePushRegistration(pushRegistrationRequest: PushRegistrationRequest, options?: RawAxiosRequestConfig) {
        return PushDeviceApiFp(this.configuration).updatePushRegistration(pushRegistrationRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * RsvpsApi - axios parameter creator
 * @export
 */
export const RsvpsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a new RSVP for an event
         * @param {string} eventId 
         * @param {string} [personalRecordId] 
         * @param {RsvpRequest} [rsvpRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRsvp: async (eventId: string, personalRecordId?: string, rsvpRequest?: RsvpRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('createRsvp', 'eventId', eventId)
            const localVarPath = `/api/v1/events/{event_id}/rsvps`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required

            if (personalRecordId !== undefined) {
                localVarQueryParameter['personal_record_id'] = personalRecordId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rsvpRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a rsvp of an event
         * @param {string} eventId 
         * @param {string} personalRecordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRsvp: async (eventId: string, personalRecordId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('deleteRsvp', 'eventId', eventId)
            // verify required parameter 'personalRecordId' is not null or undefined
            assertParamExists('deleteRsvp', 'personalRecordId', personalRecordId)
            const localVarPath = `/api/v1/events/{event_id}/rsvps/{personal_record_id}`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)))
                .replace(`{${"personal_record_id"}}`, encodeURIComponent(String(personalRecordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Download all RSVPs as an Excel file.
         * @summary Download RSVPs
         * @param {string} eventId 
         * @param {RsvpReply} [reply] Filter results for a specific reply.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadRsvps: async (eventId: string, reply?: RsvpReply, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('downloadRsvps', 'eventId', eventId)
            const localVarPath = `/api/v1/events/{event_id}/rsvps.xlsx`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required

            if (reply !== undefined) {
                localVarQueryParameter['reply'] = reply;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a RSVP of an event
         * @param {string} eventId 
         * @param {string} personalRecordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRsvp: async (eventId: string, personalRecordId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getRsvp', 'eventId', eventId)
            // verify required parameter 'personalRecordId' is not null or undefined
            assertParamExists('getRsvp', 'personalRecordId', personalRecordId)
            const localVarPath = `/api/v1/events/{event_id}/rsvps/{personal_record_id}`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)))
                .replace(`{${"personal_record_id"}}`, encodeURIComponent(String(personalRecordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * RSVPs are returned in a paginated way, so you specify how many rsvps should be on a page and where your page should begin.
         * @summary Get a list of RSVPs of an Event
         * @param {string} eventId 
         * @param {number} [offset] Index of the first requested rsvp, starting at 0.
         * @param {number} [limit] Maximum number of rsvps to be returned.
         * @param {AscDescOrder} [order] RSVPs of Coetanen are always shown first. Direction of the ordering by creation date (created_at).
         * @param {string} [name] Fuzzily filter results for a specific name of a member.
         * @param {RsvpReply} [reply] Filter results for a specific reply.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRsvps: async (eventId: string, offset?: number, limit?: number, order?: AscDescOrder, name?: string, reply?: RsvpReply, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('getRsvps', 'eventId', eventId)
            const localVarPath = `/api/v1/events/{event_id}/rsvps`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (reply !== undefined) {
                localVarQueryParameter['reply'] = reply;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update or create a RSVP of an event
         * @param {string} eventId 
         * @param {string} personalRecordId 
         * @param {RsvpRequest} [rsvpRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRsvp: async (eventId: string, personalRecordId: string, rsvpRequest?: RsvpRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('updateRsvp', 'eventId', eventId)
            // verify required parameter 'personalRecordId' is not null or undefined
            assertParamExists('updateRsvp', 'personalRecordId', personalRecordId)
            const localVarPath = `/api/v1/events/{event_id}/rsvps/{personal_record_id}`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)))
                .replace(`{${"personal_record_id"}}`, encodeURIComponent(String(personalRecordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rsvpRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set the RSVP of the current user
         * @param {string} eventId 
         * @param {string} personalRecordId 
         * @param {RsvpRequest} [rsvpRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserRsvp: async (eventId: string, personalRecordId: string, rsvpRequest?: RsvpRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'eventId' is not null or undefined
            assertParamExists('updateUserRsvp', 'eventId', eventId)
            // verify required parameter 'personalRecordId' is not null or undefined
            assertParamExists('updateUserRsvp', 'personalRecordId', personalRecordId)
            const localVarPath = `/api/v1/events/{event_id}/rsvp`
                .replace(`{${"event_id"}}`, encodeURIComponent(String(eventId)))
                .replace(`{${"personal_record_id"}}`, encodeURIComponent(String(personalRecordId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rsvpRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RsvpsApi - functional programming interface
 * @export
 */
export const RsvpsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RsvpsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a new RSVP for an event
         * @param {string} eventId 
         * @param {string} [personalRecordId] 
         * @param {RsvpRequest} [rsvpRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRsvp(eventId: string, personalRecordId?: string, rsvpRequest?: RsvpRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Rsvp>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRsvp(eventId, personalRecordId, rsvpRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RsvpsApi.createRsvp']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a rsvp of an event
         * @param {string} eventId 
         * @param {string} personalRecordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRsvp(eventId: string, personalRecordId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRsvp(eventId, personalRecordId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RsvpsApi.deleteRsvp']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Download all RSVPs as an Excel file.
         * @summary Download RSVPs
         * @param {string} eventId 
         * @param {RsvpReply} [reply] Filter results for a specific reply.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async downloadRsvps(eventId: string, reply?: RsvpReply, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.downloadRsvps(eventId, reply, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RsvpsApi.downloadRsvps']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get a RSVP of an event
         * @param {string} eventId 
         * @param {string} personalRecordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRsvp(eventId: string, personalRecordId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Rsvp>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRsvp(eventId, personalRecordId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RsvpsApi.getRsvp']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * RSVPs are returned in a paginated way, so you specify how many rsvps should be on a page and where your page should begin.
         * @summary Get a list of RSVPs of an Event
         * @param {string} eventId 
         * @param {number} [offset] Index of the first requested rsvp, starting at 0.
         * @param {number} [limit] Maximum number of rsvps to be returned.
         * @param {AscDescOrder} [order] RSVPs of Coetanen are always shown first. Direction of the ordering by creation date (created_at).
         * @param {string} [name] Fuzzily filter results for a specific name of a member.
         * @param {RsvpReply} [reply] Filter results for a specific reply.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRsvps(eventId: string, offset?: number, limit?: number, order?: AscDescOrder, name?: string, reply?: RsvpReply, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Rsvp>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRsvps(eventId, offset, limit, order, name, reply, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RsvpsApi.getRsvps']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Update or create a RSVP of an event
         * @param {string} eventId 
         * @param {string} personalRecordId 
         * @param {RsvpRequest} [rsvpRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRsvp(eventId: string, personalRecordId: string, rsvpRequest?: RsvpRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Rsvp>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRsvp(eventId, personalRecordId, rsvpRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RsvpsApi.updateRsvp']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Set the RSVP of the current user
         * @param {string} eventId 
         * @param {string} personalRecordId 
         * @param {RsvpRequest} [rsvpRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserRsvp(eventId: string, personalRecordId: string, rsvpRequest?: RsvpRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Rsvp>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserRsvp(eventId, personalRecordId, rsvpRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['RsvpsApi.updateUserRsvp']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * RsvpsApi - factory interface
 * @export
 */
export const RsvpsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RsvpsApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a new RSVP for an event
         * @param {string} eventId 
         * @param {string} [personalRecordId] 
         * @param {RsvpRequest} [rsvpRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRsvp(eventId: string, personalRecordId?: string, rsvpRequest?: RsvpRequest, options?: any): AxiosPromise<Rsvp> {
            return localVarFp.createRsvp(eventId, personalRecordId, rsvpRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a rsvp of an event
         * @param {string} eventId 
         * @param {string} personalRecordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRsvp(eventId: string, personalRecordId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteRsvp(eventId, personalRecordId, options).then((request) => request(axios, basePath));
        },
        /**
         * Download all RSVPs as an Excel file.
         * @summary Download RSVPs
         * @param {string} eventId 
         * @param {RsvpReply} [reply] Filter results for a specific reply.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadRsvps(eventId: string, reply?: RsvpReply, options?: any): AxiosPromise<void> {
            return localVarFp.downloadRsvps(eventId, reply, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a RSVP of an event
         * @param {string} eventId 
         * @param {string} personalRecordId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRsvp(eventId: string, personalRecordId: string, options?: any): AxiosPromise<Rsvp> {
            return localVarFp.getRsvp(eventId, personalRecordId, options).then((request) => request(axios, basePath));
        },
        /**
         * RSVPs are returned in a paginated way, so you specify how many rsvps should be on a page and where your page should begin.
         * @summary Get a list of RSVPs of an Event
         * @param {string} eventId 
         * @param {number} [offset] Index of the first requested rsvp, starting at 0.
         * @param {number} [limit] Maximum number of rsvps to be returned.
         * @param {AscDescOrder} [order] RSVPs of Coetanen are always shown first. Direction of the ordering by creation date (created_at).
         * @param {string} [name] Fuzzily filter results for a specific name of a member.
         * @param {RsvpReply} [reply] Filter results for a specific reply.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRsvps(eventId: string, offset?: number, limit?: number, order?: AscDescOrder, name?: string, reply?: RsvpReply, options?: any): AxiosPromise<Array<Rsvp>> {
            return localVarFp.getRsvps(eventId, offset, limit, order, name, reply, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update or create a RSVP of an event
         * @param {string} eventId 
         * @param {string} personalRecordId 
         * @param {RsvpRequest} [rsvpRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRsvp(eventId: string, personalRecordId: string, rsvpRequest?: RsvpRequest, options?: any): AxiosPromise<Rsvp> {
            return localVarFp.updateRsvp(eventId, personalRecordId, rsvpRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set the RSVP of the current user
         * @param {string} eventId 
         * @param {string} personalRecordId 
         * @param {RsvpRequest} [rsvpRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserRsvp(eventId: string, personalRecordId: string, rsvpRequest?: RsvpRequest, options?: any): AxiosPromise<Rsvp> {
            return localVarFp.updateUserRsvp(eventId, personalRecordId, rsvpRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RsvpsApi - interface
 * @export
 * @interface RsvpsApi
 */
export interface RsvpsApiInterface {
    /**
     * 
     * @summary Create a new RSVP for an event
     * @param {string} eventId 
     * @param {string} [personalRecordId] 
     * @param {RsvpRequest} [rsvpRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RsvpsApiInterface
     */
    createRsvp(eventId: string, personalRecordId?: string, rsvpRequest?: RsvpRequest, options?: RawAxiosRequestConfig): AxiosPromise<Rsvp>;

    /**
     * 
     * @summary Delete a rsvp of an event
     * @param {string} eventId 
     * @param {string} personalRecordId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RsvpsApiInterface
     */
    deleteRsvp(eventId: string, personalRecordId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Download all RSVPs as an Excel file.
     * @summary Download RSVPs
     * @param {string} eventId 
     * @param {RsvpReply} [reply] Filter results for a specific reply.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RsvpsApiInterface
     */
    downloadRsvps(eventId: string, reply?: RsvpReply, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Get a RSVP of an event
     * @param {string} eventId 
     * @param {string} personalRecordId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RsvpsApiInterface
     */
    getRsvp(eventId: string, personalRecordId: string, options?: RawAxiosRequestConfig): AxiosPromise<Rsvp>;

    /**
     * RSVPs are returned in a paginated way, so you specify how many rsvps should be on a page and where your page should begin.
     * @summary Get a list of RSVPs of an Event
     * @param {string} eventId 
     * @param {number} [offset] Index of the first requested rsvp, starting at 0.
     * @param {number} [limit] Maximum number of rsvps to be returned.
     * @param {AscDescOrder} [order] RSVPs of Coetanen are always shown first. Direction of the ordering by creation date (created_at).
     * @param {string} [name] Fuzzily filter results for a specific name of a member.
     * @param {RsvpReply} [reply] Filter results for a specific reply.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RsvpsApiInterface
     */
    getRsvps(eventId: string, offset?: number, limit?: number, order?: AscDescOrder, name?: string, reply?: RsvpReply, options?: RawAxiosRequestConfig): AxiosPromise<Array<Rsvp>>;

    /**
     * 
     * @summary Update or create a RSVP of an event
     * @param {string} eventId 
     * @param {string} personalRecordId 
     * @param {RsvpRequest} [rsvpRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RsvpsApiInterface
     */
    updateRsvp(eventId: string, personalRecordId: string, rsvpRequest?: RsvpRequest, options?: RawAxiosRequestConfig): AxiosPromise<Rsvp>;

    /**
     * 
     * @summary Set the RSVP of the current user
     * @param {string} eventId 
     * @param {string} personalRecordId 
     * @param {RsvpRequest} [rsvpRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RsvpsApiInterface
     */
    updateUserRsvp(eventId: string, personalRecordId: string, rsvpRequest?: RsvpRequest, options?: RawAxiosRequestConfig): AxiosPromise<Rsvp>;

}

/**
 * RsvpsApi - object-oriented interface
 * @export
 * @class RsvpsApi
 * @extends {BaseAPI}
 */
export class RsvpsApi extends BaseAPI implements RsvpsApiInterface {
    /**
     * 
     * @summary Create a new RSVP for an event
     * @param {string} eventId 
     * @param {string} [personalRecordId] 
     * @param {RsvpRequest} [rsvpRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RsvpsApi
     */
    public createRsvp(eventId: string, personalRecordId?: string, rsvpRequest?: RsvpRequest, options?: RawAxiosRequestConfig) {
        return RsvpsApiFp(this.configuration).createRsvp(eventId, personalRecordId, rsvpRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a rsvp of an event
     * @param {string} eventId 
     * @param {string} personalRecordId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RsvpsApi
     */
    public deleteRsvp(eventId: string, personalRecordId: string, options?: RawAxiosRequestConfig) {
        return RsvpsApiFp(this.configuration).deleteRsvp(eventId, personalRecordId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Download all RSVPs as an Excel file.
     * @summary Download RSVPs
     * @param {string} eventId 
     * @param {RsvpReply} [reply] Filter results for a specific reply.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RsvpsApi
     */
    public downloadRsvps(eventId: string, reply?: RsvpReply, options?: RawAxiosRequestConfig) {
        return RsvpsApiFp(this.configuration).downloadRsvps(eventId, reply, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a RSVP of an event
     * @param {string} eventId 
     * @param {string} personalRecordId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RsvpsApi
     */
    public getRsvp(eventId: string, personalRecordId: string, options?: RawAxiosRequestConfig) {
        return RsvpsApiFp(this.configuration).getRsvp(eventId, personalRecordId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * RSVPs are returned in a paginated way, so you specify how many rsvps should be on a page and where your page should begin.
     * @summary Get a list of RSVPs of an Event
     * @param {string} eventId 
     * @param {number} [offset] Index of the first requested rsvp, starting at 0.
     * @param {number} [limit] Maximum number of rsvps to be returned.
     * @param {AscDescOrder} [order] RSVPs of Coetanen are always shown first. Direction of the ordering by creation date (created_at).
     * @param {string} [name] Fuzzily filter results for a specific name of a member.
     * @param {RsvpReply} [reply] Filter results for a specific reply.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RsvpsApi
     */
    public getRsvps(eventId: string, offset?: number, limit?: number, order?: AscDescOrder, name?: string, reply?: RsvpReply, options?: RawAxiosRequestConfig) {
        return RsvpsApiFp(this.configuration).getRsvps(eventId, offset, limit, order, name, reply, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update or create a RSVP of an event
     * @param {string} eventId 
     * @param {string} personalRecordId 
     * @param {RsvpRequest} [rsvpRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RsvpsApi
     */
    public updateRsvp(eventId: string, personalRecordId: string, rsvpRequest?: RsvpRequest, options?: RawAxiosRequestConfig) {
        return RsvpsApiFp(this.configuration).updateRsvp(eventId, personalRecordId, rsvpRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set the RSVP of the current user
     * @param {string} eventId 
     * @param {string} personalRecordId 
     * @param {RsvpRequest} [rsvpRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RsvpsApi
     */
    public updateUserRsvp(eventId: string, personalRecordId: string, rsvpRequest?: RsvpRequest, options?: RawAxiosRequestConfig) {
        return RsvpsApiFp(this.configuration).updateUserRsvp(eventId, personalRecordId, rsvpRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * StatusApi - axios parameter creator
 * @export
 */
export const StatusApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Move members from one status to another.
         * @param {MoveMembersRequest} [moveMembersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveMembers: async (moveMembersRequest?: MoveMembersRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/statuses/move_members`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(moveMembersRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * StatusApi - functional programming interface
 * @export
 */
export const StatusApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = StatusApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Move members from one status to another.
         * @param {MoveMembersRequest} [moveMembersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async moveMembers(moveMembersRequest?: MoveMembersRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.moveMembers(moveMembersRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['StatusApi.moveMembers']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * StatusApi - factory interface
 * @export
 */
export const StatusApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = StatusApiFp(configuration)
    return {
        /**
         * 
         * @summary Move members from one status to another.
         * @param {MoveMembersRequest} [moveMembersRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveMembers(moveMembersRequest?: MoveMembersRequest, options?: any): AxiosPromise<void> {
            return localVarFp.moveMembers(moveMembersRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * StatusApi - interface
 * @export
 * @interface StatusApi
 */
export interface StatusApiInterface {
    /**
     * 
     * @summary Move members from one status to another.
     * @param {MoveMembersRequest} [moveMembersRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatusApiInterface
     */
    moveMembers(moveMembersRequest?: MoveMembersRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * StatusApi - object-oriented interface
 * @export
 * @class StatusApi
 * @extends {BaseAPI}
 */
export class StatusApi extends BaseAPI implements StatusApiInterface {
    /**
     * 
     * @summary Move members from one status to another.
     * @param {MoveMembersRequest} [moveMembersRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StatusApi
     */
    public moveMembers(moveMembersRequest?: MoveMembersRequest, options?: RawAxiosRequestConfig) {
        return StatusApiFp(this.configuration).moveMembers(moveMembersRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TagsApi - axios parameter creator
 * @export
 */
export const TagsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary tags index
         * @param {number} [clientId] only list tags of the given client (current client, if omitted)
         * @param {number} [levelId] only list tags of the given level (falls back to current client)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTags: async (clientId?: number, levelId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required

            if (clientId !== undefined) {
                localVarQueryParameter['client_id'] = clientId;
            }

            if (levelId !== undefined) {
                localVarQueryParameter['level_id'] = levelId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TagsApi - functional programming interface
 * @export
 */
export const TagsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TagsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary tags index
         * @param {number} [clientId] only list tags of the given client (current client, if omitted)
         * @param {number} [levelId] only list tags of the given level (falls back to current client)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTags(clientId?: number, levelId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Tag>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTags(clientId, levelId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TagsApi.getTags']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * TagsApi - factory interface
 * @export
 */
export const TagsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TagsApiFp(configuration)
    return {
        /**
         * 
         * @summary tags index
         * @param {number} [clientId] only list tags of the given client (current client, if omitted)
         * @param {number} [levelId] only list tags of the given level (falls back to current client)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTags(clientId?: number, levelId?: number, options?: any): AxiosPromise<Array<Tag>> {
            return localVarFp.getTags(clientId, levelId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TagsApi - interface
 * @export
 * @interface TagsApi
 */
export interface TagsApiInterface {
    /**
     * 
     * @summary tags index
     * @param {number} [clientId] only list tags of the given client (current client, if omitted)
     * @param {number} [levelId] only list tags of the given level (falls back to current client)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagsApiInterface
     */
    getTags(clientId?: number, levelId?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<Tag>>;

}

/**
 * TagsApi - object-oriented interface
 * @export
 * @class TagsApi
 * @extends {BaseAPI}
 */
export class TagsApi extends BaseAPI implements TagsApiInterface {
    /**
     * 
     * @summary tags index
     * @param {number} [clientId] only list tags of the given client (current client, if omitted)
     * @param {number} [levelId] only list tags of the given level (falls back to current client)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TagsApi
     */
    public getTags(clientId?: number, levelId?: number, options?: RawAxiosRequestConfig) {
        return TagsApiFp(this.configuration).getTags(clientId, levelId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * TopicsApi - axios parameter creator
 * @export
 */
export const TopicsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Add attachments to this topic
         * @param {string} id id of corresponding attachable (e.g. Topic)
         * @param {Array<AttachmentUpload>} [attachmentUpload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTopicAttachments: async (id: string, attachmentUpload?: Array<AttachmentUpload>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('addTopicAttachments', 'id', id)
            const localVarPath = `/api/v1/topics/{id}/attachments`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(attachmentUpload, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a Topic
         * @param {TopicCreateRequest} [topicCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTopic: async (topicCreateRequest?: TopicCreateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/topics/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(topicCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a comment to a topic
         * @param {string} id id of topic to react to
         * @param {CommentRequest} [commentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTopicComments: async (id: string, commentRequest?: CommentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createTopicComments', 'id', id)
            const localVarPath = `/api/v1/topics/{id}/comments`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(commentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a Post at a Topic
         * @param {string} id id of topic to post to
         * @param {PostRequest} [postRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTopicPost: async (id: string, postRequest?: PostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('createTopicPost', 'id', id)
            const localVarPath = `/api/v1/topics/{id}/posts`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Add your reaction to a topic
         * @param {string} topicId id of topic to react to
         * @param {Emoji} emoji 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTopicReaction: async (topicId: string, emoji: Emoji, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'topicId' is not null or undefined
            assertParamExists('createTopicReaction', 'topicId', topicId)
            // verify required parameter 'emoji' is not null or undefined
            assertParamExists('createTopicReaction', 'emoji', emoji)
            const localVarPath = `/api/v1/topics/{topic_id}/reactions`
                .replace(`{${"topic_id"}}`, encodeURIComponent(String(topicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required

            if (emoji !== undefined) {
                localVarQueryParameter['emoji'] = emoji;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a Topic
         * @param {string} id id of corresponding topic
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTopic: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteTopic', 'id', id)
            const localVarPath = `/api/v1/topics/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an Attachment
         * @param {string} id ID of the attachable, e.g. Topic.
         * @param {string} attachmentId ID of the attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTopicAttachment: async (id: string, attachmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteTopicAttachment', 'id', id)
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('deleteTopicAttachment', 'attachmentId', attachmentId)
            const localVarPath = `/api/v1/topics/{id}/attachments/{attachment_id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"attachment_id"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete attachments
         * @param {string} id id of corresponding attachable (e.g. Topic)
         * @param {Array<string>} [requestBody] IDs of the attachments to be deleted.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTopicAttachments: async (id: string, requestBody?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteTopicAttachments', 'id', id)
            const localVarPath = `/api/v1/topics/{id}/attachments`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove your reaction from a topic
         * @param {string} topicId id of topic to react to
         * @param {Emoji} emoji 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTopicReaction: async (topicId: string, emoji: Emoji, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'topicId' is not null or undefined
            assertParamExists('deleteTopicReaction', 'topicId', topicId)
            // verify required parameter 'emoji' is not null or undefined
            assertParamExists('deleteTopicReaction', 'emoji', emoji)
            const localVarPath = `/api/v1/topics/{topic_id}/reactions`
                .replace(`{${"topic_id"}}`, encodeURIComponent(String(topicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required

            if (emoji !== undefined) {
                localVarQueryParameter['emoji'] = emoji;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a Topic
         * @param {string} id id of corresponding topic
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopic: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTopic', 'id', id)
            const localVarPath = `/api/v1/topics/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get details of an Attachment
         * @param {string} id ID of the attachable, e.g. Topic.
         * @param {string} attachmentId ID of the attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopicAttachment: async (id: string, attachmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTopicAttachment', 'id', id)
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('getTopicAttachment', 'attachmentId', attachmentId)
            const localVarPath = `/api/v1/topics/{id}/attachments/{attachment_id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"attachment_id"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List all Attachments of this topic
         * @param {string} id id of corresponding attachable (e.g. Topic)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopicAttachments: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTopicAttachments', 'id', id)
            const localVarPath = `/api/v1/topics/{id}/attachments`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all comments of a topic
         * @param {string} id id of topic to react to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopicComments: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTopicComments', 'id', id)
            const localVarPath = `/api/v1/topics/{id}/comments`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Posts are returned in a paginated way, so you specify how many Posts should be on a page and where your page should begin.
         * @summary Get a list of Posts of a Topic
         * @param {string} id id of topic to post to
         * @param {number} [offset] Index of the first requested Post, starting at 0.
         * @param {number} [limit] Maximum number of Posts to be returned.
         * @param {AscDescOrder} [order] RSVPs of Coetanen are always shown first. Direction of the ordering by creation date (created_at).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopicPosts: async (id: string, offset?: number, limit?: number, order?: AscDescOrder, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getTopicPosts', 'id', id)
            const localVarPath = `/api/v1/topics/{id}/posts`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all reactions to a topic
         * @param {string} topicId id of topic to react to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopicReactions: async (topicId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'topicId' is not null or undefined
            assertParamExists('getTopicReactions', 'topicId', topicId)
            const localVarPath = `/api/v1/topics/{topic_id}/reactions`
                .replace(`{${"topic_id"}}`, encodeURIComponent(String(topicId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a Topic
         * @param {string} id id of corresponding topic
         * @param {TopicUpdateRequest} [topicUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTopic: async (id: string, topicUpdateRequest?: TopicUpdateRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTopic', 'id', id)
            const localVarPath = `/api/v1/topics/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(topicUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update the name of an Attachment
         * @param {string} id ID of the attachable, e.g. Topic.
         * @param {string} attachmentId ID of the attachment
         * @param {UpdateEventAttachmentRequest} [updateEventAttachmentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTopicAttachment: async (id: string, attachmentId: string, updateEventAttachmentRequest?: UpdateEventAttachmentRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateTopicAttachment', 'id', id)
            // verify required parameter 'attachmentId' is not null or undefined
            assertParamExists('updateTopicAttachment', 'attachmentId', attachmentId)
            const localVarPath = `/api/v1/topics/{id}/attachments/{attachment_id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"attachment_id"}}`, encodeURIComponent(String(attachmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateEventAttachmentRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TopicsApi - functional programming interface
 * @export
 */
export const TopicsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TopicsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Add attachments to this topic
         * @param {string} id id of corresponding attachable (e.g. Topic)
         * @param {Array<AttachmentUpload>} [attachmentUpload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addTopicAttachments(id: string, attachmentUpload?: Array<AttachmentUpload>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Attachment>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addTopicAttachments(id, attachmentUpload, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TopicsApi.addTopicAttachments']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Create a Topic
         * @param {TopicCreateRequest} [topicCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTopic(topicCreateRequest?: TopicCreateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Topic>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTopic(topicCreateRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TopicsApi.createTopic']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Create a comment to a topic
         * @param {string} id id of topic to react to
         * @param {CommentRequest} [commentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTopicComments(id: string, commentRequest?: CommentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Comment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTopicComments(id, commentRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TopicsApi.createTopicComments']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Create a Post at a Topic
         * @param {string} id id of topic to post to
         * @param {PostRequest} [postRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTopicPost(id: string, postRequest?: PostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Post>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTopicPost(id, postRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TopicsApi.createTopicPost']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Add your reaction to a topic
         * @param {string} topicId id of topic to react to
         * @param {Emoji} emoji 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTopicReaction(topicId: string, emoji: Emoji, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Reaction>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTopicReaction(topicId, emoji, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TopicsApi.createTopicReaction']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a Topic
         * @param {string} id id of corresponding topic
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTopic(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTopic(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TopicsApi.deleteTopic']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Delete an Attachment
         * @param {string} id ID of the attachable, e.g. Topic.
         * @param {string} attachmentId ID of the attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTopicAttachment(id: string, attachmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTopicAttachment(id, attachmentId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TopicsApi.deleteTopicAttachment']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Delete attachments
         * @param {string} id id of corresponding attachable (e.g. Topic)
         * @param {Array<string>} [requestBody] IDs of the attachments to be deleted.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTopicAttachments(id: string, requestBody?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTopicAttachments(id, requestBody, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TopicsApi.deleteTopicAttachments']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Remove your reaction from a topic
         * @param {string} topicId id of topic to react to
         * @param {Emoji} emoji 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteTopicReaction(topicId: string, emoji: Emoji, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteTopicReaction(topicId, emoji, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TopicsApi.deleteTopicReaction']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get a Topic
         * @param {string} id id of corresponding topic
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTopic(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Topic>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTopic(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TopicsApi.getTopic']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get details of an Attachment
         * @param {string} id ID of the attachable, e.g. Topic.
         * @param {string} attachmentId ID of the attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTopicAttachment(id: string, attachmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Attachment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTopicAttachment(id, attachmentId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TopicsApi.getTopicAttachment']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary List all Attachments of this topic
         * @param {string} id id of corresponding attachable (e.g. Topic)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTopicAttachments(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Attachment>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTopicAttachments(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TopicsApi.getTopicAttachments']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get all comments of a topic
         * @param {string} id id of topic to react to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTopicComments(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Comment>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTopicComments(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TopicsApi.getTopicComments']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * Posts are returned in a paginated way, so you specify how many Posts should be on a page and where your page should begin.
         * @summary Get a list of Posts of a Topic
         * @param {string} id id of topic to post to
         * @param {number} [offset] Index of the first requested Post, starting at 0.
         * @param {number} [limit] Maximum number of Posts to be returned.
         * @param {AscDescOrder} [order] RSVPs of Coetanen are always shown first. Direction of the ordering by creation date (created_at).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTopicPosts(id: string, offset?: number, limit?: number, order?: AscDescOrder, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Post>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTopicPosts(id, offset, limit, order, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TopicsApi.getTopicPosts']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get all reactions to a topic
         * @param {string} topicId id of topic to react to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTopicReactions(topicId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Reaction>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTopicReactions(topicId, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TopicsApi.getTopicReactions']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Update a Topic
         * @param {string} id id of corresponding topic
         * @param {TopicUpdateRequest} [topicUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTopic(id: string, topicUpdateRequest?: TopicUpdateRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Topic>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTopic(id, topicUpdateRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TopicsApi.updateTopic']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Update the name of an Attachment
         * @param {string} id ID of the attachable, e.g. Topic.
         * @param {string} attachmentId ID of the attachment
         * @param {UpdateEventAttachmentRequest} [updateEventAttachmentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateTopicAttachment(id: string, attachmentId: string, updateEventAttachmentRequest?: UpdateEventAttachmentRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Attachment>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateTopicAttachment(id, attachmentId, updateEventAttachmentRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['TopicsApi.updateTopicAttachment']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * TopicsApi - factory interface
 * @export
 */
export const TopicsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TopicsApiFp(configuration)
    return {
        /**
         * 
         * @summary Add attachments to this topic
         * @param {string} id id of corresponding attachable (e.g. Topic)
         * @param {Array<AttachmentUpload>} [attachmentUpload] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addTopicAttachments(id: string, attachmentUpload?: Array<AttachmentUpload>, options?: any): AxiosPromise<Array<Attachment>> {
            return localVarFp.addTopicAttachments(id, attachmentUpload, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a Topic
         * @param {TopicCreateRequest} [topicCreateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTopic(topicCreateRequest?: TopicCreateRequest, options?: any): AxiosPromise<Topic> {
            return localVarFp.createTopic(topicCreateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a comment to a topic
         * @param {string} id id of topic to react to
         * @param {CommentRequest} [commentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTopicComments(id: string, commentRequest?: CommentRequest, options?: any): AxiosPromise<Comment> {
            return localVarFp.createTopicComments(id, commentRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a Post at a Topic
         * @param {string} id id of topic to post to
         * @param {PostRequest} [postRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTopicPost(id: string, postRequest?: PostRequest, options?: any): AxiosPromise<Post> {
            return localVarFp.createTopicPost(id, postRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Add your reaction to a topic
         * @param {string} topicId id of topic to react to
         * @param {Emoji} emoji 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTopicReaction(topicId: string, emoji: Emoji, options?: any): AxiosPromise<Reaction> {
            return localVarFp.createTopicReaction(topicId, emoji, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a Topic
         * @param {string} id id of corresponding topic
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTopic(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteTopic(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an Attachment
         * @param {string} id ID of the attachable, e.g. Topic.
         * @param {string} attachmentId ID of the attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTopicAttachment(id: string, attachmentId: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteTopicAttachment(id, attachmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete attachments
         * @param {string} id id of corresponding attachable (e.g. Topic)
         * @param {Array<string>} [requestBody] IDs of the attachments to be deleted.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTopicAttachments(id: string, requestBody?: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.deleteTopicAttachments(id, requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove your reaction from a topic
         * @param {string} topicId id of topic to react to
         * @param {Emoji} emoji 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteTopicReaction(topicId: string, emoji: Emoji, options?: any): AxiosPromise<void> {
            return localVarFp.deleteTopicReaction(topicId, emoji, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a Topic
         * @param {string} id id of corresponding topic
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopic(id: string, options?: any): AxiosPromise<Topic> {
            return localVarFp.getTopic(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get details of an Attachment
         * @param {string} id ID of the attachable, e.g. Topic.
         * @param {string} attachmentId ID of the attachment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopicAttachment(id: string, attachmentId: string, options?: any): AxiosPromise<Attachment> {
            return localVarFp.getTopicAttachment(id, attachmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List all Attachments of this topic
         * @param {string} id id of corresponding attachable (e.g. Topic)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopicAttachments(id: string, options?: any): AxiosPromise<Array<Attachment>> {
            return localVarFp.getTopicAttachments(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all comments of a topic
         * @param {string} id id of topic to react to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopicComments(id: string, options?: any): AxiosPromise<Array<Comment>> {
            return localVarFp.getTopicComments(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Posts are returned in a paginated way, so you specify how many Posts should be on a page and where your page should begin.
         * @summary Get a list of Posts of a Topic
         * @param {string} id id of topic to post to
         * @param {number} [offset] Index of the first requested Post, starting at 0.
         * @param {number} [limit] Maximum number of Posts to be returned.
         * @param {AscDescOrder} [order] RSVPs of Coetanen are always shown first. Direction of the ordering by creation date (created_at).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopicPosts(id: string, offset?: number, limit?: number, order?: AscDescOrder, options?: any): AxiosPromise<Array<Post>> {
            return localVarFp.getTopicPosts(id, offset, limit, order, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all reactions to a topic
         * @param {string} topicId id of topic to react to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTopicReactions(topicId: string, options?: any): AxiosPromise<Array<Reaction>> {
            return localVarFp.getTopicReactions(topicId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a Topic
         * @param {string} id id of corresponding topic
         * @param {TopicUpdateRequest} [topicUpdateRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTopic(id: string, topicUpdateRequest?: TopicUpdateRequest, options?: any): AxiosPromise<Topic> {
            return localVarFp.updateTopic(id, topicUpdateRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update the name of an Attachment
         * @param {string} id ID of the attachable, e.g. Topic.
         * @param {string} attachmentId ID of the attachment
         * @param {UpdateEventAttachmentRequest} [updateEventAttachmentRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTopicAttachment(id: string, attachmentId: string, updateEventAttachmentRequest?: UpdateEventAttachmentRequest, options?: any): AxiosPromise<Attachment> {
            return localVarFp.updateTopicAttachment(id, attachmentId, updateEventAttachmentRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TopicsApi - interface
 * @export
 * @interface TopicsApi
 */
export interface TopicsApiInterface {
    /**
     * 
     * @summary Add attachments to this topic
     * @param {string} id id of corresponding attachable (e.g. Topic)
     * @param {Array<AttachmentUpload>} [attachmentUpload] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicsApiInterface
     */
    addTopicAttachments(id: string, attachmentUpload?: Array<AttachmentUpload>, options?: RawAxiosRequestConfig): AxiosPromise<Array<Attachment>>;

    /**
     * 
     * @summary Create a Topic
     * @param {TopicCreateRequest} [topicCreateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicsApiInterface
     */
    createTopic(topicCreateRequest?: TopicCreateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Topic>;

    /**
     * 
     * @summary Create a comment to a topic
     * @param {string} id id of topic to react to
     * @param {CommentRequest} [commentRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicsApiInterface
     */
    createTopicComments(id: string, commentRequest?: CommentRequest, options?: RawAxiosRequestConfig): AxiosPromise<Comment>;

    /**
     * 
     * @summary Create a Post at a Topic
     * @param {string} id id of topic to post to
     * @param {PostRequest} [postRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicsApiInterface
     */
    createTopicPost(id: string, postRequest?: PostRequest, options?: RawAxiosRequestConfig): AxiosPromise<Post>;

    /**
     * 
     * @summary Add your reaction to a topic
     * @param {string} topicId id of topic to react to
     * @param {Emoji} emoji 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicsApiInterface
     */
    createTopicReaction(topicId: string, emoji: Emoji, options?: RawAxiosRequestConfig): AxiosPromise<Reaction>;

    /**
     * 
     * @summary Delete a Topic
     * @param {string} id id of corresponding topic
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicsApiInterface
     */
    deleteTopic(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Delete an Attachment
     * @param {string} id ID of the attachable, e.g. Topic.
     * @param {string} attachmentId ID of the attachment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicsApiInterface
     */
    deleteTopicAttachment(id: string, attachmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Delete attachments
     * @param {string} id id of corresponding attachable (e.g. Topic)
     * @param {Array<string>} [requestBody] IDs of the attachments to be deleted.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicsApiInterface
     */
    deleteTopicAttachments(id: string, requestBody?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Remove your reaction from a topic
     * @param {string} topicId id of topic to react to
     * @param {Emoji} emoji 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicsApiInterface
     */
    deleteTopicReaction(topicId: string, emoji: Emoji, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Get a Topic
     * @param {string} id id of corresponding topic
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicsApiInterface
     */
    getTopic(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Topic>;

    /**
     * 
     * @summary Get details of an Attachment
     * @param {string} id ID of the attachable, e.g. Topic.
     * @param {string} attachmentId ID of the attachment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicsApiInterface
     */
    getTopicAttachment(id: string, attachmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<Attachment>;

    /**
     * 
     * @summary List all Attachments of this topic
     * @param {string} id id of corresponding attachable (e.g. Topic)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicsApiInterface
     */
    getTopicAttachments(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Attachment>>;

    /**
     * 
     * @summary Get all comments of a topic
     * @param {string} id id of topic to react to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicsApiInterface
     */
    getTopicComments(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Comment>>;

    /**
     * Posts are returned in a paginated way, so you specify how many Posts should be on a page and where your page should begin.
     * @summary Get a list of Posts of a Topic
     * @param {string} id id of topic to post to
     * @param {number} [offset] Index of the first requested Post, starting at 0.
     * @param {number} [limit] Maximum number of Posts to be returned.
     * @param {AscDescOrder} [order] RSVPs of Coetanen are always shown first. Direction of the ordering by creation date (created_at).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicsApiInterface
     */
    getTopicPosts(id: string, offset?: number, limit?: number, order?: AscDescOrder, options?: RawAxiosRequestConfig): AxiosPromise<Array<Post>>;

    /**
     * 
     * @summary Get all reactions to a topic
     * @param {string} topicId id of topic to react to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicsApiInterface
     */
    getTopicReactions(topicId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Reaction>>;

    /**
     * 
     * @summary Update a Topic
     * @param {string} id id of corresponding topic
     * @param {TopicUpdateRequest} [topicUpdateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicsApiInterface
     */
    updateTopic(id: string, topicUpdateRequest?: TopicUpdateRequest, options?: RawAxiosRequestConfig): AxiosPromise<Topic>;

    /**
     * 
     * @summary Update the name of an Attachment
     * @param {string} id ID of the attachable, e.g. Topic.
     * @param {string} attachmentId ID of the attachment
     * @param {UpdateEventAttachmentRequest} [updateEventAttachmentRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicsApiInterface
     */
    updateTopicAttachment(id: string, attachmentId: string, updateEventAttachmentRequest?: UpdateEventAttachmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<Attachment>;

}

/**
 * TopicsApi - object-oriented interface
 * @export
 * @class TopicsApi
 * @extends {BaseAPI}
 */
export class TopicsApi extends BaseAPI implements TopicsApiInterface {
    /**
     * 
     * @summary Add attachments to this topic
     * @param {string} id id of corresponding attachable (e.g. Topic)
     * @param {Array<AttachmentUpload>} [attachmentUpload] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicsApi
     */
    public addTopicAttachments(id: string, attachmentUpload?: Array<AttachmentUpload>, options?: RawAxiosRequestConfig) {
        return TopicsApiFp(this.configuration).addTopicAttachments(id, attachmentUpload, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a Topic
     * @param {TopicCreateRequest} [topicCreateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicsApi
     */
    public createTopic(topicCreateRequest?: TopicCreateRequest, options?: RawAxiosRequestConfig) {
        return TopicsApiFp(this.configuration).createTopic(topicCreateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a comment to a topic
     * @param {string} id id of topic to react to
     * @param {CommentRequest} [commentRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicsApi
     */
    public createTopicComments(id: string, commentRequest?: CommentRequest, options?: RawAxiosRequestConfig) {
        return TopicsApiFp(this.configuration).createTopicComments(id, commentRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a Post at a Topic
     * @param {string} id id of topic to post to
     * @param {PostRequest} [postRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicsApi
     */
    public createTopicPost(id: string, postRequest?: PostRequest, options?: RawAxiosRequestConfig) {
        return TopicsApiFp(this.configuration).createTopicPost(id, postRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Add your reaction to a topic
     * @param {string} topicId id of topic to react to
     * @param {Emoji} emoji 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicsApi
     */
    public createTopicReaction(topicId: string, emoji: Emoji, options?: RawAxiosRequestConfig) {
        return TopicsApiFp(this.configuration).createTopicReaction(topicId, emoji, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a Topic
     * @param {string} id id of corresponding topic
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicsApi
     */
    public deleteTopic(id: string, options?: RawAxiosRequestConfig) {
        return TopicsApiFp(this.configuration).deleteTopic(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an Attachment
     * @param {string} id ID of the attachable, e.g. Topic.
     * @param {string} attachmentId ID of the attachment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicsApi
     */
    public deleteTopicAttachment(id: string, attachmentId: string, options?: RawAxiosRequestConfig) {
        return TopicsApiFp(this.configuration).deleteTopicAttachment(id, attachmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete attachments
     * @param {string} id id of corresponding attachable (e.g. Topic)
     * @param {Array<string>} [requestBody] IDs of the attachments to be deleted.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicsApi
     */
    public deleteTopicAttachments(id: string, requestBody?: Array<string>, options?: RawAxiosRequestConfig) {
        return TopicsApiFp(this.configuration).deleteTopicAttachments(id, requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove your reaction from a topic
     * @param {string} topicId id of topic to react to
     * @param {Emoji} emoji 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicsApi
     */
    public deleteTopicReaction(topicId: string, emoji: Emoji, options?: RawAxiosRequestConfig) {
        return TopicsApiFp(this.configuration).deleteTopicReaction(topicId, emoji, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a Topic
     * @param {string} id id of corresponding topic
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicsApi
     */
    public getTopic(id: string, options?: RawAxiosRequestConfig) {
        return TopicsApiFp(this.configuration).getTopic(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get details of an Attachment
     * @param {string} id ID of the attachable, e.g. Topic.
     * @param {string} attachmentId ID of the attachment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicsApi
     */
    public getTopicAttachment(id: string, attachmentId: string, options?: RawAxiosRequestConfig) {
        return TopicsApiFp(this.configuration).getTopicAttachment(id, attachmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List all Attachments of this topic
     * @param {string} id id of corresponding attachable (e.g. Topic)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicsApi
     */
    public getTopicAttachments(id: string, options?: RawAxiosRequestConfig) {
        return TopicsApiFp(this.configuration).getTopicAttachments(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all comments of a topic
     * @param {string} id id of topic to react to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicsApi
     */
    public getTopicComments(id: string, options?: RawAxiosRequestConfig) {
        return TopicsApiFp(this.configuration).getTopicComments(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Posts are returned in a paginated way, so you specify how many Posts should be on a page and where your page should begin.
     * @summary Get a list of Posts of a Topic
     * @param {string} id id of topic to post to
     * @param {number} [offset] Index of the first requested Post, starting at 0.
     * @param {number} [limit] Maximum number of Posts to be returned.
     * @param {AscDescOrder} [order] RSVPs of Coetanen are always shown first. Direction of the ordering by creation date (created_at).
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicsApi
     */
    public getTopicPosts(id: string, offset?: number, limit?: number, order?: AscDescOrder, options?: RawAxiosRequestConfig) {
        return TopicsApiFp(this.configuration).getTopicPosts(id, offset, limit, order, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all reactions to a topic
     * @param {string} topicId id of topic to react to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicsApi
     */
    public getTopicReactions(topicId: string, options?: RawAxiosRequestConfig) {
        return TopicsApiFp(this.configuration).getTopicReactions(topicId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a Topic
     * @param {string} id id of corresponding topic
     * @param {TopicUpdateRequest} [topicUpdateRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicsApi
     */
    public updateTopic(id: string, topicUpdateRequest?: TopicUpdateRequest, options?: RawAxiosRequestConfig) {
        return TopicsApiFp(this.configuration).updateTopic(id, topicUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update the name of an Attachment
     * @param {string} id ID of the attachable, e.g. Topic.
     * @param {string} attachmentId ID of the attachment
     * @param {UpdateEventAttachmentRequest} [updateEventAttachmentRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TopicsApi
     */
    public updateTopicAttachment(id: string, attachmentId: string, updateEventAttachmentRequest?: UpdateEventAttachmentRequest, options?: RawAxiosRequestConfig) {
        return TopicsApiFp(this.configuration).updateTopicAttachment(id, attachmentId, updateEventAttachmentRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UmbrellaApi - axios parameter creator
 * @export
 */
export const UmbrellaApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Umbrella
         * @param {UmbrellaRequest} [umbrellaRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUmbrella: async (umbrellaRequest?: UmbrellaRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/umbrellas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(umbrellaRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Umbrella
         * @param {string} id id of umbrella
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUmbrella: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteUmbrella', 'id', id)
            const localVarPath = `/api/v1/umbrellas/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Umbrella
         * @param {string} id id of umbrella
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUmbrella: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getUmbrella', 'id', id)
            const localVarPath = `/api/v1/umbrellas/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Umbrellas
         * @param {string} [name] Search by name
         * @param {string} [shorthand] Search by shorthand
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUmbrellas: async (name?: string, shorthand?: string, offset?: number, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/umbrellas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (shorthand !== undefined) {
                localVarQueryParameter['shorthand'] = shorthand;
            }

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Umbrella
         * @param {string} id id of umbrella
         * @param {UmbrellaRequest} [umbrellaRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUmbrella: async (id: string, umbrellaRequest?: UmbrellaRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateUmbrella', 'id', id)
            const localVarPath = `/api/v1/umbrellas/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication legacyCookieAuth required


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(umbrellaRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UmbrellaApi - functional programming interface
 * @export
 */
export const UmbrellaApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UmbrellaApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Umbrella
         * @param {UmbrellaRequest} [umbrellaRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUmbrella(umbrellaRequest?: UmbrellaRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Umbrella>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUmbrella(umbrellaRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UmbrellaApi.createUmbrella']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Umbrella
         * @param {string} id id of umbrella
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUmbrella(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUmbrella(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UmbrellaApi.deleteUmbrella']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Get Umbrella
         * @param {string} id id of umbrella
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUmbrella(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Umbrella>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUmbrella(id, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UmbrellaApi.getUmbrella']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary List Umbrellas
         * @param {string} [name] Search by name
         * @param {string} [shorthand] Search by shorthand
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUmbrellas(name?: string, shorthand?: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Umbrella>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUmbrellas(name, shorthand, offset, limit, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UmbrellaApi.getUmbrellas']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
        /**
         * 
         * @summary Update Umbrella
         * @param {string} id id of umbrella
         * @param {UmbrellaRequest} [umbrellaRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUmbrella(id: string, umbrellaRequest?: UmbrellaRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Umbrella>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUmbrella(id, umbrellaRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['UmbrellaApi.updateUmbrella']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * UmbrellaApi - factory interface
 * @export
 */
export const UmbrellaApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UmbrellaApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Umbrella
         * @param {UmbrellaRequest} [umbrellaRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUmbrella(umbrellaRequest?: UmbrellaRequest, options?: any): AxiosPromise<Umbrella> {
            return localVarFp.createUmbrella(umbrellaRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Umbrella
         * @param {string} id id of umbrella
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUmbrella(id: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteUmbrella(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Umbrella
         * @param {string} id id of umbrella
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUmbrella(id: string, options?: any): AxiosPromise<Umbrella> {
            return localVarFp.getUmbrella(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Umbrellas
         * @param {string} [name] Search by name
         * @param {string} [shorthand] Search by shorthand
         * @param {number} [offset] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUmbrellas(name?: string, shorthand?: string, offset?: number, limit?: number, options?: any): AxiosPromise<Array<Umbrella>> {
            return localVarFp.getUmbrellas(name, shorthand, offset, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Umbrella
         * @param {string} id id of umbrella
         * @param {UmbrellaRequest} [umbrellaRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUmbrella(id: string, umbrellaRequest?: UmbrellaRequest, options?: any): AxiosPromise<Umbrella> {
            return localVarFp.updateUmbrella(id, umbrellaRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UmbrellaApi - interface
 * @export
 * @interface UmbrellaApi
 */
export interface UmbrellaApiInterface {
    /**
     * 
     * @summary Create Umbrella
     * @param {UmbrellaRequest} [umbrellaRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UmbrellaApiInterface
     */
    createUmbrella(umbrellaRequest?: UmbrellaRequest, options?: RawAxiosRequestConfig): AxiosPromise<Umbrella>;

    /**
     * 
     * @summary Delete Umbrella
     * @param {string} id id of umbrella
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UmbrellaApiInterface
     */
    deleteUmbrella(id: string, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Get Umbrella
     * @param {string} id id of umbrella
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UmbrellaApiInterface
     */
    getUmbrella(id: string, options?: RawAxiosRequestConfig): AxiosPromise<Umbrella>;

    /**
     * 
     * @summary List Umbrellas
     * @param {string} [name] Search by name
     * @param {string} [shorthand] Search by shorthand
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UmbrellaApiInterface
     */
    getUmbrellas(name?: string, shorthand?: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<Umbrella>>;

    /**
     * 
     * @summary Update Umbrella
     * @param {string} id id of umbrella
     * @param {UmbrellaRequest} [umbrellaRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UmbrellaApiInterface
     */
    updateUmbrella(id: string, umbrellaRequest?: UmbrellaRequest, options?: RawAxiosRequestConfig): AxiosPromise<Umbrella>;

}

/**
 * UmbrellaApi - object-oriented interface
 * @export
 * @class UmbrellaApi
 * @extends {BaseAPI}
 */
export class UmbrellaApi extends BaseAPI implements UmbrellaApiInterface {
    /**
     * 
     * @summary Create Umbrella
     * @param {UmbrellaRequest} [umbrellaRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UmbrellaApi
     */
    public createUmbrella(umbrellaRequest?: UmbrellaRequest, options?: RawAxiosRequestConfig) {
        return UmbrellaApiFp(this.configuration).createUmbrella(umbrellaRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Umbrella
     * @param {string} id id of umbrella
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UmbrellaApi
     */
    public deleteUmbrella(id: string, options?: RawAxiosRequestConfig) {
        return UmbrellaApiFp(this.configuration).deleteUmbrella(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Umbrella
     * @param {string} id id of umbrella
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UmbrellaApi
     */
    public getUmbrella(id: string, options?: RawAxiosRequestConfig) {
        return UmbrellaApiFp(this.configuration).getUmbrella(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Umbrellas
     * @param {string} [name] Search by name
     * @param {string} [shorthand] Search by shorthand
     * @param {number} [offset] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UmbrellaApi
     */
    public getUmbrellas(name?: string, shorthand?: string, offset?: number, limit?: number, options?: RawAxiosRequestConfig) {
        return UmbrellaApiFp(this.configuration).getUmbrellas(name, shorthand, offset, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Umbrella
     * @param {string} id id of umbrella
     * @param {UmbrellaRequest} [umbrellaRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UmbrellaApi
     */
    public updateUmbrella(id: string, umbrellaRequest?: UmbrellaRequest, options?: RawAxiosRequestConfig) {
        return UmbrellaApiFp(this.configuration).updateUmbrella(id, umbrellaRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



